
      var $parcel$global = globalThis;
    
class $5f00034adfeb2fe9$export$55185c17a0fcbe46 {
    routes = [];
    currentCleanup = null;
    container;
    constructor(container){
        this.container = container;
        window.addEventListener('popstate', ()=>this.handleRoute());
    }
    route(path, handler) {
        const paramNames = [];
        const patternStr = path.replace(/:(\w+)/g, (_, name)=>{
            paramNames.push(name);
            return '([^/]+)';
        });
        this.routes.push({
            pattern: new RegExp(`^${patternStr}$`),
            paramNames: paramNames,
            handler: handler
        });
        return this;
    }
    navigate(path, replace = false) {
        if (replace) history.replaceState(null, '', path);
        else history.pushState(null, '', path);
        this.handleRoute();
    }
    async handleRoute() {
        const path = window.location.pathname;
        if (this.currentCleanup) {
            this.currentCleanup();
            this.currentCleanup = null;
        }
        for (const route of this.routes){
            const match = path.match(route.pattern);
            if (match) {
                const params = {};
                route.paramNames.forEach((name, i)=>{
                    params[name] = match[i + 1];
                });
                await route.handler(params);
                return;
            }
        }
        // No match - redirect to home
        this.navigate('/', true);
    }
    setCleanup(fn) {
        this.currentCleanup = fn;
    }
    getContainer() {
        return this.container;
    }
    start() {
        this.handleRoute();
    }
}


class $46b6101c9a6cf325$export$355f3d6a1f8b250c {
    element;
    router;
    constructor(container, router){
        this.router = router;
        this.element = document.createElement('div');
        this.element.className = 'landing-page';
        this.render();
        container.appendChild(this.element);
        this.bindEvents();
    }
    render() {
        this.element.innerHTML = `
      <div class="landing-container">
        <header class="landing-header">
          <div class="landing-logo">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 2c0 10-10 10-10 10s10 0 10 10"/>
              <path d="M12 2c0 10 10 10 10 10s-10 0-10 10"/>
            </svg>
            <span>Tennis Diagrams</span>
          </div>
        </header>

        <main class="landing-hero">
          <h1>Draw plays. Share tactics.</h1>
          <p class="landing-tagline">We coaches, not artists</p>

          <button class="create-btn" id="create-new">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            Create New Diagram
          </button>

          <ul class="landing-features">
            <li>Drag to draw shot trajectories</li>
            <li>Automatic bounce trajectory arcs</li>
            <li>Rally sequencing with hit numbers</li>
            <li>Export as PNG for sharing</li>
          </ul>
        </main>

        <footer class="landing-footer">
          <p>Built for tennis coaches</p>
        </footer>
      </div>
    `;
    }
    bindEvents() {
        const createBtn = this.element.querySelector('#create-new');
        createBtn?.addEventListener('click', ()=>{
            // Full page navigation to backend /new endpoint
            // This creates the Durable Object and redirects to /d/:id
            window.location.href = '/new';
        });
    }
    destroy() {
        this.element.remove();
    }
}


const $8c8384c27430fce8$var$PI_OVER_180 = Math.PI / 180;
function $8c8384c27430fce8$var$detectBrowser() {
    return typeof window !== 'undefined' && (({}).toString.call(window) === '[object Window]' || ({}).toString.call(window) === '[object global]');
}
const $8c8384c27430fce8$export$442f1a04865e4790 = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof WorkerGlobalScope !== 'undefined' ? self : {};
const $8c8384c27430fce8$export$b9f99057a3c7692 = {
    _global: $8c8384c27430fce8$export$442f1a04865e4790,
    version: '10.0.12',
    isBrowser: $8c8384c27430fce8$var$detectBrowser(),
    isUnminified: /param/.test((function(param) {}).toString()),
    dblClickWindow: 400,
    getAngle (angle) {
        return $8c8384c27430fce8$export$b9f99057a3c7692.angleDeg ? angle * $8c8384c27430fce8$var$PI_OVER_180 : angle;
    },
    enableTrace: false,
    pointerEventsEnabled: true,
    autoDrawEnabled: true,
    hitOnDragEnabled: false,
    capturePointerEventsEnabled: false,
    _mouseListenClick: false,
    _touchListenClick: false,
    _pointerListenClick: false,
    _mouseInDblClickWindow: false,
    _touchInDblClickWindow: false,
    _pointerInDblClickWindow: false,
    _mouseDblClickPointerId: null,
    _touchDblClickPointerId: null,
    _pointerDblClickPointerId: null,
    _renderBackend: 'web',
    legacyTextRendering: false,
    pixelRatio: typeof window !== 'undefined' && window.devicePixelRatio || 1,
    dragDistance: 3,
    angleDeg: true,
    showWarnings: true,
    dragButtons: [
        0,
        1
    ],
    isDragging () {
        return $8c8384c27430fce8$export$b9f99057a3c7692['DD'].isDragging;
    },
    isTransforming () {
        var _a, _b;
        return (_b = (_a = $8c8384c27430fce8$export$b9f99057a3c7692['Transformer']) === null || _a === void 0 ? void 0 : _a.isTransforming()) !== null && _b !== void 0 ? _b : false;
    },
    isDragReady () {
        return !!$8c8384c27430fce8$export$b9f99057a3c7692['DD'].node;
    },
    releaseCanvasOnDestroy: true,
    document: $8c8384c27430fce8$export$442f1a04865e4790.document,
    _injectGlobal (Konva) {
        if (typeof $8c8384c27430fce8$export$442f1a04865e4790.Konva !== 'undefined') console.error('Several Konva instances detected. It is not recommended to use multiple Konva instances in the same environment.');
        $8c8384c27430fce8$export$442f1a04865e4790.Konva = Konva;
    }
};
const $8c8384c27430fce8$export$f7a70d87a5e829eb = (NodeClass)=>{
    $8c8384c27430fce8$export$b9f99057a3c7692[NodeClass.prototype.getClassName()] = NodeClass;
};
$8c8384c27430fce8$export$b9f99057a3c7692._injectGlobal($8c8384c27430fce8$export$b9f99057a3c7692);



const $d4400dec7c2a8326$var$NODE_ERROR = `Konva.js unsupported environment.

Looks like you are trying to use Konva.js in Node.js environment. because "document" object is undefined.

To use Konva.js in Node.js environment, you need to use the "canvas-backend" or "skia-backend" module.

bash: npm install canvas
js: import "konva/canvas-backend";

or

bash: npm install skia-canvas
js: import "konva/skia-backend";
`;
const $d4400dec7c2a8326$var$ensureBrowser = ()=>{
    if (typeof document === 'undefined') throw new Error($d4400dec7c2a8326$var$NODE_ERROR);
};
class $d4400dec7c2a8326$export$563a914cafbdc389 {
    constructor(m = [
        1,
        0,
        0,
        1,
        0,
        0
    ]){
        this.dirty = false;
        this.m = m && m.slice() || [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    reset() {
        this.m[0] = 1;
        this.m[1] = 0;
        this.m[2] = 0;
        this.m[3] = 1;
        this.m[4] = 0;
        this.m[5] = 0;
    }
    copy() {
        return new $d4400dec7c2a8326$export$563a914cafbdc389(this.m);
    }
    copyInto(tr) {
        tr.m[0] = this.m[0];
        tr.m[1] = this.m[1];
        tr.m[2] = this.m[2];
        tr.m[3] = this.m[3];
        tr.m[4] = this.m[4];
        tr.m[5] = this.m[5];
    }
    point(point) {
        const m = this.m;
        return {
            x: m[0] * point.x + m[2] * point.y + m[4],
            y: m[1] * point.x + m[3] * point.y + m[5]
        };
    }
    translate(x, y) {
        this.m[4] += this.m[0] * x + this.m[2] * y;
        this.m[5] += this.m[1] * x + this.m[3] * y;
        return this;
    }
    scale(sx, sy) {
        this.m[0] *= sx;
        this.m[1] *= sx;
        this.m[2] *= sy;
        this.m[3] *= sy;
        return this;
    }
    rotate(rad) {
        const c = Math.cos(rad);
        const s = Math.sin(rad);
        const m11 = this.m[0] * c + this.m[2] * s;
        const m12 = this.m[1] * c + this.m[3] * s;
        const m21 = this.m[0] * -s + this.m[2] * c;
        const m22 = this.m[1] * -s + this.m[3] * c;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    getTranslation() {
        return {
            x: this.m[4],
            y: this.m[5]
        };
    }
    skew(sx, sy) {
        const m11 = this.m[0] + this.m[2] * sy;
        const m12 = this.m[1] + this.m[3] * sy;
        const m21 = this.m[2] + this.m[0] * sx;
        const m22 = this.m[3] + this.m[1] * sx;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    multiply(matrix) {
        const m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
        const m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
        const m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
        const m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
        const dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
        const dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        this.m[4] = dx;
        this.m[5] = dy;
        return this;
    }
    invert() {
        const d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
        const m0 = this.m[3] * d;
        const m1 = -this.m[1] * d;
        const m2 = -this.m[2] * d;
        const m3 = this.m[0] * d;
        const m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
        const m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        this.m[0] = m0;
        this.m[1] = m1;
        this.m[2] = m2;
        this.m[3] = m3;
        this.m[4] = m4;
        this.m[5] = m5;
        return this;
    }
    getMatrix() {
        return this.m;
    }
    decompose() {
        const a = this.m[0];
        const b = this.m[1];
        const c = this.m[2];
        const d = this.m[3];
        const e = this.m[4];
        const f = this.m[5];
        const delta = a * d - b * c;
        const result = {
            x: e,
            y: f,
            rotation: 0,
            scaleX: 0,
            scaleY: 0,
            skewX: 0,
            skewY: 0
        };
        if (a != 0 || b != 0) {
            const r = Math.sqrt(a * a + b * b);
            result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
            result.scaleX = r;
            result.scaleY = delta / r;
            result.skewX = (a * c + b * d) / delta;
            result.skewY = 0;
        } else if (c != 0 || d != 0) {
            const s = Math.sqrt(c * c + d * d);
            result.rotation = Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
            result.scaleX = delta / s;
            result.scaleY = s;
            result.skewX = 0;
            result.skewY = (a * c + b * d) / delta;
        }
        result.rotation = $d4400dec7c2a8326$export$f8f26dd395d7e1bd._getRotation(result.rotation);
        return result;
    }
}
const $d4400dec7c2a8326$var$OBJECT_ARRAY = '[object Array]', $d4400dec7c2a8326$var$OBJECT_NUMBER = '[object Number]', $d4400dec7c2a8326$var$OBJECT_STRING = '[object String]', $d4400dec7c2a8326$var$OBJECT_BOOLEAN = '[object Boolean]', $d4400dec7c2a8326$var$PI_OVER_DEG180 = Math.PI / 180, $d4400dec7c2a8326$var$DEG180_OVER_PI = 180 / Math.PI, $d4400dec7c2a8326$var$HASH = '#', $d4400dec7c2a8326$var$EMPTY_STRING = '', $d4400dec7c2a8326$var$ZERO = '0', $d4400dec7c2a8326$var$KONVA_WARNING = 'Konva warning: ', $d4400dec7c2a8326$var$KONVA_ERROR = 'Konva error: ', $d4400dec7c2a8326$var$RGB_PAREN = 'rgb(', $d4400dec7c2a8326$var$COLORS = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        132,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        255,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        203
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        119,
        128,
        144
    ],
    slategrey: [
        119,
        128,
        144
    ],
    snow: [
        255,
        255,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    transparent: [
        255,
        255,
        255,
        0
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        5
    ]
}, $d4400dec7c2a8326$var$RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/;
let $d4400dec7c2a8326$var$animQueue = [];
let $d4400dec7c2a8326$var$_isCanvasFarblingActive = null;
const $d4400dec7c2a8326$var$req = typeof requestAnimationFrame !== 'undefined' && requestAnimationFrame || function(f) {
    setTimeout(f, 60);
};
const $d4400dec7c2a8326$export$f8f26dd395d7e1bd = {
    _isElement (obj) {
        return !!(obj && obj.nodeType == 1);
    },
    _isFunction (obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    },
    _isPlainObject (obj) {
        return !!obj && obj.constructor === Object;
    },
    _isArray (obj) {
        return Object.prototype.toString.call(obj) === $d4400dec7c2a8326$var$OBJECT_ARRAY;
    },
    _isNumber (obj) {
        return Object.prototype.toString.call(obj) === $d4400dec7c2a8326$var$OBJECT_NUMBER && !isNaN(obj) && isFinite(obj);
    },
    _isString (obj) {
        return Object.prototype.toString.call(obj) === $d4400dec7c2a8326$var$OBJECT_STRING;
    },
    _isBoolean (obj) {
        return Object.prototype.toString.call(obj) === $d4400dec7c2a8326$var$OBJECT_BOOLEAN;
    },
    isObject (val) {
        return val instanceof Object;
    },
    isValidSelector (selector) {
        if (typeof selector !== 'string') return false;
        const firstChar = selector[0];
        return firstChar === '#' || firstChar === '.' || firstChar === firstChar.toUpperCase();
    },
    _sign (number) {
        if (number === 0) return 1;
        if (number > 0) return 1;
        else return -1;
    },
    requestAnimFrame (callback) {
        $d4400dec7c2a8326$var$animQueue.push(callback);
        if ($d4400dec7c2a8326$var$animQueue.length === 1) $d4400dec7c2a8326$var$req(function() {
            const queue = $d4400dec7c2a8326$var$animQueue;
            $d4400dec7c2a8326$var$animQueue = [];
            queue.forEach(function(cb) {
                cb();
            });
        });
    },
    createCanvasElement () {
        $d4400dec7c2a8326$var$ensureBrowser();
        const canvas = document.createElement('canvas');
        try {
            canvas.style = canvas.style || {};
        } catch (e) {}
        return canvas;
    },
    createImageElement () {
        $d4400dec7c2a8326$var$ensureBrowser();
        return document.createElement('img');
    },
    _isInDocument (el) {
        while(el = el.parentNode){
            if (el == document) return true;
        }
        return false;
    },
    _urlToImage (url, callback) {
        const imageObj = $d4400dec7c2a8326$export$f8f26dd395d7e1bd.createImageElement();
        imageObj.onload = function() {
            callback(imageObj);
        };
        imageObj.src = url;
    },
    _rgbToHex (r, g, b) {
        return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    _hexToRgb (hex) {
        hex = hex.replace($d4400dec7c2a8326$var$HASH, $d4400dec7c2a8326$var$EMPTY_STRING);
        const bigint = parseInt(hex, 16);
        return {
            r: bigint >> 16 & 255,
            g: bigint >> 8 & 255,
            b: bigint & 255
        };
    },
    getRandomColor () {
        let randColor = (Math.random() * 0xffffff << 0).toString(16);
        while(randColor.length < 6)randColor = $d4400dec7c2a8326$var$ZERO + randColor;
        return $d4400dec7c2a8326$var$HASH + randColor;
    },
    isCanvasFarblingActive () {
        if ($d4400dec7c2a8326$var$_isCanvasFarblingActive !== null) return $d4400dec7c2a8326$var$_isCanvasFarblingActive;
        if (typeof document === 'undefined') {
            $d4400dec7c2a8326$var$_isCanvasFarblingActive = false;
            return false;
        }
        const c = this.createCanvasElement();
        c.width = 10;
        c.height = 10;
        const ctx = c.getContext('2d', {
            willReadFrequently: true
        });
        ctx.clearRect(0, 0, 10, 10);
        ctx.fillStyle = '#282828';
        ctx.fillRect(0, 0, 10, 10);
        const d = ctx.getImageData(0, 0, 10, 10).data;
        let isFarbling = false;
        for(let i = 0; i < 100; i++)if (d[i * 4] !== 40 || d[i * 4 + 1] !== 40 || d[i * 4 + 2] !== 40 || d[i * 4 + 3] !== 255) {
            isFarbling = true;
            break;
        }
        $d4400dec7c2a8326$var$_isCanvasFarblingActive = isFarbling;
        this.releaseCanvas(c);
        return $d4400dec7c2a8326$var$_isCanvasFarblingActive;
    },
    getHitColor () {
        const color = this.getRandomColor();
        return this.isCanvasFarblingActive() ? this.getSnappedHexColor(color) : color;
    },
    getHitColorKey (r, g, b) {
        if (this.isCanvasFarblingActive()) {
            r = Math.round(r / 5) * 5;
            g = Math.round(g / 5) * 5;
            b = Math.round(b / 5) * 5;
        }
        return $d4400dec7c2a8326$var$HASH + this._rgbToHex(r, g, b);
    },
    getSnappedHexColor (hex) {
        const rgb = this._hexToRgb(hex);
        return $d4400dec7c2a8326$var$HASH + this._rgbToHex(Math.round(rgb.r / 5) * 5, Math.round(rgb.g / 5) * 5, Math.round(rgb.b / 5) * 5);
    },
    getRGB (color) {
        let rgb;
        if (color in $d4400dec7c2a8326$var$COLORS) {
            rgb = $d4400dec7c2a8326$var$COLORS[color];
            return {
                r: rgb[0],
                g: rgb[1],
                b: rgb[2]
            };
        } else if (color[0] === $d4400dec7c2a8326$var$HASH) return this._hexToRgb(color.substring(1));
        else if (color.substr(0, 4) === $d4400dec7c2a8326$var$RGB_PAREN) {
            rgb = $d4400dec7c2a8326$var$RGB_REGEX.exec(color.replace(/ /g, ''));
            return {
                r: parseInt(rgb[1], 10),
                g: parseInt(rgb[2], 10),
                b: parseInt(rgb[3], 10)
            };
        } else return {
            r: 0,
            g: 0,
            b: 0
        };
    },
    colorToRGBA (str) {
        str = str || 'black';
        return $d4400dec7c2a8326$export$f8f26dd395d7e1bd._namedColorToRBA(str) || $d4400dec7c2a8326$export$f8f26dd395d7e1bd._hex3ColorToRGBA(str) || $d4400dec7c2a8326$export$f8f26dd395d7e1bd._hex4ColorToRGBA(str) || $d4400dec7c2a8326$export$f8f26dd395d7e1bd._hex6ColorToRGBA(str) || $d4400dec7c2a8326$export$f8f26dd395d7e1bd._hex8ColorToRGBA(str) || $d4400dec7c2a8326$export$f8f26dd395d7e1bd._rgbColorToRGBA(str) || $d4400dec7c2a8326$export$f8f26dd395d7e1bd._rgbaColorToRGBA(str) || $d4400dec7c2a8326$export$f8f26dd395d7e1bd._hslColorToRGBA(str);
    },
    _namedColorToRBA (str) {
        const c = $d4400dec7c2a8326$var$COLORS[str.toLowerCase()];
        if (!c) return null;
        return {
            r: c[0],
            g: c[1],
            b: c[2],
            a: 1
        };
    },
    _rgbColorToRGBA (str) {
        if (str.indexOf('rgb(') === 0) {
            str = str.match(/rgb\(([^)]+)\)/)[1];
            const parts = str.split(/ *, */).map(Number);
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: 1
            };
        }
    },
    _rgbaColorToRGBA (str) {
        if (str.indexOf('rgba(') === 0) {
            str = str.match(/rgba\(([^)]+)\)/)[1];
            const parts = str.split(/ *, */).map((n, index)=>{
                if (n.slice(-1) === '%') return index === 3 ? parseInt(n) / 100 : parseInt(n) / 100 * 255;
                return Number(n);
            });
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: parts[3]
            };
        }
    },
    _hex8ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 9) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: parseInt(str.slice(7, 9), 16) / 0xff
        };
    },
    _hex6ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 7) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: 1
        };
    },
    _hex4ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 5) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: parseInt(str[4] + str[4], 16) / 0xff
        };
    },
    _hex3ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 4) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: 1
        };
    },
    _hslColorToRGBA (str) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(str)) {
            const [_, ...hsl] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(str);
            const h = Number(hsl[0]) / 360;
            const s = Number(hsl[1]) / 100;
            const l = Number(hsl[2]) / 100;
            let t2;
            let t3;
            let val;
            if (s === 0) {
                val = l * 255;
                return {
                    r: Math.round(val),
                    g: Math.round(val),
                    b: Math.round(val),
                    a: 1
                };
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            const t1 = 2 * l - t2;
            const rgb = [
                0,
                0,
                0
            ];
            for(let i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return {
                r: Math.round(rgb[0]),
                g: Math.round(rgb[1]),
                b: Math.round(rgb[2]),
                a: 1
            };
        }
    },
    haveIntersection (r1, r2) {
        return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.height || r2.y + r2.height < r1.y);
    },
    cloneObject (obj) {
        const retObj = {};
        for(const key in obj){
            if (this._isPlainObject(obj[key])) retObj[key] = this.cloneObject(obj[key]);
            else if (this._isArray(obj[key])) retObj[key] = this.cloneArray(obj[key]);
            else retObj[key] = obj[key];
        }
        return retObj;
    },
    cloneArray (arr) {
        return arr.slice(0);
    },
    degToRad (deg) {
        return deg * $d4400dec7c2a8326$var$PI_OVER_DEG180;
    },
    radToDeg (rad) {
        return rad * $d4400dec7c2a8326$var$DEG180_OVER_PI;
    },
    _degToRad (deg) {
        $d4400dec7c2a8326$export$f8f26dd395d7e1bd.warn('Util._degToRad is removed. Please use public Util.degToRad instead.');
        return $d4400dec7c2a8326$export$f8f26dd395d7e1bd.degToRad(deg);
    },
    _radToDeg (rad) {
        $d4400dec7c2a8326$export$f8f26dd395d7e1bd.warn('Util._radToDeg is removed. Please use public Util.radToDeg instead.');
        return $d4400dec7c2a8326$export$f8f26dd395d7e1bd.radToDeg(rad);
    },
    _getRotation (radians) {
        return (0, $8c8384c27430fce8$export$b9f99057a3c7692).angleDeg ? $d4400dec7c2a8326$export$f8f26dd395d7e1bd.radToDeg(radians) : radians;
    },
    _capitalize (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    throw (str) {
        throw new Error($d4400dec7c2a8326$var$KONVA_ERROR + str);
    },
    error (str) {
        console.error($d4400dec7c2a8326$var$KONVA_ERROR + str);
    },
    warn (str) {
        if (!(0, $8c8384c27430fce8$export$b9f99057a3c7692).showWarnings) return;
        console.warn($d4400dec7c2a8326$var$KONVA_WARNING + str);
    },
    each (obj, func) {
        for(const key in obj)func(key, obj[key]);
    },
    _inRange (val, left, right) {
        return left <= val && val < right;
    },
    _getProjectionToSegment (x1, y1, x2, y2, x3, y3) {
        let x, y, dist;
        const pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
        if (pd2 == 0) {
            x = x1;
            y = y1;
            dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
        } else {
            const u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
            if (u < 0) {
                x = x1;
                y = y1;
                dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
            } else if (u > 1.0) {
                x = x2;
                y = y2;
                dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
            } else {
                x = x1 + u * (x2 - x1);
                y = y1 + u * (y2 - y1);
                dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
            }
        }
        return [
            x,
            y,
            dist
        ];
    },
    _getProjectionToLine (pt, line, isClosed) {
        const pc = $d4400dec7c2a8326$export$f8f26dd395d7e1bd.cloneObject(pt);
        let dist = Number.MAX_VALUE;
        line.forEach(function(p1, i) {
            if (!isClosed && i === line.length - 1) return;
            const p2 = line[(i + 1) % line.length];
            const proj = $d4400dec7c2a8326$export$f8f26dd395d7e1bd._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
            const px = proj[0], py = proj[1], pdist = proj[2];
            if (pdist < dist) {
                pc.x = px;
                pc.y = py;
                dist = pdist;
            }
        });
        return pc;
    },
    _prepareArrayForTween (startArray, endArray, isClosed) {
        const start = [], end = [];
        if (startArray.length > endArray.length) {
            const temp = endArray;
            endArray = startArray;
            startArray = temp;
        }
        for(let n = 0; n < startArray.length; n += 2)start.push({
            x: startArray[n],
            y: startArray[n + 1]
        });
        for(let n = 0; n < endArray.length; n += 2)end.push({
            x: endArray[n],
            y: endArray[n + 1]
        });
        const newStart = [];
        end.forEach(function(point) {
            const pr = $d4400dec7c2a8326$export$f8f26dd395d7e1bd._getProjectionToLine(point, start, isClosed);
            newStart.push(pr.x);
            newStart.push(pr.y);
        });
        return newStart;
    },
    _prepareToStringify (obj) {
        let desc;
        obj.visitedByCircularReferenceRemoval = true;
        for(const key in obj){
            if (!(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == 'object')) continue;
            desc = Object.getOwnPropertyDescriptor(obj, key);
            if (obj[key].visitedByCircularReferenceRemoval || $d4400dec7c2a8326$export$f8f26dd395d7e1bd._isElement(obj[key])) {
                if (desc.configurable) delete obj[key];
                else return null;
            } else if ($d4400dec7c2a8326$export$f8f26dd395d7e1bd._prepareToStringify(obj[key]) === null) {
                if (desc.configurable) delete obj[key];
                else return null;
            }
        }
        delete obj.visitedByCircularReferenceRemoval;
        return obj;
    },
    _assign (target, source) {
        for(const key in source)target[key] = source[key];
        return target;
    },
    _getFirstPointerId (evt) {
        if (!evt.touches) return evt.pointerId || 999;
        else return evt.changedTouches[0].identifier;
    },
    releaseCanvas (...canvases) {
        if (!(0, $8c8384c27430fce8$export$b9f99057a3c7692).releaseCanvasOnDestroy) return;
        canvases.forEach((c)=>{
            c.width = 0;
            c.height = 0;
        });
    },
    drawRoundedRectPath (context, width, height, cornerRadius) {
        let xOrigin = width < 0 ? width : 0;
        let yOrigin = height < 0 ? height : 0;
        width = Math.abs(width);
        height = Math.abs(height);
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === 'number') topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.moveTo(xOrigin + topLeft, yOrigin);
        context.lineTo(xOrigin + width - topRight, yOrigin);
        context.arc(xOrigin + width - topRight, yOrigin + topRight, topRight, Math.PI * 3 / 2, 0, false);
        context.lineTo(xOrigin + width, yOrigin + height - bottomRight);
        context.arc(xOrigin + width - bottomRight, yOrigin + height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        context.lineTo(xOrigin + bottomLeft, yOrigin + height);
        context.arc(xOrigin + bottomLeft, yOrigin + height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        context.lineTo(xOrigin, yOrigin + topLeft);
        context.arc(xOrigin + topLeft, yOrigin + topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
    },
    drawRoundedPolygonPath (context, points, sides, radius, cornerRadius) {
        radius = Math.abs(radius);
        for(let i = 0; i < sides; i++){
            const prev = points[(i - 1 + sides) % sides];
            const curr = points[i];
            const next = points[(i + 1) % sides];
            const vec1 = {
                x: curr.x - prev.x,
                y: curr.y - prev.y
            };
            const vec2 = {
                x: next.x - curr.x,
                y: next.y - curr.y
            };
            const len1 = Math.hypot(vec1.x, vec1.y);
            const len2 = Math.hypot(vec2.x, vec2.y);
            let currCornerRadius;
            if (typeof cornerRadius === 'number') currCornerRadius = cornerRadius;
            else currCornerRadius = i < cornerRadius.length ? cornerRadius[i] : 0;
            const maxCornerRadius = radius * Math.cos(Math.PI / sides);
            currCornerRadius = maxCornerRadius * Math.min(1, currCornerRadius / radius * 2);
            const normalVec1 = {
                x: vec1.x / len1,
                y: vec1.y / len1
            };
            const normalVec2 = {
                x: vec2.x / len2,
                y: vec2.y / len2
            };
            const p1 = {
                x: curr.x - normalVec1.x * currCornerRadius,
                y: curr.y - normalVec1.y * currCornerRadius
            };
            const p2 = {
                x: curr.x + normalVec2.x * currCornerRadius,
                y: curr.y + normalVec2.y * currCornerRadius
            };
            if (i === 0) context.moveTo(p1.x, p1.y);
            else context.lineTo(p1.x, p1.y);
            context.arcTo(curr.x, curr.y, p2.x, p2.y, currCornerRadius);
        }
    }
};





function $02f524f4df5fe352$var$simplifyArray(arr) {
    const retArr = [], len = arr.length, util = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd);
    for(let n = 0; n < len; n++){
        let val = arr[n];
        if (util._isNumber(val)) val = Math.round(val * 1000) / 1000;
        else if (!util._isString(val)) val = val + '';
        retArr.push(val);
    }
    return retArr;
}
const $02f524f4df5fe352$var$COMMA = ',', $02f524f4df5fe352$var$OPEN_PAREN = '(', $02f524f4df5fe352$var$CLOSE_PAREN = ')', $02f524f4df5fe352$var$OPEN_PAREN_BRACKET = '([', $02f524f4df5fe352$var$CLOSE_BRACKET_PAREN = '])', $02f524f4df5fe352$var$SEMICOLON = ';', $02f524f4df5fe352$var$DOUBLE_PAREN = '()', $02f524f4df5fe352$var$EQUALS = '=', $02f524f4df5fe352$var$CONTEXT_METHODS = [
    'arc',
    'arcTo',
    'beginPath',
    'bezierCurveTo',
    'clearRect',
    'clip',
    'closePath',
    'createLinearGradient',
    'createPattern',
    'createRadialGradient',
    'drawImage',
    'ellipse',
    'fill',
    'fillText',
    'getImageData',
    'createImageData',
    'lineTo',
    'moveTo',
    'putImageData',
    'quadraticCurveTo',
    'rect',
    'roundRect',
    'restore',
    'rotate',
    'save',
    'scale',
    'setLineDash',
    'setTransform',
    'stroke',
    'strokeText',
    'transform',
    'translate'
];
const $02f524f4df5fe352$var$CONTEXT_PROPERTIES = [
    'fillStyle',
    'strokeStyle',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'letterSpacing',
    'lineCap',
    'lineDashOffset',
    'lineJoin',
    'lineWidth',
    'miterLimit',
    'direction',
    'font',
    'textAlign',
    'textBaseline',
    'globalAlpha',
    'globalCompositeOperation',
    'imageSmoothingEnabled',
    'filter'
];
const $02f524f4df5fe352$var$traceArrMax = 100;
let $02f524f4df5fe352$var$_cssFiltersSupported = null;
function $02f524f4df5fe352$export$887ce9926cc3f80f() {
    if ($02f524f4df5fe352$var$_cssFiltersSupported !== null) return $02f524f4df5fe352$var$_cssFiltersSupported;
    try {
        const canvas = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).createCanvasElement();
        const ctx = canvas.getContext('2d');
        if (!ctx) {
            $02f524f4df5fe352$var$_cssFiltersSupported = false;
            return false;
        }
        return !!ctx && 'filter' in ctx;
    } catch (e) {
        $02f524f4df5fe352$var$_cssFiltersSupported = false;
        return false;
    }
}
class $02f524f4df5fe352$export$841858b892ce1f4c {
    constructor(canvas){
        this.canvas = canvas;
        if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).enableTrace) {
            this.traceArr = [];
            this._enableTrace();
        }
    }
    fillShape(shape) {
        if (shape.fillEnabled()) this._fill(shape);
    }
    _fill(shape) {}
    strokeShape(shape) {
        if (shape.hasStroke()) this._stroke(shape);
    }
    _stroke(shape) {}
    fillStrokeShape(shape) {
        if (shape.attrs.fillAfterStrokeEnabled) {
            this.strokeShape(shape);
            this.fillShape(shape);
        } else {
            this.fillShape(shape);
            this.strokeShape(shape);
        }
    }
    getTrace(relaxed, rounded) {
        let traceArr = this.traceArr, len = traceArr.length, str = '', n, trace, method, args;
        for(n = 0; n < len; n++){
            trace = traceArr[n];
            method = trace.method;
            if (method) {
                args = trace.args;
                str += method;
                if (relaxed) str += $02f524f4df5fe352$var$DOUBLE_PAREN;
                else if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isArray(args[0])) str += $02f524f4df5fe352$var$OPEN_PAREN_BRACKET + args.join($02f524f4df5fe352$var$COMMA) + $02f524f4df5fe352$var$CLOSE_BRACKET_PAREN;
                else {
                    if (rounded) args = args.map((a)=>typeof a === 'number' ? Math.floor(a) : a);
                    str += $02f524f4df5fe352$var$OPEN_PAREN + args.join($02f524f4df5fe352$var$COMMA) + $02f524f4df5fe352$var$CLOSE_PAREN;
                }
            } else {
                str += trace.property;
                if (!relaxed) str += $02f524f4df5fe352$var$EQUALS + trace.val;
            }
            str += $02f524f4df5fe352$var$SEMICOLON;
        }
        return str;
    }
    clearTrace() {
        this.traceArr = [];
    }
    _trace(str) {
        let traceArr = this.traceArr, len;
        traceArr.push(str);
        len = traceArr.length;
        if (len >= $02f524f4df5fe352$var$traceArrMax) traceArr.shift();
    }
    reset() {
        const pixelRatio = this.getCanvas().getPixelRatio();
        this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
    }
    getCanvas() {
        return this.canvas;
    }
    clear(bounds) {
        const canvas = this.getCanvas();
        if (bounds) this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
        else this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
    }
    _applyLineCap(shape) {
        const lineCap = shape.attrs.lineCap;
        if (lineCap) this.setAttr('lineCap', lineCap);
    }
    _applyOpacity(shape) {
        const absOpacity = shape.getAbsoluteOpacity();
        if (absOpacity !== 1) this.setAttr('globalAlpha', absOpacity);
    }
    _applyLineJoin(shape) {
        const lineJoin = shape.attrs.lineJoin;
        if (lineJoin) this.setAttr('lineJoin', lineJoin);
    }
    _applyMiterLimit(shape) {
        const miterLimit = shape.attrs.miterLimit;
        if (miterLimit != null) this.setAttr('miterLimit', miterLimit);
    }
    setAttr(attr, val) {
        this._context[attr] = val;
    }
    arc(x, y, radius, startAngle, endAngle, counterClockwise) {
        this._context.arc(x, y, radius, startAngle, endAngle, counterClockwise);
    }
    arcTo(x1, y1, x2, y2, radius) {
        this._context.arcTo(x1, y1, x2, y2, radius);
    }
    beginPath() {
        this._context.beginPath();
    }
    bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
        this._context.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
    }
    clearRect(x, y, width, height) {
        this._context.clearRect(x, y, width, height);
    }
    clip(...args) {
        this._context.clip.apply(this._context, args);
    }
    closePath() {
        this._context.closePath();
    }
    createImageData(width, height) {
        const a = arguments;
        if (a.length === 2) return this._context.createImageData(width, height);
        else if (a.length === 1) return this._context.createImageData(width);
    }
    createLinearGradient(x0, y0, x1, y1) {
        return this._context.createLinearGradient(x0, y0, x1, y1);
    }
    createPattern(image, repetition) {
        return this._context.createPattern(image, repetition);
    }
    createRadialGradient(x0, y0, r0, x1, y1, r1) {
        return this._context.createRadialGradient(x0, y0, r0, x1, y1, r1);
    }
    drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight) {
        const a = arguments, _context = this._context;
        if (a.length === 3) _context.drawImage(image, sx, sy);
        else if (a.length === 5) _context.drawImage(image, sx, sy, sWidth, sHeight);
        else if (a.length === 9) _context.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
    }
    ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise) {
        this._context.ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise);
    }
    isPointInPath(x, y, path, fillRule) {
        if (path) return this._context.isPointInPath(path, x, y, fillRule);
        return this._context.isPointInPath(x, y, fillRule);
    }
    fill(...args) {
        this._context.fill.apply(this._context, args);
    }
    fillRect(x, y, width, height) {
        this._context.fillRect(x, y, width, height);
    }
    strokeRect(x, y, width, height) {
        this._context.strokeRect(x, y, width, height);
    }
    fillText(text, x, y, maxWidth) {
        if (maxWidth) this._context.fillText(text, x, y, maxWidth);
        else this._context.fillText(text, x, y);
    }
    measureText(text) {
        return this._context.measureText(text);
    }
    getImageData(sx, sy, sw, sh) {
        return this._context.getImageData(sx, sy, sw, sh);
    }
    lineTo(x, y) {
        this._context.lineTo(x, y);
    }
    moveTo(x, y) {
        this._context.moveTo(x, y);
    }
    rect(x, y, width, height) {
        this._context.rect(x, y, width, height);
    }
    roundRect(x, y, width, height, radii) {
        this._context.roundRect(x, y, width, height, radii);
    }
    putImageData(imageData, dx, dy) {
        this._context.putImageData(imageData, dx, dy);
    }
    quadraticCurveTo(cpx, cpy, x, y) {
        this._context.quadraticCurveTo(cpx, cpy, x, y);
    }
    restore() {
        this._context.restore();
    }
    rotate(angle) {
        this._context.rotate(angle);
    }
    save() {
        this._context.save();
    }
    scale(x, y) {
        this._context.scale(x, y);
    }
    setLineDash(segments) {
        if (this._context.setLineDash) this._context.setLineDash(segments);
        else if ('mozDash' in this._context) this._context['mozDash'] = segments;
        else if ('webkitLineDash' in this._context) this._context['webkitLineDash'] = segments;
    }
    getLineDash() {
        return this._context.getLineDash();
    }
    setTransform(a, b, c, d, e, f) {
        this._context.setTransform(a, b, c, d, e, f);
    }
    stroke(path2d) {
        if (path2d) this._context.stroke(path2d);
        else this._context.stroke();
    }
    strokeText(text, x, y, maxWidth) {
        this._context.strokeText(text, x, y, maxWidth);
    }
    transform(a, b, c, d, e, f) {
        this._context.transform(a, b, c, d, e, f);
    }
    translate(x, y) {
        this._context.translate(x, y);
    }
    _enableTrace() {
        let that = this, len = $02f524f4df5fe352$var$CONTEXT_METHODS.length, origSetter = this.setAttr, n, args;
        const func = function(methodName) {
            let origMethod = that[methodName], ret;
            that[methodName] = function() {
                args = $02f524f4df5fe352$var$simplifyArray(Array.prototype.slice.call(arguments, 0));
                ret = origMethod.apply(that, arguments);
                that._trace({
                    method: methodName,
                    args: args
                });
                return ret;
            };
        };
        for(n = 0; n < len; n++)func($02f524f4df5fe352$var$CONTEXT_METHODS[n]);
        that.setAttr = function() {
            origSetter.apply(that, arguments);
            const prop = arguments[0];
            let val = arguments[1];
            if (prop === 'shadowOffsetX' || prop === 'shadowOffsetY' || prop === 'shadowBlur') val = val / this.canvas.getPixelRatio();
            that._trace({
                property: prop,
                val: val
            });
        };
    }
    _applyGlobalCompositeOperation(node) {
        const op = node.attrs.globalCompositeOperation;
        const def = !op || op === 'source-over';
        if (!def) this.setAttr('globalCompositeOperation', op);
    }
}
$02f524f4df5fe352$var$CONTEXT_PROPERTIES.forEach(function(prop) {
    Object.defineProperty($02f524f4df5fe352$export$841858b892ce1f4c.prototype, prop, {
        get () {
            return this._context[prop];
        },
        set (val) {
            this._context[prop] = val;
        }
    });
});
class $02f524f4df5fe352$export$576380cfa99ddf20 extends $02f524f4df5fe352$export$841858b892ce1f4c {
    constructor(canvas, { willReadFrequently: willReadFrequently = false } = {}){
        super(canvas);
        this._context = canvas._canvas.getContext('2d', {
            willReadFrequently: willReadFrequently
        });
    }
    _fillColor(shape) {
        const fill = shape.fill();
        this.setAttr('fillStyle', fill);
        shape._fillFunc(this);
    }
    _fillPattern(shape) {
        this.setAttr('fillStyle', shape._getFillPattern());
        shape._fillFunc(this);
    }
    _fillLinearGradient(shape) {
        const grd = shape._getLinearGradient();
        if (grd) {
            this.setAttr('fillStyle', grd);
            shape._fillFunc(this);
        }
    }
    _fillRadialGradient(shape) {
        const grd = shape._getRadialGradient();
        if (grd) {
            this.setAttr('fillStyle', grd);
            shape._fillFunc(this);
        }
    }
    _fill(shape) {
        const hasColor = shape.fill(), fillPriority = shape.getFillPriority();
        if (hasColor && fillPriority === 'color') {
            this._fillColor(shape);
            return;
        }
        const hasPattern = shape.getFillPatternImage();
        if (hasPattern && fillPriority === 'pattern') {
            this._fillPattern(shape);
            return;
        }
        const hasLinearGradient = shape.getFillLinearGradientColorStops();
        if (hasLinearGradient && fillPriority === 'linear-gradient') {
            this._fillLinearGradient(shape);
            return;
        }
        const hasRadialGradient = shape.getFillRadialGradientColorStops();
        if (hasRadialGradient && fillPriority === 'radial-gradient') {
            this._fillRadialGradient(shape);
            return;
        }
        if (hasColor) this._fillColor(shape);
        else if (hasPattern) this._fillPattern(shape);
        else if (hasLinearGradient) this._fillLinearGradient(shape);
        else if (hasRadialGradient) this._fillRadialGradient(shape);
    }
    _strokeLinearGradient(shape) {
        const start = shape.getStrokeLinearGradientStartPoint(), end = shape.getStrokeLinearGradientEndPoint(), colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
        if (colorStops) {
            for(let n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            this.setAttr('strokeStyle', grd);
        }
    }
    _stroke(shape) {
        const dash = shape.dash(), strokeScaleEnabled = shape.getStrokeScaleEnabled();
        if (shape.hasStroke()) {
            if (!strokeScaleEnabled) {
                this.save();
                const pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            if (dash && shape.dashEnabled()) {
                this.setLineDash(dash);
                this.setAttr('lineDashOffset', shape.dashOffset());
            }
            this.setAttr('lineWidth', shape.strokeWidth());
            if (!shape.getShadowForStrokeEnabled()) this.setAttr('shadowColor', 'rgba(0,0,0,0)');
            const hasLinearGradient = shape.getStrokeLinearGradientColorStops();
            if (hasLinearGradient) this._strokeLinearGradient(shape);
            else this.setAttr('strokeStyle', shape.stroke());
            shape._strokeFunc(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
    _applyShadow(shape) {
        var _a, _b, _c;
        const color = (_a = shape.getShadowRGBA()) !== null && _a !== void 0 ? _a : 'black', blur = (_b = shape.getShadowBlur()) !== null && _b !== void 0 ? _b : 5, offset = (_c = shape.getShadowOffset()) !== null && _c !== void 0 ? _c : {
            x: 0,
            y: 0
        }, scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
        this.setAttr('shadowColor', color);
        this.setAttr('shadowBlur', blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
        this.setAttr('shadowOffsetX', offset.x * scaleX);
        this.setAttr('shadowOffsetY', offset.y * scaleY);
    }
}
class $02f524f4df5fe352$export$85eec7ef35542dce extends $02f524f4df5fe352$export$841858b892ce1f4c {
    constructor(canvas){
        super(canvas);
        this._context = canvas._canvas.getContext('2d', {
            willReadFrequently: true
        });
    }
    _fill(shape) {
        this.save();
        this.setAttr('fillStyle', shape.colorKey);
        shape._fillFuncHit(this);
        this.restore();
    }
    strokeShape(shape) {
        if (shape.hasHitStroke()) this._stroke(shape);
    }
    _stroke(shape) {
        if (shape.hasHitStroke()) {
            const strokeScaleEnabled = shape.getStrokeScaleEnabled();
            if (!strokeScaleEnabled) {
                this.save();
                const pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            const hitStrokeWidth = shape.hitStrokeWidth();
            const strokeWidth = hitStrokeWidth === 'auto' ? shape.strokeWidth() : hitStrokeWidth;
            this.setAttr('lineWidth', strokeWidth);
            this.setAttr('strokeStyle', shape.colorKey);
            shape._strokeFuncHit(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
}



let $94cf583ff38878f8$var$_pixelRatio;
function $94cf583ff38878f8$var$getDevicePixelRatio() {
    if ($94cf583ff38878f8$var$_pixelRatio) return $94cf583ff38878f8$var$_pixelRatio;
    const canvas = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).createCanvasElement();
    const context = canvas.getContext('2d');
    $94cf583ff38878f8$var$_pixelRatio = function() {
        const devicePixelRatio = (0, $8c8384c27430fce8$export$b9f99057a3c7692)._global.devicePixelRatio || 1, backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
        return devicePixelRatio / backingStoreRatio;
    }();
    (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).releaseCanvas(canvas);
    return $94cf583ff38878f8$var$_pixelRatio;
}
class $94cf583ff38878f8$export$8d01c972ee8b14a9 {
    constructor(config){
        this.pixelRatio = 1;
        this.width = 0;
        this.height = 0;
        this.isCache = false;
        const conf = config || {};
        const pixelRatio = conf.pixelRatio || (0, $8c8384c27430fce8$export$b9f99057a3c7692).pixelRatio || $94cf583ff38878f8$var$getDevicePixelRatio();
        this.pixelRatio = pixelRatio;
        this._canvas = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).createCanvasElement();
        this._canvas.style.padding = '0';
        this._canvas.style.margin = '0';
        this._canvas.style.border = '0';
        this._canvas.style.background = 'transparent';
        this._canvas.style.position = 'absolute';
        this._canvas.style.top = '0';
        this._canvas.style.left = '0';
    }
    getContext() {
        return this.context;
    }
    getPixelRatio() {
        return this.pixelRatio;
    }
    setPixelRatio(pixelRatio) {
        const previousRatio = this.pixelRatio;
        this.pixelRatio = pixelRatio;
        this.setSize(this.getWidth() / previousRatio, this.getHeight() / previousRatio);
    }
    setWidth(width) {
        this.width = this._canvas.width = width * this.pixelRatio;
        this._canvas.style.width = width + 'px';
        const pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    setHeight(height) {
        this.height = this._canvas.height = height * this.pixelRatio;
        this._canvas.style.height = height + 'px';
        const pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    setSize(width, height) {
        this.setWidth(width || 0);
        this.setHeight(height || 0);
    }
    toDataURL(mimeType, quality) {
        try {
            return this._canvas.toDataURL(mimeType, quality);
        } catch (e) {
            try {
                return this._canvas.toDataURL();
            } catch (err) {
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('Unable to get data URL. ' + err.message + ' For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.');
                return '';
            }
        }
    }
}
class $94cf583ff38878f8$export$ee612225bd2e63be extends $94cf583ff38878f8$export$8d01c972ee8b14a9 {
    constructor(config = {
        width: 0,
        height: 0,
        willReadFrequently: false
    }){
        super(config);
        this.context = new (0, $02f524f4df5fe352$export$576380cfa99ddf20)(this, {
            willReadFrequently: config.willReadFrequently
        });
        this.setSize(config.width, config.height);
    }
}
class $94cf583ff38878f8$export$43a2e1456e27dc84 extends $94cf583ff38878f8$export$8d01c972ee8b14a9 {
    constructor(config = {
        width: 0,
        height: 0
    }){
        super(config);
        this.hitCanvas = true;
        this.context = new (0, $02f524f4df5fe352$export$85eec7ef35542dce)(this);
        this.setSize(config.width, config.height);
    }
}





const $fa6dae8e3add958f$export$e34f1b340034d7f = {
    get isDragging () {
        let flag = false;
        $fa6dae8e3add958f$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            if (elem.dragStatus === 'dragging') flag = true;
        });
        return flag;
    },
    justDragged: false,
    get node () {
        let node;
        $fa6dae8e3add958f$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            node = elem.node;
        });
        return node;
    },
    _dragElements: new Map(),
    _drag (evt) {
        const nodesToFireEvents = [];
        $fa6dae8e3add958f$export$e34f1b340034d7f._dragElements.forEach((elem, key)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            stage.setPointersPositions(evt);
            if (elem.pointerId === undefined) elem.pointerId = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getFirstPointerId(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus !== 'dragging') {
                const dragDistance = node.dragDistance();
                const distance = Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y));
                if (distance < dragDistance) return;
                node.startDrag({
                    evt: evt
                });
                if (!node.isDragging()) return;
            }
            node._setDragPosition(evt, elem);
            nodesToFireEvents.push(node);
        });
        nodesToFireEvents.forEach((node)=>{
            node.fire('dragmove', {
                type: 'dragmove',
                target: node,
                evt: evt
            }, true);
        });
    },
    _endDragBefore (evt) {
        const drawNodes = [];
        $fa6dae8e3add958f$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            if (evt) stage.setPointersPositions(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus === 'dragging' || elem.dragStatus === 'stopped') {
                $fa6dae8e3add958f$export$e34f1b340034d7f.justDragged = true;
                (0, $8c8384c27430fce8$export$b9f99057a3c7692)._mouseListenClick = false;
                (0, $8c8384c27430fce8$export$b9f99057a3c7692)._touchListenClick = false;
                (0, $8c8384c27430fce8$export$b9f99057a3c7692)._pointerListenClick = false;
                elem.dragStatus = 'stopped';
            }
            const drawNode = elem.node.getLayer() || elem.node instanceof (0, $8c8384c27430fce8$export$b9f99057a3c7692)['Stage'] && elem.node;
            if (drawNode && drawNodes.indexOf(drawNode) === -1) drawNodes.push(drawNode);
        });
        drawNodes.forEach((drawNode)=>{
            drawNode.draw();
        });
    },
    _endDragAfter (evt) {
        $fa6dae8e3add958f$export$e34f1b340034d7f._dragElements.forEach((elem, key)=>{
            if (elem.dragStatus === 'stopped') elem.node.fire('dragend', {
                type: 'dragend',
                target: elem.node,
                evt: evt
            }, true);
            if (elem.dragStatus !== 'dragging') $fa6dae8e3add958f$export$e34f1b340034d7f._dragElements.delete(key);
        });
    }
};
if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isBrowser) {
    window.addEventListener('mouseup', $fa6dae8e3add958f$export$e34f1b340034d7f._endDragBefore, true);
    window.addEventListener('touchend', $fa6dae8e3add958f$export$e34f1b340034d7f._endDragBefore, true);
    window.addEventListener('touchcancel', $fa6dae8e3add958f$export$e34f1b340034d7f._endDragBefore, true);
    window.addEventListener('mousemove', $fa6dae8e3add958f$export$e34f1b340034d7f._drag);
    window.addEventListener('touchmove', $fa6dae8e3add958f$export$e34f1b340034d7f._drag);
    window.addEventListener('mouseup', $fa6dae8e3add958f$export$e34f1b340034d7f._endDragAfter, false);
    window.addEventListener('touchend', $fa6dae8e3add958f$export$e34f1b340034d7f._endDragAfter, false);
    window.addEventListener('touchcancel', $fa6dae8e3add958f$export$e34f1b340034d7f._endDragAfter, false);
}





function $d7c0e5ae0fe3f9a6$var$_formatValue(val) {
    if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isString(val)) return '"' + val + '"';
    if (Object.prototype.toString.call(val) === '[object Number]') return val;
    if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isBoolean(val)) return val;
    return Object.prototype.toString.call(val);
}
function $d7c0e5ae0fe3f9a6$export$af51e4581c640b27(val) {
    if (val > 255) return 255;
    else if (val < 0) return 0;
    return Math.round(val);
}
function $d7c0e5ae0fe3f9a6$export$7078afdc21938e7(val) {
    if (val > 1) return 1;
    else if (val < 0.0001) return 0.0001;
    return val;
}
function $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c() {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isNumber(val)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number.');
        return val;
    };
}
function $d7c0e5ae0fe3f9a6$export$7d4ab1842c1b264b(noOfElements) {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        let isNumber = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isNumber(val);
        let isValidArray = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isArray(val) && val.length == noOfElements;
        if (!isNumber && !isValidArray) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or Array<number>(' + noOfElements + ')');
        return val;
    };
}
function $d7c0e5ae0fe3f9a6$export$3b7df2720ef33404() {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const isNumber = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isNumber(val);
        const isAuto = val === 'auto';
        if (!(isNumber || isAuto)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or "auto".');
        return val;
    };
}
function $d7c0e5ae0fe3f9a6$export$5837c5b6cc5b4d63() {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isString(val)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string.');
        return val;
    };
}
function $d7c0e5ae0fe3f9a6$export$9c72f966a828cc68() {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const isString = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isString(val);
        const isGradient = Object.prototype.toString.call(val) === '[object CanvasGradient]' || val && val['addColorStop'];
        if (!(isString || isGradient)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string or a native gradient.');
        return val;
    };
}
function $d7c0e5ae0fe3f9a6$export$61d6863134de1cd() {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isFunction(val)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a function.');
        return val;
    };
}
function $d7c0e5ae0fe3f9a6$export$42b6f8f340e9a165() {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const TypedArray = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
        if (TypedArray && val instanceof TypedArray) return val;
        if (!(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isArray(val)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a array of numbers.');
        else val.forEach(function(item) {
            if (!(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isNumber(item)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('"' + attr + '" attribute has non numeric element ' + item + '. Make sure that all elements are numbers.');
        });
        return val;
    };
}
function $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1() {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const isBool = val === true || val === false;
        if (!isBool) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a boolean.');
        return val;
    };
}
function $d7c0e5ae0fe3f9a6$export$5c1978fb8431d4a1(components) {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (val === undefined || val === null) return val;
        if (!(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).isObject(val)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be an object with properties ' + components);
        return val;
    };
}


const $abe0ad8331aee635$var$GET = 'get';
const $abe0ad8331aee635$var$SET = 'set';
const $abe0ad8331aee635$export$8354032f3852ec50 = {
    addGetterSetter (constructor, attr, def, validator, after) {
        $abe0ad8331aee635$export$8354032f3852ec50.addGetter(constructor, attr, def);
        $abe0ad8331aee635$export$8354032f3852ec50.addSetter(constructor, attr, validator, after);
        $abe0ad8331aee635$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    addGetter (constructor, attr, def) {
        const method = $abe0ad8331aee635$var$GET + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(attr);
        constructor.prototype[method] = constructor.prototype[method] || function() {
            const val = this.attrs[attr];
            return val === undefined ? def : val;
        };
    },
    addSetter (constructor, attr, validator, after) {
        const method = $abe0ad8331aee635$var$SET + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(attr);
        if (!constructor.prototype[method]) $abe0ad8331aee635$export$8354032f3852ec50.overWriteSetter(constructor, attr, validator, after);
    },
    overWriteSetter (constructor, attr, validator, after) {
        const method = $abe0ad8331aee635$var$SET + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(attr);
        constructor.prototype[method] = function(val) {
            if (validator && val !== undefined && val !== null) val = validator.call(this, val, attr);
            this._setAttr(attr, val);
            if (after) after.call(this);
            return this;
        };
    },
    addComponentsGetterSetter (constructor, attr, components, validator, after) {
        const len = components.length, capitalize = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize, getter = $abe0ad8331aee635$var$GET + capitalize(attr), setter = $abe0ad8331aee635$var$SET + capitalize(attr);
        constructor.prototype[getter] = function() {
            const ret = {};
            for(let n = 0; n < len; n++){
                const component = components[n];
                ret[component] = this.getAttr(attr + capitalize(component));
            }
            return ret;
        };
        const basicValidator = (0, $d7c0e5ae0fe3f9a6$export$5c1978fb8431d4a1)(components);
        constructor.prototype[setter] = function(val) {
            const oldVal = this.attrs[attr];
            if (validator) val = validator.call(this, val, attr);
            if (basicValidator) basicValidator.call(this, val, attr);
            for(const key in val){
                if (!val.hasOwnProperty(key)) continue;
                this._setAttr(attr + capitalize(key), val[key]);
            }
            if (!val) components.forEach((component)=>{
                this._setAttr(attr + capitalize(component), undefined);
            });
            this._fireChangeEvent(attr, oldVal, val);
            if (after) after.call(this);
            return this;
        };
        $abe0ad8331aee635$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    addOverloadedGetterSetter (constructor, attr) {
        const capitalizedAttr = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(attr), setter = $abe0ad8331aee635$var$SET + capitalizedAttr, getter = $abe0ad8331aee635$var$GET + capitalizedAttr;
        constructor.prototype[attr] = function() {
            if (arguments.length) {
                this[setter](arguments[0]);
                return this;
            }
            return this[getter]();
        };
    },
    addDeprecatedGetterSetter (constructor, attr, def, validator) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('Adding deprecated ' + attr);
        const method = $abe0ad8331aee635$var$GET + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(attr);
        const message = attr + ' property is deprecated and will be removed soon. Look at Konva change log for more information.';
        constructor.prototype[method] = function() {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error(message);
            const val = this.attrs[attr];
            return val === undefined ? def : val;
        };
        $abe0ad8331aee635$export$8354032f3852ec50.addSetter(constructor, attr, validator, function() {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error(message);
        });
        $abe0ad8331aee635$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    backCompat (constructor, methods) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).each(methods, function(oldMethodName, newMethodName) {
            const method = constructor.prototype[newMethodName];
            const oldGetter = $abe0ad8331aee635$var$GET + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(oldMethodName);
            const oldSetter = $abe0ad8331aee635$var$SET + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(oldMethodName);
            function deprecated() {
                method.apply(this, arguments);
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('"' + oldMethodName + '" method is deprecated and will be removed soon. Use ""' + newMethodName + '" instead.');
            }
            constructor.prototype[oldMethodName] = deprecated;
            constructor.prototype[oldGetter] = deprecated;
            constructor.prototype[oldSetter] = deprecated;
        });
    },
    afterSetFilter () {
        this._filterUpToDate = false;
    }
};





function $367bbc8f6a40f243$var$parseCSSFilters(cssFilter) {
    const filterRegex = /(\w+)\(([^)]+)\)/g;
    let match;
    while((match = filterRegex.exec(cssFilter)) !== null){
        const [, filterName, filterValue] = match;
        switch(filterName){
            case 'blur':
                {
                    const blurRadius = parseFloat(filterValue.replace('px', ''));
                    return function(imageData) {
                        this.blurRadius(blurRadius * 0.5);
                        const KonvaFilters = (0, $8c8384c27430fce8$export$b9f99057a3c7692).Filters;
                        if (KonvaFilters && KonvaFilters.Blur) KonvaFilters.Blur.call(this, imageData);
                    };
                }
            case 'brightness':
                {
                    const brightness = filterValue.includes('%') ? parseFloat(filterValue) / 100 : parseFloat(filterValue);
                    return function(imageData) {
                        this.brightness(brightness);
                        const KonvaFilters = (0, $8c8384c27430fce8$export$b9f99057a3c7692).Filters;
                        if (KonvaFilters && KonvaFilters.Brightness) KonvaFilters.Brightness.call(this, imageData);
                    };
                }
            case 'contrast':
                {
                    const contrast = parseFloat(filterValue);
                    return function(imageData) {
                        const konvaContrast = 100 * (Math.sqrt(contrast) - 1);
                        this.contrast(konvaContrast);
                        const KonvaFilters = (0, $8c8384c27430fce8$export$b9f99057a3c7692).Filters;
                        if (KonvaFilters && KonvaFilters.Contrast) KonvaFilters.Contrast.call(this, imageData);
                    };
                }
            case 'grayscale':
                return function(imageData) {
                    const KonvaFilters = (0, $8c8384c27430fce8$export$b9f99057a3c7692).Filters;
                    if (KonvaFilters && KonvaFilters.Grayscale) KonvaFilters.Grayscale.call(this, imageData);
                };
            case 'sepia':
                return function(imageData) {
                    const KonvaFilters = (0, $8c8384c27430fce8$export$b9f99057a3c7692).Filters;
                    if (KonvaFilters && KonvaFilters.Sepia) KonvaFilters.Sepia.call(this, imageData);
                };
            case 'invert':
                return function(imageData) {
                    const KonvaFilters = (0, $8c8384c27430fce8$export$b9f99057a3c7692).Filters;
                    if (KonvaFilters && KonvaFilters.Invert) KonvaFilters.Invert.call(this, imageData);
                };
            default:
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn(`CSS filter "${filterName}" is not supported in fallback mode. Consider using function filters for better compatibility.`);
                break;
        }
    }
    return ()=>{};
}
const $367bbc8f6a40f243$var$ABSOLUTE_OPACITY = 'absoluteOpacity', $367bbc8f6a40f243$var$ALL_LISTENERS = 'allEventListeners', $367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM = 'absoluteTransform', $367bbc8f6a40f243$var$ABSOLUTE_SCALE = 'absoluteScale', $367bbc8f6a40f243$var$CANVAS = 'canvas', $367bbc8f6a40f243$var$CHANGE = 'Change', $367bbc8f6a40f243$var$CHILDREN = 'children', $367bbc8f6a40f243$var$KONVA = 'konva', $367bbc8f6a40f243$var$LISTENING = 'listening', $367bbc8f6a40f243$var$MOUSEENTER = 'mouseenter', $367bbc8f6a40f243$var$MOUSELEAVE = 'mouseleave', $367bbc8f6a40f243$var$POINTERENTER = 'pointerenter', $367bbc8f6a40f243$var$POINTERLEAVE = 'pointerleave', $367bbc8f6a40f243$var$TOUCHENTER = 'touchenter', $367bbc8f6a40f243$var$TOUCHLEAVE = 'touchleave', $367bbc8f6a40f243$var$NAME = 'name', $367bbc8f6a40f243$var$SET = 'set', $367bbc8f6a40f243$var$SHAPE = 'Shape', $367bbc8f6a40f243$var$SPACE = ' ', $367bbc8f6a40f243$var$STAGE = 'stage', $367bbc8f6a40f243$var$TRANSFORM = 'transform', $367bbc8f6a40f243$var$UPPER_STAGE = 'Stage', $367bbc8f6a40f243$var$VISIBLE = 'visible', $367bbc8f6a40f243$var$TRANSFORM_CHANGE_STR = [
    'xChange.konva',
    'yChange.konva',
    'scaleXChange.konva',
    'scaleYChange.konva',
    'skewXChange.konva',
    'skewYChange.konva',
    'rotationChange.konva',
    'offsetXChange.konva',
    'offsetYChange.konva',
    'transformsEnabledChange.konva'
].join($367bbc8f6a40f243$var$SPACE);
let $367bbc8f6a40f243$var$idCounter = 1;
class $367bbc8f6a40f243$export$85c928794f8d04d4 {
    constructor(config){
        this._id = $367bbc8f6a40f243$var$idCounter++;
        this.eventListeners = {};
        this.attrs = {};
        this.index = 0;
        this._allEventListeners = null;
        this.parent = null;
        this._cache = new Map();
        this._attachedDepsListeners = new Map();
        this._lastPos = null;
        this._batchingTransformChange = false;
        this._needClearTransformCache = false;
        this._filterUpToDate = false;
        this._isUnderCache = false;
        this._dragEventId = null;
        this._shouldFireChangeEvents = false;
        this.setAttrs(config);
        this._shouldFireChangeEvents = true;
    }
    hasChildren() {
        return false;
    }
    _clearCache(attr) {
        if ((attr === $367bbc8f6a40f243$var$TRANSFORM || attr === $367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM) && this._cache.get(attr)) this._cache.get(attr).dirty = true;
        else if (attr) this._cache.delete(attr);
        else this._cache.clear();
    }
    _getCache(attr, privateGetter) {
        let cache = this._cache.get(attr);
        const isTransform = attr === $367bbc8f6a40f243$var$TRANSFORM || attr === $367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM;
        const invalid = cache === undefined || isTransform && cache.dirty === true;
        if (invalid) {
            cache = privateGetter.call(this);
            this._cache.set(attr, cache);
        }
        return cache;
    }
    _calculate(name, deps, getter) {
        if (!this._attachedDepsListeners.get(name)) {
            const depsString = deps.map((dep)=>dep + 'Change.konva').join($367bbc8f6a40f243$var$SPACE);
            this.on(depsString, ()=>{
                this._clearCache(name);
            });
            this._attachedDepsListeners.set(name, true);
        }
        return this._getCache(name, getter);
    }
    _getCanvasCache() {
        return this._cache.get($367bbc8f6a40f243$var$CANVAS);
    }
    _clearSelfAndDescendantCache(attr) {
        this._clearCache(attr);
        if (attr === $367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM) this.fire('absoluteTransformChange');
    }
    clearCache() {
        if (this._cache.has($367bbc8f6a40f243$var$CANVAS)) {
            const { scene: scene, filter: filter, hit: hit, buffer: buffer } = this._cache.get($367bbc8f6a40f243$var$CANVAS);
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).releaseCanvas(scene, filter, hit, buffer);
            this._cache.delete($367bbc8f6a40f243$var$CANVAS);
        }
        this._clearSelfAndDescendantCache();
        this._requestDraw();
        return this;
    }
    cache(config) {
        const conf = config || {};
        let rect = {};
        if (conf.x === undefined || conf.y === undefined || conf.width === undefined || conf.height === undefined) rect = this.getClientRect({
            skipTransform: true,
            relativeTo: this.getParent() || undefined
        });
        let width = Math.ceil(conf.width || rect.width), height = Math.ceil(conf.height || rect.height), pixelRatio = conf.pixelRatio, x = conf.x === undefined ? Math.floor(rect.x) : conf.x, y = conf.y === undefined ? Math.floor(rect.y) : conf.y, offset = conf.offset || 0, drawBorder = conf.drawBorder || false, hitCanvasPixelRatio = conf.hitCanvasPixelRatio || 1;
        if (!width || !height) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('Can not cache the node. Width or height of the node equals 0. Caching is skipped.');
            return;
        }
        const extraPaddingX = Math.abs(Math.round(rect.x) - x) > 0.5 ? 1 : 0;
        const extraPaddingY = Math.abs(Math.round(rect.y) - y) > 0.5 ? 1 : 0;
        width += offset * 2 + extraPaddingX;
        height += offset * 2 + extraPaddingY;
        x -= offset;
        y -= offset;
        const cachedSceneCanvas = new (0, $94cf583ff38878f8$export$ee612225bd2e63be)({
            pixelRatio: pixelRatio,
            width: width,
            height: height
        }), cachedFilterCanvas = new (0, $94cf583ff38878f8$export$ee612225bd2e63be)({
            pixelRatio: pixelRatio,
            width: 0,
            height: 0,
            willReadFrequently: true
        }), cachedHitCanvas = new (0, $94cf583ff38878f8$export$43a2e1456e27dc84)({
            pixelRatio: hitCanvasPixelRatio,
            width: width,
            height: height
        }), sceneContext = cachedSceneCanvas.getContext(), hitContext = cachedHitCanvas.getContext();
        const bufferCanvas = new (0, $94cf583ff38878f8$export$ee612225bd2e63be)({
            width: cachedSceneCanvas.width / cachedSceneCanvas.pixelRatio + Math.abs(x),
            height: cachedSceneCanvas.height / cachedSceneCanvas.pixelRatio + Math.abs(y),
            pixelRatio: cachedSceneCanvas.pixelRatio
        }), bufferContext = bufferCanvas.getContext();
        cachedHitCanvas.isCache = true;
        cachedSceneCanvas.isCache = true;
        this._cache.delete($367bbc8f6a40f243$var$CANVAS);
        this._filterUpToDate = false;
        if (conf.imageSmoothingEnabled === false) {
            cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
            cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
        }
        sceneContext.save();
        hitContext.save();
        bufferContext.save();
        sceneContext.translate(-x, -y);
        hitContext.translate(-x, -y);
        bufferContext.translate(-x, -y);
        bufferCanvas.x = x;
        bufferCanvas.y = y;
        this._isUnderCache = true;
        this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_SCALE);
        this.drawScene(cachedSceneCanvas, this, bufferCanvas);
        this.drawHit(cachedHitCanvas, this);
        this._isUnderCache = false;
        sceneContext.restore();
        hitContext.restore();
        if (drawBorder) {
            sceneContext.save();
            sceneContext.beginPath();
            sceneContext.rect(0, 0, width, height);
            sceneContext.closePath();
            sceneContext.setAttr('strokeStyle', 'red');
            sceneContext.setAttr('lineWidth', 5);
            sceneContext.stroke();
            sceneContext.restore();
        }
        this._cache.set($367bbc8f6a40f243$var$CANVAS, {
            scene: cachedSceneCanvas,
            filter: cachedFilterCanvas,
            hit: cachedHitCanvas,
            buffer: bufferCanvas,
            x: x,
            y: y
        });
        this._requestDraw();
        return this;
    }
    isCached() {
        return this._cache.has($367bbc8f6a40f243$var$CANVAS);
    }
    getClientRect(config) {
        throw new Error('abstract "getClientRect" method call');
    }
    _transformedRect(rect, top) {
        const points = [
            {
                x: rect.x,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y + rect.height
            },
            {
                x: rect.x,
                y: rect.y + rect.height
            }
        ];
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        const trans = this.getAbsoluteTransform(top);
        points.forEach(function(point) {
            const transformed = trans.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    _drawCachedSceneCanvas(context) {
        context.save();
        context._applyOpacity(this);
        context._applyGlobalCompositeOperation(this);
        const canvasCache = this._getCanvasCache();
        context.translate(canvasCache.x, canvasCache.y);
        const cacheCanvas = this._getCachedSceneCanvas();
        const ratio = cacheCanvas.pixelRatio;
        context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
        context.restore();
    }
    _drawCachedHitCanvas(context) {
        const canvasCache = this._getCanvasCache(), hitCanvas = canvasCache.hit;
        context.save();
        context.translate(canvasCache.x, canvasCache.y);
        context.drawImage(hitCanvas._canvas, 0, 0, hitCanvas.width / hitCanvas.pixelRatio, hitCanvas.height / hitCanvas.pixelRatio);
        context.restore();
    }
    _getCachedSceneCanvas() {
        let filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter;
        if (!filters || filters.length === 0) return sceneCanvas;
        if (this._filterUpToDate) return filterCanvas;
        let useNativeOnly = true;
        for(let i = 0; i < filters.length; i++){
            const fallbackRequired = typeof filters[i] === 'string' && !(0, $02f524f4df5fe352$export$887ce9926cc3f80f)();
            fallbackRequired;
            if (typeof filters[i] !== 'string' || !(0, $02f524f4df5fe352$export$887ce9926cc3f80f)()) {
                useNativeOnly = false;
                break;
            }
        }
        const ratio = sceneCanvas.pixelRatio;
        filterCanvas.setSize(sceneCanvas.width / sceneCanvas.pixelRatio, sceneCanvas.height / sceneCanvas.pixelRatio);
        if (useNativeOnly) {
            const finalFilter = filters.join(' ');
            filterContext.save();
            filterContext.setAttr('filter', finalFilter);
            filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
            filterContext.restore();
            this._filterUpToDate = true;
            return filterCanvas;
        }
        try {
            len = filters.length;
            filterContext.clear();
            filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
            imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
            for(n = 0; n < len; n++){
                filter = filters[n];
                if (typeof filter === 'string') filter = $367bbc8f6a40f243$var$parseCSSFilters(filter);
                filter.call(this, imageData);
                filterContext.putImageData(imageData, 0, 0);
            }
        } catch (e) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('Unable to apply filter. ' + e.message + ' This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.');
        }
        this._filterUpToDate = true;
        return filterCanvas;
    }
    on(evtStr, handler) {
        if (this._cache) this._cache.delete($367bbc8f6a40f243$var$ALL_LISTENERS);
        if (arguments.length === 3) return this._delegate.apply(this, arguments);
        const events = evtStr.split($367bbc8f6a40f243$var$SPACE);
        for(let n = 0; n < events.length; n++){
            const event = events[n];
            const parts = event.split('.');
            const baseEvent = parts[0];
            const name = parts[1] || '';
            if (!this.eventListeners[baseEvent]) this.eventListeners[baseEvent] = [];
            this.eventListeners[baseEvent].push({
                name: name,
                handler: handler
            });
        }
        return this;
    }
    off(evtStr, callback) {
        let events = (evtStr || '').split($367bbc8f6a40f243$var$SPACE), len = events.length, n, t, event, parts, baseEvent, name;
        this._cache && this._cache.delete($367bbc8f6a40f243$var$ALL_LISTENERS);
        if (!evtStr) for(t in this.eventListeners)this._off(t);
        for(n = 0; n < len; n++){
            event = events[n];
            parts = event.split('.');
            baseEvent = parts[0];
            name = parts[1];
            if (baseEvent) {
                if (this.eventListeners[baseEvent]) this._off(baseEvent, name, callback);
            } else for(t in this.eventListeners)this._off(t, name, callback);
        }
        return this;
    }
    dispatchEvent(evt) {
        const e = {
            target: this,
            type: evt.type,
            evt: evt
        };
        this.fire(evt.type, e);
        return this;
    }
    addEventListener(type, handler) {
        this.on(type, function(evt) {
            handler.call(this, evt.evt);
        });
        return this;
    }
    removeEventListener(type) {
        this.off(type);
        return this;
    }
    _delegate(event, selector, handler) {
        const stopNode = this;
        this.on(event, function(evt) {
            const targets = evt.target.findAncestors(selector, true, stopNode);
            for(let i = 0; i < targets.length; i++){
                evt = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).cloneObject(evt);
                evt.currentTarget = targets[i];
                handler.call(targets[i], evt);
            }
        });
    }
    remove() {
        if (this.isDragging()) this.stopDrag();
        (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.delete(this._id);
        this._remove();
        return this;
    }
    _clearCaches() {
        this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM);
        this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_SCALE);
        this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$STAGE);
        this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$VISIBLE);
        this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$LISTENING);
    }
    _remove() {
        this._clearCaches();
        const parent = this.getParent();
        if (parent && parent.children) {
            parent.children.splice(this.index, 1);
            parent._setChildrenIndices();
            this.parent = null;
        }
    }
    destroy() {
        this.remove();
        this.clearCache();
        return this;
    }
    getAttr(attr) {
        const method = 'get' + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(attr);
        if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isFunction(this[method])) return this[method]();
        return this.attrs[attr];
    }
    getAncestors() {
        let parent = this.getParent(), ancestors = [];
        while(parent){
            ancestors.push(parent);
            parent = parent.getParent();
        }
        return ancestors;
    }
    getAttrs() {
        return this.attrs || {};
    }
    setAttrs(config) {
        this._batchTransformChanges(()=>{
            let key, method;
            if (!config) return this;
            for(key in config){
                if (key === $367bbc8f6a40f243$var$CHILDREN) continue;
                method = $367bbc8f6a40f243$var$SET + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(key);
                if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isFunction(this[method])) this[method](config[key]);
                else this._setAttr(key, config[key]);
            }
        });
        return this;
    }
    isListening() {
        return this._getCache($367bbc8f6a40f243$var$LISTENING, this._isListening);
    }
    _isListening(relativeTo) {
        const listening = this.listening();
        if (!listening) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isListening(relativeTo);
        else return true;
    }
    isVisible() {
        return this._getCache($367bbc8f6a40f243$var$VISIBLE, this._isVisible);
    }
    _isVisible(relativeTo) {
        const visible = this.visible();
        if (!visible) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isVisible(relativeTo);
        else return true;
    }
    shouldDrawHit(top, skipDragCheck = false) {
        if (top) return this._isVisible(top) && this._isListening(top);
        const layer = this.getLayer();
        let layerUnderDrag = false;
        (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.forEach((elem)=>{
            if (elem.dragStatus !== 'dragging') return;
            else if (elem.node.nodeType === 'Stage') layerUnderDrag = true;
            else if (elem.node.getLayer() === layer) layerUnderDrag = true;
        });
        const dragSkip = !skipDragCheck && !(0, $8c8384c27430fce8$export$b9f99057a3c7692).hitOnDragEnabled && (layerUnderDrag || (0, $8c8384c27430fce8$export$b9f99057a3c7692).isTransforming());
        return this.isListening() && this.isVisible() && !dragSkip;
    }
    show() {
        this.visible(true);
        return this;
    }
    hide() {
        this.visible(false);
        return this;
    }
    getZIndex() {
        return this.index || 0;
    }
    getAbsoluteZIndex() {
        let depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
        function addChildren(children) {
            nodes = [];
            len = children.length;
            for(n = 0; n < len; n++){
                child = children[n];
                index++;
                if (child.nodeType !== $367bbc8f6a40f243$var$SHAPE) nodes = nodes.concat(child.getChildren().slice());
                if (child._id === that._id) n = len;
            }
            if (nodes.length > 0 && nodes[0].getDepth() <= depth) addChildren(nodes);
        }
        const stage = this.getStage();
        if (that.nodeType !== $367bbc8f6a40f243$var$UPPER_STAGE && stage) addChildren(stage.getChildren());
        return index;
    }
    getDepth() {
        let depth = 0, parent = this.parent;
        while(parent){
            depth++;
            parent = parent.parent;
        }
        return depth;
    }
    _batchTransformChanges(func) {
        this._batchingTransformChange = true;
        func();
        this._batchingTransformChange = false;
        if (this._needClearTransformCache) {
            this._clearCache($367bbc8f6a40f243$var$TRANSFORM);
            this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM);
        }
        this._needClearTransformCache = false;
    }
    setPosition(pos) {
        this._batchTransformChanges(()=>{
            this.x(pos.x);
            this.y(pos.y);
        });
        return this;
    }
    getPosition() {
        return {
            x: this.x(),
            y: this.y()
        };
    }
    getRelativePointerPosition() {
        const stage = this.getStage();
        if (!stage) return null;
        const pos = stage.getPointerPosition();
        if (!pos) return null;
        const transform = this.getAbsoluteTransform().copy();
        transform.invert();
        return transform.point(pos);
    }
    getAbsolutePosition(top) {
        let haveCachedParent = false;
        let parent = this.parent;
        while(parent){
            if (parent.isCached()) {
                haveCachedParent = true;
                break;
            }
            parent = parent.parent;
        }
        if (haveCachedParent && !top) top = true;
        const absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)(), offset = this.offset();
        absoluteTransform.m = absoluteMatrix.slice();
        absoluteTransform.translate(offset.x, offset.y);
        return absoluteTransform.getTranslation();
    }
    setAbsolutePosition(pos) {
        const { x: x, y: y, ...origTrans } = this._clearTransform();
        this.attrs.x = x;
        this.attrs.y = y;
        this._clearCache($367bbc8f6a40f243$var$TRANSFORM);
        const it = this._getAbsoluteTransform().copy();
        it.invert();
        it.translate(pos.x, pos.y);
        pos = {
            x: this.attrs.x + it.getTranslation().x,
            y: this.attrs.y + it.getTranslation().y
        };
        this._setTransform(origTrans);
        this.setPosition({
            x: pos.x,
            y: pos.y
        });
        this._clearCache($367bbc8f6a40f243$var$TRANSFORM);
        this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM);
        return this;
    }
    _setTransform(trans) {
        let key;
        for(key in trans)this.attrs[key] = trans[key];
    }
    _clearTransform() {
        const trans = {
            x: this.x(),
            y: this.y(),
            rotation: this.rotation(),
            scaleX: this.scaleX(),
            scaleY: this.scaleY(),
            offsetX: this.offsetX(),
            offsetY: this.offsetY(),
            skewX: this.skewX(),
            skewY: this.skewY()
        };
        this.attrs.x = 0;
        this.attrs.y = 0;
        this.attrs.rotation = 0;
        this.attrs.scaleX = 1;
        this.attrs.scaleY = 1;
        this.attrs.offsetX = 0;
        this.attrs.offsetY = 0;
        this.attrs.skewX = 0;
        this.attrs.skewY = 0;
        return trans;
    }
    move(change) {
        let changeX = change.x, changeY = change.y, x = this.x(), y = this.y();
        if (changeX !== undefined) x += changeX;
        if (changeY !== undefined) y += changeY;
        this.setPosition({
            x: x,
            y: y
        });
        return this;
    }
    _eachAncestorReverse(func, top) {
        let family = [], parent = this.getParent(), len, n;
        if (top && top._id === this._id) return;
        family.unshift(this);
        while(parent && (!top || parent._id !== top._id)){
            family.unshift(parent);
            parent = parent.parent;
        }
        len = family.length;
        for(n = 0; n < len; n++)func(family[n]);
    }
    rotate(theta) {
        this.rotation(this.rotation() + theta);
        return this;
    }
    moveToTop() {
        if (!this.parent) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Node has no parent. moveToTop function is ignored.');
            return false;
        }
        const index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.push(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveUp() {
        if (!this.parent) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Node has no parent. moveUp function is ignored.');
            return false;
        }
        const index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index + 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveDown() {
        if (!this.parent) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Node has no parent. moveDown function is ignored.');
            return false;
        }
        const index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index - 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveToBottom() {
        if (!this.parent) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Node has no parent. moveToBottom function is ignored.');
            return false;
        }
        const index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.unshift(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    setZIndex(zIndex) {
        if (!this.parent) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Node has no parent. zIndex parameter is ignored.');
            return this;
        }
        if (zIndex < 0 || zIndex >= this.parent.children.length) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Unexpected value ' + zIndex + ' for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to ' + (this.parent.children.length - 1) + '.');
        const index = this.index;
        this.parent.children.splice(index, 1);
        this.parent.children.splice(zIndex, 0, this);
        this.parent._setChildrenIndices();
        return this;
    }
    getAbsoluteOpacity() {
        return this._getCache($367bbc8f6a40f243$var$ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
        let absOpacity = this.opacity();
        const parent = this.getParent();
        if (parent && !parent._isUnderCache) absOpacity *= parent.getAbsoluteOpacity();
        return absOpacity;
    }
    moveTo(newContainer) {
        if (this.getParent() !== newContainer) {
            this._remove();
            newContainer.add(this);
        }
        return this;
    }
    toObject() {
        let attrs = this.getAttrs(), key, val, getter, defaultValue, nonPlainObject;
        const obj = {
            attrs: {},
            className: this.getClassName()
        };
        for(key in attrs){
            val = attrs[key];
            nonPlainObject = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).isObject(val) && !(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isPlainObject(val) && !(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isArray(val);
            if (nonPlainObject) continue;
            getter = typeof this[key] === 'function' && this[key];
            delete attrs[key];
            defaultValue = getter ? getter.call(this) : null;
            attrs[key] = val;
            if (defaultValue !== val) obj.attrs[key] = val;
        }
        return (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._prepareToStringify(obj);
    }
    toJSON() {
        return JSON.stringify(this.toObject());
    }
    getParent() {
        return this.parent;
    }
    findAncestors(selector, includeSelf, stopNode) {
        const res = [];
        if (includeSelf && this._isMatch(selector)) res.push(this);
        let ancestor = this.parent;
        while(ancestor){
            if (ancestor === stopNode) return res;
            if (ancestor._isMatch(selector)) res.push(ancestor);
            ancestor = ancestor.parent;
        }
        return res;
    }
    isAncestorOf(node) {
        return false;
    }
    findAncestor(selector, includeSelf, stopNode) {
        return this.findAncestors(selector, includeSelf, stopNode)[0];
    }
    _isMatch(selector) {
        if (!selector) return false;
        if (typeof selector === 'function') return selector(this);
        let selectorArr = selector.replace(/ /g, '').split(','), len = selectorArr.length, n, sel;
        for(n = 0; n < len; n++){
            sel = selectorArr[n];
            if (!(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).isValidSelector(sel)) {
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Selector "' + sel + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Konva is awesome, right?');
            }
            if (sel.charAt(0) === '#') {
                if (this.id() === sel.slice(1)) return true;
            } else if (sel.charAt(0) === '.') {
                if (this.hasName(sel.slice(1))) return true;
            } else if (this.className === sel || this.nodeType === sel) return true;
        }
        return false;
    }
    getLayer() {
        const parent = this.getParent();
        return parent ? parent.getLayer() : null;
    }
    getStage() {
        return this._getCache($367bbc8f6a40f243$var$STAGE, this._getStage);
    }
    _getStage() {
        const parent = this.getParent();
        if (parent) return parent.getStage();
        else return null;
    }
    fire(eventType, evt = {}, bubble) {
        evt.target = evt.target || this;
        if (bubble) this._fireAndBubble(eventType, evt);
        else this._fire(eventType, evt);
        return this;
    }
    getAbsoluteTransform(top) {
        if (top) return this._getAbsoluteTransform(top);
        else return this._getCache($367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
    }
    _getAbsoluteTransform(top) {
        let at;
        if (top) {
            at = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
            this._eachAncestorReverse(function(node) {
                const transformsEnabled = node.transformsEnabled();
                if (transformsEnabled === 'all') at.multiply(node.getTransform());
                else if (transformsEnabled === 'position') at.translate(node.x() - node.offsetX(), node.y() - node.offsetY());
            }, top);
            return at;
        } else {
            at = this._cache.get($367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM) || new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
            if (this.parent) this.parent.getAbsoluteTransform().copyInto(at);
            else at.reset();
            const transformsEnabled = this.transformsEnabled();
            if (transformsEnabled === 'all') at.multiply(this.getTransform());
            else if (transformsEnabled === 'position') {
                const x = this.attrs.x || 0;
                const y = this.attrs.y || 0;
                const offsetX = this.attrs.offsetX || 0;
                const offsetY = this.attrs.offsetY || 0;
                at.translate(x - offsetX, y - offsetY);
            }
            at.dirty = false;
            return at;
        }
    }
    getAbsoluteScale(top) {
        let parent = this;
        while(parent){
            if (parent._isUnderCache) top = parent;
            parent = parent.getParent();
        }
        const transform = this.getAbsoluteTransform(top);
        const attrs = transform.decompose();
        return {
            x: attrs.scaleX,
            y: attrs.scaleY
        };
    }
    getAbsoluteRotation() {
        return this.getAbsoluteTransform().decompose().rotation;
    }
    getTransform() {
        return this._getCache($367bbc8f6a40f243$var$TRANSFORM, this._getTransform);
    }
    _getTransform() {
        var _a, _b;
        const m = this._cache.get($367bbc8f6a40f243$var$TRANSFORM) || new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
        m.reset();
        const x = this.x(), y = this.y(), rotation = (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
        if (x !== 0 || y !== 0) m.translate(x, y);
        if (rotation !== 0) m.rotate(rotation);
        if (skewX !== 0 || skewY !== 0) m.skew(skewX, skewY);
        if (scaleX !== 1 || scaleY !== 1) m.scale(scaleX, scaleY);
        if (offsetX !== 0 || offsetY !== 0) m.translate(-1 * offsetX, -1 * offsetY);
        m.dirty = false;
        return m;
    }
    clone(obj) {
        let attrs = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).cloneObject(this.attrs), key, allListeners, len, n, listener;
        for(key in obj)attrs[key] = obj[key];
        const node = new this.constructor(attrs);
        for(key in this.eventListeners){
            allListeners = this.eventListeners[key];
            len = allListeners.length;
            for(n = 0; n < len; n++){
                listener = allListeners[n];
                if (listener.name.indexOf($367bbc8f6a40f243$var$KONVA) < 0) {
                    if (!node.eventListeners[key]) node.eventListeners[key] = [];
                    node.eventListeners[key].push(listener);
                }
            }
        }
        return node;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        const box = this.getClientRect();
        const stage = this.getStage(), x = config.x !== undefined ? config.x : Math.floor(box.x), y = config.y !== undefined ? config.y : Math.floor(box.y), pixelRatio = config.pixelRatio || 1, canvas = new (0, $94cf583ff38878f8$export$ee612225bd2e63be)({
            width: config.width || Math.ceil(box.width) || (stage ? stage.width() : 0),
            height: config.height || Math.ceil(box.height) || (stage ? stage.height() : 0),
            pixelRatio: pixelRatio
        }), context = canvas.getContext();
        const bufferCanvas = new (0, $94cf583ff38878f8$export$ee612225bd2e63be)({
            width: canvas.width / canvas.pixelRatio + Math.abs(x),
            height: canvas.height / canvas.pixelRatio + Math.abs(y),
            pixelRatio: canvas.pixelRatio
        });
        if (config.imageSmoothingEnabled === false) context._context.imageSmoothingEnabled = false;
        context.save();
        if (x || y) context.translate(-1 * x, -1 * y);
        this.drawScene(canvas, undefined, bufferCanvas);
        context.restore();
        return canvas;
    }
    toCanvas(config) {
        return this._toKonvaCanvas(config)._canvas;
    }
    toDataURL(config) {
        config = config || {};
        const mimeType = config.mimeType || null, quality = config.quality || null;
        const url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
        if (config.callback) config.callback(url);
        return url;
    }
    toImage(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._urlToImage(this.toDataURL(config), function(img) {
                    resolve(img);
                    callback === null || callback === void 0 || callback(img);
                });
            } catch (err) {
                reject(err);
            }
        });
    }
    toBlob(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                this.toCanvas(config).toBlob((blob)=>{
                    resolve(blob);
                    callback === null || callback === void 0 || callback(blob);
                }, config === null || config === void 0 ? void 0 : config.mimeType, config === null || config === void 0 ? void 0 : config.quality);
            } catch (err) {
                reject(err);
            }
        });
    }
    setSize(size) {
        this.width(size.width);
        this.height(size.height);
        return this;
    }
    getSize() {
        return {
            width: this.width(),
            height: this.height()
        };
    }
    getClassName() {
        return this.className || this.nodeType;
    }
    getType() {
        return this.nodeType;
    }
    getDragDistance() {
        if (this.attrs.dragDistance !== undefined) return this.attrs.dragDistance;
        else if (this.parent) return this.parent.getDragDistance();
        else return (0, $8c8384c27430fce8$export$b9f99057a3c7692).dragDistance;
    }
    _off(type, name, callback) {
        let evtListeners = this.eventListeners[type], i, evtName, handler;
        for(i = 0; i < evtListeners.length; i++){
            evtName = evtListeners[i].name;
            handler = evtListeners[i].handler;
            if ((evtName !== 'konva' || name === 'konva') && (!name || evtName === name) && (!callback || callback === handler)) {
                evtListeners.splice(i, 1);
                if (evtListeners.length === 0) {
                    delete this.eventListeners[type];
                    break;
                }
                i--;
            }
        }
    }
    _fireChangeEvent(attr, oldVal, newVal) {
        this._fire(attr + $367bbc8f6a40f243$var$CHANGE, {
            oldVal: oldVal,
            newVal: newVal
        });
    }
    addName(name) {
        if (!this.hasName(name)) {
            const oldName = this.name();
            const newName = oldName ? oldName + ' ' + name : name;
            this.name(newName);
        }
        return this;
    }
    hasName(name) {
        if (!name) return false;
        const fullName = this.name();
        if (!fullName) return false;
        const names = (fullName || '').split(/\s/g);
        return names.indexOf(name) !== -1;
    }
    removeName(name) {
        const names = (this.name() || '').split(/\s/g);
        const index = names.indexOf(name);
        if (index !== -1) {
            names.splice(index, 1);
            this.name(names.join(' '));
        }
        return this;
    }
    setAttr(attr, val) {
        const func = this[$367bbc8f6a40f243$var$SET + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(attr)];
        if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isFunction(func)) func.call(this, val);
        else this._setAttr(attr, val);
        return this;
    }
    _requestDraw() {
        if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).autoDrawEnabled) {
            const drawNode = this.getLayer() || this.getStage();
            drawNode === null || drawNode === void 0 || drawNode.batchDraw();
        }
    }
    _setAttr(key, val) {
        const oldVal = this.attrs[key];
        if (oldVal === val && !(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).isObject(val)) return;
        if (val === undefined || val === null) delete this.attrs[key];
        else this.attrs[key] = val;
        if (this._shouldFireChangeEvents) this._fireChangeEvent(key, oldVal, val);
        this._requestDraw();
    }
    _setComponentAttr(key, component, val) {
        let oldVal;
        if (val !== undefined) {
            oldVal = this.attrs[key];
            if (!oldVal) this.attrs[key] = this.getAttr(key);
            this.attrs[key][component] = val;
            this._fireChangeEvent(key, oldVal, val);
        }
    }
    _fireAndBubble(eventType, evt, compareShape) {
        if (evt && this.nodeType === $367bbc8f6a40f243$var$SHAPE) evt.target = this;
        const nonBubbling = [
            $367bbc8f6a40f243$var$MOUSEENTER,
            $367bbc8f6a40f243$var$MOUSELEAVE,
            $367bbc8f6a40f243$var$POINTERENTER,
            $367bbc8f6a40f243$var$POINTERLEAVE,
            $367bbc8f6a40f243$var$TOUCHENTER,
            $367bbc8f6a40f243$var$TOUCHLEAVE
        ];
        const shouldStop = nonBubbling.indexOf(eventType) !== -1 && (compareShape && (this === compareShape || this.isAncestorOf && this.isAncestorOf(compareShape)) || this.nodeType === 'Stage' && !compareShape);
        if (!shouldStop) {
            this._fire(eventType, evt);
            const stopBubble = nonBubbling.indexOf(eventType) !== -1 && compareShape && compareShape.isAncestorOf && compareShape.isAncestorOf(this) && !compareShape.isAncestorOf(this.parent);
            if ((evt && !evt.cancelBubble || !evt) && this.parent && this.parent.isListening() && !stopBubble) {
                if (compareShape && compareShape.parent) this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
                else this._fireAndBubble.call(this.parent, eventType, evt);
            }
        }
    }
    _getProtoListeners(eventType) {
        var _a, _b, _c;
        const allListeners = (_a = this._cache.get($367bbc8f6a40f243$var$ALL_LISTENERS)) !== null && _a !== void 0 ? _a : {};
        let events = allListeners === null || allListeners === void 0 ? void 0 : allListeners[eventType];
        if (events === undefined) {
            events = [];
            let obj = Object.getPrototypeOf(this);
            while(obj){
                const hierarchyEvents = (_c = (_b = obj.eventListeners) === null || _b === void 0 ? void 0 : _b[eventType]) !== null && _c !== void 0 ? _c : [];
                events.push(...hierarchyEvents);
                obj = Object.getPrototypeOf(obj);
            }
            allListeners[eventType] = events;
            this._cache.set($367bbc8f6a40f243$var$ALL_LISTENERS, allListeners);
        }
        return events;
    }
    _fire(eventType, evt) {
        evt = evt || {};
        evt.currentTarget = this;
        evt.type = eventType;
        const topListeners = this._getProtoListeners(eventType);
        if (topListeners) for(let i = 0; i < topListeners.length; i++)topListeners[i].handler.call(this, evt);
        const selfListeners = this.eventListeners[eventType];
        if (selfListeners) for(let i = 0; i < selfListeners.length; i++)selfListeners[i].handler.call(this, evt);
    }
    draw() {
        this.drawScene();
        this.drawHit();
        return this;
    }
    _createDragElement(evt) {
        const pointerId = evt ? evt.pointerId : undefined;
        const stage = this.getStage();
        const ap = this.getAbsolutePosition();
        if (!stage) return;
        const pos = stage._getPointerById(pointerId) || stage._changedPointerPositions[0] || ap;
        (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.set(this._id, {
            node: this,
            startPointerPos: pos,
            offset: {
                x: pos.x - ap.x,
                y: pos.y - ap.y
            },
            dragStatus: 'ready',
            pointerId: pointerId
        });
    }
    startDrag(evt, bubbleEvent = true) {
        if (!(0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.has(this._id)) this._createDragElement(evt);
        const elem = (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.get(this._id);
        elem.dragStatus = 'dragging';
        this.fire('dragstart', {
            type: 'dragstart',
            target: this,
            evt: evt && evt.evt
        }, bubbleEvent);
    }
    _setDragPosition(evt, elem) {
        const pos = this.getStage()._getPointerById(elem.pointerId);
        if (!pos) return;
        let newNodePos = {
            x: pos.x - elem.offset.x,
            y: pos.y - elem.offset.y
        };
        const dbf = this.dragBoundFunc();
        if (dbf !== undefined) {
            const bounded = dbf.call(this, newNodePos, evt);
            if (!bounded) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.');
            else newNodePos = bounded;
        }
        if (!this._lastPos || this._lastPos.x !== newNodePos.x || this._lastPos.y !== newNodePos.y) {
            this.setAbsolutePosition(newNodePos);
            this._requestDraw();
        }
        this._lastPos = newNodePos;
    }
    stopDrag(evt) {
        const elem = (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.get(this._id);
        if (elem) elem.dragStatus = 'stopped';
        (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._endDragBefore(evt);
        (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._endDragAfter(evt);
    }
    setDraggable(draggable) {
        this._setAttr('draggable', draggable);
        this._dragChange();
    }
    isDragging() {
        const elem = (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.get(this._id);
        return elem ? elem.dragStatus === 'dragging' : false;
    }
    _listenDrag() {
        this._dragCleanup();
        this.on('mousedown.konva touchstart.konva', function(evt) {
            const shouldCheckButton = evt.evt['button'] !== undefined;
            const canDrag = !shouldCheckButton || (0, $8c8384c27430fce8$export$b9f99057a3c7692).dragButtons.indexOf(evt.evt['button']) >= 0;
            if (!canDrag) return;
            if (this.isDragging()) return;
            let hasDraggingChild = false;
            (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.forEach((elem)=>{
                if (this.isAncestorOf(elem.node)) hasDraggingChild = true;
            });
            if (!hasDraggingChild) this._createDragElement(evt);
        });
    }
    _dragChange() {
        if (this.attrs.draggable) this._listenDrag();
        else {
            this._dragCleanup();
            const stage = this.getStage();
            if (!stage) return;
            const dragElement = (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.get(this._id);
            const isDragging = dragElement && dragElement.dragStatus === 'dragging';
            const isReady = dragElement && dragElement.dragStatus === 'ready';
            if (isDragging) this.stopDrag();
            else if (isReady) (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.delete(this._id);
        }
    }
    _dragCleanup() {
        this.off('mousedown.konva');
        this.off('touchstart.konva');
    }
    isClientRectOnScreen(margin = {
        x: 0,
        y: 0
    }) {
        const stage = this.getStage();
        if (!stage) return false;
        const screenRect = {
            x: -margin.x,
            y: -margin.y,
            width: stage.width() + 2 * margin.x,
            height: stage.height() + 2 * margin.y
        };
        return (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).haveIntersection(screenRect, this.getClientRect());
    }
    static create(data, container) {
        if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isString(data)) data = JSON.parse(data);
        return this._createNode(data, container);
    }
    static _createNode(obj, container) {
        let className = $367bbc8f6a40f243$export$85c928794f8d04d4.prototype.getClassName.call(obj), children = obj.children, no, len, n;
        if (container) obj.attrs.container = container;
        if (!(0, $8c8384c27430fce8$export$b9f99057a3c7692)[className]) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Can not find a node with class name "' + className + '". Fallback to "Shape".');
            className = 'Shape';
        }
        const Class = (0, $8c8384c27430fce8$export$b9f99057a3c7692)[className];
        no = new Class(obj.attrs);
        if (children) {
            len = children.length;
            for(n = 0; n < len; n++)no.add($367bbc8f6a40f243$export$85c928794f8d04d4._createNode(children[n]));
        }
        return no;
    }
}
$367bbc8f6a40f243$export$85c928794f8d04d4.prototype.nodeType = 'Node';
$367bbc8f6a40f243$export$85c928794f8d04d4.prototype._attrsAffectingSize = [];
$367bbc8f6a40f243$export$85c928794f8d04d4.prototype.eventListeners = {};
$367bbc8f6a40f243$export$85c928794f8d04d4.prototype.on.call($367bbc8f6a40f243$export$85c928794f8d04d4.prototype, $367bbc8f6a40f243$var$TRANSFORM_CHANGE_STR, function() {
    if (this._batchingTransformChange) {
        this._needClearTransformCache = true;
        return;
    }
    this._clearCache($367bbc8f6a40f243$var$TRANSFORM);
    this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM);
});
$367bbc8f6a40f243$export$85c928794f8d04d4.prototype.on.call($367bbc8f6a40f243$export$85c928794f8d04d4.prototype, 'visibleChange.konva', function() {
    this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$VISIBLE);
});
$367bbc8f6a40f243$export$85c928794f8d04d4.prototype.on.call($367bbc8f6a40f243$export$85c928794f8d04d4.prototype, 'listeningChange.konva', function() {
    this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$LISTENING);
});
$367bbc8f6a40f243$export$85c928794f8d04d4.prototype.on.call($367bbc8f6a40f243$export$85c928794f8d04d4.prototype, 'opacityChange.konva', function() {
    this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_OPACITY);
});
const $367bbc8f6a40f243$var$addGetterSetter = (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter;
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'zIndex');
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'absolutePosition');
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'position');
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'x', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'y', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'globalCompositeOperation', 'source-over', (0, $d7c0e5ae0fe3f9a6$export$5837c5b6cc5b4d63)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'opacity', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'name', '', (0, $d7c0e5ae0fe3f9a6$export$5837c5b6cc5b4d63)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'id', '', (0, $d7c0e5ae0fe3f9a6$export$5837c5b6cc5b4d63)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'rotation', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'scale', [
    'x',
    'y'
]);
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'scaleX', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'scaleY', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'skew', [
    'x',
    'y'
]);
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'skewX', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'skewY', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'offset', [
    'x',
    'y'
]);
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'offsetX', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'offsetY', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'dragDistance', undefined, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'width', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'height', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'listening', true, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'preventDefault', true, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'filters', undefined, function(val) {
    this._filterUpToDate = false;
    return val;
});
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'visible', true, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'transformsEnabled', 'all', (0, $d7c0e5ae0fe3f9a6$export$5837c5b6cc5b4d63)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'size');
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'dragBoundFunc');
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'draggable', false, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).backCompat($367bbc8f6a40f243$export$85c928794f8d04d4, {
    rotateDeg: 'rotate',
    setRotationDeg: 'setRotation',
    getRotationDeg: 'getRotation'
});





class $f02a8e3513953b09$export$42a852a2b6b56249 extends (0, $367bbc8f6a40f243$export$85c928794f8d04d4) {
    constructor(){
        super(...arguments);
        this.children = [];
    }
    getChildren(filterFunc) {
        const children = this.children || [];
        if (filterFunc) return children.filter(filterFunc);
        return children;
    }
    hasChildren() {
        return this.getChildren().length > 0;
    }
    removeChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.remove();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    destroyChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.destroy();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    add(...children) {
        if (children.length === 0) return this;
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.add(children[i]);
            return this;
        }
        const child = children[0];
        if (child.getParent()) {
            child.moveTo(this);
            return this;
        }
        this._validateAdd(child);
        child.index = this.getChildren().length;
        child.parent = this;
        child._clearCaches();
        this.getChildren().push(child);
        this._fire('add', {
            child: child
        });
        this._requestDraw();
        return this;
    }
    destroy() {
        if (this.hasChildren()) this.destroyChildren();
        super.destroy();
        return this;
    }
    find(selector) {
        return this._generalFind(selector, false);
    }
    findOne(selector) {
        const result = this._generalFind(selector, true);
        return result.length > 0 ? result[0] : undefined;
    }
    _generalFind(selector, findOne) {
        const retArr = [];
        this._descendants((node)=>{
            const valid = node._isMatch(selector);
            if (valid) retArr.push(node);
            if (valid && findOne) return true;
            return false;
        });
        return retArr;
    }
    _descendants(fn) {
        let shouldStop = false;
        const children = this.getChildren();
        for (const child of children){
            shouldStop = fn(child);
            if (shouldStop) return true;
            if (!child.hasChildren()) continue;
            shouldStop = child._descendants(fn);
            if (shouldStop) return true;
        }
        return false;
    }
    toObject() {
        const obj = (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.toObject.call(this);
        obj.children = [];
        this.getChildren().forEach((child)=>{
            obj.children.push(child.toObject());
        });
        return obj;
    }
    isAncestorOf(node) {
        let parent = node.getParent();
        while(parent){
            if (parent._id === this._id) return true;
            parent = parent.getParent();
        }
        return false;
    }
    clone(obj) {
        const node = (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.clone.call(this, obj);
        this.getChildren().forEach(function(no) {
            node.add(no.clone());
        });
        return node;
    }
    getAllIntersections(pos) {
        const arr = [];
        this.find('Shape').forEach((shape)=>{
            if (shape.isVisible() && shape.intersects(pos)) arr.push(shape);
        });
        return arr;
    }
    _clearSelfAndDescendantCache(attr) {
        var _a;
        super._clearSelfAndDescendantCache(attr);
        if (this.isCached()) return;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(node) {
            node._clearSelfAndDescendantCache(attr);
        });
    }
    _setChildrenIndices() {
        var _a;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child, n) {
            child.index = n;
        });
        this._requestDraw();
    }
    drawScene(can, top, bufferCanvas) {
        const layer = this.getLayer(), canvas = can || layer && layer.getCanvas(), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
        const caching = canvas && canvas.isCache;
        if (!this.isVisible() && !caching) return this;
        if (cachedSceneCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
        } else this._drawChildren('drawScene', canvas, top, bufferCanvas);
        return this;
    }
    drawHit(can, top) {
        if (!this.shouldDrawHit(top)) return this;
        const layer = this.getLayer(), canvas = can || layer && layer.hitCanvas, context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (cachedHitCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
        } else this._drawChildren('drawHit', canvas, top);
        return this;
    }
    _drawChildren(drawMethod, canvas, top, bufferCanvas) {
        var _a;
        const context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = typeof clipWidth === 'number' && typeof clipHeight === 'number' || clipFunc;
        const selfCache = top === this;
        if (hasClip) {
            context.save();
            const transform = this.getAbsoluteTransform(top);
            let m = transform.getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            context.beginPath();
            let clipArgs;
            if (clipFunc) clipArgs = clipFunc.call(this, context, this);
            else {
                const clipX = this.clipX();
                const clipY = this.clipY();
                context.rect(clipX || 0, clipY || 0, clipWidth, clipHeight);
            }
            context.clip.apply(context, clipArgs);
            m = transform.copy().invert().getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        const hasComposition = !selfCache && this.globalCompositeOperation() !== 'source-over' && drawMethod === 'drawScene';
        if (hasComposition) {
            context.save();
            context._applyGlobalCompositeOperation(this);
        }
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            child[drawMethod](canvas, top, bufferCanvas);
        });
        if (hasComposition) context.restore();
        if (hasClip) context.restore();
    }
    getClientRect(config = {}) {
        var _a;
        const skipTransform = config.skipTransform;
        const relativeTo = config.relativeTo;
        let minX, minY, maxX, maxY;
        let selfRect = {
            x: Infinity,
            y: Infinity,
            width: 0,
            height: 0
        };
        const that = this;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            if (!child.visible()) return;
            const rect = child.getClientRect({
                relativeTo: that,
                skipShadow: config.skipShadow,
                skipStroke: config.skipStroke
            });
            if (rect.width === 0 && rect.height === 0) return;
            if (minX === undefined) {
                minX = rect.x;
                minY = rect.y;
                maxX = rect.x + rect.width;
                maxY = rect.y + rect.height;
            } else {
                minX = Math.min(minX, rect.x);
                minY = Math.min(minY, rect.y);
                maxX = Math.max(maxX, rect.x + rect.width);
                maxY = Math.max(maxY, rect.y + rect.height);
            }
        });
        const shapes = this.find('Shape');
        let hasVisible = false;
        for(let i = 0; i < shapes.length; i++){
            const shape = shapes[i];
            if (shape._isVisible(this)) {
                hasVisible = true;
                break;
            }
        }
        if (hasVisible && minX !== undefined) selfRect = {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
        else selfRect = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (!skipTransform) return this._transformedRect(selfRect, relativeTo);
        return selfRect;
    }
}
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($f02a8e3513953b09$export$42a852a2b6b56249, 'clip', [
    'x',
    'y',
    'width',
    'height'
]);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f02a8e3513953b09$export$42a852a2b6b56249, 'clipX', undefined, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f02a8e3513953b09$export$42a852a2b6b56249, 'clipY', undefined, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f02a8e3513953b09$export$42a852a2b6b56249, 'clipWidth', undefined, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f02a8e3513953b09$export$42a852a2b6b56249, 'clipHeight', undefined, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f02a8e3513953b09$export$42a852a2b6b56249, 'clipFunc');









const $6d58c7ba166afa5f$var$Captures = new Map();
const $6d58c7ba166afa5f$var$SUPPORT_POINTER_EVENTS = (0, $8c8384c27430fce8$export$b9f99057a3c7692)._global['PointerEvent'] !== undefined;
function $6d58c7ba166afa5f$export$a55e3aaa85f15b00(pointerId) {
    return $6d58c7ba166afa5f$var$Captures.get(pointerId);
}
function $6d58c7ba166afa5f$export$c30017717ce2168e(evt) {
    return {
        evt: evt,
        pointerId: evt.pointerId
    };
}
function $6d58c7ba166afa5f$export$3b42bc7c43025bad(pointerId, shape) {
    return $6d58c7ba166afa5f$var$Captures.get(pointerId) === shape;
}
function $6d58c7ba166afa5f$export$1cab177b65f17c5a(pointerId, shape) {
    $6d58c7ba166afa5f$export$50f687f23c43e4d9(pointerId);
    const stage = shape.getStage();
    if (!stage) return;
    $6d58c7ba166afa5f$var$Captures.set(pointerId, shape);
    if ($6d58c7ba166afa5f$var$SUPPORT_POINTER_EVENTS) shape._fire('gotpointercapture', $6d58c7ba166afa5f$export$c30017717ce2168e(new PointerEvent('gotpointercapture')));
}
function $6d58c7ba166afa5f$export$50f687f23c43e4d9(pointerId, target) {
    const shape = $6d58c7ba166afa5f$var$Captures.get(pointerId);
    if (!shape) return;
    const stage = shape.getStage();
    stage && stage.content;
    $6d58c7ba166afa5f$var$Captures.delete(pointerId);
    if ($6d58c7ba166afa5f$var$SUPPORT_POINTER_EVENTS) shape._fire('lostpointercapture', $6d58c7ba166afa5f$export$c30017717ce2168e(new PointerEvent('lostpointercapture')));
}


const $ac2a2e8b879d4f85$var$STAGE = 'Stage', $ac2a2e8b879d4f85$var$STRING = 'string', $ac2a2e8b879d4f85$var$PX = 'px', $ac2a2e8b879d4f85$var$MOUSEOUT = 'mouseout', $ac2a2e8b879d4f85$var$MOUSELEAVE = 'mouseleave', $ac2a2e8b879d4f85$var$MOUSEOVER = 'mouseover', $ac2a2e8b879d4f85$var$MOUSEENTER = 'mouseenter', $ac2a2e8b879d4f85$var$MOUSEMOVE = 'mousemove', $ac2a2e8b879d4f85$var$MOUSEDOWN = 'mousedown', $ac2a2e8b879d4f85$var$MOUSEUP = 'mouseup', $ac2a2e8b879d4f85$var$POINTERMOVE = 'pointermove', $ac2a2e8b879d4f85$var$POINTERDOWN = 'pointerdown', $ac2a2e8b879d4f85$var$POINTERUP = 'pointerup', $ac2a2e8b879d4f85$var$POINTERCANCEL = 'pointercancel', $ac2a2e8b879d4f85$var$LOSTPOINTERCAPTURE = 'lostpointercapture', $ac2a2e8b879d4f85$var$POINTEROUT = 'pointerout', $ac2a2e8b879d4f85$var$POINTERLEAVE = 'pointerleave', $ac2a2e8b879d4f85$var$POINTEROVER = 'pointerover', $ac2a2e8b879d4f85$var$POINTERENTER = 'pointerenter', $ac2a2e8b879d4f85$var$CONTEXTMENU = 'contextmenu', $ac2a2e8b879d4f85$var$TOUCHSTART = 'touchstart', $ac2a2e8b879d4f85$var$TOUCHEND = 'touchend', $ac2a2e8b879d4f85$var$TOUCHMOVE = 'touchmove', $ac2a2e8b879d4f85$var$TOUCHCANCEL = 'touchcancel', $ac2a2e8b879d4f85$var$WHEEL = 'wheel', $ac2a2e8b879d4f85$var$MAX_LAYERS_NUMBER = 5, $ac2a2e8b879d4f85$var$EVENTS = [
    [
        $ac2a2e8b879d4f85$var$MOUSEENTER,
        '_pointerenter'
    ],
    [
        $ac2a2e8b879d4f85$var$MOUSEDOWN,
        '_pointerdown'
    ],
    [
        $ac2a2e8b879d4f85$var$MOUSEMOVE,
        '_pointermove'
    ],
    [
        $ac2a2e8b879d4f85$var$MOUSEUP,
        '_pointerup'
    ],
    [
        $ac2a2e8b879d4f85$var$MOUSELEAVE,
        '_pointerleave'
    ],
    [
        $ac2a2e8b879d4f85$var$TOUCHSTART,
        '_pointerdown'
    ],
    [
        $ac2a2e8b879d4f85$var$TOUCHMOVE,
        '_pointermove'
    ],
    [
        $ac2a2e8b879d4f85$var$TOUCHEND,
        '_pointerup'
    ],
    [
        $ac2a2e8b879d4f85$var$TOUCHCANCEL,
        '_pointercancel'
    ],
    [
        $ac2a2e8b879d4f85$var$MOUSEOVER,
        '_pointerover'
    ],
    [
        $ac2a2e8b879d4f85$var$WHEEL,
        '_wheel'
    ],
    [
        $ac2a2e8b879d4f85$var$CONTEXTMENU,
        '_contextmenu'
    ],
    [
        $ac2a2e8b879d4f85$var$POINTERDOWN,
        '_pointerdown'
    ],
    [
        $ac2a2e8b879d4f85$var$POINTERMOVE,
        '_pointermove'
    ],
    [
        $ac2a2e8b879d4f85$var$POINTERUP,
        '_pointerup'
    ],
    [
        $ac2a2e8b879d4f85$var$POINTERCANCEL,
        '_pointercancel'
    ],
    [
        $ac2a2e8b879d4f85$var$POINTERLEAVE,
        '_pointerleave'
    ],
    [
        $ac2a2e8b879d4f85$var$LOSTPOINTERCAPTURE,
        '_lostpointercapture'
    ]
];
const $ac2a2e8b879d4f85$var$EVENTS_MAP = {
    mouse: {
        [$ac2a2e8b879d4f85$var$POINTEROUT]: $ac2a2e8b879d4f85$var$MOUSEOUT,
        [$ac2a2e8b879d4f85$var$POINTERLEAVE]: $ac2a2e8b879d4f85$var$MOUSELEAVE,
        [$ac2a2e8b879d4f85$var$POINTEROVER]: $ac2a2e8b879d4f85$var$MOUSEOVER,
        [$ac2a2e8b879d4f85$var$POINTERENTER]: $ac2a2e8b879d4f85$var$MOUSEENTER,
        [$ac2a2e8b879d4f85$var$POINTERMOVE]: $ac2a2e8b879d4f85$var$MOUSEMOVE,
        [$ac2a2e8b879d4f85$var$POINTERDOWN]: $ac2a2e8b879d4f85$var$MOUSEDOWN,
        [$ac2a2e8b879d4f85$var$POINTERUP]: $ac2a2e8b879d4f85$var$MOUSEUP,
        [$ac2a2e8b879d4f85$var$POINTERCANCEL]: 'mousecancel',
        pointerclick: 'click',
        pointerdblclick: 'dblclick'
    },
    touch: {
        [$ac2a2e8b879d4f85$var$POINTEROUT]: 'touchout',
        [$ac2a2e8b879d4f85$var$POINTERLEAVE]: 'touchleave',
        [$ac2a2e8b879d4f85$var$POINTEROVER]: 'touchover',
        [$ac2a2e8b879d4f85$var$POINTERENTER]: 'touchenter',
        [$ac2a2e8b879d4f85$var$POINTERMOVE]: $ac2a2e8b879d4f85$var$TOUCHMOVE,
        [$ac2a2e8b879d4f85$var$POINTERDOWN]: $ac2a2e8b879d4f85$var$TOUCHSTART,
        [$ac2a2e8b879d4f85$var$POINTERUP]: $ac2a2e8b879d4f85$var$TOUCHEND,
        [$ac2a2e8b879d4f85$var$POINTERCANCEL]: $ac2a2e8b879d4f85$var$TOUCHCANCEL,
        pointerclick: 'tap',
        pointerdblclick: 'dbltap'
    },
    pointer: {
        [$ac2a2e8b879d4f85$var$POINTEROUT]: $ac2a2e8b879d4f85$var$POINTEROUT,
        [$ac2a2e8b879d4f85$var$POINTERLEAVE]: $ac2a2e8b879d4f85$var$POINTERLEAVE,
        [$ac2a2e8b879d4f85$var$POINTEROVER]: $ac2a2e8b879d4f85$var$POINTEROVER,
        [$ac2a2e8b879d4f85$var$POINTERENTER]: $ac2a2e8b879d4f85$var$POINTERENTER,
        [$ac2a2e8b879d4f85$var$POINTERMOVE]: $ac2a2e8b879d4f85$var$POINTERMOVE,
        [$ac2a2e8b879d4f85$var$POINTERDOWN]: $ac2a2e8b879d4f85$var$POINTERDOWN,
        [$ac2a2e8b879d4f85$var$POINTERUP]: $ac2a2e8b879d4f85$var$POINTERUP,
        [$ac2a2e8b879d4f85$var$POINTERCANCEL]: $ac2a2e8b879d4f85$var$POINTERCANCEL,
        pointerclick: 'pointerclick',
        pointerdblclick: 'pointerdblclick'
    }
};
const $ac2a2e8b879d4f85$var$getEventType = (type)=>{
    if (type.indexOf('pointer') >= 0) return 'pointer';
    if (type.indexOf('touch') >= 0) return 'touch';
    return 'mouse';
};
const $ac2a2e8b879d4f85$var$getEventsMap = (eventType)=>{
    const type = $ac2a2e8b879d4f85$var$getEventType(eventType);
    if (type === 'pointer') return (0, $8c8384c27430fce8$export$b9f99057a3c7692).pointerEventsEnabled && $ac2a2e8b879d4f85$var$EVENTS_MAP.pointer;
    if (type === 'touch') return $ac2a2e8b879d4f85$var$EVENTS_MAP.touch;
    if (type === 'mouse') return $ac2a2e8b879d4f85$var$EVENTS_MAP.mouse;
};
function $ac2a2e8b879d4f85$var$checkNoClip(attrs = {}) {
    if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Stage does not support clipping. Please use clip for Layers or Groups.');
    return attrs;
}
const $ac2a2e8b879d4f85$var$NO_POINTERS_MESSAGE = `Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);`;
const $ac2a2e8b879d4f85$export$1bfcff8d7c4bf05 = [];
class $ac2a2e8b879d4f85$export$208cd1682bd0e4b6 extends (0, $f02a8e3513953b09$export$42a852a2b6b56249) {
    constructor(config){
        super($ac2a2e8b879d4f85$var$checkNoClip(config));
        this._pointerPositions = [];
        this._changedPointerPositions = [];
        this._buildDOM();
        this._bindContentEvents();
        $ac2a2e8b879d4f85$export$1bfcff8d7c4bf05.push(this);
        this.on('widthChange.konva heightChange.konva', this._resizeDOM);
        this.on('visibleChange.konva', this._checkVisibility);
        this.on('clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva', ()=>{
            $ac2a2e8b879d4f85$var$checkNoClip(this.attrs);
        });
        this._checkVisibility();
    }
    _validateAdd(child) {
        const isLayer = child.getType() === 'Layer';
        const isFastLayer = child.getType() === 'FastLayer';
        const valid = isLayer || isFastLayer;
        if (!valid) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).throw('You may only add layers to the stage.');
    }
    _checkVisibility() {
        if (!this.content) return;
        const style = this.visible() ? '' : 'none';
        this.content.style.display = style;
    }
    setContainer(container) {
        if (typeof container === $ac2a2e8b879d4f85$var$STRING) {
            let id;
            if (container.charAt(0) === '.') {
                const className = container.slice(1);
                container = document.getElementsByClassName(className)[0];
            } else {
                if (container.charAt(0) !== '#') id = container;
                else id = container.slice(1);
                container = document.getElementById(id);
            }
            if (!container) throw 'Can not find container in document with id ' + id;
        }
        this._setAttr('container', container);
        if (this.content) {
            if (this.content.parentElement) this.content.parentElement.removeChild(this.content);
            container.appendChild(this.content);
        }
        return this;
    }
    shouldDrawHit() {
        return true;
    }
    clear() {
        const layers = this.children, len = layers.length;
        for(let n = 0; n < len; n++)layers[n].clear();
        return this;
    }
    clone(obj) {
        if (!obj) obj = {};
        obj.container = typeof document !== 'undefined' && document.createElement('div');
        return (0, $f02a8e3513953b09$export$42a852a2b6b56249).prototype.clone.call(this, obj);
    }
    destroy() {
        super.destroy();
        const content = this.content;
        if (content && (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isInDocument(content)) this.container().removeChild(content);
        const index = $ac2a2e8b879d4f85$export$1bfcff8d7c4bf05.indexOf(this);
        if (index > -1) $ac2a2e8b879d4f85$export$1bfcff8d7c4bf05.splice(index, 1);
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas);
        return this;
    }
    getPointerPosition() {
        const pos = this._pointerPositions[0] || this._changedPointerPositions[0];
        if (!pos) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($ac2a2e8b879d4f85$var$NO_POINTERS_MESSAGE);
            return null;
        }
        return {
            x: pos.x,
            y: pos.y
        };
    }
    _getPointerById(id) {
        return this._pointerPositions.find((p)=>p.id === id);
    }
    getPointersPositions() {
        return this._pointerPositions;
    }
    getStage() {
        return this;
    }
    getContent() {
        return this.content;
    }
    _toKonvaCanvas(config) {
        config = {
            ...config
        };
        config.x = config.x || 0;
        config.y = config.y || 0;
        config.width = config.width || this.width();
        config.height = config.height || this.height();
        const canvas = new (0, $94cf583ff38878f8$export$ee612225bd2e63be)({
            width: config.width,
            height: config.height,
            pixelRatio: config.pixelRatio || 1
        });
        const _context = canvas.getContext()._context;
        const layers = this.children;
        if (config.x || config.y) _context.translate(-1 * config.x, -1 * config.y);
        layers.forEach(function(layer) {
            if (!layer.isVisible()) return;
            const layerCanvas = layer._toKonvaCanvas(config);
            _context.drawImage(layerCanvas._canvas, config.x, config.y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
        });
        return canvas;
    }
    getIntersection(pos) {
        if (!pos) return null;
        const layers = this.children, len = layers.length, end = len - 1;
        for(let n = end; n >= 0; n--){
            const shape = layers[n].getIntersection(pos);
            if (shape) return shape;
        }
        return null;
    }
    _resizeDOM() {
        const width = this.width();
        const height = this.height();
        if (this.content) {
            this.content.style.width = width + $ac2a2e8b879d4f85$var$PX;
            this.content.style.height = height + $ac2a2e8b879d4f85$var$PX;
        }
        this.bufferCanvas.setSize(width, height);
        this.bufferHitCanvas.setSize(width, height);
        this.children.forEach((layer)=>{
            layer.setSize({
                width: width,
                height: height
            });
            layer.draw();
        });
    }
    add(layer, ...rest) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        super.add(layer);
        const length = this.children.length;
        if (length > $ac2a2e8b879d4f85$var$MAX_LAYERS_NUMBER) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('The stage has ' + length + ' layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.');
        layer.setSize({
            width: this.width(),
            height: this.height()
        });
        layer.draw();
        if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isBrowser) this.content.appendChild(layer.canvas._canvas);
        return this;
    }
    getParent() {
        return null;
    }
    getLayer() {
        return null;
    }
    hasPointerCapture(pointerId) {
        return $6d58c7ba166afa5f$export$3b42bc7c43025bad(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $6d58c7ba166afa5f$export$1cab177b65f17c5a(pointerId, this);
    }
    releaseCapture(pointerId) {
        $6d58c7ba166afa5f$export$50f687f23c43e4d9(pointerId, this);
    }
    getLayers() {
        return this.children;
    }
    _bindContentEvents() {
        if (!(0, $8c8384c27430fce8$export$b9f99057a3c7692).isBrowser) return;
        $ac2a2e8b879d4f85$var$EVENTS.forEach(([event, methodName])=>{
            this.content.addEventListener(event, (evt)=>{
                this[methodName](evt);
            }, {
                passive: false
            });
        });
    }
    _pointerenter(evt) {
        this.setPointersPositions(evt);
        const events = $ac2a2e8b879d4f85$var$getEventsMap(evt.type);
        if (events) this._fire(events.pointerenter, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointerover(evt) {
        this.setPointersPositions(evt);
        const events = $ac2a2e8b879d4f85$var$getEventsMap(evt.type);
        if (events) this._fire(events.pointerover, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _getTargetShape(evenType) {
        let shape = this[evenType + 'targetShape'];
        if (shape && !shape.getStage()) shape = null;
        return shape;
    }
    _pointerleave(evt) {
        const events = $ac2a2e8b879d4f85$var$getEventsMap(evt.type);
        const eventType = $ac2a2e8b879d4f85$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        const targetShape = this._getTargetShape(eventType);
        const eventsEnabled = !((0, $8c8384c27430fce8$export$b9f99057a3c7692).isDragging() || (0, $8c8384c27430fce8$export$b9f99057a3c7692).isTransforming()) || (0, $8c8384c27430fce8$export$b9f99057a3c7692).hitOnDragEnabled;
        if (targetShape && eventsEnabled) {
            targetShape._fireAndBubble(events.pointerout, {
                evt: evt
            });
            targetShape._fireAndBubble(events.pointerleave, {
                evt: evt
            });
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this[eventType + 'targetShape'] = null;
        } else if (eventsEnabled) {
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this._fire(events.pointerout, {
                evt: evt,
                target: this,
                currentTarget: this
            });
        }
        this.pointerPos = null;
        this._pointerPositions = [];
    }
    _pointerdown(evt) {
        const events = $ac2a2e8b879d4f85$var$getEventsMap(evt.type);
        const eventType = $ac2a2e8b879d4f85$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        let triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            const shape = this.getIntersection(pos);
            (0, $fa6dae8e3add958f$export$e34f1b340034d7f).justDragged = false;
            (0, $8c8384c27430fce8$export$b9f99057a3c7692)['_' + eventType + 'ListenClick'] = true;
            if (!shape || !shape.isListening()) {
                this[eventType + 'ClickStartShape'] = undefined;
                return;
            }
            if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).capturePointerEventsEnabled) shape.setPointerCapture(pos.id);
            this[eventType + 'ClickStartShape'] = shape;
            shape._fireAndBubble(events.pointerdown, {
                evt: evt,
                pointerId: pos.id
            });
            triggeredOnShape = true;
            const isTouch = evt.type.indexOf('touch') >= 0;
            if (shape.preventDefault() && evt.cancelable && isTouch) evt.preventDefault();
        });
        if (!triggeredOnShape) this._fire(events.pointerdown, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._pointerPositions[0].id
        });
    }
    _pointermove(evt) {
        const events = $ac2a2e8b879d4f85$var$getEventsMap(evt.type);
        const eventType = $ac2a2e8b879d4f85$var$getEventType(evt.type);
        if (!events) return;
        const isTouchPointer = evt.type.indexOf('touch') >= 0 || evt.pointerType === 'touch';
        if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isDragging() && (0, $fa6dae8e3add958f$export$e34f1b340034d7f).node.preventDefault() && evt.cancelable && isTouchPointer) evt.preventDefault();
        this.setPointersPositions(evt);
        const eventsEnabled = !((0, $8c8384c27430fce8$export$b9f99057a3c7692).isDragging() || (0, $8c8384c27430fce8$export$b9f99057a3c7692).isTransforming()) || (0, $8c8384c27430fce8$export$b9f99057a3c7692).hitOnDragEnabled;
        if (!eventsEnabled) return;
        const processedShapesIds = {};
        let triggeredOnShape = false;
        const targetShape = this._getTargetShape(eventType);
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $6d58c7ba166afa5f$export$a55e3aaa85f15b00(pos.id) || this.getIntersection(pos);
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            const differentTarget = targetShape !== shape;
            if (differentTarget && targetShape) {
                targetShape._fireAndBubble(events.pointerout, {
                    ...event
                }, shape);
                targetShape._fireAndBubble(events.pointerleave, {
                    ...event
                }, shape);
            }
            if (shape) {
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                if (differentTarget) {
                    shape._fireAndBubble(events.pointerover, {
                        ...event
                    }, targetShape);
                    shape._fireAndBubble(events.pointerenter, {
                        ...event
                    }, targetShape);
                    this[eventType + 'targetShape'] = shape;
                }
                shape._fireAndBubble(events.pointermove, {
                    ...event
                });
            } else if (targetShape) {
                this._fire(events.pointerover, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                this[eventType + 'targetShape'] = null;
            }
        });
        if (!triggeredOnShape) this._fire(events.pointermove, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
    }
    _pointerup(evt) {
        const events = $ac2a2e8b879d4f85$var$getEventsMap(evt.type);
        const eventType = $ac2a2e8b879d4f85$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        const clickStartShape = this[eventType + 'ClickStartShape'];
        const clickEndShape = this[eventType + 'ClickEndShape'];
        const processedShapesIds = {};
        let skipPointerUpTrigger = false;
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $6d58c7ba166afa5f$export$a55e3aaa85f15b00(pos.id) || this.getIntersection(pos);
            if (shape) {
                shape.releaseCapture(pos.id);
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            let fireDblClick = false;
            if ((0, $8c8384c27430fce8$export$b9f99057a3c7692)['_' + eventType + 'InDblClickWindow']) {
                fireDblClick = true;
                clearTimeout(this[eventType + 'DblTimeout']);
            } else if (!(0, $fa6dae8e3add958f$export$e34f1b340034d7f).justDragged) {
                (0, $8c8384c27430fce8$export$b9f99057a3c7692)['_' + eventType + 'InDblClickWindow'] = true;
                clearTimeout(this[eventType + 'DblTimeout']);
            }
            this[eventType + 'DblTimeout'] = setTimeout(function() {
                (0, $8c8384c27430fce8$export$b9f99057a3c7692)['_' + eventType + 'InDblClickWindow'] = false;
            }, (0, $8c8384c27430fce8$export$b9f99057a3c7692).dblClickWindow);
            if (shape && shape.isListening()) {
                skipPointerUpTrigger = true;
                this[eventType + 'ClickEndShape'] = shape;
                shape._fireAndBubble(events.pointerup, {
                    ...event
                });
                if ((0, $8c8384c27430fce8$export$b9f99057a3c7692)['_' + eventType + 'ListenClick'] && clickStartShape && clickStartShape === shape) {
                    shape._fireAndBubble(events.pointerclick, {
                        ...event
                    });
                    if (fireDblClick && clickEndShape && clickEndShape === shape) shape._fireAndBubble(events.pointerdblclick, {
                        ...event
                    });
                }
            } else {
                this[eventType + 'ClickEndShape'] = null;
                if (!skipPointerUpTrigger) {
                    this._fire(events.pointerup, {
                        evt: evt,
                        target: this,
                        currentTarget: this,
                        pointerId: this._changedPointerPositions[0].id
                    });
                    skipPointerUpTrigger = true;
                }
                if ((0, $8c8384c27430fce8$export$b9f99057a3c7692)['_' + eventType + 'ListenClick']) this._fire(events.pointerclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                if (fireDblClick) this._fire(events.pointerdblclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
            }
        });
        if (!skipPointerUpTrigger) this._fire(events.pointerup, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
        (0, $8c8384c27430fce8$export$b9f99057a3c7692)['_' + eventType + 'ListenClick'] = false;
        if (evt.cancelable && eventType !== 'touch' && eventType !== 'pointer') evt.preventDefault();
    }
    _contextmenu(evt) {
        this.setPointersPositions(evt);
        const shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($ac2a2e8b879d4f85$var$CONTEXTMENU, {
            evt: evt
        });
        else this._fire($ac2a2e8b879d4f85$var$CONTEXTMENU, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _wheel(evt) {
        this.setPointersPositions(evt);
        const shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($ac2a2e8b879d4f85$var$WHEEL, {
            evt: evt
        });
        else this._fire($ac2a2e8b879d4f85$var$WHEEL, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointercancel(evt) {
        this.setPointersPositions(evt);
        const shape = $6d58c7ba166afa5f$export$a55e3aaa85f15b00(evt.pointerId) || this.getIntersection(this.getPointerPosition());
        if (shape) shape._fireAndBubble($ac2a2e8b879d4f85$var$POINTERUP, $6d58c7ba166afa5f$export$c30017717ce2168e(evt));
        $6d58c7ba166afa5f$export$50f687f23c43e4d9(evt.pointerId);
    }
    _lostpointercapture(evt) {
        $6d58c7ba166afa5f$export$50f687f23c43e4d9(evt.pointerId);
    }
    setPointersPositions(evt) {
        const contentPosition = this._getContentPosition();
        let x = null, y = null;
        evt = evt ? evt : window.event;
        if (evt.touches !== undefined) {
            this._pointerPositions = [];
            this._changedPointerPositions = [];
            Array.prototype.forEach.call(evt.touches, (touch)=>{
                this._pointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
            Array.prototype.forEach.call(evt.changedTouches || evt.touches, (touch)=>{
                this._changedPointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
        } else {
            x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
            y = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
            this.pointerPos = {
                x: x,
                y: y
            };
            this._pointerPositions = [
                {
                    x: x,
                    y: y,
                    id: (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getFirstPointerId(evt)
                }
            ];
            this._changedPointerPositions = [
                {
                    x: x,
                    y: y,
                    id: (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getFirstPointerId(evt)
                }
            ];
        }
    }
    _setPointerPosition(evt) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.');
        this.setPointersPositions(evt);
    }
    _getContentPosition() {
        if (!this.content || !this.content.getBoundingClientRect) return {
            top: 0,
            left: 0,
            scaleX: 1,
            scaleY: 1
        };
        const rect = this.content.getBoundingClientRect();
        return {
            top: rect.top,
            left: rect.left,
            scaleX: rect.width / this.content.clientWidth || 1,
            scaleY: rect.height / this.content.clientHeight || 1
        };
    }
    _buildDOM() {
        this.bufferCanvas = new (0, $94cf583ff38878f8$export$ee612225bd2e63be)({
            width: this.width(),
            height: this.height()
        });
        this.bufferHitCanvas = new (0, $94cf583ff38878f8$export$43a2e1456e27dc84)({
            pixelRatio: 1,
            width: this.width(),
            height: this.height()
        });
        if (!(0, $8c8384c27430fce8$export$b9f99057a3c7692).isBrowser) return;
        const container = this.container();
        if (!container) throw 'Stage has no container. A container is required.';
        container.innerHTML = '';
        this.content = document.createElement('div');
        this.content.style.position = 'relative';
        this.content.style.userSelect = 'none';
        this.content.className = 'konvajs-content';
        this.content.setAttribute('role', 'presentation');
        container.appendChild(this.content);
        this._resizeDOM();
    }
    cache() {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.');
        return this;
    }
    clearCache() {
        return this;
    }
    batchDraw() {
        this.getChildren().forEach(function(layer) {
            layer.batchDraw();
        });
        return this;
    }
}
$ac2a2e8b879d4f85$export$208cd1682bd0e4b6.prototype.nodeType = $ac2a2e8b879d4f85$var$STAGE;
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($ac2a2e8b879d4f85$export$208cd1682bd0e4b6);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($ac2a2e8b879d4f85$export$208cd1682bd0e4b6, 'container');
if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isBrowser) document.addEventListener('visibilitychange', ()=>{
    $ac2a2e8b879d4f85$export$1bfcff8d7c4bf05.forEach((stage)=>{
        stage.batchDraw();
    });
});














const $9081147451080c7d$var$HAS_SHADOW = 'hasShadow';
const $9081147451080c7d$var$SHADOW_RGBA = 'shadowRGBA';
const $9081147451080c7d$var$patternImage = 'patternImage';
const $9081147451080c7d$var$linearGradient = 'linearGradient';
const $9081147451080c7d$var$radialGradient = 'radialGradient';
let $9081147451080c7d$var$dummyContext;
function $9081147451080c7d$var$getDummyContext() {
    if ($9081147451080c7d$var$dummyContext) return $9081147451080c7d$var$dummyContext;
    $9081147451080c7d$var$dummyContext = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).createCanvasElement().getContext('2d');
    return $9081147451080c7d$var$dummyContext;
}
const $9081147451080c7d$export$4ff7fc6f1af248b5 = {};
function $9081147451080c7d$var$_fillFunc(context) {
    const fillRule = this.attrs.fillRule;
    if (fillRule) context.fill(fillRule);
    else context.fill();
}
function $9081147451080c7d$var$_strokeFunc(context) {
    context.stroke();
}
function $9081147451080c7d$var$_fillFuncHit(context) {
    const fillRule = this.attrs.fillRule;
    if (fillRule) context.fill(fillRule);
    else context.fill();
}
function $9081147451080c7d$var$_strokeFuncHit(context) {
    context.stroke();
}
function $9081147451080c7d$var$_clearHasShadowCache() {
    this._clearCache($9081147451080c7d$var$HAS_SHADOW);
}
function $9081147451080c7d$var$_clearGetShadowRGBACache() {
    this._clearCache($9081147451080c7d$var$SHADOW_RGBA);
}
function $9081147451080c7d$var$_clearFillPatternCache() {
    this._clearCache($9081147451080c7d$var$patternImage);
}
function $9081147451080c7d$var$_clearLinearGradientCache() {
    this._clearCache($9081147451080c7d$var$linearGradient);
}
function $9081147451080c7d$var$_clearRadialGradientCache() {
    this._clearCache($9081147451080c7d$var$radialGradient);
}
class $9081147451080c7d$export$6428a7f2611ef1fa extends (0, $367bbc8f6a40f243$export$85c928794f8d04d4) {
    constructor(config){
        super(config);
        let key;
        let attempts = 0;
        while(true){
            key = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).getHitColor();
            if (key && !(key in $9081147451080c7d$export$4ff7fc6f1af248b5)) break;
            attempts++;
            if (attempts >= 10000) {
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Failed to find a unique color key for a shape. Konva may work incorrectly. Most likely your browser is using canvas farbling. Consider disabling it.');
                key = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).getRandomColor();
                break;
            }
        }
        this.colorKey = key;
        $9081147451080c7d$export$4ff7fc6f1af248b5[key] = this;
    }
    getContext() {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('shape.getContext() method is deprecated. Please do not use it.');
        return this.getLayer().getContext();
    }
    getCanvas() {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('shape.getCanvas() method is deprecated. Please do not use it.');
        return this.getLayer().getCanvas();
    }
    getSceneFunc() {
        return this.attrs.sceneFunc || this['_sceneFunc'];
    }
    getHitFunc() {
        return this.attrs.hitFunc || this['_hitFunc'];
    }
    hasShadow() {
        return this._getCache($9081147451080c7d$var$HAS_SHADOW, this._hasShadow);
    }
    _hasShadow() {
        return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
    }
    _getFillPattern() {
        return this._getCache($9081147451080c7d$var$patternImage, this.__getFillPattern);
    }
    __getFillPattern() {
        if (this.fillPatternImage()) {
            const ctx = $9081147451080c7d$var$getDummyContext();
            const pattern = ctx.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || 'repeat');
            if (pattern && pattern.setTransform) {
                const tr = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
                tr.translate(this.fillPatternX(), this.fillPatternY());
                tr.rotate((0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.fillPatternRotation()));
                tr.scale(this.fillPatternScaleX(), this.fillPatternScaleY());
                tr.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
                const m = tr.getMatrix();
                const matrix = typeof DOMMatrix === 'undefined' ? {
                    a: m[0],
                    b: m[1],
                    c: m[2],
                    d: m[3],
                    e: m[4],
                    f: m[5]
                } : new DOMMatrix(m);
                pattern.setTransform(matrix);
            }
            return pattern;
        }
    }
    _getLinearGradient() {
        return this._getCache($9081147451080c7d$var$linearGradient, this.__getLinearGradient);
    }
    __getLinearGradient() {
        const colorStops = this.fillLinearGradientColorStops();
        if (colorStops) {
            const ctx = $9081147451080c7d$var$getDummyContext();
            const start = this.fillLinearGradientStartPoint();
            const end = this.fillLinearGradientEndPoint();
            const grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
            for(let n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    _getRadialGradient() {
        return this._getCache($9081147451080c7d$var$radialGradient, this.__getRadialGradient);
    }
    __getRadialGradient() {
        const colorStops = this.fillRadialGradientColorStops();
        if (colorStops) {
            const ctx = $9081147451080c7d$var$getDummyContext();
            const start = this.fillRadialGradientStartPoint();
            const end = this.fillRadialGradientEndPoint();
            const grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
            for(let n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    getShadowRGBA() {
        return this._getCache($9081147451080c7d$var$SHADOW_RGBA, this._getShadowRGBA);
    }
    _getShadowRGBA() {
        if (!this.hasShadow()) return;
        const rgba = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).colorToRGBA(this.shadowColor());
        if (rgba) return 'rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + rgba.a * (this.shadowOpacity() || 1) + ')';
    }
    hasFill() {
        return this._calculate('hasFill', [
            'fillEnabled',
            'fill',
            'fillPatternImage',
            'fillLinearGradientColorStops',
            'fillRadialGradientColorStops'
        ], ()=>{
            return this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops());
        });
    }
    hasStroke() {
        return this._calculate('hasStroke', [
            'strokeEnabled',
            'strokeWidth',
            'stroke',
            'strokeLinearGradientColorStops'
        ], ()=>{
            return this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops());
        });
    }
    hasHitStroke() {
        const width = this.hitStrokeWidth();
        if (width === 'auto') return this.hasStroke();
        return this.strokeEnabled() && !!width;
    }
    intersects(point) {
        const stage = this.getStage();
        if (!stage) return false;
        const bufferHitCanvas = stage.bufferHitCanvas;
        bufferHitCanvas.getContext().clear();
        this.drawHit(bufferHitCanvas, undefined, true);
        const p = bufferHitCanvas.context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data;
        return p[3] > 0;
    }
    destroy() {
        (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.destroy.call(this);
        delete $9081147451080c7d$export$4ff7fc6f1af248b5[this.colorKey];
        delete this.colorKey;
        return this;
    }
    _useBufferCanvas(forceFill) {
        var _a;
        const perfectDrawEnabled = (_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true;
        if (!perfectDrawEnabled) return false;
        const hasFill = forceFill || this.hasFill();
        const hasStroke = this.hasStroke();
        const isTransparent = this.getAbsoluteOpacity() !== 1;
        if (hasFill && hasStroke && isTransparent) return true;
        const hasShadow = this.hasShadow();
        const strokeForShadow = this.shadowForStrokeEnabled();
        if (hasFill && hasStroke && hasShadow && strokeForShadow) return true;
        return false;
    }
    setStrokeHitEnabled(val) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.');
        if (val) this.hitStrokeWidth('auto');
        else this.hitStrokeWidth(0);
    }
    getStrokeHitEnabled() {
        if (this.hitStrokeWidth() === 0) return false;
        else return true;
    }
    getSelfRect() {
        const size = this.size();
        return {
            x: this._centroid ? -size.width / 2 : 0,
            y: this._centroid ? -size.height / 2 : 0,
            width: size.width,
            height: size.height
        };
    }
    getClientRect(config = {}) {
        let hasCachedParent = false;
        let parent = this.getParent();
        while(parent){
            if (parent.isCached()) {
                hasCachedParent = true;
                break;
            }
            parent = parent.getParent();
        }
        const skipTransform = config.skipTransform;
        const relativeTo = config.relativeTo || hasCachedParent && this.getStage() || undefined;
        const fillRect = this.getSelfRect();
        const applyStroke = !config.skipStroke && this.hasStroke();
        const strokeWidth = applyStroke && this.strokeWidth() || 0;
        const fillAndStrokeWidth = fillRect.width + strokeWidth;
        const fillAndStrokeHeight = fillRect.height + strokeWidth;
        const applyShadow = !config.skipShadow && this.hasShadow();
        const shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
        const shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;
        const preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
        const preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
        const blurRadius = applyShadow && this.shadowBlur() || 0;
        const width = preWidth + blurRadius * 2;
        const height = preHeight + blurRadius * 2;
        const rect = {
            width: width,
            height: height,
            x: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetX, 0) + fillRect.x,
            y: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetY, 0) + fillRect.y
        };
        if (!skipTransform) return this._transformedRect(rect, relativeTo);
        return rect;
    }
    drawScene(can, top, bufferCanvas) {
        const layer = this.getLayer();
        const canvas = can || layer.getCanvas(), context = canvas.getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow();
        let stage;
        const skipBuffer = false;
        const cachingSelf = top === this;
        if (!this.isVisible() && !cachingSelf) return this;
        if (cachedCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        if (this._useBufferCanvas() && !skipBuffer) {
            stage = this.getStage();
            const bc = bufferCanvas || stage.bufferCanvas;
            const bufferContext = bc.getContext();
            bufferContext.clear();
            bufferContext.save();
            bufferContext._applyLineJoin(this);
            bufferContext._applyMiterLimit(this);
            const o = this.getAbsoluteTransform(top).getMatrix();
            bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
            drawFunc.call(this, bufferContext, this);
            bufferContext.restore();
            const ratio = bc.pixelRatio;
            if (hasShadow) context._applyShadow(this);
            if (!cachingSelf) {
                context._applyOpacity(this);
                context._applyGlobalCompositeOperation(this);
            }
            context.drawImage(bc._canvas, bc.x || 0, bc.y || 0, bc.width / ratio, bc.height / ratio);
        } else {
            context._applyLineJoin(this);
            context._applyMiterLimit(this);
            if (!cachingSelf) {
                const o = this.getAbsoluteTransform(top).getMatrix();
                context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
                context._applyOpacity(this);
                context._applyGlobalCompositeOperation(this);
            }
            if (hasShadow) context._applyShadow(this);
            drawFunc.call(this, context, this);
        }
        context.restore();
        return this;
    }
    drawHit(can, top, skipDragCheck = false) {
        if (!this.shouldDrawHit(top, skipDragCheck)) return this;
        const layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (!this.colorKey) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()');
        if (cachedHitCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        context._applyLineJoin(this);
        context._applyMiterLimit(this);
        const selfCache = this === top;
        if (!selfCache) {
            const o = this.getAbsoluteTransform(top).getMatrix();
            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
        }
        drawFunc.call(this, context, this);
        context.restore();
        return this;
    }
    drawHitFromCache(alphaThreshold = 0) {
        const cachedCanvas = this._getCanvasCache(), sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = cachedCanvas.hit, hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight();
        hitContext.clear();
        hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
        try {
            const hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
            const hitData = hitImageData.data;
            const len = hitData.length;
            const rgbColorKey = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._hexToRgb(this.colorKey);
            for(let i = 0; i < len; i += 4){
                const alpha = hitData[i + 3];
                if (alpha > alphaThreshold) {
                    hitData[i] = rgbColorKey.r;
                    hitData[i + 1] = rgbColorKey.g;
                    hitData[i + 2] = rgbColorKey.b;
                    hitData[i + 3] = 255;
                } else hitData[i + 3] = 0;
            }
            hitContext.putImageData(hitImageData, 0, 0);
        } catch (e) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('Unable to draw hit graph from cached scene canvas. ' + e.message);
        }
        return this;
    }
    hasPointerCapture(pointerId) {
        return $6d58c7ba166afa5f$export$3b42bc7c43025bad(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $6d58c7ba166afa5f$export$1cab177b65f17c5a(pointerId, this);
    }
    releaseCapture(pointerId) {
        $6d58c7ba166afa5f$export$50f687f23c43e4d9(pointerId, this);
    }
}
$9081147451080c7d$export$6428a7f2611ef1fa.prototype._fillFunc = $9081147451080c7d$var$_fillFunc;
$9081147451080c7d$export$6428a7f2611ef1fa.prototype._strokeFunc = $9081147451080c7d$var$_strokeFunc;
$9081147451080c7d$export$6428a7f2611ef1fa.prototype._fillFuncHit = $9081147451080c7d$var$_fillFuncHit;
$9081147451080c7d$export$6428a7f2611ef1fa.prototype._strokeFuncHit = $9081147451080c7d$var$_strokeFuncHit;
$9081147451080c7d$export$6428a7f2611ef1fa.prototype._centroid = false;
$9081147451080c7d$export$6428a7f2611ef1fa.prototype.nodeType = 'Shape';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($9081147451080c7d$export$6428a7f2611ef1fa);
$9081147451080c7d$export$6428a7f2611ef1fa.prototype.eventListeners = {};
$9081147451080c7d$export$6428a7f2611ef1fa.prototype.on.call($9081147451080c7d$export$6428a7f2611ef1fa.prototype, 'shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', $9081147451080c7d$var$_clearHasShadowCache);
$9081147451080c7d$export$6428a7f2611ef1fa.prototype.on.call($9081147451080c7d$export$6428a7f2611ef1fa.prototype, 'shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', $9081147451080c7d$var$_clearGetShadowRGBACache);
$9081147451080c7d$export$6428a7f2611ef1fa.prototype.on.call($9081147451080c7d$export$6428a7f2611ef1fa.prototype, 'fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva', $9081147451080c7d$var$_clearFillPatternCache);
$9081147451080c7d$export$6428a7f2611ef1fa.prototype.on.call($9081147451080c7d$export$6428a7f2611ef1fa.prototype, 'fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva', $9081147451080c7d$var$_clearLinearGradientCache);
$9081147451080c7d$export$6428a7f2611ef1fa.prototype.on.call($9081147451080c7d$export$6428a7f2611ef1fa.prototype, 'fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva', $9081147451080c7d$var$_clearRadialGradientCache);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'stroke', undefined, (0, $d7c0e5ae0fe3f9a6$export$9c72f966a828cc68)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeWidth', 2, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillAfterStrokeEnabled', false);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'hitStrokeWidth', 'auto', (0, $d7c0e5ae0fe3f9a6$export$3b7df2720ef33404)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeHitEnabled', true, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'perfectDrawEnabled', true, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'shadowForStrokeEnabled', true, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'lineJoin');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'lineCap');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'miterLimit');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'sceneFunc');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'hitFunc');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'dash');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'dashOffset', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'shadowColor', undefined, (0, $d7c0e5ae0fe3f9a6$export$5837c5b6cc5b4d63)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'shadowBlur', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'shadowOpacity', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'shadowOffset', [
    'x',
    'y'
]);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'shadowOffsetX', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'shadowOffsetY', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternImage');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fill', undefined, (0, $d7c0e5ae0fe3f9a6$export$9c72f966a828cc68)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternX', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternY', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillLinearGradientColorStops');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeLinearGradientColorStops');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientStartRadius', 0);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientEndRadius', 0);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientColorStops');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternRepeat', 'repeat');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillEnabled', true);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeEnabled', true);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'shadowEnabled', true);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'dashEnabled', true);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeScaleEnabled', true);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPriority', 'color');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternOffset', [
    'x',
    'y'
]);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternOffsetX', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternOffsetY', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternScale', [
    'x',
    'y'
]);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternScaleX', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternScaleY', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillLinearGradientStartPoint', [
    'x',
    'y'
]);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeLinearGradientStartPoint', [
    'x',
    'y'
]);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillLinearGradientStartPointX', 0);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeLinearGradientStartPointX', 0);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillLinearGradientStartPointY', 0);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeLinearGradientStartPointY', 0);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillLinearGradientEndPoint', [
    'x',
    'y'
]);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeLinearGradientEndPoint', [
    'x',
    'y'
]);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillLinearGradientEndPointX', 0);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeLinearGradientEndPointX', 0);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillLinearGradientEndPointY', 0);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeLinearGradientEndPointY', 0);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientStartPoint', [
    'x',
    'y'
]);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientStartPointX', 0);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientStartPointY', 0);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientEndPoint', [
    'x',
    'y'
]);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientEndPointX', 0);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientEndPointY', 0);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternRotation', 0);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRule', undefined, (0, $d7c0e5ae0fe3f9a6$export$5837c5b6cc5b4d63)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).backCompat($9081147451080c7d$export$6428a7f2611ef1fa, {
    dashArray: 'dash',
    getDashArray: 'getDash',
    setDashArray: 'getDash',
    drawFunc: 'sceneFunc',
    getDrawFunc: 'getSceneFunc',
    setDrawFunc: 'setSceneFunc',
    drawHitFunc: 'hitFunc',
    getDrawHitFunc: 'getHitFunc',
    setDrawHitFunc: 'setHitFunc'
});



const $1ff13b72400727ee$var$HASH = '#', $1ff13b72400727ee$var$BEFORE_DRAW = 'beforeDraw', $1ff13b72400727ee$var$DRAW = 'draw', $1ff13b72400727ee$var$INTERSECTION_OFFSETS = [
    {
        x: 0,
        y: 0
    },
    {
        x: -1,
        y: -1
    },
    {
        x: 1,
        y: -1
    },
    {
        x: 1,
        y: 1
    },
    {
        x: -1,
        y: 1
    }
], $1ff13b72400727ee$var$INTERSECTION_OFFSETS_LEN = $1ff13b72400727ee$var$INTERSECTION_OFFSETS.length;
class $1ff13b72400727ee$export$936d0764594b6eb3 extends (0, $f02a8e3513953b09$export$42a852a2b6b56249) {
    constructor(config){
        super(config);
        this.canvas = new (0, $94cf583ff38878f8$export$ee612225bd2e63be)();
        this.hitCanvas = new (0, $94cf583ff38878f8$export$43a2e1456e27dc84)({
            pixelRatio: 1
        });
        this._waitingForDraw = false;
        this.on('visibleChange.konva', this._checkVisibility);
        this._checkVisibility();
        this.on('imageSmoothingEnabledChange.konva', this._setSmoothEnabled);
        this._setSmoothEnabled();
    }
    createPNGStream() {
        const c = this.canvas._canvas;
        return c.createPNGStream();
    }
    getCanvas() {
        return this.canvas;
    }
    getNativeCanvasElement() {
        return this.canvas._canvas;
    }
    getHitCanvas() {
        return this.hitCanvas;
    }
    getContext() {
        return this.getCanvas().getContext();
    }
    clear(bounds) {
        this.getContext().clear(bounds);
        this.getHitCanvas().getContext().clear(bounds);
        return this;
    }
    setZIndex(index) {
        super.setZIndex(index);
        const stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            if (index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[index + 1].getCanvas()._canvas);
            else stage.content.appendChild(this.getNativeCanvasElement());
        }
        return this;
    }
    moveToTop() {
        (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.moveToTop.call(this);
        const stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            stage.content.appendChild(this.getNativeCanvasElement());
        }
        return true;
    }
    moveUp() {
        const moved = (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.moveUp.call(this);
        if (!moved) return false;
        const stage = this.getStage();
        if (!stage || !stage.content) return false;
        stage.content.removeChild(this.getNativeCanvasElement());
        if (this.index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[this.index + 1].getCanvas()._canvas);
        else stage.content.appendChild(this.getNativeCanvasElement());
        return true;
    }
    moveDown() {
        if ((0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.moveDown.call(this)) {
            const stage = this.getStage();
            if (stage) {
                const children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[this.index + 1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    moveToBottom() {
        if ((0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.moveToBottom.call(this)) {
            const stage = this.getStage();
            if (stage) {
                const children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    getLayer() {
        return this;
    }
    remove() {
        const _canvas = this.getNativeCanvasElement();
        (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.remove.call(this);
        if (_canvas && _canvas.parentNode && (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isInDocument(_canvas)) _canvas.parentNode.removeChild(_canvas);
        return this;
    }
    getStage() {
        return this.parent;
    }
    setSize({ width: width, height: height }) {
        this.canvas.setSize(width, height);
        this.hitCanvas.setSize(width, height);
        this._setSmoothEnabled();
        return this;
    }
    _validateAdd(child) {
        const type = child.getType();
        if (type !== 'Group' && type !== 'Shape') (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).throw('You may only add groups and shapes to a layer.');
    }
    _toKonvaCanvas(config) {
        config = {
            ...config
        };
        config.width = config.width || this.getWidth();
        config.height = config.height || this.getHeight();
        config.x = config.x !== undefined ? config.x : this.x();
        config.y = config.y !== undefined ? config.y : this.y();
        return (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype._toKonvaCanvas.call(this, config);
    }
    _checkVisibility() {
        const visible = this.visible();
        if (visible) this.canvas._canvas.style.display = 'block';
        else this.canvas._canvas.style.display = 'none';
    }
    _setSmoothEnabled() {
        this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
    getWidth() {
        if (this.parent) return this.parent.width();
    }
    setWidth() {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    getHeight() {
        if (this.parent) return this.parent.height();
    }
    setHeight() {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    batchDraw() {
        if (!this._waitingForDraw) {
            this._waitingForDraw = true;
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).requestAnimFrame(()=>{
                this.draw();
                this._waitingForDraw = false;
            });
        }
        return this;
    }
    getIntersection(pos) {
        if (!this.isListening() || !this.isVisible()) return null;
        let spiralSearchDistance = 1;
        let continueSearch = false;
        while(true){
            for(let i = 0; i < $1ff13b72400727ee$var$INTERSECTION_OFFSETS_LEN; i++){
                const intersectionOffset = $1ff13b72400727ee$var$INTERSECTION_OFFSETS[i];
                const obj = this._getIntersection({
                    x: pos.x + intersectionOffset.x * spiralSearchDistance,
                    y: pos.y + intersectionOffset.y * spiralSearchDistance
                });
                const shape = obj.shape;
                if (shape) return shape;
                continueSearch = !!obj.antialiased;
                if (!obj.antialiased) break;
            }
            if (continueSearch) spiralSearchDistance += 1;
            else return null;
        }
    }
    _getIntersection(pos) {
        const ratio = this.hitCanvas.pixelRatio;
        const p = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data;
        const p3 = p[3];
        if (p3 === 255) {
            const colorKey = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).getHitColorKey(p[0], p[1], p[2]);
            const shape = (0, $9081147451080c7d$export$4ff7fc6f1af248b5)[colorKey];
            if (shape) return {
                shape: shape
            };
            return {
                antialiased: true
            };
        } else if (p3 > 0) return {
            antialiased: true
        };
        return {};
    }
    drawScene(can, top, bufferCanvas) {
        const layer = this.getLayer(), canvas = can || layer && layer.getCanvas();
        this._fire($1ff13b72400727ee$var$BEFORE_DRAW, {
            node: this
        });
        if (this.clearBeforeDraw()) canvas.getContext().clear();
        (0, $f02a8e3513953b09$export$42a852a2b6b56249).prototype.drawScene.call(this, canvas, top, bufferCanvas);
        this._fire($1ff13b72400727ee$var$DRAW, {
            node: this
        });
        return this;
    }
    drawHit(can, top) {
        const layer = this.getLayer(), canvas = can || layer && layer.hitCanvas;
        if (layer && layer.clearBeforeDraw()) layer.getHitCanvas().getContext().clear();
        (0, $f02a8e3513953b09$export$42a852a2b6b56249).prototype.drawHit.call(this, canvas, top);
        return this;
    }
    enableHitGraph() {
        this.hitGraphEnabled(true);
        return this;
    }
    disableHitGraph() {
        this.hitGraphEnabled(false);
        return this;
    }
    setHitGraphEnabled(val) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        this.listening(val);
    }
    getHitGraphEnabled(val) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        return this.listening();
    }
    toggleHitCanvas() {
        if (!this.parent || !this.parent['content']) return;
        const parent = this.parent;
        const added = !!this.hitCanvas._canvas.parentNode;
        if (added) parent.content.removeChild(this.hitCanvas._canvas);
        else parent.content.appendChild(this.hitCanvas._canvas);
    }
    destroy() {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas);
        return super.destroy();
    }
}
$1ff13b72400727ee$export$936d0764594b6eb3.prototype.nodeType = 'Layer';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($1ff13b72400727ee$export$936d0764594b6eb3);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($1ff13b72400727ee$export$936d0764594b6eb3, 'imageSmoothingEnabled', true);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($1ff13b72400727ee$export$936d0764594b6eb3, 'clearBeforeDraw', true);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($1ff13b72400727ee$export$936d0764594b6eb3, 'hitGraphEnabled', true, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());





class $42d998124386a05c$export$92d64f29192d1118 extends (0, $1ff13b72400727ee$export$936d0764594b6eb3) {
    constructor(attrs){
        super(attrs);
        this.listening(false);
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
}
$42d998124386a05c$export$92d64f29192d1118.prototype.nodeType = 'FastLayer';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($42d998124386a05c$export$92d64f29192d1118);





class $644b7f3bf259f4bd$export$eb2fcfdbd7ba97d4 extends (0, $f02a8e3513953b09$export$42a852a2b6b56249) {
    _validateAdd(child) {
        const type = child.getType();
        if (type !== 'Group' && type !== 'Shape') (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).throw('You may only add groups and shapes to groups.');
    }
}
$644b7f3bf259f4bd$export$eb2fcfdbd7ba97d4.prototype.nodeType = 'Group';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($644b7f3bf259f4bd$export$eb2fcfdbd7ba97d4);






const $e780181a0ef0b2c4$var$now = function() {
    if ((0, $8c8384c27430fce8$export$442f1a04865e4790).performance && (0, $8c8384c27430fce8$export$442f1a04865e4790).performance.now) return function() {
        return (0, $8c8384c27430fce8$export$442f1a04865e4790).performance.now();
    };
    return function() {
        return new Date().getTime();
    };
}();
class $e780181a0ef0b2c4$export$c35d437ae5945fcd {
    constructor(func, layers){
        this.id = $e780181a0ef0b2c4$export$c35d437ae5945fcd.animIdCounter++;
        this.frame = {
            time: 0,
            timeDiff: 0,
            lastTime: $e780181a0ef0b2c4$var$now(),
            frameRate: 0
        };
        this.func = func;
        this.setLayers(layers);
    }
    setLayers(layers) {
        let lays = [];
        if (layers) lays = Array.isArray(layers) ? layers : [
            layers
        ];
        this.layers = lays;
        return this;
    }
    getLayers() {
        return this.layers;
    }
    addLayer(layer) {
        const layers = this.layers;
        const len = layers.length;
        for(let n = 0; n < len; n++){
            if (layers[n]._id === layer._id) return false;
        }
        this.layers.push(layer);
        return true;
    }
    isRunning() {
        const a = $e780181a0ef0b2c4$export$c35d437ae5945fcd;
        const animations = a.animations;
        const len = animations.length;
        for(let n = 0; n < len; n++){
            if (animations[n].id === this.id) return true;
        }
        return false;
    }
    start() {
        this.stop();
        this.frame.timeDiff = 0;
        this.frame.lastTime = $e780181a0ef0b2c4$var$now();
        $e780181a0ef0b2c4$export$c35d437ae5945fcd._addAnimation(this);
        return this;
    }
    stop() {
        $e780181a0ef0b2c4$export$c35d437ae5945fcd._removeAnimation(this);
        return this;
    }
    _updateFrameObject(time) {
        this.frame.timeDiff = time - this.frame.lastTime;
        this.frame.lastTime = time;
        this.frame.time += this.frame.timeDiff;
        this.frame.frameRate = 1000 / this.frame.timeDiff;
    }
    static _addAnimation(anim) {
        this.animations.push(anim);
        this._handleAnimation();
    }
    static _removeAnimation(anim) {
        const id = anim.id;
        const animations = this.animations;
        const len = animations.length;
        for(let n = 0; n < len; n++)if (animations[n].id === id) {
            this.animations.splice(n, 1);
            break;
        }
    }
    static _runFrames() {
        const layerHash = {};
        const animations = this.animations;
        for(let n = 0; n < animations.length; n++){
            const anim = animations[n];
            const layers = anim.layers;
            const func = anim.func;
            anim._updateFrameObject($e780181a0ef0b2c4$var$now());
            const layersLen = layers.length;
            let needRedraw;
            if (func) needRedraw = func.call(anim, anim.frame) !== false;
            else needRedraw = true;
            if (!needRedraw) continue;
            for(let i = 0; i < layersLen; i++){
                const layer = layers[i];
                if (layer._id !== undefined) layerHash[layer._id] = layer;
            }
        }
        for(const key in layerHash){
            if (!layerHash.hasOwnProperty(key)) continue;
            layerHash[key].batchDraw();
        }
    }
    static _animationLoop() {
        const Anim = $e780181a0ef0b2c4$export$c35d437ae5945fcd;
        if (Anim.animations.length) {
            Anim._runFrames();
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).requestAnimFrame(Anim._animationLoop);
        } else Anim.animRunning = false;
    }
    static _handleAnimation() {
        if (!this.animRunning) {
            this.animRunning = true;
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).requestAnimFrame(this._animationLoop);
        }
    }
}
$e780181a0ef0b2c4$export$c35d437ae5945fcd.animations = [];
$e780181a0ef0b2c4$export$c35d437ae5945fcd.animIdCounter = 0;
$e780181a0ef0b2c4$export$c35d437ae5945fcd.animRunning = false;






const $1a900cbc7cd0dac4$var$blacklist = {
    node: 1,
    duration: 1,
    easing: 1,
    onFinish: 1,
    yoyo: 1
}, $1a900cbc7cd0dac4$var$PAUSED = 1, $1a900cbc7cd0dac4$var$PLAYING = 2, $1a900cbc7cd0dac4$var$REVERSING = 3, $1a900cbc7cd0dac4$var$colorAttrs = [
    'fill',
    'stroke',
    'shadowColor'
];
let $1a900cbc7cd0dac4$var$idCounter = 0;
class $1a900cbc7cd0dac4$var$TweenEngine {
    constructor(prop, propFunc, func, begin, finish, duration, yoyo){
        this.prop = prop;
        this.propFunc = propFunc;
        this.begin = begin;
        this._pos = begin;
        this.duration = duration;
        this._change = 0;
        this.prevPos = 0;
        this.yoyo = yoyo;
        this._time = 0;
        this._position = 0;
        this._startTime = 0;
        this._finish = 0;
        this.func = func;
        this._change = finish - this.begin;
        this.pause();
    }
    fire(str) {
        const handler = this[str];
        if (handler) handler();
    }
    setTime(t) {
        if (t > this.duration) {
            if (this.yoyo) {
                this._time = this.duration;
                this.reverse();
            } else this.finish();
        } else if (t < 0) {
            if (this.yoyo) {
                this._time = 0;
                this.play();
            } else this.reset();
        } else {
            this._time = t;
            this.update();
        }
    }
    getTime() {
        return this._time;
    }
    setPosition(p) {
        this.prevPos = this._pos;
        this.propFunc(p);
        this._pos = p;
    }
    getPosition(t) {
        if (t === undefined) t = this._time;
        return this.func(t, this.begin, this._change, this.duration);
    }
    play() {
        this.state = $1a900cbc7cd0dac4$var$PLAYING;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire('onPlay');
    }
    reverse() {
        this.state = $1a900cbc7cd0dac4$var$REVERSING;
        this._time = this.duration - this._time;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire('onReverse');
    }
    seek(t) {
        this.pause();
        this._time = t;
        this.update();
        this.fire('onSeek');
    }
    reset() {
        this.pause();
        this._time = 0;
        this.update();
        this.fire('onReset');
    }
    finish() {
        this.pause();
        this._time = this.duration;
        this.update();
        this.fire('onFinish');
    }
    update() {
        this.setPosition(this.getPosition(this._time));
        this.fire('onUpdate');
    }
    onEnterFrame() {
        const t = this.getTimer() - this._startTime;
        if (this.state === $1a900cbc7cd0dac4$var$PLAYING) this.setTime(t);
        else if (this.state === $1a900cbc7cd0dac4$var$REVERSING) this.setTime(this.duration - t);
    }
    pause() {
        this.state = $1a900cbc7cd0dac4$var$PAUSED;
        this.fire('onPause');
    }
    getTimer() {
        return new Date().getTime();
    }
}
class $1a900cbc7cd0dac4$export$208a41d6b4e37b97 {
    constructor(config){
        const that = this, node = config.node, nodeId = node._id, easing = config.easing || $1a900cbc7cd0dac4$export$ade85cc9682adcc5.Linear, yoyo = !!config.yoyo;
        let duration, key;
        if (typeof config.duration === 'undefined') duration = 0.3;
        else if (config.duration === 0) duration = 0.001;
        else duration = config.duration;
        this.node = node;
        this._id = $1a900cbc7cd0dac4$var$idCounter++;
        const layers = node.getLayer() || (node instanceof (0, $8c8384c27430fce8$export$b9f99057a3c7692)['Stage'] ? node.getLayers() : null);
        if (!layers) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('Tween constructor have `node` that is not in a layer. Please add node into layer first.');
        this.anim = new (0, $e780181a0ef0b2c4$export$c35d437ae5945fcd)(function() {
            that.tween.onEnterFrame();
        }, layers);
        this.tween = new $1a900cbc7cd0dac4$var$TweenEngine(key, function(i) {
            that._tweenFunc(i);
        }, easing, 0, 1, duration * 1000, yoyo);
        this._addListeners();
        if (!$1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId]) $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId] = {};
        if (!$1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId][this._id]) $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId][this._id] = {};
        if (!$1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens[nodeId]) $1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens[nodeId] = {};
        for(key in config)if ($1a900cbc7cd0dac4$var$blacklist[key] === undefined) this._addAttr(key, config[key]);
        this.reset();
        this.onFinish = config.onFinish;
        this.onReset = config.onReset;
        this.onUpdate = config.onUpdate;
    }
    _addAttr(key, end) {
        const node = this.node, nodeId = node._id;
        let diff, len, trueEnd, trueStart, endRGBA;
        const tweenId = $1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens[nodeId][key];
        if (tweenId) delete $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId][tweenId][key];
        let start = node.getAttr(key);
        if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isArray(end)) {
            diff = [];
            len = Math.max(end.length, start.length);
            if (key === 'points' && end.length !== start.length) {
                if (end.length > start.length) {
                    trueStart = start;
                    start = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._prepareArrayForTween(start, end, node.closed());
                } else {
                    trueEnd = end;
                    end = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._prepareArrayForTween(end, start, node.closed());
                }
            }
            if (key.indexOf('fill') === 0) {
                for(let n = 0; n < len; n++)if (n % 2 === 0) diff.push(end[n] - start[n]);
                else {
                    const startRGBA = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).colorToRGBA(start[n]);
                    endRGBA = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).colorToRGBA(end[n]);
                    start[n] = startRGBA;
                    diff.push({
                        r: endRGBA.r - startRGBA.r,
                        g: endRGBA.g - startRGBA.g,
                        b: endRGBA.b - startRGBA.b,
                        a: endRGBA.a - startRGBA.a
                    });
                }
            } else for(let n = 0; n < len; n++)diff.push(end[n] - start[n]);
        } else if ($1a900cbc7cd0dac4$var$colorAttrs.indexOf(key) !== -1) {
            start = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).colorToRGBA(start);
            endRGBA = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).colorToRGBA(end);
            diff = {
                r: endRGBA.r - start.r,
                g: endRGBA.g - start.g,
                b: endRGBA.b - start.b,
                a: endRGBA.a - start.a
            };
        } else diff = end - start;
        $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId][this._id][key] = {
            start: start,
            diff: diff,
            end: end,
            trueEnd: trueEnd,
            trueStart: trueStart
        };
        $1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens[nodeId][key] = this._id;
    }
    _tweenFunc(i) {
        const node = this.node, attrs = $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[node._id][this._id];
        let key, attr, start, diff, newVal, n, len, end;
        for(key in attrs){
            attr = attrs[key];
            start = attr.start;
            diff = attr.diff;
            end = attr.end;
            if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isArray(start)) {
                newVal = [];
                len = Math.max(start.length, end.length);
                if (key.indexOf('fill') === 0) {
                    for(n = 0; n < len; n++)if (n % 2 === 0) newVal.push((start[n] || 0) + diff[n] * i);
                    else newVal.push('rgba(' + Math.round(start[n].r + diff[n].r * i) + ',' + Math.round(start[n].g + diff[n].g * i) + ',' + Math.round(start[n].b + diff[n].b * i) + ',' + (start[n].a + diff[n].a * i) + ')');
                } else for(n = 0; n < len; n++)newVal.push((start[n] || 0) + diff[n] * i);
            } else if ($1a900cbc7cd0dac4$var$colorAttrs.indexOf(key) !== -1) newVal = 'rgba(' + Math.round(start.r + diff.r * i) + ',' + Math.round(start.g + diff.g * i) + ',' + Math.round(start.b + diff.b * i) + ',' + (start.a + diff.a * i) + ')';
            else newVal = start + diff * i;
            node.setAttr(key, newVal);
        }
    }
    _addListeners() {
        this.tween.onPlay = ()=>{
            this.anim.start();
        };
        this.tween.onReverse = ()=>{
            this.anim.start();
        };
        this.tween.onPause = ()=>{
            this.anim.stop();
        };
        this.tween.onFinish = ()=>{
            const node = this.node;
            const attrs = $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueEnd) node.setAttr('points', attrs.points.trueEnd);
            if (this.onFinish) this.onFinish.call(this);
        };
        this.tween.onReset = ()=>{
            const node = this.node;
            const attrs = $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueStart) node.points(attrs.points.trueStart);
            if (this.onReset) this.onReset();
        };
        this.tween.onUpdate = ()=>{
            if (this.onUpdate) this.onUpdate.call(this);
        };
    }
    play() {
        this.tween.play();
        return this;
    }
    reverse() {
        this.tween.reverse();
        return this;
    }
    reset() {
        this.tween.reset();
        return this;
    }
    seek(t) {
        this.tween.seek(t * 1000);
        return this;
    }
    pause() {
        this.tween.pause();
        return this;
    }
    finish() {
        this.tween.finish();
        return this;
    }
    destroy() {
        const nodeId = this.node._id, thisId = this._id, attrs = $1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens[nodeId];
        this.pause();
        if (this.anim) this.anim.stop();
        for(const key in attrs)delete $1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens[nodeId][key];
        delete $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId][thisId];
        if ($1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens[nodeId]) {
            if (Object.keys($1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens[nodeId]).length === 0) delete $1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens[nodeId];
            if (Object.keys($1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId]).length === 0) delete $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId];
        }
    }
}
$1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs = {};
$1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens = {};
(0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.to = function(params) {
    const onFinish = params.onFinish;
    params.node = this;
    params.onFinish = function() {
        this.destroy();
        if (onFinish) onFinish();
    };
    const tween = new $1a900cbc7cd0dac4$export$208a41d6b4e37b97(params);
    tween.play();
};
const $1a900cbc7cd0dac4$export$ade85cc9682adcc5 = {
    BackEaseIn (t, b, c, d) {
        const s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    BackEaseOut (t, b, c, d) {
        const s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    BackEaseInOut (t, b, c, d) {
        let s = 1.70158;
        if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    },
    ElasticEaseIn (t, b, c, d, a, p) {
        let s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    },
    ElasticEaseOut (t, b, c, d, a, p) {
        let s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
    },
    ElasticEaseInOut (t, b, c, d, a, p) {
        let s = 0;
        if (t === 0) return b;
        if ((t /= d / 2) === 2) return b + c;
        if (!p) p = d * (0.3 * 1.5);
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
    },
    BounceEaseOut (t, b, c, d) {
        if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
        else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
        else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
        else return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    },
    BounceEaseIn (t, b, c, d) {
        return c - $1a900cbc7cd0dac4$export$ade85cc9682adcc5.BounceEaseOut(d - t, 0, c, d) + b;
    },
    BounceEaseInOut (t, b, c, d) {
        if (t < d / 2) return $1a900cbc7cd0dac4$export$ade85cc9682adcc5.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b;
        else return $1a900cbc7cd0dac4$export$ade85cc9682adcc5.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
    },
    EaseIn (t, b, c, d) {
        return c * (t /= d) * t + b;
    },
    EaseOut (t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
    },
    EaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b;
        return -c / 2 * (--t * (t - 2) - 1) + b;
    },
    StrongEaseIn (t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    },
    StrongEaseOut (t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    StrongEaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    },
    Linear (t, b, c, d) {
        return c * t / d + b;
    }
};




const $184c4f87393bf8b7$export$b9f99057a3c7692 = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._assign((0, $8c8384c27430fce8$export$b9f99057a3c7692), {
    Util: $d4400dec7c2a8326$export$f8f26dd395d7e1bd,
    Transform: $d4400dec7c2a8326$export$563a914cafbdc389,
    Node: $367bbc8f6a40f243$export$85c928794f8d04d4,
    Container: $f02a8e3513953b09$export$42a852a2b6b56249,
    Stage: $ac2a2e8b879d4f85$export$208cd1682bd0e4b6,
    stages: $ac2a2e8b879d4f85$export$1bfcff8d7c4bf05,
    Layer: $1ff13b72400727ee$export$936d0764594b6eb3,
    FastLayer: $42d998124386a05c$export$92d64f29192d1118,
    Group: $644b7f3bf259f4bd$export$eb2fcfdbd7ba97d4,
    DD: $fa6dae8e3add958f$export$e34f1b340034d7f,
    Shape: $9081147451080c7d$export$6428a7f2611ef1fa,
    shapes: $9081147451080c7d$export$4ff7fc6f1af248b5,
    Animation: $e780181a0ef0b2c4$export$c35d437ae5945fcd,
    Tween: $1a900cbc7cd0dac4$export$208a41d6b4e37b97,
    Easings: $1a900cbc7cd0dac4$export$ade85cc9682adcc5,
    Context: $02f524f4df5fe352$export$841858b892ce1f4c,
    Canvas: $94cf583ff38878f8$export$8d01c972ee8b14a9
});
var $184c4f87393bf8b7$export$2e2bcd8739ae039 = $184c4f87393bf8b7$export$b9f99057a3c7692;






class $7e6edc1d7eb9aa8d$export$6ef80ffb606dd232 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const angle = (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.angle()), clockwise = this.clockwise();
        context.beginPath();
        context.arc(0, 0, this.outerRadius(), 0, angle, clockwise);
        context.arc(0, 0, this.innerRadius(), angle, 0, !clockwise);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
    getSelfRect() {
        const innerRadius = this.innerRadius();
        const outerRadius = this.outerRadius();
        const clockwise = this.clockwise();
        const angle = (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(clockwise ? 360 - this.angle() : this.angle());
        const boundLeftRatio = Math.cos(Math.min(angle, Math.PI));
        const boundRightRatio = 1;
        const boundTopRatio = Math.sin(Math.min(Math.max(Math.PI, angle), 3 * Math.PI / 2));
        const boundBottomRatio = Math.sin(Math.min(angle, Math.PI / 2));
        const boundLeft = boundLeftRatio * (boundLeftRatio > 0 ? innerRadius : outerRadius);
        const boundRight = boundRightRatio * (boundRightRatio > 0 ? outerRadius : innerRadius);
        const boundTop = boundTopRatio * (boundTopRatio > 0 ? innerRadius : outerRadius);
        const boundBottom = boundBottomRatio * (boundBottomRatio > 0 ? outerRadius : innerRadius);
        return {
            x: boundLeft,
            y: clockwise ? -1 * boundBottom : boundTop,
            width: boundRight - boundLeft,
            height: boundBottom - boundTop
        };
    }
}
$7e6edc1d7eb9aa8d$export$6ef80ffb606dd232.prototype._centroid = true;
$7e6edc1d7eb9aa8d$export$6ef80ffb606dd232.prototype.className = 'Arc';
$7e6edc1d7eb9aa8d$export$6ef80ffb606dd232.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius',
    'angle',
    'clockwise'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($7e6edc1d7eb9aa8d$export$6ef80ffb606dd232);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($7e6edc1d7eb9aa8d$export$6ef80ffb606dd232, 'innerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($7e6edc1d7eb9aa8d$export$6ef80ffb606dd232, 'outerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($7e6edc1d7eb9aa8d$export$6ef80ffb606dd232, 'angle', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($7e6edc1d7eb9aa8d$export$6ef80ffb606dd232, 'clockwise', false, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());







function $5329876ec3db1142$var$getControlPoints(x0, y0, x1, y1, x2, y2, t) {
    const d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)), d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), fa = t * d01 / (d01 + d12), fb = t * d12 / (d01 + d12), p1x = x1 - fa * (x2 - x0), p1y = y1 - fa * (y2 - y0), p2x = x1 + fb * (x2 - x0), p2y = y1 + fb * (y2 - y0);
    return [
        p1x,
        p1y,
        p2x,
        p2y
    ];
}
function $5329876ec3db1142$var$expandPoints(p, tension) {
    const len = p.length, allPoints = [];
    for(let n = 2; n < len - 2; n += 2){
        const cp = $5329876ec3db1142$var$getControlPoints(p[n - 2], p[n - 1], p[n], p[n + 1], p[n + 2], p[n + 3], tension);
        if (isNaN(cp[0])) continue;
        allPoints.push(cp[0]);
        allPoints.push(cp[1]);
        allPoints.push(p[n]);
        allPoints.push(p[n + 1]);
        allPoints.push(cp[2]);
        allPoints.push(cp[3]);
    }
    return allPoints;
}
class $5329876ec3db1142$export$17d680238e50603e extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.on('pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva', function() {
            this._clearCache('tensionPoints');
        });
    }
    _sceneFunc(context) {
        const points = this.points(), length = points.length, tension = this.tension(), closed = this.closed(), bezier = this.bezier();
        if (!length) return;
        let n = 0;
        context.beginPath();
        context.moveTo(points[0], points[1]);
        if (tension !== 0 && length > 4) {
            const tp = this.getTensionPoints();
            const len = tp.length;
            n = closed ? 0 : 4;
            if (!closed) context.quadraticCurveTo(tp[0], tp[1], tp[2], tp[3]);
            while(n < len - 2)context.bezierCurveTo(tp[n++], tp[n++], tp[n++], tp[n++], tp[n++], tp[n++]);
            if (!closed) context.quadraticCurveTo(tp[len - 2], tp[len - 1], points[length - 2], points[length - 1]);
        } else if (bezier) {
            n = 2;
            while(n < length)context.bezierCurveTo(points[n++], points[n++], points[n++], points[n++], points[n++], points[n++]);
        } else for(n = 2; n < length; n += 2)context.lineTo(points[n], points[n + 1]);
        if (closed) {
            context.closePath();
            context.fillStrokeShape(this);
        } else context.strokeShape(this);
    }
    getTensionPoints() {
        return this._getCache('tensionPoints', this._getTensionPoints);
    }
    _getTensionPoints() {
        if (this.closed()) return this._getTensionPointsClosed();
        else return $5329876ec3db1142$var$expandPoints(this.points(), this.tension());
    }
    _getTensionPointsClosed() {
        const p = this.points(), len = p.length, tension = this.tension(), firstControlPoints = $5329876ec3db1142$var$getControlPoints(p[len - 2], p[len - 1], p[0], p[1], p[2], p[3], tension), lastControlPoints = $5329876ec3db1142$var$getControlPoints(p[len - 4], p[len - 3], p[len - 2], p[len - 1], p[0], p[1], tension), middle = $5329876ec3db1142$var$expandPoints(p, tension), tp = [
            firstControlPoints[2],
            firstControlPoints[3]
        ].concat(middle).concat([
            lastControlPoints[0],
            lastControlPoints[1],
            p[len - 2],
            p[len - 1],
            lastControlPoints[2],
            lastControlPoints[3],
            firstControlPoints[0],
            firstControlPoints[1],
            p[0],
            p[1]
        ]);
        return tp;
    }
    getWidth() {
        return this.getSelfRect().width;
    }
    getHeight() {
        return this.getSelfRect().height;
    }
    getSelfRect() {
        let points = this.points();
        if (points.length < 4) return {
            x: points[0] || 0,
            y: points[1] || 0,
            width: 0,
            height: 0
        };
        if (this.tension() !== 0) points = [
            points[0],
            points[1],
            ...this._getTensionPoints(),
            points[points.length - 2],
            points[points.length - 1]
        ];
        else points = this.points();
        let minX = points[0];
        let maxX = points[0];
        let minY = points[1];
        let maxY = points[1];
        let x, y;
        for(let i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
}
$5329876ec3db1142$export$17d680238e50603e.prototype.className = 'Line';
$5329876ec3db1142$export$17d680238e50603e.prototype._attrsAffectingSize = [
    'points',
    'bezier',
    'tension'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($5329876ec3db1142$export$17d680238e50603e);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5329876ec3db1142$export$17d680238e50603e, 'closed', false);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5329876ec3db1142$export$17d680238e50603e, 'bezier', false);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5329876ec3db1142$export$17d680238e50603e, 'tension', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5329876ec3db1142$export$17d680238e50603e, 'points', [], (0, $d7c0e5ae0fe3f9a6$export$42b6f8f340e9a165)());







const $5445f83816334314$export$9b0e545caa171200 = [
    [],
    [],
    [
        -0.5773502691896257,
        0.5773502691896257645091487805019574556476
    ],
    [
        0,
        -0.7745966692414834,
        0.7745966692414833770358530799564799221665
    ],
    [
        -0.33998104358485626,
        0.3399810435848562648026657591032446872005,
        -0.8611363115940526,
        0.8611363115940525752239464888928095050957
    ],
    [
        0,
        -0.5384693101056831,
        0.5384693101056830910363144207002088049672,
        -0.906179845938664,
        0.9061798459386639927976268782993929651256
    ],
    [
        0.6612093864662645136613995950199053470064,
        -0.6612093864662645,
        -0.2386191860831969,
        0.2386191860831969086305017216807119354186,
        -0.932469514203152,
        0.9324695142031520278123015544939946091347
    ],
    [
        0,
        0.4058451513773971669066064120769614633473,
        -0.4058451513773972,
        -0.7415311855993945,
        0.7415311855993944398638647732807884070741,
        -0.9491079123427585,
        0.9491079123427585245261896840478512624007
    ],
    [
        -0.1834346424956498,
        0.1834346424956498049394761423601839806667,
        -0.525532409916329,
        0.5255324099163289858177390491892463490419,
        -0.7966664774136267,
        0.7966664774136267395915539364758304368371,
        -0.9602898564975363,
        0.9602898564975362316835608685694729904282
    ],
    [
        0,
        -0.8360311073266358,
        0.8360311073266357942994297880697348765441,
        -0.9681602395076261,
        0.9681602395076260898355762029036728700494,
        -0.3242534234038089,
        0.3242534234038089290385380146433366085719,
        -0.6133714327005904,
        0.6133714327005903973087020393414741847857
    ],
    [
        -0.14887433898163122,
        0.1488743389816312108848260011297199846175,
        -0.4333953941292472,
        0.4333953941292471907992659431657841622,
        -0.6794095682990244,
        0.6794095682990244062343273651148735757692,
        -0.8650633666889845,
        0.8650633666889845107320966884234930485275,
        -0.9739065285171717,
        0.9739065285171717200779640120844520534282
    ],
    [
        0,
        -0.26954315595234496,
        0.2695431559523449723315319854008615246796,
        -0.5190961292068118,
        0.5190961292068118159257256694586095544802,
        -0.7301520055740494,
        0.7301520055740493240934162520311534580496,
        -0.8870625997680953,
        0.8870625997680952990751577693039272666316,
        -0.978228658146057,
        0.9782286581460569928039380011228573907714
    ],
    [
        -0.1252334085114689,
        0.1252334085114689154724413694638531299833,
        -0.3678314989981802,
        0.3678314989981801937526915366437175612563,
        -0.5873179542866175,
        0.587317954286617447296702418940534280369,
        -0.7699026741943047,
        0.7699026741943046870368938332128180759849,
        -0.9041172563704749,
        0.9041172563704748566784658661190961925375,
        -0.9815606342467192,
        0.9815606342467192506905490901492808229601
    ],
    [
        0,
        -0.2304583159551348,
        0.2304583159551347940655281210979888352115,
        -0.44849275103644687,
        0.4484927510364468528779128521276398678019,
        -0.6423493394403402,
        0.6423493394403402206439846069955156500716,
        -0.8015780907333099,
        0.8015780907333099127942064895828598903056,
        -0.9175983992229779,
        0.9175983992229779652065478365007195123904,
        -0.9841830547185881,
        0.9841830547185881494728294488071096110649
    ],
    [
        -0.10805494870734367,
        0.1080549487073436620662446502198347476119,
        -0.31911236892788974,
        0.3191123689278897604356718241684754668342,
        -0.5152486363581541,
        0.5152486363581540919652907185511886623088,
        -0.6872929048116855,
        0.6872929048116854701480198030193341375384,
        -0.827201315069765,
        0.8272013150697649931897947426503949610397,
        -0.9284348836635735,
        0.928434883663573517336391139377874264477,
        -0.9862838086968123,
        0.986283808696812338841597266704052801676
    ],
    [
        0,
        -0.20119409399743451,
        0.2011940939974345223006283033945962078128,
        -0.3941513470775634,
        0.3941513470775633698972073709810454683627,
        -0.5709721726085388,
        0.5709721726085388475372267372539106412383,
        -0.7244177313601701,
        0.7244177313601700474161860546139380096308,
        -0.8482065834104272,
        0.8482065834104272162006483207742168513662,
        -0.937273392400706,
        0.9372733924007059043077589477102094712439,
        -0.9879925180204854,
        0.9879925180204854284895657185866125811469
    ],
    [
        -0.09501250983763744,
        0.0950125098376374401853193354249580631303,
        -0.2816035507792589,
        0.281603550779258913230460501460496106486,
        -0.45801677765722737,
        0.45801677765722738634241944298357757354,
        -0.6178762444026438,
        0.6178762444026437484466717640487910189918,
        -0.755404408355003,
        0.7554044083550030338951011948474422683538,
        -0.8656312023878318,
        0.8656312023878317438804678977123931323873,
        -0.9445750230732326,
        0.9445750230732325760779884155346083450911,
        -0.9894009349916499,
        0.9894009349916499325961541734503326274262
    ],
    [
        0,
        -0.17848418149584785,
        0.1784841814958478558506774936540655574754,
        -0.3512317634538763,
        0.3512317634538763152971855170953460050405,
        -0.5126905370864769,
        0.5126905370864769678862465686295518745829,
        -0.6576711592166907,
        0.6576711592166907658503022166430023351478,
        -0.7815140038968014,
        0.7815140038968014069252300555204760502239,
        -0.8802391537269859,
        0.8802391537269859021229556944881556926234,
        -0.9506755217687678,
        0.9506755217687677612227169578958030214433,
        -0.9905754753144174,
        0.9905754753144173356754340199406652765077
    ],
    [
        -0.0847750130417353,
        0.0847750130417353012422618529357838117333,
        -0.2518862256915055,
        0.2518862256915055095889728548779112301628,
        -0.41175116146284263,
        0.4117511614628426460359317938330516370789,
        -0.5597708310739475,
        0.5597708310739475346078715485253291369276,
        -0.6916870430603532,
        0.6916870430603532078748910812888483894522,
        -0.8037049589725231,
        0.8037049589725231156824174550145907971032,
        -0.8926024664975557,
        0.8926024664975557392060605911271455154078,
        -0.9558239495713977,
        0.9558239495713977551811958929297763099728,
        -0.9915651684209309,
        0.9915651684209309467300160047061507702525
    ],
    [
        0,
        -0.16035864564022537,
        0.1603586456402253758680961157407435495048,
        -0.31656409996362983,
        0.3165640999636298319901173288498449178922,
        -0.46457074137596094,
        0.4645707413759609457172671481041023679762,
        -0.600545304661681,
        0.6005453046616810234696381649462392798683,
        -0.7209661773352294,
        0.7209661773352293786170958608237816296571,
        -0.8227146565371428,
        0.8227146565371428249789224867127139017745,
        -0.9031559036148179,
        0.9031559036148179016426609285323124878093,
        -0.96020815213483,
        0.960208152134830030852778840687651526615,
        -0.9924068438435844,
        0.9924068438435844031890176702532604935893
    ],
    [
        -0.07652652113349734,
        0.0765265211334973337546404093988382110047,
        -0.22778585114164507,
        0.227785851141645078080496195368574624743,
        -0.37370608871541955,
        0.3737060887154195606725481770249272373957,
        -0.5108670019508271,
        0.5108670019508270980043640509552509984254,
        -0.636053680726515,
        0.6360536807265150254528366962262859367433,
        -0.7463319064601508,
        0.7463319064601507926143050703556415903107,
        -0.8391169718222188,
        0.8391169718222188233945290617015206853296,
        -0.912234428251326,
        0.9122344282513259058677524412032981130491,
        -0.9639719272779138,
        0.963971927277913791267666131197277221912,
        -0.9931285991850949,
        0.9931285991850949247861223884713202782226
    ],
    [
        0,
        -0.1455618541608951,
        0.1455618541608950909370309823386863301163,
        -0.2880213168024011,
        0.288021316802401096600792516064600319909,
        -0.4243421202074388,
        0.4243421202074387835736688885437880520964,
        -0.5516188358872198,
        0.551618835887219807059018796724313286622,
        -0.6671388041974123,
        0.667138804197412319305966669990339162597,
        -0.7684399634756779,
        0.7684399634756779086158778513062280348209,
        -0.8533633645833173,
        0.8533633645833172836472506385875676702761,
        -0.9200993341504008,
        0.9200993341504008287901871337149688941591,
        -0.9672268385663063,
        0.9672268385663062943166222149076951614246,
        -0.9937521706203895,
        0.9937521706203895002602420359379409291933
    ],
    [
        -0.06973927331972223,
        0.0697392733197222212138417961186280818222,
        -0.20786042668822127,
        0.2078604266882212854788465339195457342156,
        -0.34193582089208424,
        0.3419358208920842251581474204273796195591,
        -0.469355837986757,
        0.4693558379867570264063307109664063460953,
        -0.5876404035069116,
        0.5876404035069115929588769276386473488776,
        -0.6944872631866827,
        0.6944872631866827800506898357622567712673,
        -0.7878168059792081,
        0.7878168059792081620042779554083515213881,
        -0.8658125777203002,
        0.8658125777203001365364256370193787290847,
        -0.926956772187174,
        0.9269567721871740005206929392590531966353,
        -0.9700604978354287,
        0.9700604978354287271239509867652687108059,
        -0.9942945854823992,
        0.994294585482399292073031421161298980393
    ],
    [
        0,
        -0.1332568242984661,
        0.1332568242984661109317426822417661370104,
        -0.26413568097034495,
        0.264135680970344930533869538283309602979,
        -0.3903010380302908,
        0.390301038030290831421488872880605458578,
        -0.5095014778460075,
        0.5095014778460075496897930478668464305448,
        -0.6196098757636461,
        0.6196098757636461563850973116495956533871,
        -0.7186613631319502,
        0.7186613631319501944616244837486188483299,
        -0.8048884016188399,
        0.8048884016188398921511184069967785579414,
        -0.8767523582704416,
        0.8767523582704416673781568859341456716389,
        -0.9329710868260161,
        0.9329710868260161023491969890384229782357,
        -0.9725424712181152,
        0.9725424712181152319560240768207773751816,
        -0.9947693349975522,
        0.9947693349975521235239257154455743605736
    ],
    [
        -0.06405689286260563,
        0.0640568928626056260850430826247450385909,
        -0.1911188674736163,
        0.1911188674736163091586398207570696318404,
        -0.3150426796961634,
        0.3150426796961633743867932913198102407864,
        -0.4337935076260451,
        0.4337935076260451384870842319133497124524,
        -0.5454214713888396,
        0.5454214713888395356583756172183723700107,
        -0.6480936519369755,
        0.6480936519369755692524957869107476266696,
        -0.7401241915785544,
        0.7401241915785543642438281030999784255232,
        -0.820001985973903,
        0.8200019859739029219539498726697452080761,
        -0.8864155270044011,
        0.8864155270044010342131543419821967550873,
        -0.9382745520027328,
        0.9382745520027327585236490017087214496548,
        -0.9747285559713095,
        0.9747285559713094981983919930081690617411,
        -0.9951872199970213,
        0.9951872199970213601799974097007368118745
    ]
];
const $5445f83816334314$export$63f082a24e4d0d2 = [
    [],
    [],
    [
        1.0,
        1.0
    ],
    [
        0.8888888888888888888888888888888888888888,
        0.5555555555555555555555555555555555555555,
        0.5555555555555555555555555555555555555555
    ],
    [
        0.6521451548625461426269360507780005927646,
        0.6521451548625461426269360507780005927646,
        0.3478548451374538573730639492219994072353,
        0.3478548451374538573730639492219994072353
    ],
    [
        0.5688888888888888888888888888888888888888,
        0.4786286704993664680412915148356381929122,
        0.4786286704993664680412915148356381929122,
        0.2369268850561890875142640407199173626432,
        0.2369268850561890875142640407199173626432
    ],
    [
        0.3607615730481386075698335138377161116615,
        0.3607615730481386075698335138377161116615,
        0.4679139345726910473898703439895509948116,
        0.4679139345726910473898703439895509948116,
        0.1713244923791703450402961421727328935268,
        0.1713244923791703450402961421727328935268
    ],
    [
        0.4179591836734693877551020408163265306122,
        0.3818300505051189449503697754889751338783,
        0.3818300505051189449503697754889751338783,
        0.2797053914892766679014677714237795824869,
        0.2797053914892766679014677714237795824869,
        0.1294849661688696932706114326790820183285,
        0.1294849661688696932706114326790820183285
    ],
    [
        0.3626837833783619829651504492771956121941,
        0.3626837833783619829651504492771956121941,
        0.3137066458778872873379622019866013132603,
        0.3137066458778872873379622019866013132603,
        0.2223810344533744705443559944262408844301,
        0.2223810344533744705443559944262408844301,
        0.1012285362903762591525313543099621901153,
        0.1012285362903762591525313543099621901153
    ],
    [
        0.3302393550012597631645250692869740488788,
        0.1806481606948574040584720312429128095143,
        0.1806481606948574040584720312429128095143,
        0.0812743883615744119718921581105236506756,
        0.0812743883615744119718921581105236506756,
        0.3123470770400028400686304065844436655987,
        0.3123470770400028400686304065844436655987,
        0.2606106964029354623187428694186328497718,
        0.2606106964029354623187428694186328497718
    ],
    [
        0.295524224714752870173892994651338329421,
        0.295524224714752870173892994651338329421,
        0.2692667193099963550912269215694693528597,
        0.2692667193099963550912269215694693528597,
        0.2190863625159820439955349342281631924587,
        0.2190863625159820439955349342281631924587,
        0.1494513491505805931457763396576973324025,
        0.1494513491505805931457763396576973324025,
        0.0666713443086881375935688098933317928578,
        0.0666713443086881375935688098933317928578
    ],
    [
        0.272925086777900630714483528336342189156,
        0.2628045445102466621806888698905091953727,
        0.2628045445102466621806888698905091953727,
        0.2331937645919904799185237048431751394317,
        0.2331937645919904799185237048431751394317,
        0.1862902109277342514260976414316558916912,
        0.1862902109277342514260976414316558916912,
        0.1255803694649046246346942992239401001976,
        0.1255803694649046246346942992239401001976,
        0.0556685671161736664827537204425485787285,
        0.0556685671161736664827537204425485787285
    ],
    [
        0.2491470458134027850005624360429512108304,
        0.2491470458134027850005624360429512108304,
        0.2334925365383548087608498989248780562594,
        0.2334925365383548087608498989248780562594,
        0.2031674267230659217490644558097983765065,
        0.2031674267230659217490644558097983765065,
        0.160078328543346226334652529543359071872,
        0.160078328543346226334652529543359071872,
        0.1069393259953184309602547181939962242145,
        0.1069393259953184309602547181939962242145,
        0.047175336386511827194615961485017060317,
        0.047175336386511827194615961485017060317
    ],
    [
        0.2325515532308739101945895152688359481566,
        0.2262831802628972384120901860397766184347,
        0.2262831802628972384120901860397766184347,
        0.2078160475368885023125232193060527633865,
        0.2078160475368885023125232193060527633865,
        0.1781459807619457382800466919960979955128,
        0.1781459807619457382800466919960979955128,
        0.1388735102197872384636017768688714676218,
        0.1388735102197872384636017768688714676218,
        0.0921214998377284479144217759537971209236,
        0.0921214998377284479144217759537971209236,
        0.0404840047653158795200215922009860600419,
        0.0404840047653158795200215922009860600419
    ],
    [
        0.2152638534631577901958764433162600352749,
        0.2152638534631577901958764433162600352749,
        0.2051984637212956039659240656612180557103,
        0.2051984637212956039659240656612180557103,
        0.1855383974779378137417165901251570362489,
        0.1855383974779378137417165901251570362489,
        0.1572031671581935345696019386238421566056,
        0.1572031671581935345696019386238421566056,
        0.1215185706879031846894148090724766259566,
        0.1215185706879031846894148090724766259566,
        0.0801580871597602098056332770628543095836,
        0.0801580871597602098056332770628543095836,
        0.0351194603317518630318328761381917806197,
        0.0351194603317518630318328761381917806197
    ],
    [
        0.2025782419255612728806201999675193148386,
        0.1984314853271115764561183264438393248186,
        0.1984314853271115764561183264438393248186,
        0.1861610000155622110268005618664228245062,
        0.1861610000155622110268005618664228245062,
        0.1662692058169939335532008604812088111309,
        0.1662692058169939335532008604812088111309,
        0.1395706779261543144478047945110283225208,
        0.1395706779261543144478047945110283225208,
        0.1071592204671719350118695466858693034155,
        0.1071592204671719350118695466858693034155,
        0.0703660474881081247092674164506673384667,
        0.0703660474881081247092674164506673384667,
        0.0307532419961172683546283935772044177217,
        0.0307532419961172683546283935772044177217
    ],
    [
        0.1894506104550684962853967232082831051469,
        0.1894506104550684962853967232082831051469,
        0.1826034150449235888667636679692199393835,
        0.1826034150449235888667636679692199393835,
        0.1691565193950025381893120790303599622116,
        0.1691565193950025381893120790303599622116,
        0.1495959888165767320815017305474785489704,
        0.1495959888165767320815017305474785489704,
        0.1246289712555338720524762821920164201448,
        0.1246289712555338720524762821920164201448,
        0.0951585116824927848099251076022462263552,
        0.0951585116824927848099251076022462263552,
        0.0622535239386478928628438369943776942749,
        0.0622535239386478928628438369943776942749,
        0.0271524594117540948517805724560181035122,
        0.0271524594117540948517805724560181035122
    ],
    [
        0.1794464703562065254582656442618856214487,
        0.1765627053669926463252709901131972391509,
        0.1765627053669926463252709901131972391509,
        0.1680041021564500445099706637883231550211,
        0.1680041021564500445099706637883231550211,
        0.1540457610768102880814315948019586119404,
        0.1540457610768102880814315948019586119404,
        0.1351363684685254732863199817023501973721,
        0.1351363684685254732863199817023501973721,
        0.1118838471934039710947883856263559267358,
        0.1118838471934039710947883856263559267358,
        0.0850361483171791808835353701910620738504,
        0.0850361483171791808835353701910620738504,
        0.0554595293739872011294401653582446605128,
        0.0554595293739872011294401653582446605128,
        0.0241483028685479319601100262875653246916,
        0.0241483028685479319601100262875653246916
    ],
    [
        0.1691423829631435918406564701349866103341,
        0.1691423829631435918406564701349866103341,
        0.1642764837458327229860537764659275904123,
        0.1642764837458327229860537764659275904123,
        0.1546846751262652449254180038363747721932,
        0.1546846751262652449254180038363747721932,
        0.1406429146706506512047313037519472280955,
        0.1406429146706506512047313037519472280955,
        0.1225552067114784601845191268002015552281,
        0.1225552067114784601845191268002015552281,
        0.1009420441062871655628139849248346070628,
        0.1009420441062871655628139849248346070628,
        0.0764257302548890565291296776166365256053,
        0.0764257302548890565291296776166365256053,
        0.0497145488949697964533349462026386416808,
        0.0497145488949697964533349462026386416808,
        0.0216160135264833103133427102664524693876,
        0.0216160135264833103133427102664524693876
    ],
    [
        0.1610544498487836959791636253209167350399,
        0.1589688433939543476499564394650472016787,
        0.1589688433939543476499564394650472016787,
        0.152766042065859666778855400897662998461,
        0.152766042065859666778855400897662998461,
        0.1426067021736066117757461094419029724756,
        0.1426067021736066117757461094419029724756,
        0.1287539625393362276755157848568771170558,
        0.1287539625393362276755157848568771170558,
        0.1115666455473339947160239016817659974813,
        0.1115666455473339947160239016817659974813,
        0.0914900216224499994644620941238396526609,
        0.0914900216224499994644620941238396526609,
        0.0690445427376412265807082580060130449618,
        0.0690445427376412265807082580060130449618,
        0.0448142267656996003328381574019942119517,
        0.0448142267656996003328381574019942119517,
        0.0194617882297264770363120414644384357529,
        0.0194617882297264770363120414644384357529
    ],
    [
        0.1527533871307258506980843319550975934919,
        0.1527533871307258506980843319550975934919,
        0.1491729864726037467878287370019694366926,
        0.1491729864726037467878287370019694366926,
        0.1420961093183820513292983250671649330345,
        0.1420961093183820513292983250671649330345,
        0.1316886384491766268984944997481631349161,
        0.1316886384491766268984944997481631349161,
        0.118194531961518417312377377711382287005,
        0.118194531961518417312377377711382287005,
        0.1019301198172404350367501354803498761666,
        0.1019301198172404350367501354803498761666,
        0.0832767415767047487247581432220462061001,
        0.0832767415767047487247581432220462061001,
        0.0626720483341090635695065351870416063516,
        0.0626720483341090635695065351870416063516,
        0.040601429800386941331039952274932109879,
        0.040601429800386941331039952274932109879,
        0.0176140071391521183118619623518528163621,
        0.0176140071391521183118619623518528163621
    ],
    [
        0.1460811336496904271919851476833711882448,
        0.1445244039899700590638271665537525436099,
        0.1445244039899700590638271665537525436099,
        0.1398873947910731547221334238675831108927,
        0.1398873947910731547221334238675831108927,
        0.132268938633337461781052574496775604329,
        0.132268938633337461781052574496775604329,
        0.1218314160537285341953671771257335983563,
        0.1218314160537285341953671771257335983563,
        0.1087972991671483776634745780701056420336,
        0.1087972991671483776634745780701056420336,
        0.0934444234560338615532897411139320884835,
        0.0934444234560338615532897411139320884835,
        0.0761001136283793020170516533001831792261,
        0.0761001136283793020170516533001831792261,
        0.0571344254268572082836358264724479574912,
        0.0571344254268572082836358264724479574912,
        0.0369537897708524937999506682993296661889,
        0.0369537897708524937999506682993296661889,
        0.0160172282577743333242246168584710152658,
        0.0160172282577743333242246168584710152658
    ],
    [
        0.1392518728556319933754102483418099578739,
        0.1392518728556319933754102483418099578739,
        0.1365414983460151713525738312315173965863,
        0.1365414983460151713525738312315173965863,
        0.1311735047870623707329649925303074458757,
        0.1311735047870623707329649925303074458757,
        0.1232523768105124242855609861548144719594,
        0.1232523768105124242855609861548144719594,
        0.1129322960805392183934006074217843191142,
        0.1129322960805392183934006074217843191142,
        0.1004141444428809649320788378305362823508,
        0.1004141444428809649320788378305362823508,
        0.0859416062170677274144436813727028661891,
        0.0859416062170677274144436813727028661891,
        0.0697964684245204880949614189302176573987,
        0.0697964684245204880949614189302176573987,
        0.0522933351526832859403120512732112561121,
        0.0522933351526832859403120512732112561121,
        0.0337749015848141547933022468659129013491,
        0.0337749015848141547933022468659129013491,
        0.0146279952982722006849910980471854451902,
        0.0146279952982722006849910980471854451902
    ],
    [
        0.1336545721861061753514571105458443385831,
        0.132462039404696617371642464703316925805,
        0.132462039404696617371642464703316925805,
        0.1289057221880821499785953393997936532597,
        0.1289057221880821499785953393997936532597,
        0.1230490843067295304675784006720096548158,
        0.1230490843067295304675784006720096548158,
        0.1149966402224113649416435129339613014914,
        0.1149966402224113649416435129339613014914,
        0.1048920914645414100740861850147438548584,
        0.1048920914645414100740861850147438548584,
        0.0929157660600351474770186173697646486034,
        0.0929157660600351474770186173697646486034,
        0.0792814117767189549228925247420432269137,
        0.0792814117767189549228925247420432269137,
        0.0642324214085258521271696151589109980391,
        0.0642324214085258521271696151589109980391,
        0.0480376717310846685716410716320339965612,
        0.0480376717310846685716410716320339965612,
        0.0309880058569794443106942196418845053837,
        0.0309880058569794443106942196418845053837,
        0.0134118594871417720813094934586150649766,
        0.0134118594871417720813094934586150649766
    ],
    [
        0.1279381953467521569740561652246953718517,
        0.1279381953467521569740561652246953718517,
        0.1258374563468282961213753825111836887264,
        0.1258374563468282961213753825111836887264,
        0.121670472927803391204463153476262425607,
        0.121670472927803391204463153476262425607,
        0.1155056680537256013533444839067835598622,
        0.1155056680537256013533444839067835598622,
        0.1074442701159656347825773424466062227946,
        0.1074442701159656347825773424466062227946,
        0.0976186521041138882698806644642471544279,
        0.0976186521041138882698806644642471544279,
        0.086190161531953275917185202983742667185,
        0.086190161531953275917185202983742667185,
        0.0733464814110803057340336152531165181193,
        0.0733464814110803057340336152531165181193,
        0.0592985849154367807463677585001085845412,
        0.0592985849154367807463677585001085845412,
        0.0442774388174198061686027482113382288593,
        0.0442774388174198061686027482113382288593,
        0.0285313886289336631813078159518782864491,
        0.0285313886289336631813078159518782864491,
        0.0123412297999871995468056670700372915759,
        0.0123412297999871995468056670700372915759
    ]
];
const $5445f83816334314$export$75c342514231e6de = [
    [
        1
    ],
    [
        1,
        1
    ],
    [
        1,
        2,
        1
    ],
    [
        1,
        3,
        3,
        1
    ]
];
const $5445f83816334314$export$303d0010d4a82673 = (xs, ys, t)=>{
    let sum;
    let correctedT;
    const n = 20;
    const z = t / 2;
    sum = 0;
    for(let i = 0; i < n; i++){
        correctedT = z * $5445f83816334314$export$9b0e545caa171200[n][i] + z;
        sum += $5445f83816334314$export$63f082a24e4d0d2[n][i] * $5445f83816334314$var$BFunc(xs, ys, correctedT);
    }
    return z * sum;
};
const $5445f83816334314$export$80a8cfc7cba8a0a9 = (xs, ys, t)=>{
    if (t === undefined) t = 1;
    const ax = xs[0] - 2 * xs[1] + xs[2];
    const ay = ys[0] - 2 * ys[1] + ys[2];
    const bx = 2 * xs[1] - 2 * xs[0];
    const by = 2 * ys[1] - 2 * ys[0];
    const A = 4 * (ax * ax + ay * ay);
    const B = 4 * (ax * bx + ay * by);
    const C = bx * bx + by * by;
    if (A === 0) return t * Math.sqrt(Math.pow(xs[2] - xs[0], 2) + Math.pow(ys[2] - ys[0], 2));
    const b = B / (2 * A);
    const c = C / A;
    const u = t + b;
    const k = c - b * b;
    const uuk = u * u + k > 0 ? Math.sqrt(u * u + k) : 0;
    const bbk = b * b + k > 0 ? Math.sqrt(b * b + k) : 0;
    const term = b + Math.sqrt(b * b + k) !== 0 ? k * Math.log(Math.abs((u + uuk) / (b + bbk))) : 0;
    return Math.sqrt(A) / 2 * (u * uuk - b * bbk + term);
};
function $5445f83816334314$var$BFunc(xs, ys, t) {
    const xbase = $5445f83816334314$var$getDerivative(1, t, xs);
    const ybase = $5445f83816334314$var$getDerivative(1, t, ys);
    const combined = xbase * xbase + ybase * ybase;
    return Math.sqrt(combined);
}
const $5445f83816334314$var$getDerivative = (derivative, t, vs)=>{
    const n = vs.length - 1;
    let _vs;
    let value;
    if (n === 0) return 0;
    if (derivative === 0) {
        value = 0;
        for(let k = 0; k <= n; k++)value += $5445f83816334314$export$75c342514231e6de[n][k] * Math.pow(1 - t, n - k) * Math.pow(t, k) * vs[k];
        return value;
    } else {
        _vs = new Array(n);
        for(let k = 0; k < n; k++)_vs[k] = n * (vs[k + 1] - vs[k]);
        return $5445f83816334314$var$getDerivative(derivative - 1, t, _vs);
    }
};
const $5445f83816334314$export$e638253c5cb35420 = (length, totalLength, func)=>{
    let error = 1;
    let t = length / totalLength;
    let step = (length - func(t)) / totalLength;
    let numIterations = 0;
    while(error > 0.001){
        const increasedTLength = func(t + step);
        const increasedTError = Math.abs(length - increasedTLength) / totalLength;
        if (increasedTError < error) {
            error = increasedTError;
            t += step;
        } else {
            const decreasedTLength = func(t - step);
            const decreasedTError = Math.abs(length - decreasedTLength) / totalLength;
            if (decreasedTError < error) {
                error = decreasedTError;
                t -= step;
            } else step /= 2;
        }
        numIterations++;
        if (numIterations > 500) break;
    }
    return t;
};


class $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.dataArray = [];
        this.pathLength = 0;
        this._readDataAttribute();
        this.on('dataChange.konva', function() {
            this._readDataAttribute();
        });
    }
    _readDataAttribute() {
        this.dataArray = $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.parsePathData(this.data());
        this.pathLength = $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPathLength(this.dataArray);
    }
    _sceneFunc(context) {
        const ca = this.dataArray;
        context.beginPath();
        let isClosed = false;
        for(let n = 0; n < ca.length; n++){
            const c = ca[n].command;
            const p = ca[n].points;
            switch(c){
                case 'L':
                    context.lineTo(p[0], p[1]);
                    break;
                case 'M':
                    context.moveTo(p[0], p[1]);
                    break;
                case 'C':
                    context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
                    break;
                case 'Q':
                    context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
                    break;
                case 'A':
                    const cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6], fs = p[7];
                    const r = rx > ry ? rx : ry;
                    const scaleX = rx > ry ? 1 : rx / ry;
                    const scaleY = rx > ry ? ry / rx : 1;
                    context.translate(cx, cy);
                    context.rotate(psi);
                    context.scale(scaleX, scaleY);
                    context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
                    context.scale(1 / scaleX, 1 / scaleY);
                    context.rotate(-psi);
                    context.translate(-cx, -cy);
                    break;
                case 'z':
                    isClosed = true;
                    context.closePath();
                    break;
            }
        }
        if (!isClosed && !this.hasFill()) context.strokeShape(this);
        else context.fillStrokeShape(this);
    }
    getSelfRect() {
        let points = [];
        this.dataArray.forEach(function(data) {
            if (data.command === 'A') {
                const start = data.points[4];
                const dTheta = data.points[5];
                const end = data.points[4] + dTheta;
                let inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                if (dTheta < 0) for(let t = start - inc; t > end; t -= inc){
                    const point = $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
                else for(let t = start + inc; t < end; t += inc){
                    const point = $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
            } else if (data.command === 'C') for(let t = 0.0; t <= 1; t += 0.01){
                const point = $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointOnCubicBezier(t, data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3], data.points[4], data.points[5]);
                points.push(point.x, point.y);
            }
            else points = points.concat(data.points);
        });
        let minX = points[0];
        let maxX = points[0];
        let minY = points[1];
        let maxY = points[1];
        let x, y;
        for(let i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            if (!isNaN(x)) {
                minX = Math.min(minX, x);
                maxX = Math.max(maxX, x);
            }
            if (!isNaN(y)) {
                minY = Math.min(minY, y);
                maxY = Math.max(maxY, y);
            }
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getLength() {
        return this.pathLength;
    }
    getPointAtLength(length) {
        return $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointAtLengthOfDataArray(length, this.dataArray);
    }
    static getLineLength(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    static getPathLength(dataArray) {
        let pathLength = 0;
        for(let i = 0; i < dataArray.length; ++i)pathLength += dataArray[i].pathLength;
        return pathLength;
    }
    static getPointAtLengthOfDataArray(length, dataArray) {
        let points, i = 0, ii = dataArray.length;
        if (!ii) return null;
        while(i < ii && length > dataArray[i].pathLength){
            length -= dataArray[i].pathLength;
            ++i;
        }
        if (i === ii) {
            points = dataArray[i - 1].points.slice(-2);
            return {
                x: points[0],
                y: points[1]
            };
        }
        if (length < 0.01) {
            const cmd = dataArray[i].command;
            if (cmd === 'M') {
                points = dataArray[i].points.slice(0, 2);
                return {
                    x: points[0],
                    y: points[1]
                };
            } else return {
                x: dataArray[i].start.x,
                y: dataArray[i].start.y
            };
        }
        const cp = dataArray[i];
        const p = cp.points;
        switch(cp.command){
            case 'L':
                return $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointOnLine(length, cp.start.x, cp.start.y, p[0], p[1]);
            case 'C':
                return $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointOnCubicBezier((0, $5445f83816334314$export$e638253c5cb35420)(length, $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPathLength(dataArray), (i)=>{
                    return (0, $5445f83816334314$export$303d0010d4a82673)([
                        cp.start.x,
                        p[0],
                        p[2],
                        p[4]
                    ], [
                        cp.start.y,
                        p[1],
                        p[3],
                        p[5]
                    ], i);
                }), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3], p[4], p[5]);
            case 'Q':
                return $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointOnQuadraticBezier((0, $5445f83816334314$export$e638253c5cb35420)(length, $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPathLength(dataArray), (i)=>{
                    return (0, $5445f83816334314$export$80a8cfc7cba8a0a9)([
                        cp.start.x,
                        p[0],
                        p[2]
                    ], [
                        cp.start.y,
                        p[1],
                        p[3]
                    ], i);
                }), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3]);
            case 'A':
                const cx = p[0], cy = p[1], rx = p[2], ry = p[3], dTheta = p[5], psi = p[6];
                let theta = p[4];
                theta += dTheta * length / cp.pathLength;
                return $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi);
        }
        return null;
    }
    static getPointOnLine(dist, P1x, P1y, P2x, P2y, fromX, fromY) {
        fromX = fromX !== null && fromX !== void 0 ? fromX : P1x;
        fromY = fromY !== null && fromY !== void 0 ? fromY : P1y;
        const len = this.getLineLength(P1x, P1y, P2x, P2y);
        if (len < 1e-10) return {
            x: P1x,
            y: P1y
        };
        if (P2x === P1x) return {
            x: fromX,
            y: fromY + (P2y > P1y ? dist : -dist)
        };
        const m = (P2y - P1y) / (P2x - P1x);
        const run = Math.sqrt(dist * dist / (1 + m * m)) * (P2x < P1x ? -1 : 1);
        const rise = m * run;
        if (Math.abs(fromY - P1y - m * (fromX - P1x)) < 1e-10) return {
            x: fromX + run,
            y: fromY + rise
        };
        const u = ((fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y)) / (len * len);
        const ix = P1x + u * (P2x - P1x);
        const iy = P1y + u * (P2y - P1y);
        const pRise = this.getLineLength(fromX, fromY, ix, iy);
        const pRun = Math.sqrt(dist * dist - pRise * pRise);
        const adjustedRun = Math.sqrt(pRun * pRun / (1 + m * m)) * (P2x < P1x ? -1 : 1);
        const adjustedRise = m * adjustedRun;
        return {
            x: ix + adjustedRun,
            y: iy + adjustedRise
        };
    }
    static getPointOnCubicBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
        function CB1(t) {
            return t * t * t;
        }
        function CB2(t) {
            return 3 * t * t * (1 - t);
        }
        function CB3(t) {
            return 3 * t * (1 - t) * (1 - t);
        }
        function CB4(t) {
            return (1 - t) * (1 - t) * (1 - t);
        }
        const x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
        const y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnQuadraticBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y) {
        function QB1(t) {
            return t * t;
        }
        function QB2(t) {
            return 2 * t * (1 - t);
        }
        function QB3(t) {
            return (1 - t) * (1 - t);
        }
        const x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
        const y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
        const cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
        const pt = {
            x: rx * Math.cos(theta),
            y: ry * Math.sin(theta)
        };
        return {
            x: cx + (pt.x * cosPsi - pt.y * sinPsi),
            y: cy + (pt.x * sinPsi + pt.y * cosPsi)
        };
    }
    static parsePathData(data) {
        if (!data) return [];
        let cs = data;
        const cc = [
            'm',
            'M',
            'l',
            'L',
            'v',
            'V',
            'h',
            'H',
            'z',
            'Z',
            'c',
            'C',
            'q',
            'Q',
            't',
            'T',
            's',
            'S',
            'a',
            'A'
        ];
        cs = cs.replace(new RegExp(' ', 'g'), ',');
        for(let n = 0; n < cc.length; n++)cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
        const arr = cs.split('|');
        const ca = [];
        const coords = [];
        let cpx = 0;
        let cpy = 0;
        const re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
        let match;
        for(let n = 1; n < arr.length; n++){
            let str = arr[n];
            let c = str.charAt(0);
            str = str.slice(1);
            coords.length = 0;
            while(match = re.exec(str))coords.push(match[0]);
            let p = [];
            let arcParamIndex = c === 'A' || c === 'a' ? 0 : -1;
            for(let j = 0, jlen = coords.length; j < jlen; j++){
                const token = coords[j];
                if (token === '00') {
                    p.push(0, 0);
                    if (arcParamIndex >= 0) {
                        arcParamIndex += 2;
                        if (arcParamIndex >= 7) arcParamIndex -= 7;
                    }
                    continue;
                }
                if (arcParamIndex >= 0) {
                    if (arcParamIndex === 3) {
                        if (/^[01]{2}\d+(?:\.\d+)?$/.test(token)) {
                            p.push(parseInt(token[0], 10));
                            p.push(parseInt(token[1], 10));
                            p.push(parseFloat(token.slice(2)));
                            arcParamIndex += 3;
                            if (arcParamIndex >= 7) arcParamIndex -= 7;
                            continue;
                        }
                        if (token === '11' || token === '10' || token === '01') {
                            p.push(parseInt(token[0], 10));
                            p.push(parseInt(token[1], 10));
                            arcParamIndex += 2;
                            if (arcParamIndex >= 7) arcParamIndex -= 7;
                            continue;
                        }
                        if (token === '0' || token === '1') {
                            p.push(parseInt(token, 10));
                            arcParamIndex += 1;
                            if (arcParamIndex >= 7) arcParamIndex -= 7;
                            continue;
                        }
                    } else if (arcParamIndex === 4) {
                        if (/^[01]\d+(?:\.\d+)?$/.test(token)) {
                            p.push(parseInt(token[0], 10));
                            p.push(parseFloat(token.slice(1)));
                            arcParamIndex += 2;
                            if (arcParamIndex >= 7) arcParamIndex -= 7;
                            continue;
                        }
                        if (token === '0' || token === '1') {
                            p.push(parseInt(token, 10));
                            arcParamIndex += 1;
                            if (arcParamIndex >= 7) arcParamIndex -= 7;
                            continue;
                        }
                    }
                    const parsedArc = parseFloat(token);
                    if (!isNaN(parsedArc)) p.push(parsedArc);
                    else p.push(0);
                    arcParamIndex += 1;
                    if (arcParamIndex >= 7) arcParamIndex -= 7;
                } else {
                    const parsed = parseFloat(token);
                    if (!isNaN(parsed)) p.push(parsed);
                    else p.push(0);
                }
            }
            while(p.length > 0){
                if (isNaN(p[0])) break;
                let cmd = '';
                let points = [];
                const startX = cpx, startY = cpy;
                let prevCmd, ctlPtx, ctlPty;
                let rx, ry, psi, fa, fs, x1, y1;
                switch(c){
                    case 'l':
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'L':
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'm':
                        const dx = p.shift();
                        const dy = p.shift();
                        cpx += dx;
                        cpy += dy;
                        cmd = 'M';
                        if (ca.length > 2 && ca[ca.length - 1].command === 'z') {
                            for(let idx = ca.length - 2; idx >= 0; idx--)if (ca[idx].command === 'M') {
                                cpx = ca[idx].points[0] + dx;
                                cpy = ca[idx].points[1] + dy;
                                break;
                            }
                        }
                        points.push(cpx, cpy);
                        c = 'l';
                        break;
                    case 'M':
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'M';
                        points.push(cpx, cpy);
                        c = 'L';
                        break;
                    case 'h':
                        cpx += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'H':
                        cpx = p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'v':
                        cpy += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'V':
                        cpy = p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'C':
                        points.push(p.shift(), p.shift(), p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'c':
                        points.push(cpx + p.shift(), cpy + p.shift(), cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'S':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 's':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'Q':
                        points.push(p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'q':
                        points.push(cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'Q';
                        points.push(cpx, cpy);
                        break;
                    case 'T':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 't':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 'A':
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'A';
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                    case 'a':
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'A';
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                }
                ca.push({
                    command: cmd || c,
                    points: points,
                    start: {
                        x: startX,
                        y: startY
                    },
                    pathLength: this.calcLength(startX, startY, cmd || c, points)
                });
            }
            if (c === 'z' || c === 'Z') ca.push({
                command: 'z',
                points: [],
                start: undefined,
                pathLength: 0
            });
        }
        return ca;
    }
    static calcLength(x, y, cmd, points) {
        let len, p1, p2, t;
        const path = $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9;
        switch(cmd){
            case 'L':
                return path.getLineLength(x, y, points[0], points[1]);
            case 'C':
                return (0, $5445f83816334314$export$303d0010d4a82673)([
                    x,
                    points[0],
                    points[2],
                    points[4]
                ], [
                    y,
                    points[1],
                    points[3],
                    points[5]
                ], 1);
            case 'Q':
                return (0, $5445f83816334314$export$80a8cfc7cba8a0a9)([
                    x,
                    points[0],
                    points[2]
                ], [
                    y,
                    points[1],
                    points[3]
                ], 1);
            case 'A':
                len = 0.0;
                const start = points[4];
                const dTheta = points[5];
                const end = points[4] + dTheta;
                let inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                p1 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
                if (dTheta < 0) for(t = start - inc; t > end; t -= inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                else for(t = start + inc; t < end; t += inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
                len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                return len;
        }
        return 0;
    }
    static convertEndpointToCenterParameterization(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg) {
        const psi = psiDeg * (Math.PI / 180.0);
        const xp = Math.cos(psi) * (x1 - x2) / 2.0 + Math.sin(psi) * (y1 - y2) / 2.0;
        const yp = -1 * Math.sin(psi) * (x1 - x2) / 2.0 + Math.cos(psi) * (y1 - y2) / 2.0;
        const lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
        if (lambda > 1) {
            rx *= Math.sqrt(lambda);
            ry *= Math.sqrt(lambda);
        }
        let f = Math.sqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp)));
        if (fa === fs) f *= -1;
        if (isNaN(f)) f = 0;
        const cxp = f * rx * yp / ry;
        const cyp = f * -ry * xp / rx;
        const cx = (x1 + x2) / 2.0 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
        const cy = (y1 + y2) / 2.0 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
        const vMag = function(v) {
            return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
        };
        const vRatio = function(u, v) {
            return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
        };
        const vAngle = function(u, v) {
            return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
        };
        const theta = vAngle([
            1,
            0
        ], [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ]);
        const u = [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ];
        const v = [
            (-1 * xp - cxp) / rx,
            (-1 * yp - cyp) / ry
        ];
        let dTheta = vAngle(u, v);
        if (vRatio(u, v) <= -1) dTheta = Math.PI;
        if (vRatio(u, v) >= 1) dTheta = 0;
        if (fs === 0 && dTheta > 0) dTheta = dTheta - 2 * Math.PI;
        if (fs === 1 && dTheta < 0) dTheta = dTheta + 2 * Math.PI;
        return [
            cx,
            cy,
            rx,
            ry,
            theta,
            dTheta,
            psi,
            fs
        ];
    }
}
$d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.prototype.className = 'Path';
$d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.prototype._attrsAffectingSize = [
    'data'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9, 'data');


class $ed4c5015d754ac7a$export$21b07c8f274aebd5 extends (0, $5329876ec3db1142$export$17d680238e50603e) {
    _sceneFunc(ctx) {
        super._sceneFunc(ctx);
        const PI2 = Math.PI * 2;
        const points = this.points();
        let tp = points;
        const fromTension = this.tension() !== 0 && points.length > 4;
        if (fromTension) tp = this.getTensionPoints();
        const length = this.pointerLength();
        const n = points.length;
        let dx, dy;
        if (fromTension) {
            const lp = [
                tp[tp.length - 4],
                tp[tp.length - 3],
                tp[tp.length - 2],
                tp[tp.length - 1],
                points[n - 2],
                points[n - 1]
            ];
            const lastLength = (0, $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9).calcLength(tp[tp.length - 4], tp[tp.length - 3], 'C', lp);
            const previous = (0, $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9).getPointOnQuadraticBezier(Math.min(1, 1 - length / lastLength), lp[0], lp[1], lp[2], lp[3], lp[4], lp[5]);
            dx = points[n - 2] - previous.x;
            dy = points[n - 1] - previous.y;
        } else {
            dx = points[n - 2] - points[n - 4];
            dy = points[n - 1] - points[n - 3];
        }
        const radians = (Math.atan2(dy, dx) + PI2) % PI2;
        const width = this.pointerWidth();
        if (this.pointerAtEnding()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[n - 2], points[n - 1]);
            ctx.rotate(radians);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
        if (this.pointerAtBeginning()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[0], points[1]);
            if (fromTension) {
                dx = (tp[0] + tp[2]) / 2 - points[0];
                dy = (tp[1] + tp[3]) / 2 - points[1];
            } else {
                dx = points[2] - points[0];
                dy = points[3] - points[1];
            }
            ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
    }
    __fillStroke(ctx) {
        const isDashEnabled = this.dashEnabled();
        if (isDashEnabled) {
            this.attrs.dashEnabled = false;
            ctx.setLineDash([]);
        }
        ctx.fillStrokeShape(this);
        if (isDashEnabled) this.attrs.dashEnabled = true;
    }
    getSelfRect() {
        const lineRect = super.getSelfRect();
        const offset = this.pointerWidth() / 2;
        return {
            x: lineRect.x,
            y: lineRect.y - offset,
            width: lineRect.width,
            height: lineRect.height + offset * 2
        };
    }
}
$ed4c5015d754ac7a$export$21b07c8f274aebd5.prototype.className = 'Arrow';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($ed4c5015d754ac7a$export$21b07c8f274aebd5);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($ed4c5015d754ac7a$export$21b07c8f274aebd5, 'pointerLength', 10, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($ed4c5015d754ac7a$export$21b07c8f274aebd5, 'pointerWidth', 10, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($ed4c5015d754ac7a$export$21b07c8f274aebd5, 'pointerAtBeginning', false);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($ed4c5015d754ac7a$export$21b07c8f274aebd5, 'pointerAtEnding', true);






class $cfc8e10222484598$export$c89a927ffc67e6fa extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        if (this.radius() !== width / 2) this.radius(width / 2);
    }
    setHeight(height) {
        if (this.radius() !== height / 2) this.radius(height / 2);
    }
}
$cfc8e10222484598$export$c89a927ffc67e6fa.prototype._centroid = true;
$cfc8e10222484598$export$c89a927ffc67e6fa.prototype.className = 'Circle';
$cfc8e10222484598$export$c89a927ffc67e6fa.prototype._attrsAffectingSize = [
    'radius'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($cfc8e10222484598$export$c89a927ffc67e6fa);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($cfc8e10222484598$export$c89a927ffc67e6fa, 'radius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());






class $a1df33efdd3b5d94$export$80b0269ab108fa11 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const rx = this.radiusX(), ry = this.radiusY();
        context.beginPath();
        context.save();
        if (rx !== ry) context.scale(1, ry / rx);
        context.arc(0, 0, rx, 0, Math.PI * 2, false);
        context.restore();
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radiusX() * 2;
    }
    getHeight() {
        return this.radiusY() * 2;
    }
    setWidth(width) {
        this.radiusX(width / 2);
    }
    setHeight(height) {
        this.radiusY(height / 2);
    }
}
$a1df33efdd3b5d94$export$80b0269ab108fa11.prototype.className = 'Ellipse';
$a1df33efdd3b5d94$export$80b0269ab108fa11.prototype._centroid = true;
$a1df33efdd3b5d94$export$80b0269ab108fa11.prototype._attrsAffectingSize = [
    'radiusX',
    'radiusY'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($a1df33efdd3b5d94$export$80b0269ab108fa11);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($a1df33efdd3b5d94$export$80b0269ab108fa11, 'radius', [
    'x',
    'y'
]);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($a1df33efdd3b5d94$export$80b0269ab108fa11, 'radiusX', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($a1df33efdd3b5d94$export$80b0269ab108fa11, 'radiusY', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());







class $f0156a163f3b5062$export$3e431a229df88919 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    constructor(attrs){
        super(attrs);
        this._loadListener = ()=>{
            this._requestDraw();
        };
        this.on('imageChange.konva', (props)=>{
            this._removeImageLoad(props.oldVal);
            this._setImageLoad();
        });
        this._setImageLoad();
    }
    _setImageLoad() {
        const image = this.image();
        if (image && image.complete) return;
        if (image && image.readyState === 4) return;
        if (image && image['addEventListener']) image['addEventListener']('load', this._loadListener);
    }
    _removeImageLoad(image) {
        if (image && image['removeEventListener']) image['removeEventListener']('load', this._loadListener);
    }
    destroy() {
        this._removeImageLoad(this.image());
        super.destroy();
        return this;
    }
    _useBufferCanvas() {
        const hasCornerRadius = !!this.cornerRadius();
        const hasShadow = this.hasShadow();
        if (hasCornerRadius && hasShadow) return true;
        return super._useBufferCanvas(true);
    }
    _sceneFunc(context) {
        const width = this.getWidth();
        const height = this.getHeight();
        const cornerRadius = this.cornerRadius();
        const image = this.attrs.image;
        let params;
        if (image) {
            const cropWidth = this.attrs.cropWidth;
            const cropHeight = this.attrs.cropHeight;
            if (cropWidth && cropHeight) params = [
                image,
                this.cropX(),
                this.cropY(),
                cropWidth,
                cropHeight,
                0,
                0,
                width,
                height
            ];
            else params = [
                image,
                0,
                0,
                width,
                height
            ];
        }
        if (this.hasFill() || this.hasStroke() || cornerRadius) {
            context.beginPath();
            cornerRadius ? (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius) : context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (cornerRadius) context.clip();
            context.drawImage.apply(context, params);
        }
    }
    _hitFunc(context) {
        const width = this.width(), height = this.height(), cornerRadius = this.cornerRadius();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        var _a, _b, _c;
        return (_c = (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : 0;
    }
    getHeight() {
        var _a, _b, _c;
        return (_c = (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.height) !== null && _c !== void 0 ? _c : 0;
    }
    static fromURL(url, callback, onError = null) {
        const img = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).createImageElement();
        img.onload = function() {
            const image = new $f0156a163f3b5062$export$3e431a229df88919({
                image: img
            });
            callback(image);
        };
        img.onerror = onError;
        img.crossOrigin = 'Anonymous';
        img.src = url;
    }
}
$f0156a163f3b5062$export$3e431a229df88919.prototype.className = 'Image';
$f0156a163f3b5062$export$3e431a229df88919.prototype._attrsAffectingSize = [
    'image'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($f0156a163f3b5062$export$3e431a229df88919);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f0156a163f3b5062$export$3e431a229df88919, 'cornerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$7d4ab1842c1b264b)(4));
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f0156a163f3b5062$export$3e431a229df88919, 'image');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($f0156a163f3b5062$export$3e431a229df88919, 'crop', [
    'x',
    'y',
    'width',
    'height'
]);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f0156a163f3b5062$export$3e431a229df88919, 'cropX', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f0156a163f3b5062$export$3e431a229df88919, 'cropY', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f0156a163f3b5062$export$3e431a229df88919, 'cropWidth', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f0156a163f3b5062$export$3e431a229df88919, 'cropHeight', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());







const $68b4427dcf69bf6a$var$ATTR_CHANGE_LIST = [
    'fontFamily',
    'fontSize',
    'fontStyle',
    'padding',
    'lineHeight',
    'text',
    'width',
    'height',
    'pointerDirection',
    'pointerWidth',
    'pointerHeight'
], $68b4427dcf69bf6a$var$CHANGE_KONVA = 'Change.konva', $68b4427dcf69bf6a$var$NONE = 'none', $68b4427dcf69bf6a$var$UP = 'up', $68b4427dcf69bf6a$var$RIGHT = 'right', $68b4427dcf69bf6a$var$DOWN = 'down', $68b4427dcf69bf6a$var$LEFT = 'left', $68b4427dcf69bf6a$var$attrChangeListLen = $68b4427dcf69bf6a$var$ATTR_CHANGE_LIST.length;
class $68b4427dcf69bf6a$export$b04be29aa201d4f5 extends (0, $644b7f3bf259f4bd$export$eb2fcfdbd7ba97d4) {
    constructor(config){
        super(config);
        this.on('add.konva', function(evt) {
            this._addListeners(evt.child);
            this._sync();
        });
    }
    getText() {
        return this.find('Text')[0];
    }
    getTag() {
        return this.find('Tag')[0];
    }
    _addListeners(text) {
        let that = this, n;
        const func = function() {
            that._sync();
        };
        for(n = 0; n < $68b4427dcf69bf6a$var$attrChangeListLen; n++)text.on($68b4427dcf69bf6a$var$ATTR_CHANGE_LIST[n] + $68b4427dcf69bf6a$var$CHANGE_KONVA, func);
    }
    getWidth() {
        return this.getText().width();
    }
    getHeight() {
        return this.getText().height();
    }
    _sync() {
        let text = this.getText(), tag = this.getTag(), width, height, pointerDirection, pointerWidth, x, y, pointerHeight;
        if (text && tag) {
            width = text.width();
            height = text.height();
            pointerDirection = tag.pointerDirection();
            pointerWidth = tag.pointerWidth();
            pointerHeight = tag.pointerHeight();
            x = 0;
            y = 0;
            switch(pointerDirection){
                case $68b4427dcf69bf6a$var$UP:
                    x = width / 2;
                    y = -1 * pointerHeight;
                    break;
                case $68b4427dcf69bf6a$var$RIGHT:
                    x = width + pointerWidth;
                    y = height / 2;
                    break;
                case $68b4427dcf69bf6a$var$DOWN:
                    x = width / 2;
                    y = height + pointerHeight;
                    break;
                case $68b4427dcf69bf6a$var$LEFT:
                    x = -1 * pointerWidth;
                    y = height / 2;
                    break;
            }
            tag.setAttrs({
                x: -1 * x,
                y: -1 * y,
                width: width,
                height: height
            });
            text.setAttrs({
                x: -1 * x,
                y: -1 * y
            });
        }
    }
}
$68b4427dcf69bf6a$export$b04be29aa201d4f5.prototype.className = 'Label';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($68b4427dcf69bf6a$export$b04be29aa201d4f5);
class $68b4427dcf69bf6a$export$3288d34c523a1192 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const width = this.width(), height = this.height(), pointerDirection = this.pointerDirection(), pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), cornerRadius = this.cornerRadius();
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === 'number') topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.beginPath();
        context.moveTo(topLeft, 0);
        if (pointerDirection === $68b4427dcf69bf6a$var$UP) {
            context.lineTo((width - pointerWidth) / 2, 0);
            context.lineTo(width / 2, -1 * pointerHeight);
            context.lineTo((width + pointerWidth) / 2, 0);
        }
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
        if (pointerDirection === $68b4427dcf69bf6a$var$RIGHT) {
            context.lineTo(width, (height - pointerHeight) / 2);
            context.lineTo(width + pointerWidth, height / 2);
            context.lineTo(width, (height + pointerHeight) / 2);
        }
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        if (pointerDirection === $68b4427dcf69bf6a$var$DOWN) {
            context.lineTo((width + pointerWidth) / 2, height);
            context.lineTo(width / 2, height + pointerHeight);
            context.lineTo((width - pointerWidth) / 2, height);
        }
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        if (pointerDirection === $68b4427dcf69bf6a$var$LEFT) {
            context.lineTo(0, (height + pointerHeight) / 2);
            context.lineTo(-1 * pointerWidth, height / 2);
            context.lineTo(0, (height - pointerHeight) / 2);
        }
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getSelfRect() {
        let x = 0, y = 0, pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), direction = this.pointerDirection(), width = this.width(), height = this.height();
        if (direction === $68b4427dcf69bf6a$var$UP) {
            y -= pointerHeight;
            height += pointerHeight;
        } else if (direction === $68b4427dcf69bf6a$var$DOWN) height += pointerHeight;
        else if (direction === $68b4427dcf69bf6a$var$LEFT) {
            x -= pointerWidth * 1.5;
            width += pointerWidth;
        } else if (direction === $68b4427dcf69bf6a$var$RIGHT) width += pointerWidth * 1.5;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    }
}
$68b4427dcf69bf6a$export$3288d34c523a1192.prototype.className = 'Tag';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($68b4427dcf69bf6a$export$3288d34c523a1192);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($68b4427dcf69bf6a$export$3288d34c523a1192, 'pointerDirection', $68b4427dcf69bf6a$var$NONE);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($68b4427dcf69bf6a$export$3288d34c523a1192, 'pointerWidth', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($68b4427dcf69bf6a$export$3288d34c523a1192, 'pointerHeight', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($68b4427dcf69bf6a$export$3288d34c523a1192, 'cornerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$7d4ab1842c1b264b)(4));









class $f22346c22f20789a$export$c79fc6492f3af13d extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const cornerRadius = this.cornerRadius(), width = this.width(), height = this.height();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
}
$f22346c22f20789a$export$c79fc6492f3af13d.prototype.className = 'Rect';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($f22346c22f20789a$export$c79fc6492f3af13d);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f22346c22f20789a$export$c79fc6492f3af13d, 'cornerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$7d4ab1842c1b264b)(4));







class $a02eac566278789b$export$e2ee866164812ecd extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const points = this._getPoints(), radius = this.radius(), sides = this.sides(), cornerRadius = this.cornerRadius();
        context.beginPath();
        if (!cornerRadius) {
            context.moveTo(points[0].x, points[0].y);
            for(let n = 1; n < points.length; n++)context.lineTo(points[n].x, points[n].y);
        } else (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).drawRoundedPolygonPath(context, points, sides, radius, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
    _getPoints() {
        const sides = this.attrs.sides;
        const radius = this.attrs.radius || 0;
        const points = [];
        for(let n = 0; n < sides; n++)points.push({
            x: radius * Math.sin(n * 2 * Math.PI / sides),
            y: -1 * radius * Math.cos(n * 2 * Math.PI / sides)
        });
        return points;
    }
    getSelfRect() {
        const points = this._getPoints();
        let minX = points[0].x;
        let maxX = points[0].x;
        let minY = points[0].y;
        let maxY = points[0].y;
        points.forEach((point)=>{
            minX = Math.min(minX, point.x);
            maxX = Math.max(maxX, point.x);
            minY = Math.min(minY, point.y);
            maxY = Math.max(maxY, point.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$a02eac566278789b$export$e2ee866164812ecd.prototype.className = 'RegularPolygon';
$a02eac566278789b$export$e2ee866164812ecd.prototype._centroid = true;
$a02eac566278789b$export$e2ee866164812ecd.prototype._attrsAffectingSize = [
    'radius'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($a02eac566278789b$export$e2ee866164812ecd);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($a02eac566278789b$export$e2ee866164812ecd, 'radius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($a02eac566278789b$export$e2ee866164812ecd, 'sides', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($a02eac566278789b$export$e2ee866164812ecd, 'cornerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$7d4ab1842c1b264b)(4));






const $e1deb4ed1ad79a18$var$PIx2 = Math.PI * 2;
class $e1deb4ed1ad79a18$export$a6e3577650b6d6d7 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.innerRadius(), 0, $e1deb4ed1ad79a18$var$PIx2, false);
        context.moveTo(this.outerRadius(), 0);
        context.arc(0, 0, this.outerRadius(), $e1deb4ed1ad79a18$var$PIx2, 0, true);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
$e1deb4ed1ad79a18$export$a6e3577650b6d6d7.prototype.className = 'Ring';
$e1deb4ed1ad79a18$export$a6e3577650b6d6d7.prototype._centroid = true;
$e1deb4ed1ad79a18$export$a6e3577650b6d6d7.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($e1deb4ed1ad79a18$export$a6e3577650b6d6d7);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($e1deb4ed1ad79a18$export$a6e3577650b6d6d7, 'innerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($e1deb4ed1ad79a18$export$a6e3577650b6d6d7, 'outerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());







class $5a6b0dd32a4eac33$export$3075603db8e6204c extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this._updated = true;
        this.anim = new (0, $e780181a0ef0b2c4$export$c35d437ae5945fcd)(()=>{
            const updated = this._updated;
            this._updated = false;
            return updated;
        });
        this.on('animationChange.konva', function() {
            this.frameIndex(0);
        });
        this.on('frameIndexChange.konva', function() {
            this._updated = true;
        });
        this.on('frameRateChange.konva', function() {
            if (!this.anim.isRunning()) return;
            clearInterval(this.interval);
            this._setInterval();
        });
    }
    _sceneFunc(context) {
        const anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), x = set[ix4 + 0], y = set[ix4 + 1], width = set[ix4 + 2], height = set[ix4 + 3], image = this.image();
        if (this.hasFill() || this.hasStroke()) {
            context.beginPath();
            context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (offsets) {
                const offset = offsets[anim], ix2 = index * 2;
                context.drawImage(image, x, y, width, height, offset[ix2 + 0], offset[ix2 + 1], width, height);
            } else context.drawImage(image, x, y, width, height, 0, 0, width, height);
        }
    }
    _hitFunc(context) {
        const anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), width = set[ix4 + 2], height = set[ix4 + 3];
        context.beginPath();
        if (offsets) {
            const offset = offsets[anim];
            const ix2 = index * 2;
            context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
        } else context.rect(0, 0, width, height);
        context.closePath();
        context.fillShape(this);
    }
    _useBufferCanvas() {
        return super._useBufferCanvas(true);
    }
    _setInterval() {
        const that = this;
        this.interval = setInterval(function() {
            that._updateIndex();
        }, 1000 / this.frameRate());
    }
    start() {
        if (this.isRunning()) return;
        const layer = this.getLayer();
        this.anim.setLayers(layer);
        this._setInterval();
        this.anim.start();
    }
    stop() {
        this.anim.stop();
        clearInterval(this.interval);
    }
    isRunning() {
        return this.anim.isRunning();
    }
    _updateIndex() {
        const index = this.frameIndex(), animation = this.animation(), animations = this.animations(), anim = animations[animation], len = anim.length / 4;
        if (index < len - 1) this.frameIndex(index + 1);
        else this.frameIndex(0);
    }
}
$5a6b0dd32a4eac33$export$3075603db8e6204c.prototype.className = 'Sprite';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($5a6b0dd32a4eac33$export$3075603db8e6204c);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5a6b0dd32a4eac33$export$3075603db8e6204c, 'animation');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5a6b0dd32a4eac33$export$3075603db8e6204c, 'animations');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5a6b0dd32a4eac33$export$3075603db8e6204c, 'frameOffsets');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5a6b0dd32a4eac33$export$3075603db8e6204c, 'image');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5a6b0dd32a4eac33$export$3075603db8e6204c, 'frameIndex', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5a6b0dd32a4eac33$export$3075603db8e6204c, 'frameRate', 17, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).backCompat($5a6b0dd32a4eac33$export$3075603db8e6204c, {
    index: 'frameIndex',
    getIndex: 'getFrameIndex',
    setIndex: 'setFrameIndex'
});






class $4d356f0361a4a7f0$export$1644ba17714857f1 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const innerRadius = this.innerRadius(), outerRadius = this.outerRadius(), numPoints = this.numPoints();
        context.beginPath();
        context.moveTo(0, 0 - outerRadius);
        for(let n = 1; n < numPoints * 2; n++){
            const radius = n % 2 === 0 ? outerRadius : innerRadius;
            const x = radius * Math.sin(n * Math.PI / numPoints);
            const y = -1 * radius * Math.cos(n * Math.PI / numPoints);
            context.lineTo(x, y);
        }
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
$4d356f0361a4a7f0$export$1644ba17714857f1.prototype.className = 'Star';
$4d356f0361a4a7f0$export$1644ba17714857f1.prototype._centroid = true;
$4d356f0361a4a7f0$export$1644ba17714857f1.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($4d356f0361a4a7f0$export$1644ba17714857f1);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($4d356f0361a4a7f0$export$1644ba17714857f1, 'numPoints', 5, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($4d356f0361a4a7f0$export$1644ba17714857f1, 'innerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($4d356f0361a4a7f0$export$1644ba17714857f1, 'outerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());







function $8540f0f5ac9d4ade$export$b9ca061da17f2d30(string) {
    return [
        ...string
    ].reduce((acc, char, index, array)=>{
        if (/\p{Emoji}/u.test(char)) {
            const nextChar = array[index + 1];
            if (nextChar && /\p{Emoji_Modifier}|\u200D/u.test(nextChar)) {
                acc.push(char + nextChar);
                array[index + 1] = '';
            } else acc.push(char);
        } else if (/\p{Regional_Indicator}{2}/u.test(char + (array[index + 1] || ''))) acc.push(char + array[index + 1]);
        else if (index > 0 && /\p{Mn}|\p{Me}|\p{Mc}/u.test(char)) acc[acc.length - 1] += char;
        else if (char) acc.push(char);
        return acc;
    }, []);
}
const $8540f0f5ac9d4ade$var$AUTO = 'auto', $8540f0f5ac9d4ade$var$CENTER = 'center', $8540f0f5ac9d4ade$var$INHERIT = 'inherit', $8540f0f5ac9d4ade$var$JUSTIFY = 'justify', $8540f0f5ac9d4ade$var$CHANGE_KONVA = 'Change.konva', $8540f0f5ac9d4ade$var$CONTEXT_2D = '2d', $8540f0f5ac9d4ade$var$DASH = '-', $8540f0f5ac9d4ade$var$LEFT = 'left', $8540f0f5ac9d4ade$var$TEXT = 'text', $8540f0f5ac9d4ade$var$TEXT_UPPER = 'Text', $8540f0f5ac9d4ade$var$TOP = 'top', $8540f0f5ac9d4ade$var$BOTTOM = 'bottom', $8540f0f5ac9d4ade$var$MIDDLE = 'middle', $8540f0f5ac9d4ade$var$NORMAL = 'normal', $8540f0f5ac9d4ade$var$PX_SPACE = 'px ', $8540f0f5ac9d4ade$var$SPACE = ' ', $8540f0f5ac9d4ade$var$RIGHT = 'right', $8540f0f5ac9d4ade$var$RTL = 'rtl', $8540f0f5ac9d4ade$var$WORD = 'word', $8540f0f5ac9d4ade$var$CHAR = 'char', $8540f0f5ac9d4ade$var$NONE = 'none', $8540f0f5ac9d4ade$var$ELLIPSIS = "\u2026", $8540f0f5ac9d4ade$var$ATTR_CHANGE_LIST = [
    'direction',
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontVariant',
    'padding',
    'align',
    'verticalAlign',
    'lineHeight',
    'text',
    'width',
    'height',
    'wrap',
    'ellipsis',
    'letterSpacing'
], $8540f0f5ac9d4ade$var$attrChangeListLen = $8540f0f5ac9d4ade$var$ATTR_CHANGE_LIST.length;
function $8540f0f5ac9d4ade$var$normalizeFontFamily(fontFamily) {
    return fontFamily.split(',').map((family)=>{
        family = family.trim();
        const hasSpace = family.indexOf(' ') >= 0;
        const hasQuotes = family.indexOf('"') >= 0 || family.indexOf("'") >= 0;
        if (hasSpace && !hasQuotes) family = `"${family}"`;
        return family;
    }).join(', ');
}
let $8540f0f5ac9d4ade$var$dummyContext;
function $8540f0f5ac9d4ade$var$getDummyContext() {
    if ($8540f0f5ac9d4ade$var$dummyContext) return $8540f0f5ac9d4ade$var$dummyContext;
    $8540f0f5ac9d4ade$var$dummyContext = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).createCanvasElement().getContext($8540f0f5ac9d4ade$var$CONTEXT_2D);
    return $8540f0f5ac9d4ade$var$dummyContext;
}
function $8540f0f5ac9d4ade$var$_fillFunc(context) {
    context.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function $8540f0f5ac9d4ade$var$_strokeFunc(context) {
    context.setAttr('miterLimit', 2);
    context.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function $8540f0f5ac9d4ade$var$checkDefaultFill(config) {
    config = config || {};
    if (!config.fillLinearGradientColorStops && !config.fillRadialGradientColorStops && !config.fillPatternImage) config.fill = config.fill || 'black';
    return config;
}
class $8540f0f5ac9d4ade$export$5f1af8db9871e1d6 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    constructor(config){
        super($8540f0f5ac9d4ade$var$checkDefaultFill(config));
        this._partialTextX = 0;
        this._partialTextY = 0;
        for(let n = 0; n < $8540f0f5ac9d4ade$var$attrChangeListLen; n++)this.on($8540f0f5ac9d4ade$var$ATTR_CHANGE_LIST[n] + $8540f0f5ac9d4ade$var$CHANGE_KONVA, this._setTextData);
        this._setTextData();
    }
    _sceneFunc(context) {
        var _a, _b;
        const textArr = this.textArr, textArrLen = textArr.length;
        if (!this.text()) return;
        let padding = this.padding(), fontSize = this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, verticalAlign = this.verticalAlign(), direction = this.direction(), alignY = 0, align = this.align(), totalWidth = this.getWidth(), letterSpacing = this.letterSpacing(), charRenderFunc = this.charRenderFunc(), fill = this.fill(), textDecoration = this.textDecoration(), shouldUnderline = textDecoration.indexOf('underline') !== -1, shouldLineThrough = textDecoration.indexOf('line-through') !== -1, n;
        direction = direction === $8540f0f5ac9d4ade$var$INHERIT ? context.direction : direction;
        let translateY = lineHeightPx / 2;
        let baseline = $8540f0f5ac9d4ade$var$MIDDLE;
        if (!(0, $8c8384c27430fce8$export$b9f99057a3c7692).legacyTextRendering) {
            const metrics = this.measureSize('M');
            baseline = 'alphabetic';
            const ascent = (_a = metrics.fontBoundingBoxAscent) !== null && _a !== void 0 ? _a : metrics.actualBoundingBoxAscent;
            const descent = (_b = metrics.fontBoundingBoxDescent) !== null && _b !== void 0 ? _b : metrics.actualBoundingBoxDescent;
            translateY = (ascent - descent) / 2 + lineHeightPx / 2;
        }
        if (direction === $8540f0f5ac9d4ade$var$RTL) context.setAttr('direction', direction);
        context.setAttr('font', this._getContextFont());
        context.setAttr('textBaseline', baseline);
        context.setAttr('textAlign', $8540f0f5ac9d4ade$var$LEFT);
        if (verticalAlign === $8540f0f5ac9d4ade$var$MIDDLE) alignY = (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
        else if (verticalAlign === $8540f0f5ac9d4ade$var$BOTTOM) alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
        context.translate(padding, alignY + padding);
        for(n = 0; n < textArrLen; n++){
            let lineTranslateX = 0;
            let lineTranslateY = 0;
            const obj = textArr[n], text = obj.text, width = obj.width, lastLine = obj.lastInParagraph;
            context.save();
            if (align === $8540f0f5ac9d4ade$var$RIGHT) lineTranslateX += totalWidth - width - padding * 2;
            else if (align === $8540f0f5ac9d4ade$var$CENTER) lineTranslateX += (totalWidth - width - padding * 2) / 2;
            if (shouldUnderline) {
                context.save();
                context.beginPath();
                const yOffset = !(0, $8c8384c27430fce8$export$b9f99057a3c7692).legacyTextRendering ? Math.round(fontSize / 4) : Math.round(fontSize / 2);
                const x = lineTranslateX;
                const y = translateY + lineTranslateY + yOffset;
                context.moveTo(x, y);
                const lineWidth = align === $8540f0f5ac9d4ade$var$JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
                context.lineTo(x + Math.round(lineWidth), y);
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            const lineThroughStartX = lineTranslateX;
            if (direction !== $8540f0f5ac9d4ade$var$RTL && (letterSpacing !== 0 || align === $8540f0f5ac9d4ade$var$JUSTIFY || charRenderFunc)) {
                const spacesNumber = text.split(' ').length - 1;
                const array = $8540f0f5ac9d4ade$export$b9ca061da17f2d30(text);
                for(let li = 0; li < array.length; li++){
                    const letter = array[li];
                    if (letter === ' ' && !lastLine && align === $8540f0f5ac9d4ade$var$JUSTIFY) lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
                    this._partialTextX = lineTranslateX;
                    this._partialTextY = translateY + lineTranslateY;
                    this._partialText = letter;
                    if (charRenderFunc) {
                        context.save();
                        const previousLines = textArr.slice(0, n);
                        const previousGraphemes = previousLines.reduce((acc, line)=>acc + $8540f0f5ac9d4ade$export$b9ca061da17f2d30(line.text).length, 0);
                        const charIndex = li + previousGraphemes;
                        charRenderFunc({
                            char: letter,
                            index: charIndex,
                            x: lineTranslateX,
                            y: translateY + lineTranslateY,
                            lineIndex: n,
                            column: li,
                            isLastInLine: lastLine,
                            width: this.measureSize(letter).width,
                            context: context
                        });
                    }
                    context.fillStrokeShape(this);
                    if (charRenderFunc) context.restore();
                    lineTranslateX += this.measureSize(letter).width + letterSpacing;
                }
            } else {
                if (letterSpacing !== 0) context.setAttr('letterSpacing', `${letterSpacing}px`);
                this._partialTextX = lineTranslateX;
                this._partialTextY = translateY + lineTranslateY;
                this._partialText = text;
                context.fillStrokeShape(this);
            }
            if (shouldLineThrough) {
                context.save();
                context.beginPath();
                const yOffset = !(0, $8c8384c27430fce8$export$b9f99057a3c7692).legacyTextRendering ? -Math.round(fontSize / 4) : 0;
                const x = lineThroughStartX;
                context.moveTo(x, translateY + lineTranslateY + yOffset);
                const lineWidth = align === $8540f0f5ac9d4ade$var$JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
                context.lineTo(x + Math.round(lineWidth), translateY + lineTranslateY + yOffset);
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            context.restore();
            if (textArrLen > 1) translateY += lineHeightPx;
        }
    }
    _hitFunc(context) {
        const width = this.getWidth(), height = this.getHeight();
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
    }
    setText(text) {
        const str = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isString(text) ? text : text === null || text === undefined ? '' : text + '';
        this._setAttr($8540f0f5ac9d4ade$var$TEXT, str);
        return this;
    }
    getWidth() {
        const isAuto = this.attrs.width === $8540f0f5ac9d4ade$var$AUTO || this.attrs.width === undefined;
        return isAuto ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
    getHeight() {
        const isAuto = this.attrs.height === $8540f0f5ac9d4ade$var$AUTO || this.attrs.height === undefined;
        return isAuto ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
        return this.textHeight;
    }
    measureSize(text) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        let _context = $8540f0f5ac9d4ade$var$getDummyContext(), fontSize = this.fontSize(), metrics;
        _context.save();
        _context.font = this._getContextFont();
        metrics = _context.measureText(text);
        _context.restore();
        const scaleFactor = fontSize / 100;
        return {
            actualBoundingBoxAscent: (_a = metrics.actualBoundingBoxAscent) !== null && _a !== void 0 ? _a : 71.58203125 * scaleFactor,
            actualBoundingBoxDescent: (_b = metrics.actualBoundingBoxDescent) !== null && _b !== void 0 ? _b : 0,
            actualBoundingBoxLeft: (_c = metrics.actualBoundingBoxLeft) !== null && _c !== void 0 ? _c : -7.421875 * scaleFactor,
            actualBoundingBoxRight: (_d = metrics.actualBoundingBoxRight) !== null && _d !== void 0 ? _d : 75.732421875 * scaleFactor,
            alphabeticBaseline: (_e = metrics.alphabeticBaseline) !== null && _e !== void 0 ? _e : 0,
            emHeightAscent: (_f = metrics.emHeightAscent) !== null && _f !== void 0 ? _f : 100 * scaleFactor,
            emHeightDescent: (_g = metrics.emHeightDescent) !== null && _g !== void 0 ? _g : -20 * scaleFactor,
            fontBoundingBoxAscent: (_h = metrics.fontBoundingBoxAscent) !== null && _h !== void 0 ? _h : 91 * scaleFactor,
            fontBoundingBoxDescent: (_j = metrics.fontBoundingBoxDescent) !== null && _j !== void 0 ? _j : 21 * scaleFactor,
            hangingBaseline: (_k = metrics.hangingBaseline) !== null && _k !== void 0 ? _k : 72.80000305175781 * scaleFactor,
            ideographicBaseline: (_l = metrics.ideographicBaseline) !== null && _l !== void 0 ? _l : -21 * scaleFactor,
            width: metrics.width,
            height: fontSize
        };
    }
    _getContextFont() {
        return this.fontStyle() + $8540f0f5ac9d4ade$var$SPACE + this.fontVariant() + $8540f0f5ac9d4ade$var$SPACE + (this.fontSize() + $8540f0f5ac9d4ade$var$PX_SPACE) + $8540f0f5ac9d4ade$var$normalizeFontFamily(this.fontFamily());
    }
    _addTextLine(line) {
        const align = this.align();
        if (align === $8540f0f5ac9d4ade$var$JUSTIFY) line = line.trim();
        const width = this._getTextWidth(line);
        return this.textArr.push({
            text: line,
            width: width,
            lastInParagraph: false
        });
    }
    _getTextWidth(text) {
        const letterSpacing = this.letterSpacing();
        const length = text.length;
        return $8540f0f5ac9d4ade$var$getDummyContext().measureText(text).width + letterSpacing * length;
    }
    _setTextData() {
        let lines = this.text().split('\n'), fontSize = +this.fontSize(), textWidth = 0, lineHeightPx = this.lineHeight() * fontSize, width = this.attrs.width, height = this.attrs.height, fixedWidth = width !== $8540f0f5ac9d4ade$var$AUTO && width !== undefined, fixedHeight = height !== $8540f0f5ac9d4ade$var$AUTO && height !== undefined, padding = this.padding(), maxWidth = width - padding * 2, maxHeightPx = height - padding * 2, currentHeightPx = 0, wrap = this.wrap(), shouldWrap = wrap !== $8540f0f5ac9d4ade$var$NONE, wrapAtWord = wrap !== $8540f0f5ac9d4ade$var$CHAR && shouldWrap, shouldAddEllipsis = this.ellipsis();
        this.textArr = [];
        $8540f0f5ac9d4ade$var$getDummyContext().font = this._getContextFont();
        const additionalWidth = shouldAddEllipsis ? this._getTextWidth($8540f0f5ac9d4ade$var$ELLIPSIS) : 0;
        for(let i = 0, max = lines.length; i < max; ++i){
            let line = lines[i];
            let lineWidth = this._getTextWidth(line);
            if (fixedWidth && lineWidth > maxWidth) while(line.length > 0){
                let low = 0, high = $8540f0f5ac9d4ade$export$b9ca061da17f2d30(line).length, match = '', matchWidth = 0;
                while(low < high){
                    const mid = low + high >>> 1, lineArray = $8540f0f5ac9d4ade$export$b9ca061da17f2d30(line), substr = lineArray.slice(0, mid + 1).join(''), substrWidth = this._getTextWidth(substr);
                    const shouldConsiderEllipsis = shouldAddEllipsis && fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx;
                    const effectiveWidth = shouldConsiderEllipsis ? substrWidth + additionalWidth : substrWidth;
                    if (effectiveWidth <= maxWidth) {
                        low = mid + 1;
                        match = substr;
                        matchWidth = substrWidth;
                    } else high = mid;
                }
                if (match) {
                    if (wrapAtWord) {
                        const lineArray = $8540f0f5ac9d4ade$export$b9ca061da17f2d30(line);
                        const matchArray = $8540f0f5ac9d4ade$export$b9ca061da17f2d30(match);
                        const nextChar = lineArray[matchArray.length];
                        const nextIsSpaceOrDash = nextChar === $8540f0f5ac9d4ade$var$SPACE || nextChar === $8540f0f5ac9d4ade$var$DASH;
                        let wrapIndex;
                        if (nextIsSpaceOrDash && matchWidth <= maxWidth) wrapIndex = matchArray.length;
                        else {
                            const lastSpaceIndex = matchArray.lastIndexOf($8540f0f5ac9d4ade$var$SPACE);
                            const lastDashIndex = matchArray.lastIndexOf($8540f0f5ac9d4ade$var$DASH);
                            wrapIndex = Math.max(lastSpaceIndex, lastDashIndex) + 1;
                        }
                        if (wrapIndex > 0) {
                            low = wrapIndex;
                            match = lineArray.slice(0, low).join('');
                            matchWidth = this._getTextWidth(match);
                        }
                    }
                    match = match.trimRight();
                    this._addTextLine(match);
                    textWidth = Math.max(textWidth, matchWidth);
                    currentHeightPx += lineHeightPx;
                    const shouldHandleEllipsis = this._shouldHandleEllipsis(currentHeightPx);
                    if (shouldHandleEllipsis) {
                        this._tryToAddEllipsisToLastLine();
                        break;
                    }
                    const lineArray = $8540f0f5ac9d4ade$export$b9ca061da17f2d30(line);
                    line = lineArray.slice(low).join('').trimLeft();
                    if (line.length > 0) {
                        lineWidth = this._getTextWidth(line);
                        if (lineWidth <= maxWidth) {
                            this._addTextLine(line);
                            currentHeightPx += lineHeightPx;
                            textWidth = Math.max(textWidth, lineWidth);
                            break;
                        }
                    }
                } else break;
            }
            else {
                this._addTextLine(line);
                currentHeightPx += lineHeightPx;
                textWidth = Math.max(textWidth, lineWidth);
                if (this._shouldHandleEllipsis(currentHeightPx) && i < max - 1) this._tryToAddEllipsisToLastLine();
            }
            if (this.textArr[this.textArr.length - 1]) this.textArr[this.textArr.length - 1].lastInParagraph = true;
            if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) break;
        }
        this.textHeight = fontSize;
        this.textWidth = textWidth;
    }
    _shouldHandleEllipsis(currentHeightPx) {
        const fontSize = +this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, height = this.attrs.height, fixedHeight = height !== $8540f0f5ac9d4ade$var$AUTO && height !== undefined, padding = this.padding(), maxHeightPx = height - padding * 2, wrap = this.wrap(), shouldWrap = wrap !== $8540f0f5ac9d4ade$var$NONE;
        return !shouldWrap || fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx;
    }
    _tryToAddEllipsisToLastLine() {
        const width = this.attrs.width, fixedWidth = width !== $8540f0f5ac9d4ade$var$AUTO && width !== undefined, padding = this.padding(), maxWidth = width - padding * 2, shouldAddEllipsis = this.ellipsis();
        const lastLine = this.textArr[this.textArr.length - 1];
        if (!lastLine || !shouldAddEllipsis) return;
        if (fixedWidth) {
            const haveSpace = this._getTextWidth(lastLine.text + $8540f0f5ac9d4ade$var$ELLIPSIS) < maxWidth;
            if (!haveSpace) lastLine.text = lastLine.text.slice(0, lastLine.text.length - 3);
        }
        this.textArr.splice(this.textArr.length - 1, 1);
        this._addTextLine(lastLine.text + $8540f0f5ac9d4ade$var$ELLIPSIS);
    }
    getStrokeScaleEnabled() {
        return true;
    }
    _useBufferCanvas() {
        const hasLine = this.textDecoration().indexOf('underline') !== -1 || this.textDecoration().indexOf('line-through') !== -1;
        const hasShadow = this.hasShadow();
        if (hasLine && hasShadow) return true;
        return super._useBufferCanvas();
    }
}
$8540f0f5ac9d4ade$export$5f1af8db9871e1d6.prototype._fillFunc = $8540f0f5ac9d4ade$var$_fillFunc;
$8540f0f5ac9d4ade$export$5f1af8db9871e1d6.prototype._strokeFunc = $8540f0f5ac9d4ade$var$_strokeFunc;
$8540f0f5ac9d4ade$export$5f1af8db9871e1d6.prototype.className = $8540f0f5ac9d4ade$var$TEXT_UPPER;
$8540f0f5ac9d4ade$export$5f1af8db9871e1d6.prototype._attrsAffectingSize = [
    'text',
    'fontSize',
    'padding',
    'wrap',
    'lineHeight',
    'letterSpacing'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($8540f0f5ac9d4ade$export$5f1af8db9871e1d6);
(0, $abe0ad8331aee635$export$8354032f3852ec50).overWriteSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'width', (0, $d7c0e5ae0fe3f9a6$export$3b7df2720ef33404)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).overWriteSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'height', (0, $d7c0e5ae0fe3f9a6$export$3b7df2720ef33404)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'direction', $8540f0f5ac9d4ade$var$INHERIT);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'fontFamily', 'Arial');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'fontSize', 12, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'fontStyle', $8540f0f5ac9d4ade$var$NORMAL);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'fontVariant', $8540f0f5ac9d4ade$var$NORMAL);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'padding', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'align', $8540f0f5ac9d4ade$var$LEFT);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'verticalAlign', $8540f0f5ac9d4ade$var$TOP);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'lineHeight', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'wrap', $8540f0f5ac9d4ade$var$WORD);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'ellipsis', false, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'letterSpacing', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'text', '', (0, $d7c0e5ae0fe3f9a6$export$5837c5b6cc5b4d63)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'textDecoration', '');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'charRenderFunc', undefined);









const $df8ddbf07e58c785$var$EMPTY_STRING = '', $df8ddbf07e58c785$var$NORMAL = 'normal';
function $df8ddbf07e58c785$var$_fillFunc(context) {
    context.fillText(this.partialText, 0, 0);
}
function $df8ddbf07e58c785$var$_strokeFunc(context) {
    context.strokeText(this.partialText, 0, 0);
}
class $df8ddbf07e58c785$export$f7e34a95cc06fac7 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.dummyCanvas = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).createCanvasElement();
        this.dataArray = [];
        this._readDataAttribute();
        this.on('dataChange.konva', function() {
            this._readDataAttribute();
            this._setTextData();
        });
        this.on('textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva', this._setTextData);
        this._setTextData();
    }
    _getTextPathLength() {
        return (0, $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9).getPathLength(this.dataArray);
    }
    _getPointAtLength(length) {
        if (!this.attrs.data) return null;
        const totalLength = this.pathLength;
        if (length > totalLength) return null;
        return (0, $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9).getPointAtLengthOfDataArray(length, this.dataArray);
    }
    _readDataAttribute() {
        this.dataArray = (0, $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9).parsePathData(this.attrs.data);
        this.pathLength = this._getTextPathLength();
    }
    _sceneFunc(context) {
        context.setAttr('font', this._getContextFont());
        context.setAttr('textBaseline', this.textBaseline());
        context.setAttr('textAlign', 'left');
        context.save();
        const textDecoration = this.textDecoration();
        const fill = this.fill();
        const fontSize = this.fontSize();
        const glyphInfo = this.glyphInfo;
        const hasUnderline = textDecoration.indexOf('underline') !== -1;
        const hasLineThrough = textDecoration.indexOf('line-through') !== -1;
        if (hasUnderline) context.beginPath();
        for(let i = 0; i < glyphInfo.length; i++){
            context.save();
            const p0 = glyphInfo[i].p0;
            context.translate(p0.x, p0.y);
            context.rotate(glyphInfo[i].rotation);
            this.partialText = glyphInfo[i].text;
            context.fillStrokeShape(this);
            if (hasUnderline) {
                if (i === 0) context.moveTo(0, fontSize / 2 + 1);
                context.lineTo(glyphInfo[i].width, fontSize / 2 + 1);
            }
            context.restore();
        }
        if (hasUnderline) {
            context.strokeStyle = fill;
            context.lineWidth = fontSize / 20;
            context.stroke();
        }
        if (hasLineThrough) {
            context.beginPath();
            for(let i = 0; i < glyphInfo.length; i++){
                context.save();
                const p0 = glyphInfo[i].p0;
                context.translate(p0.x, p0.y);
                context.rotate(glyphInfo[i].rotation);
                if (i === 0) context.moveTo(0, 0);
                context.lineTo(glyphInfo[i].width, 0);
                context.restore();
            }
            context.strokeStyle = fill;
            context.lineWidth = fontSize / 20;
            context.stroke();
        }
        context.restore();
    }
    _hitFunc(context) {
        context.beginPath();
        const glyphInfo = this.glyphInfo;
        if (glyphInfo.length >= 1) {
            const p0 = glyphInfo[0].p0;
            context.moveTo(p0.x, p0.y);
        }
        for(let i = 0; i < glyphInfo.length; i++){
            const p1 = glyphInfo[i].p1;
            context.lineTo(p1.x, p1.y);
        }
        context.setAttr('lineWidth', this.fontSize());
        context.setAttr('strokeStyle', this.colorKey);
        context.stroke();
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
        return this.textHeight;
    }
    setText(text) {
        return (0, $8540f0f5ac9d4ade$export$5f1af8db9871e1d6).prototype.setText.call(this, text);
    }
    _getContextFont() {
        return (0, $8540f0f5ac9d4ade$export$5f1af8db9871e1d6).prototype._getContextFont.call(this);
    }
    _getTextSize(text) {
        const dummyCanvas = this.dummyCanvas;
        const _context = dummyCanvas.getContext('2d');
        _context.save();
        _context.font = this._getContextFont();
        const metrics = _context.measureText(text);
        _context.restore();
        return {
            width: metrics.width,
            height: parseInt(`${this.fontSize()}`, 10)
        };
    }
    _setTextData() {
        const charArr = (0, $8540f0f5ac9d4ade$export$b9ca061da17f2d30)(this.text());
        const chars = [];
        let width = 0;
        for(let i = 0; i < charArr.length; i++){
            chars.push({
                char: charArr[i],
                width: this._getTextSize(charArr[i]).width
            });
            width += chars[i].width;
        }
        const { height: height } = this._getTextSize(this.attrs.text);
        this.textWidth = width;
        this.textHeight = height;
        this.glyphInfo = [];
        if (!this.attrs.data) return null;
        const letterSpacing = this.letterSpacing();
        const align = this.align();
        const kerningFunc = this.kerningFunc();
        const textWidth = Math.max(this.textWidth + ((this.attrs.text || '').length - 1) * letterSpacing, 0);
        let offset = 0;
        if (align === 'center') offset = Math.max(0, this.pathLength / 2 - textWidth / 2);
        if (align === 'right') offset = Math.max(0, this.pathLength - textWidth);
        let offsetToGlyph = offset;
        for(let i = 0; i < chars.length; i++){
            const charStartPoint = this._getPointAtLength(offsetToGlyph);
            if (!charStartPoint) return;
            const char = chars[i].char;
            let glyphWidth = chars[i].width + letterSpacing;
            if (char === ' ' && align === 'justify') {
                const numberOfSpaces = this.text().split(' ').length - 1;
                glyphWidth += (this.pathLength - textWidth) / numberOfSpaces;
            }
            const charEndPoint = this._getPointAtLength(offsetToGlyph + glyphWidth);
            if (!charEndPoint) return;
            const width = (0, $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9).getLineLength(charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
            let kern = 0;
            if (kerningFunc) try {
                kern = kerningFunc(chars[i - 1].char, char) * this.fontSize();
            } catch (e) {
                kern = 0;
            }
            charStartPoint.x += kern;
            charEndPoint.x += kern;
            this.textWidth += kern;
            const midpoint = (0, $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9).getPointOnLine(kern + width / 2.0, charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
            const rotation = Math.atan2(charEndPoint.y - charStartPoint.y, charEndPoint.x - charStartPoint.x);
            this.glyphInfo.push({
                transposeX: midpoint.x,
                transposeY: midpoint.y,
                text: charArr[i],
                rotation: rotation,
                p0: charStartPoint,
                p1: charEndPoint,
                width: width
            });
            offsetToGlyph += glyphWidth;
        }
    }
    getSelfRect() {
        if (!this.glyphInfo.length) return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        const points = [];
        this.glyphInfo.forEach(function(info) {
            points.push(info.p0.x);
            points.push(info.p0.y);
            points.push(info.p1.x);
            points.push(info.p1.y);
        });
        let minX = points[0] || 0;
        let maxX = points[0] || 0;
        let minY = points[1] || 0;
        let maxY = points[1] || 0;
        let x, y;
        for(let i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        const fontSize = this.fontSize();
        return {
            x: minX - fontSize / 2,
            y: minY - fontSize / 2,
            width: maxX - minX + fontSize,
            height: maxY - minY + fontSize
        };
    }
    destroy() {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).releaseCanvas(this.dummyCanvas);
        return super.destroy();
    }
}
$df8ddbf07e58c785$export$f7e34a95cc06fac7.prototype._fillFunc = $df8ddbf07e58c785$var$_fillFunc;
$df8ddbf07e58c785$export$f7e34a95cc06fac7.prototype._strokeFunc = $df8ddbf07e58c785$var$_strokeFunc;
$df8ddbf07e58c785$export$f7e34a95cc06fac7.prototype._fillFuncHit = $df8ddbf07e58c785$var$_fillFunc;
$df8ddbf07e58c785$export$f7e34a95cc06fac7.prototype._strokeFuncHit = $df8ddbf07e58c785$var$_strokeFunc;
$df8ddbf07e58c785$export$f7e34a95cc06fac7.prototype.className = 'TextPath';
$df8ddbf07e58c785$export$f7e34a95cc06fac7.prototype._attrsAffectingSize = [
    'text',
    'fontSize',
    'data'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($df8ddbf07e58c785$export$f7e34a95cc06fac7);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'data');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'fontFamily', 'Arial');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'fontSize', 12, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'fontStyle', $df8ddbf07e58c785$var$NORMAL);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'align', 'left');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'letterSpacing', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'textBaseline', 'middle');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'fontVariant', $df8ddbf07e58c785$var$NORMAL);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'text', $df8ddbf07e58c785$var$EMPTY_STRING);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'textDecoration', '');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'kerningFunc', undefined);










const $801345eab32c3d30$var$EVENTS_NAME = 'tr-konva';
const $801345eab32c3d30$var$ATTR_CHANGE_LIST = [
    'resizeEnabledChange',
    'rotateAnchorOffsetChange',
    'rotateEnabledChange',
    'enabledAnchorsChange',
    'anchorSizeChange',
    'borderEnabledChange',
    'borderStrokeChange',
    'borderStrokeWidthChange',
    'borderDashChange',
    'anchorStrokeChange',
    'anchorStrokeWidthChange',
    'anchorFillChange',
    'anchorCornerRadiusChange',
    'ignoreStrokeChange',
    'anchorStyleFuncChange'
].map((e)=>e + `.${$801345eab32c3d30$var$EVENTS_NAME}`).join(' ');
const $801345eab32c3d30$var$NODES_RECT = 'nodesRect';
const $801345eab32c3d30$var$TRANSFORM_CHANGE_STR = [
    'widthChange',
    'heightChange',
    'scaleXChange',
    'scaleYChange',
    'skewXChange',
    'skewYChange',
    'rotationChange',
    'offsetXChange',
    'offsetYChange',
    'transformsEnabledChange',
    'strokeWidthChange',
    'draggableChange'
];
const $801345eab32c3d30$var$ANGLES = {
    'top-left': -45,
    'top-center': 0,
    'top-right': 45,
    'middle-right': -90,
    'middle-left': 90,
    'bottom-left': -135,
    'bottom-center': 180,
    'bottom-right': 135
};
const $801345eab32c3d30$var$TOUCH_DEVICE = 'ontouchstart' in (0, $8c8384c27430fce8$export$b9f99057a3c7692)._global;
function $801345eab32c3d30$var$getCursor(anchorName, rad, rotateCursor) {
    if (anchorName === 'rotater') return rotateCursor;
    rad += (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).degToRad($801345eab32c3d30$var$ANGLES[anchorName] || 0);
    const angle = ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).radToDeg(rad) % 360 + 360) % 360;
    if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 337.5, 360) || (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 0, 22.5)) return 'ns-resize';
    else if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 22.5, 67.5)) return 'nesw-resize';
    else if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 67.5, 112.5)) return 'ew-resize';
    else if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 112.5, 157.5)) return 'nwse-resize';
    else if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 157.5, 202.5)) return 'ns-resize';
    else if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 202.5, 247.5)) return 'nesw-resize';
    else if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 247.5, 292.5)) return 'ew-resize';
    else if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 292.5, 337.5)) return 'nwse-resize';
    else {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('Transformer has unknown angle for cursor detection: ' + angle);
        return 'pointer';
    }
}
const $801345eab32c3d30$var$ANCHORS_NAMES = [
    'top-left',
    'top-center',
    'top-right',
    'middle-right',
    'middle-left',
    'bottom-left',
    'bottom-center',
    'bottom-right'
];
const $801345eab32c3d30$var$MAX_SAFE_INTEGER = 100000000;
function $801345eab32c3d30$var$getCenter(shape) {
    return {
        x: shape.x + shape.width / 2 * Math.cos(shape.rotation) + shape.height / 2 * Math.sin(-shape.rotation),
        y: shape.y + shape.height / 2 * Math.cos(shape.rotation) + shape.width / 2 * Math.sin(shape.rotation)
    };
}
function $801345eab32c3d30$var$rotateAroundPoint(shape, angleRad, point) {
    const x = point.x + (shape.x - point.x) * Math.cos(angleRad) - (shape.y - point.y) * Math.sin(angleRad);
    const y = point.y + (shape.x - point.x) * Math.sin(angleRad) + (shape.y - point.y) * Math.cos(angleRad);
    return {
        ...shape,
        rotation: shape.rotation + angleRad,
        x: x,
        y: y
    };
}
function $801345eab32c3d30$var$rotateAroundCenter(shape, deltaRad) {
    const center = $801345eab32c3d30$var$getCenter(shape);
    return $801345eab32c3d30$var$rotateAroundPoint(shape, deltaRad, center);
}
function $801345eab32c3d30$var$getSnap(snaps, newRotationRad, tol) {
    let snapped = newRotationRad;
    for(let i = 0; i < snaps.length; i++){
        const angle = (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(snaps[i]);
        const absDiff = Math.abs(angle - newRotationRad) % (Math.PI * 2);
        const dif = Math.min(absDiff, Math.PI * 2 - absDiff);
        if (dif < tol) snapped = angle;
    }
    return snapped;
}
let $801345eab32c3d30$var$activeTransformersCount = 0;
class $801345eab32c3d30$export$f993aef960936087 extends (0, $644b7f3bf259f4bd$export$eb2fcfdbd7ba97d4) {
    constructor(config){
        super(config);
        this._movingAnchorName = null;
        this._transforming = false;
        this._createElements();
        this._handleMouseMove = this._handleMouseMove.bind(this);
        this._handleMouseUp = this._handleMouseUp.bind(this);
        this.update = this.update.bind(this);
        this.on($801345eab32c3d30$var$ATTR_CHANGE_LIST, this.update);
        if (this.getNode()) this.update();
    }
    attachTo(node) {
        this.setNode(node);
        return this;
    }
    setNode(node) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead.');
        return this.setNodes([
            node
        ]);
    }
    getNode() {
        return this._nodes && this._nodes[0];
    }
    _getEventNamespace() {
        return $801345eab32c3d30$var$EVENTS_NAME + this._id;
    }
    setNodes(nodes = []) {
        if (this._nodes && this._nodes.length) this.detach();
        const filteredNodes = nodes.filter((node)=>{
            if (node.isAncestorOf(this)) {
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('Konva.Transformer cannot be an a child of the node you are trying to attach');
                return false;
            }
            return true;
        });
        this._nodes = nodes = filteredNodes;
        if (nodes.length === 1 && this.useSingleNodeRotation()) this.rotation(nodes[0].getAbsoluteRotation());
        else this.rotation(0);
        this._nodes.forEach((node)=>{
            const onChange = ()=>{
                if (this.nodes().length === 1 && this.useSingleNodeRotation()) this.rotation(this.nodes()[0].getAbsoluteRotation());
                this._resetTransformCache();
                if (!this._transforming && !this.isDragging()) this.update();
            };
            if (node._attrsAffectingSize.length) {
                const additionalEvents = node._attrsAffectingSize.map((prop)=>prop + 'Change.' + this._getEventNamespace()).join(' ');
                node.on(additionalEvents, onChange);
            }
            node.on($801345eab32c3d30$var$TRANSFORM_CHANGE_STR.map((e)=>e + `.${this._getEventNamespace()}`).join(' '), onChange);
            node.on(`absoluteTransformChange.${this._getEventNamespace()}`, onChange);
            this._proxyDrag(node);
        });
        this._resetTransformCache();
        const elementsCreated = !!this.findOne('.top-left');
        if (elementsCreated) this.update();
        return this;
    }
    _proxyDrag(node) {
        let lastPos;
        node.on(`dragstart.${this._getEventNamespace()}`, (e)=>{
            lastPos = node.getAbsolutePosition();
            if (!this.isDragging() && node !== this.findOne('.back')) this.startDrag(e, false);
        });
        node.on(`dragmove.${this._getEventNamespace()}`, (e)=>{
            if (!lastPos) return;
            const abs = node.getAbsolutePosition();
            const dx = abs.x - lastPos.x;
            const dy = abs.y - lastPos.y;
            this.nodes().forEach((otherNode)=>{
                if (otherNode === node) return;
                if (otherNode.isDragging()) return;
                const otherAbs = otherNode.getAbsolutePosition();
                otherNode.setAbsolutePosition({
                    x: otherAbs.x + dx,
                    y: otherAbs.y + dy
                });
                otherNode.startDrag(e);
            });
            lastPos = null;
        });
    }
    getNodes() {
        return this._nodes || [];
    }
    getActiveAnchor() {
        return this._movingAnchorName;
    }
    detach() {
        if (this._nodes) this._nodes.forEach((node)=>{
            node.off('.' + this._getEventNamespace());
        });
        this._nodes = [];
        this._resetTransformCache();
    }
    _resetTransformCache() {
        this._clearCache($801345eab32c3d30$var$NODES_RECT);
        this._clearCache('transform');
        this._clearSelfAndDescendantCache('absoluteTransform');
    }
    _getNodeRect() {
        return this._getCache($801345eab32c3d30$var$NODES_RECT, this.__getNodeRect);
    }
    __getNodeShape(node, rot = this.rotation(), relative) {
        const rect = node.getClientRect({
            skipTransform: true,
            skipShadow: true,
            skipStroke: this.ignoreStroke()
        });
        const absScale = node.getAbsoluteScale(relative);
        const absPos = node.getAbsolutePosition(relative);
        const dx = rect.x * absScale.x - node.offsetX() * absScale.x;
        const dy = rect.y * absScale.y - node.offsetY() * absScale.y;
        const rotation = ((0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(node.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2);
        const box = {
            x: absPos.x + dx * Math.cos(rotation) + dy * Math.sin(-rotation),
            y: absPos.y + dy * Math.cos(rotation) + dx * Math.sin(rotation),
            width: rect.width * absScale.x,
            height: rect.height * absScale.y,
            rotation: rotation
        };
        return $801345eab32c3d30$var$rotateAroundPoint(box, -(0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(rot), {
            x: 0,
            y: 0
        });
    }
    __getNodeRect() {
        const node = this.getNode();
        if (!node) return {
            x: -$801345eab32c3d30$var$MAX_SAFE_INTEGER,
            y: -$801345eab32c3d30$var$MAX_SAFE_INTEGER,
            width: 0,
            height: 0,
            rotation: 0
        };
        const totalPoints = [];
        this.nodes().map((node)=>{
            const box = node.getClientRect({
                skipTransform: true,
                skipShadow: true,
                skipStroke: this.ignoreStroke()
            });
            const points = [
                {
                    x: box.x,
                    y: box.y
                },
                {
                    x: box.x + box.width,
                    y: box.y
                },
                {
                    x: box.x + box.width,
                    y: box.y + box.height
                },
                {
                    x: box.x,
                    y: box.y + box.height
                }
            ];
            const trans = node.getAbsoluteTransform();
            points.forEach(function(point) {
                const transformed = trans.point(point);
                totalPoints.push(transformed);
            });
        });
        const tr = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
        tr.rotate(-(0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.rotation()));
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        totalPoints.forEach(function(point) {
            const transformed = tr.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        tr.invert();
        const p = tr.point({
            x: minX,
            y: minY
        });
        return {
            x: p.x,
            y: p.y,
            width: maxX - minX,
            height: maxY - minY,
            rotation: (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.rotation())
        };
    }
    getX() {
        return this._getNodeRect().x;
    }
    getY() {
        return this._getNodeRect().y;
    }
    getWidth() {
        return this._getNodeRect().width;
    }
    getHeight() {
        return this._getNodeRect().height;
    }
    _createElements() {
        this._createBack();
        $801345eab32c3d30$var$ANCHORS_NAMES.forEach((name)=>{
            this._createAnchor(name);
        });
        this._createAnchor('rotater');
    }
    _createAnchor(name) {
        const anchor = new (0, $f22346c22f20789a$export$c79fc6492f3af13d)({
            stroke: 'rgb(0, 161, 255)',
            fill: 'white',
            strokeWidth: 1,
            name: name + ' _anchor',
            dragDistance: 0,
            draggable: true,
            hitStrokeWidth: $801345eab32c3d30$var$TOUCH_DEVICE ? 10 : 'auto'
        });
        const self = this;
        anchor.on('mousedown touchstart', function(e) {
            self._handleMouseDown(e);
        });
        anchor.on('dragstart', (e)=>{
            anchor.stopDrag();
            e.cancelBubble = true;
        });
        anchor.on('dragend', (e)=>{
            e.cancelBubble = true;
        });
        anchor.on('mouseenter', ()=>{
            const rad = (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.rotation());
            const rotateCursor = this.rotateAnchorCursor();
            const cursor = $801345eab32c3d30$var$getCursor(name, rad, rotateCursor);
            anchor.getStage().content && (anchor.getStage().content.style.cursor = cursor);
            this._cursorChange = true;
        });
        anchor.on('mouseout', ()=>{
            anchor.getStage().content && (anchor.getStage().content.style.cursor = '');
            this._cursorChange = false;
        });
        this.add(anchor);
    }
    _createBack() {
        const back = new (0, $9081147451080c7d$export$6428a7f2611ef1fa)({
            name: 'back',
            width: 0,
            height: 0,
            sceneFunc (ctx, shape) {
                const tr = shape.getParent();
                const padding = tr.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
                ctx.moveTo(shape.width() / 2, -padding);
                if (tr.rotateEnabled() && tr.rotateLineVisible()) ctx.lineTo(shape.width() / 2, -tr.rotateAnchorOffset() * (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._sign(shape.height()) - padding);
                ctx.fillStrokeShape(shape);
            },
            hitFunc: (ctx, shape)=>{
                if (!this.shouldOverdrawWholeArea()) return;
                const padding = this.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
                ctx.fillStrokeShape(shape);
            }
        });
        this.add(back);
        this._proxyDrag(back);
        back.on('dragstart', (e)=>{
            e.cancelBubble = true;
        });
        back.on('dragmove', (e)=>{
            e.cancelBubble = true;
        });
        back.on('dragend', (e)=>{
            e.cancelBubble = true;
        });
        this.on('dragmove', (e)=>{
            this.update();
        });
    }
    _handleMouseDown(e) {
        if (this._transforming) return;
        this._movingAnchorName = e.target.name().split(' ')[0];
        const attrs = this._getNodeRect();
        const width = attrs.width;
        const height = attrs.height;
        const hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
        this.sin = Math.abs(height / hypotenuse);
        this.cos = Math.abs(width / hypotenuse);
        if (typeof window !== 'undefined') {
            window.addEventListener('mousemove', this._handleMouseMove);
            window.addEventListener('touchmove', this._handleMouseMove);
            window.addEventListener('mouseup', this._handleMouseUp, true);
            window.addEventListener('touchend', this._handleMouseUp, true);
        }
        this._transforming = true;
        const ap = e.target.getAbsolutePosition();
        const pos = e.target.getStage().getPointerPosition();
        this._anchorDragOffset = {
            x: pos.x - ap.x,
            y: pos.y - ap.y
        };
        $801345eab32c3d30$var$activeTransformersCount++;
        this._fire('transformstart', {
            evt: e.evt,
            target: this.getNode()
        });
        this._nodes.forEach((target)=>{
            target._fire('transformstart', {
                evt: e.evt,
                target: target
            });
        });
    }
    _handleMouseMove(e) {
        let x, y, newHypotenuse;
        const anchorNode = this.findOne('.' + this._movingAnchorName);
        const stage = anchorNode.getStage();
        stage.setPointersPositions(e);
        const pp = stage.getPointerPosition();
        let newNodePos = {
            x: pp.x - this._anchorDragOffset.x,
            y: pp.y - this._anchorDragOffset.y
        };
        const oldAbs = anchorNode.getAbsolutePosition();
        if (this.anchorDragBoundFunc()) newNodePos = this.anchorDragBoundFunc()(oldAbs, newNodePos, e);
        anchorNode.setAbsolutePosition(newNodePos);
        const newAbs = anchorNode.getAbsolutePosition();
        if (oldAbs.x === newAbs.x && oldAbs.y === newAbs.y) return;
        if (this._movingAnchorName === 'rotater') {
            const attrs = this._getNodeRect();
            x = anchorNode.x() - attrs.width / 2;
            y = -anchorNode.y() + attrs.height / 2;
            let delta = Math.atan2(-y, x) + Math.PI / 2;
            if (attrs.height < 0) delta -= Math.PI;
            const oldRotation = (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.rotation());
            const newRotation = oldRotation + delta;
            const tol = (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.rotationSnapTolerance());
            const snappedRot = $801345eab32c3d30$var$getSnap(this.rotationSnaps(), newRotation, tol);
            const diff = snappedRot - attrs.rotation;
            const shape = $801345eab32c3d30$var$rotateAroundCenter(attrs, diff);
            this._fitNodesInto(shape, e);
            return;
        }
        const shiftBehavior = this.shiftBehavior();
        let keepProportion;
        if (shiftBehavior === 'inverted') keepProportion = this.keepRatio() && !e.shiftKey;
        else if (shiftBehavior === 'none') keepProportion = this.keepRatio();
        else keepProportion = this.keepRatio() || e.shiftKey;
        let centeredScaling = this.centeredScaling() || e.altKey;
        if (this._movingAnchorName === 'top-left') {
            if (keepProportion) {
                const comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.bottom-right').x(),
                    y: this.findOne('.bottom-right').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                const reverseX = this.findOne('.top-left').x() > comparePoint.x ? -1 : 1;
                const reverseY = this.findOne('.top-left').y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.top-left').x(comparePoint.x - x);
                this.findOne('.top-left').y(comparePoint.y - y);
            }
        } else if (this._movingAnchorName === 'top-center') this.findOne('.top-left').y(anchorNode.y());
        else if (this._movingAnchorName === 'top-right') {
            if (keepProportion) {
                const comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.bottom-left').x(),
                    y: this.findOne('.bottom-left').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                const reverseX = this.findOne('.top-right').x() < comparePoint.x ? -1 : 1;
                const reverseY = this.findOne('.top-right').y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.top-right').x(comparePoint.x + x);
                this.findOne('.top-right').y(comparePoint.y - y);
            }
            var pos = anchorNode.position();
            this.findOne('.top-left').y(pos.y);
            this.findOne('.bottom-right').x(pos.x);
        } else if (this._movingAnchorName === 'middle-left') this.findOne('.top-left').x(anchorNode.x());
        else if (this._movingAnchorName === 'middle-right') this.findOne('.bottom-right').x(anchorNode.x());
        else if (this._movingAnchorName === 'bottom-left') {
            if (keepProportion) {
                const comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.top-right').x(),
                    y: this.findOne('.top-right').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                const reverseX = comparePoint.x < anchorNode.x() ? -1 : 1;
                const reverseY = anchorNode.y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                anchorNode.x(comparePoint.x - x);
                anchorNode.y(comparePoint.y + y);
            }
            pos = anchorNode.position();
            this.findOne('.top-left').x(pos.x);
            this.findOne('.bottom-right').y(pos.y);
        } else if (this._movingAnchorName === 'bottom-center') this.findOne('.bottom-right').y(anchorNode.y());
        else if (this._movingAnchorName === 'bottom-right') {
            if (keepProportion) {
                const comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.top-left').x(),
                    y: this.findOne('.top-left').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                const reverseX = this.findOne('.bottom-right').x() < comparePoint.x ? -1 : 1;
                const reverseY = this.findOne('.bottom-right').y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.bottom-right').x(comparePoint.x + x);
                this.findOne('.bottom-right').y(comparePoint.y + y);
            }
        } else console.error(new Error('Wrong position argument of selection resizer: ' + this._movingAnchorName));
        centeredScaling = this.centeredScaling() || e.altKey;
        if (centeredScaling) {
            const topLeft = this.findOne('.top-left');
            const bottomRight = this.findOne('.bottom-right');
            const topOffsetX = topLeft.x();
            const topOffsetY = topLeft.y();
            const bottomOffsetX = this.getWidth() - bottomRight.x();
            const bottomOffsetY = this.getHeight() - bottomRight.y();
            bottomRight.move({
                x: -topOffsetX,
                y: -topOffsetY
            });
            topLeft.move({
                x: bottomOffsetX,
                y: bottomOffsetY
            });
        }
        const absPos = this.findOne('.top-left').getAbsolutePosition();
        x = absPos.x;
        y = absPos.y;
        const width = this.findOne('.bottom-right').x() - this.findOne('.top-left').x();
        const height = this.findOne('.bottom-right').y() - this.findOne('.top-left').y();
        this._fitNodesInto({
            x: x,
            y: y,
            width: width,
            height: height,
            rotation: (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.rotation())
        }, e);
    }
    _handleMouseUp(e) {
        this._removeEvents(e);
    }
    getAbsoluteTransform() {
        return this.getTransform();
    }
    _removeEvents(e) {
        var _a;
        if (this._transforming) {
            this._transforming = false;
            if (typeof window !== 'undefined') {
                window.removeEventListener('mousemove', this._handleMouseMove);
                window.removeEventListener('touchmove', this._handleMouseMove);
                window.removeEventListener('mouseup', this._handleMouseUp, true);
                window.removeEventListener('touchend', this._handleMouseUp, true);
            }
            const node = this.getNode();
            $801345eab32c3d30$var$activeTransformersCount--;
            this._fire('transformend', {
                evt: e,
                target: node
            });
            (_a = this.getLayer()) === null || _a === void 0 || _a.batchDraw();
            if (node) this._nodes.forEach((target)=>{
                var _a;
                target._fire('transformend', {
                    evt: e,
                    target: target
                });
                (_a = target.getLayer()) === null || _a === void 0 || _a.batchDraw();
            });
            this._movingAnchorName = null;
        }
    }
    _fitNodesInto(newAttrs, evt) {
        const oldAttrs = this._getNodeRect();
        const minSize = 1;
        if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(newAttrs.width, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(newAttrs.height, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        const t = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
        t.rotate((0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.rotation()));
        if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf('left') >= 0) {
            const offset = t.point({
                x: -this.padding() * 2,
                y: 0
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            newAttrs.width += this.padding() * 2;
            this._movingAnchorName = this._movingAnchorName.replace('left', 'right');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
        } else if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf('right') >= 0) {
            const offset = t.point({
                x: this.padding() * 2,
                y: 0
            });
            this._movingAnchorName = this._movingAnchorName.replace('right', 'left');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.width += this.padding() * 2;
        }
        if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf('top') >= 0) {
            const offset = t.point({
                x: 0,
                y: -this.padding() * 2
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            this._movingAnchorName = this._movingAnchorName.replace('top', 'bottom');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
        } else if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf('bottom') >= 0) {
            const offset = t.point({
                x: 0,
                y: this.padding() * 2
            });
            this._movingAnchorName = this._movingAnchorName.replace('bottom', 'top');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
        }
        if (this.boundBoxFunc()) {
            const bounded = this.boundBoxFunc()(oldAttrs, newAttrs);
            if (bounded) newAttrs = bounded;
            else (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('boundBoxFunc returned falsy. You should return new bound rect from it!');
        }
        const baseSize = 10000000;
        const oldTr = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
        oldTr.translate(oldAttrs.x, oldAttrs.y);
        oldTr.rotate(oldAttrs.rotation);
        oldTr.scale(oldAttrs.width / baseSize, oldAttrs.height / baseSize);
        const newTr = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
        const newScaleX = newAttrs.width / baseSize;
        const newScaleY = newAttrs.height / baseSize;
        if (this.flipEnabled() === false) {
            newTr.translate(newAttrs.x, newAttrs.y);
            newTr.rotate(newAttrs.rotation);
            newTr.translate(newAttrs.width < 0 ? newAttrs.width : 0, newAttrs.height < 0 ? newAttrs.height : 0);
            newTr.scale(Math.abs(newScaleX), Math.abs(newScaleY));
        } else {
            newTr.translate(newAttrs.x, newAttrs.y);
            newTr.rotate(newAttrs.rotation);
            newTr.scale(newScaleX, newScaleY);
        }
        const delta = newTr.multiply(oldTr.invert());
        this._nodes.forEach((node)=>{
            var _a;
            if (!node.getStage()) return;
            const parentTransform = node.getParent().getAbsoluteTransform();
            const localTransform = node.getTransform().copy();
            localTransform.translate(node.offsetX(), node.offsetY());
            const newLocalTransform = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
            newLocalTransform.multiply(parentTransform.copy().invert()).multiply(delta).multiply(parentTransform).multiply(localTransform);
            const attrs = newLocalTransform.decompose();
            node.setAttrs(attrs);
            (_a = node.getLayer()) === null || _a === void 0 || _a.batchDraw();
        });
        this.rotation((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getRotation(newAttrs.rotation));
        this._nodes.forEach((node)=>{
            this._fire('transform', {
                evt: evt,
                target: node
            });
            node._fire('transform', {
                evt: evt,
                target: node
            });
        });
        this._resetTransformCache();
        this.update();
        this.getLayer().batchDraw();
    }
    forceUpdate() {
        this._resetTransformCache();
        this.update();
    }
    _batchChangeChild(selector, attrs) {
        const anchor = this.findOne(selector);
        anchor.setAttrs(attrs);
    }
    update() {
        var _a;
        const attrs = this._getNodeRect();
        this.rotation((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getRotation(attrs.rotation));
        const width = attrs.width;
        const height = attrs.height;
        const enabledAnchors = this.enabledAnchors();
        const resizeEnabled = this.resizeEnabled();
        const padding = this.padding();
        const anchorSize = this.anchorSize();
        const anchors = this.find('._anchor');
        anchors.forEach((node)=>{
            node.setAttrs({
                width: anchorSize,
                height: anchorSize,
                offsetX: anchorSize / 2,
                offsetY: anchorSize / 2,
                stroke: this.anchorStroke(),
                strokeWidth: this.anchorStrokeWidth(),
                fill: this.anchorFill(),
                cornerRadius: this.anchorCornerRadius()
            });
        });
        this._batchChangeChild('.top-left', {
            x: 0,
            y: 0,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-left') >= 0
        });
        this._batchChangeChild('.top-center', {
            x: width / 2,
            y: 0,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-center') >= 0
        });
        this._batchChangeChild('.top-right', {
            x: width,
            y: 0,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-right') >= 0
        });
        this._batchChangeChild('.middle-left', {
            x: 0,
            y: height / 2,
            offsetX: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('middle-left') >= 0
        });
        this._batchChangeChild('.middle-right', {
            x: width,
            y: height / 2,
            offsetX: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('middle-right') >= 0
        });
        this._batchChangeChild('.bottom-left', {
            x: 0,
            y: height,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-left') >= 0
        });
        this._batchChangeChild('.bottom-center', {
            x: width / 2,
            y: height,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-center') >= 0
        });
        this._batchChangeChild('.bottom-right', {
            x: width,
            y: height,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-right') >= 0
        });
        this._batchChangeChild('.rotater', {
            x: width / 2,
            y: -this.rotateAnchorOffset() * (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._sign(height) - padding,
            visible: this.rotateEnabled()
        });
        this._batchChangeChild('.back', {
            width: width,
            height: height,
            visible: this.borderEnabled(),
            stroke: this.borderStroke(),
            strokeWidth: this.borderStrokeWidth(),
            dash: this.borderDash(),
            draggable: this.nodes().some((node)=>node.draggable()),
            x: 0,
            y: 0
        });
        const styleFunc = this.anchorStyleFunc();
        if (styleFunc) anchors.forEach((node)=>{
            styleFunc(node);
        });
        (_a = this.getLayer()) === null || _a === void 0 || _a.batchDraw();
    }
    isTransforming() {
        return this._transforming;
    }
    stopTransform() {
        if (this._transforming) {
            this._removeEvents();
            const anchorNode = this.findOne('.' + this._movingAnchorName);
            if (anchorNode) anchorNode.stopDrag();
        }
    }
    destroy() {
        if (this.getStage() && this._cursorChange) this.getStage().content && (this.getStage().content.style.cursor = '');
        (0, $644b7f3bf259f4bd$export$eb2fcfdbd7ba97d4).prototype.destroy.call(this);
        this.detach();
        this._removeEvents();
        return this;
    }
    toObject() {
        return (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.toObject.call(this);
    }
    clone(obj) {
        const node = (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.clone.call(this, obj);
        return node;
    }
    getClientRect() {
        if (this.nodes().length > 0) return super.getClientRect();
        else return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}
$801345eab32c3d30$export$f993aef960936087.isTransforming = ()=>{
    return $801345eab32c3d30$var$activeTransformersCount > 0;
};
function $801345eab32c3d30$var$validateAnchors(val) {
    if (!(val instanceof Array)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('enabledAnchors value should be an array');
    if (val instanceof Array) val.forEach(function(name) {
        if ($801345eab32c3d30$var$ANCHORS_NAMES.indexOf(name) === -1) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Unknown anchor name: ' + name + '. Available names are: ' + $801345eab32c3d30$var$ANCHORS_NAMES.join(', '));
    });
    return val || [];
}
$801345eab32c3d30$export$f993aef960936087.prototype.className = 'Transformer';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($801345eab32c3d30$export$f993aef960936087);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'enabledAnchors', $801345eab32c3d30$var$ANCHORS_NAMES, $801345eab32c3d30$var$validateAnchors);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'flipEnabled', true, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'resizeEnabled', true);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'anchorSize', 10, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'rotateEnabled', true);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'rotateLineVisible', true);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'rotationSnaps', []);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'rotateAnchorOffset', 50, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'rotateAnchorCursor', 'crosshair');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'rotationSnapTolerance', 5, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'borderEnabled', true);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'anchorStroke', 'rgb(0, 161, 255)');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'anchorStrokeWidth', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'anchorFill', 'white');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'anchorCornerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'borderStroke', 'rgb(0, 161, 255)');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'borderStrokeWidth', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'borderDash');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'keepRatio', true);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'shiftBehavior', 'default');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'centeredScaling', false);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'ignoreStroke', false);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'padding', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'nodes');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'node');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'boundBoxFunc');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'anchorDragBoundFunc');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'anchorStyleFunc');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'shouldOverdrawWholeArea', false);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'useSingleNodeRotation', true);
(0, $abe0ad8331aee635$export$8354032f3852ec50).backCompat($801345eab32c3d30$export$f993aef960936087, {
    lineEnabled: 'borderEnabled',
    rotateHandlerOffset: 'rotateAnchorOffset',
    enabledHandlers: 'enabledAnchors'
});






class $38218507e674999c$export$28718c7785907330 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.radius(), 0, (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.angle()), this.clockwise());
        context.lineTo(0, 0);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$38218507e674999c$export$28718c7785907330.prototype.className = 'Wedge';
$38218507e674999c$export$28718c7785907330.prototype._centroid = true;
$38218507e674999c$export$28718c7785907330.prototype._attrsAffectingSize = [
    'radius'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($38218507e674999c$export$28718c7785907330);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($38218507e674999c$export$28718c7785907330, 'radius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($38218507e674999c$export$28718c7785907330, 'angle', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($38218507e674999c$export$28718c7785907330, 'clockwise', false);
(0, $abe0ad8331aee635$export$8354032f3852ec50).backCompat($38218507e674999c$export$28718c7785907330, {
    angleDeg: 'angle',
    getAngleDeg: 'getAngle',
    setAngleDeg: 'setAngle'
});





function $115c1355c0a3c8a8$var$BlurStack() {
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = 0;
    this.next = null;
}
const $115c1355c0a3c8a8$var$mul_table = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
];
const $115c1355c0a3c8a8$var$shg_table = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
];
function $115c1355c0a3c8a8$var$filterGaussBlurRGBA(imageData, radius) {
    const pixels = imageData.data, width = imageData.width, height = imageData.height;
    let p, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;
    const div = radius + radius + 1, widthMinus1 = width - 1, heightMinus1 = height - 1, radiusPlus1 = radius + 1, sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2, stackStart = new $115c1355c0a3c8a8$var$BlurStack(), mul_sum = $115c1355c0a3c8a8$var$mul_table[radius], shg_sum = $115c1355c0a3c8a8$var$shg_table[radius];
    let stackEnd = null, stack = stackStart, stackIn = null, stackOut = null;
    for(let i = 1; i < div; i++){
        stack = stack.next = new $115c1355c0a3c8a8$var$BlurStack();
        if (i === radiusPlus1) stackEnd = stack;
    }
    stack.next = stackStart;
    yw = yi = 0;
    for(let y = 0; y < height; y++){
        r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(let i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        for(let i = 1; i < radiusPlus1; i++){
            p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
            r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[p + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
        }
        stackIn = stackStart;
        stackOut = stackEnd;
        for(let x = 0; x < width; x++){
            pixels[yi + 3] = pa = a_sum * mul_sum >> shg_sum;
            if (pa !== 0) {
                pa = 255 / pa;
                pixels[yi] = (r_sum * mul_sum >> shg_sum) * pa;
                pixels[yi + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                pixels[yi + 2] = (b_sum * mul_sum >> shg_sum) * pa;
            } else pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;
            r_in_sum += stackIn.r = pixels[p];
            g_in_sum += stackIn.g = pixels[p + 1];
            b_in_sum += stackIn.b = pixels[p + 2];
            a_in_sum += stackIn.a = pixels[p + 3];
            r_sum += r_in_sum;
            g_sum += g_in_sum;
            b_sum += b_in_sum;
            a_sum += a_in_sum;
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += 4;
        }
        yw += width;
    }
    for(let x = 0; x < width; x++){
        g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;
        yi = x << 2;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(let i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        let yp = width;
        for(let i = 1; i <= radius; i++){
            yi = yp + x << 2;
            r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
            if (i < heightMinus1) yp += width;
        }
        yi = x;
        stackIn = stackStart;
        stackOut = stackEnd;
        for(let y = 0; y < height; y++){
            p = yi << 2;
            pixels[p + 3] = pa = a_sum * mul_sum >> shg_sum;
            if (pa > 0) {
                pa = 255 / pa;
                pixels[p] = (r_sum * mul_sum >> shg_sum) * pa;
                pixels[p + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                pixels[p + 2] = (b_sum * mul_sum >> shg_sum) * pa;
            } else pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = x + ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;
            r_sum += r_in_sum += stackIn.r = pixels[p];
            g_sum += g_in_sum += stackIn.g = pixels[p + 1];
            b_sum += b_in_sum += stackIn.b = pixels[p + 2];
            a_sum += a_in_sum += stackIn.a = pixels[p + 3];
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += width;
        }
    }
}
const $115c1355c0a3c8a8$export$975a268f2c733e4 = function Blur(imageData) {
    const radius = Math.round(this.blurRadius());
    if (radius > 0) $115c1355c0a3c8a8$var$filterGaussBlurRGBA(imageData, radius);
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'blurRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);





const $ced669b61682093f$export$a2d0d82739cac11f = function(imageData) {
    const brightness = this.brightness() * 255, data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 4){
        data[i] += brightness;
        data[i + 1] += brightness;
        data[i + 2] += brightness;
    }
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'brightness', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);


const $d2cbac3f9294abf4$export$98835ff3df8927e5 = function(imageData) {
    const brightness = this.brightness(), data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 4){
        data[i] = Math.min(255, data[i] * brightness);
        data[i + 1] = Math.min(255, data[i + 1] * brightness);
        data[i + 2] = Math.min(255, data[i + 2] * brightness);
    }
};





const $915438a9a02e65de$export$656ae42051d0ca86 = function(imageData) {
    const adjust = Math.pow((this.contrast() + 100) / 100, 2);
    const data = imageData.data, nPixels = data.length;
    let red = 150, green = 150, blue = 150;
    for(let i = 0; i < nPixels; i += 4){
        red = data[i];
        green = data[i + 1];
        blue = data[i + 2];
        red /= 255;
        red -= 0.5;
        red *= adjust;
        red += 0.5;
        red *= 255;
        green /= 255;
        green -= 0.5;
        green *= adjust;
        green += 0.5;
        green *= 255;
        blue /= 255;
        blue -= 0.5;
        blue *= adjust;
        blue += 0.5;
        blue *= 255;
        red = red < 0 ? 0 : red > 255 ? 255 : red;
        green = green < 0 ? 0 : green > 255 ? 255 : green;
        blue = blue < 0 ? 0 : blue > 255 ? 255 : blue;
        data[i] = red;
        data[i + 1] = green;
        data[i + 2] = blue;
    }
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'contrast', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);





const $2b42f6c4d038b489$export$3c8699b389eb838 = function(imageData) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const data = imageData.data;
    const w = imageData.width;
    const h = imageData.height;
    const strength01 = Math.min(1, Math.max(0, (_b = (_a = this.embossStrength) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : 0.5));
    const whiteLevel01 = Math.min(1, Math.max(0, (_d = (_c = this.embossWhiteLevel) === null || _c === void 0 ? void 0 : _c.call(this)) !== null && _d !== void 0 ? _d : 0.5));
    const directionMap = {
        'top-left': 315,
        top: 270,
        'top-right': 225,
        right: 180,
        'bottom-right': 135,
        bottom: 90,
        'bottom-left': 45,
        left: 0
    };
    const directionDeg = (_g = directionMap[(_f = (_e = this.embossDirection) === null || _e === void 0 ? void 0 : _e.call(this)) !== null && _f !== void 0 ? _f : 'top-left']) !== null && _g !== void 0 ? _g : 315;
    const blend = !!((_j = (_h = this.embossBlend) === null || _h === void 0 ? void 0 : _h.call(this)) !== null && _j !== void 0 ? _j : false);
    const strength = strength01 * 10;
    const bias = whiteLevel01 * 255;
    const dirRad = directionDeg * Math.PI / 180;
    const cx = Math.cos(dirRad);
    const cy = Math.sin(dirRad);
    const SCALE = 128 / 1020 * strength;
    const src = new Uint8ClampedArray(data);
    const lum = new Float32Array(w * h);
    for(let p = 0, i = 0; i < data.length; i += 4, p++)lum[p] = 0.2126 * src[i] + 0.7152 * src[i + 1] + 0.0722 * src[i + 2];
    const Gx = [
        -1,
        0,
        1,
        -2,
        0,
        2,
        -1,
        0,
        1
    ];
    const Gy = [
        -1,
        -2,
        -1,
        0,
        0,
        0,
        1,
        2,
        1
    ];
    const OFF = [
        -w - 1,
        -w,
        -w + 1,
        -1,
        0,
        1,
        w - 1,
        w,
        w + 1
    ];
    const clamp8 = (v)=>v < 0 ? 0 : v > 255 ? 255 : v;
    for(let y = 1; y < h - 1; y++)for(let x = 1; x < w - 1; x++){
        const p = y * w + x;
        let sx = 0, sy = 0;
        sx += lum[p + OFF[0]] * Gx[0];
        sy += lum[p + OFF[0]] * Gy[0];
        sx += lum[p + OFF[1]] * Gx[1];
        sy += lum[p + OFF[1]] * Gy[1];
        sx += lum[p + OFF[2]] * Gx[2];
        sy += lum[p + OFF[2]] * Gy[2];
        sx += lum[p + OFF[3]] * Gx[3];
        sy += lum[p + OFF[3]] * Gy[3];
        sx += lum[p + OFF[5]] * Gx[5];
        sy += lum[p + OFF[5]] * Gy[5];
        sx += lum[p + OFF[6]] * Gx[6];
        sy += lum[p + OFF[6]] * Gy[6];
        sx += lum[p + OFF[7]] * Gx[7];
        sy += lum[p + OFF[7]] * Gy[7];
        sx += lum[p + OFF[8]] * Gx[8];
        sy += lum[p + OFF[8]] * Gy[8];
        const r = cx * sx + cy * sy;
        const outGray = clamp8(bias + r * SCALE);
        const o = p * 4;
        if (blend) {
            const delta = outGray - bias;
            data[o] = clamp8(src[o] + delta);
            data[o + 1] = clamp8(src[o + 1] + delta);
            data[o + 2] = clamp8(src[o + 2] + delta);
            data[o + 3] = src[o + 3];
        } else {
            data[o] = data[o + 1] = data[o + 2] = outGray;
            data[o + 3] = src[o + 3];
        }
    }
    for(let x = 0; x < w; x++){
        let oTop = x * 4, oBot = ((h - 1) * w + x) * 4;
        data[oTop] = src[oTop];
        data[oTop + 1] = src[oTop + 1];
        data[oTop + 2] = src[oTop + 2];
        data[oTop + 3] = src[oTop + 3];
        data[oBot] = src[oBot];
        data[oBot + 1] = src[oBot + 1];
        data[oBot + 2] = src[oBot + 2];
        data[oBot + 3] = src[oBot + 3];
    }
    for(let y = 1; y < h - 1; y++){
        let oL = y * w * 4, oR = (y * w + (w - 1)) * 4;
        data[oL] = src[oL];
        data[oL + 1] = src[oL + 1];
        data[oL + 2] = src[oL + 2];
        data[oL + 3] = src[oL + 3];
        data[oR] = src[oR];
        data[oR + 1] = src[oR + 1];
        data[oR + 2] = src[oR + 2];
        data[oR + 3] = src[oR + 3];
    }
    return imageData;
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'embossStrength', 0.5, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'embossWhiteLevel', 0.5, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'embossDirection', 'top-left', undefined, (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'embossBlend', false, undefined, (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);





function $2ad1b73e774f59bb$var$remap(fromValue, fromMin, fromMax, toMin, toMax) {
    const fromRange = fromMax - fromMin, toRange = toMax - toMin;
    if (fromRange === 0) return toMin + toRange / 2;
    if (toRange === 0) return toMin;
    let toValue = (fromValue - fromMin) / fromRange;
    toValue = toRange * toValue + toMin;
    return toValue;
}
const $2ad1b73e774f59bb$export$5cb8e8388f951d6f = function(imageData) {
    const data = imageData.data, nSubPixels = data.length;
    let rMin = data[0], rMax = rMin, r, gMin = data[1], gMax = gMin, g, bMin = data[2], bMax = bMin, b;
    const enhanceAmount = this.enhance();
    if (enhanceAmount === 0) return;
    for(let i = 0; i < nSubPixels; i += 4){
        r = data[i + 0];
        if (r < rMin) rMin = r;
        else if (r > rMax) rMax = r;
        g = data[i + 1];
        if (g < gMin) gMin = g;
        else if (g > gMax) gMax = g;
        b = data[i + 2];
        if (b < bMin) bMin = b;
        else if (b > bMax) bMax = b;
    }
    if (rMax === rMin) {
        rMax = 255;
        rMin = 0;
    }
    if (gMax === gMin) {
        gMax = 255;
        gMin = 0;
    }
    if (bMax === bMin) {
        bMax = 255;
        bMin = 0;
    }
    let rGoalMax, rGoalMin, gGoalMax, gGoalMin, bGoalMax, bGoalMin;
    if (enhanceAmount > 0) {
        rGoalMax = rMax + enhanceAmount * (255 - rMax);
        rGoalMin = rMin - enhanceAmount * (rMin - 0);
        gGoalMax = gMax + enhanceAmount * (255 - gMax);
        gGoalMin = gMin - enhanceAmount * (gMin - 0);
        bGoalMax = bMax + enhanceAmount * (255 - bMax);
        bGoalMin = bMin - enhanceAmount * (bMin - 0);
    } else {
        const rMid = (rMax + rMin) * 0.5;
        rGoalMax = rMax + enhanceAmount * (rMax - rMid);
        rGoalMin = rMin + enhanceAmount * (rMin - rMid);
        const gMid = (gMax + gMin) * 0.5;
        gGoalMax = gMax + enhanceAmount * (gMax - gMid);
        gGoalMin = gMin + enhanceAmount * (gMin - gMid);
        const bMid = (bMax + bMin) * 0.5;
        bGoalMax = bMax + enhanceAmount * (bMax - bMid);
        bGoalMin = bMin + enhanceAmount * (bMin - bMid);
    }
    for(let i = 0; i < nSubPixels; i += 4){
        data[i + 0] = $2ad1b73e774f59bb$var$remap(data[i + 0], rMin, rMax, rGoalMin, rGoalMax);
        data[i + 1] = $2ad1b73e774f59bb$var$remap(data[i + 1], gMin, gMax, gGoalMin, gGoalMax);
        data[i + 2] = $2ad1b73e774f59bb$var$remap(data[i + 2], bMin, bMax, bGoalMin, bGoalMax);
    }
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'enhance', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);


const $d01fff91fba4df8f$export$e2b0a794e83ca071 = function(imageData) {
    const data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 4){
        const brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
        data[i] = brightness;
        data[i + 1] = brightness;
        data[i + 2] = brightness;
    }
};





(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'hue', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'saturation', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'luminance', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
const $4b70970df87d7d14$export$46d8b0f9bc8f87a2 = function(imageData) {
    const data = imageData.data, nPixels = data.length, v = 1, s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, l = this.luminance() * 127;
    const vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    const rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    const gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    const br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    let r, g, b, a;
    for(let i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b + l;
        data[i + 1] = gr * r + gg * g + gb * b + l;
        data[i + 2] = br * r + bg * g + bb * b + l;
        data[i + 3] = a;
    }
};





const $a9eed7ce687c1218$export$d2edaecd208aed43 = function(imageData) {
    const data = imageData.data, nPixels = data.length, v = Math.pow(2, this.value()), s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360;
    const vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    const rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    const gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    const br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    for(let i = 0; i < nPixels; i += 4){
        const r = data[i + 0];
        const g = data[i + 1];
        const b = data[i + 2];
        const a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b;
        data[i + 1] = gr * r + gg * g + gb * b;
        data[i + 2] = br * r + bg * g + bb * b;
        data[i + 3] = a;
    }
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'hue', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'saturation', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'value', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);


const $15eda2f50977af8f$export$1073348d81b17440 = function(imageData) {
    const data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 4){
        data[i] = 255 - data[i];
        data[i + 1] = 255 - data[i + 1];
        data[i + 2] = 255 - data[i + 2];
    }
};






const $6c6b8bc9d19c96ee$var$ToPolar = function(src, dst, opt) {
    const srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2;
    let rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    let x = xSize - xMid;
    let y = ySize - yMid;
    const rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    const rSize = ySize, tSize = xSize;
    const conversion = 360 / tSize * Math.PI / 180;
    for(let theta = 0; theta < tSize; theta += 1){
        const sin = Math.sin(theta * conversion);
        const cos = Math.cos(theta * conversion);
        for(let radius = 0; radius < rSize; radius += 1){
            x = Math.floor(xMid + rMax * radius / rSize * cos);
            y = Math.floor(yMid + rMax * radius / rSize * sin);
            let i = (y * xSize + x) * 4;
            const r = srcPixels[i + 0];
            const g = srcPixels[i + 1];
            const b = srcPixels[i + 2];
            const a = srcPixels[i + 3];
            i = (theta + radius * xSize) * 4;
            dstPixels[i + 0] = r;
            dstPixels[i + 1] = g;
            dstPixels[i + 2] = b;
            dstPixels[i + 3] = a;
        }
    }
};
const $6c6b8bc9d19c96ee$var$FromPolar = function(src, dst, opt) {
    const srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2;
    let rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    let x = xSize - xMid;
    let y = ySize - yMid;
    const rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    const rSize = ySize, tSize = xSize, phaseShift = opt.polarRotation || 0;
    let x1, y1;
    for(x = 0; x < xSize; x += 1)for(y = 0; y < ySize; y += 1){
        const dx = x - xMid;
        const dy = y - yMid;
        const radius = Math.sqrt(dx * dx + dy * dy) * rSize / rMax;
        let theta = (Math.atan2(dy, dx) * 180 / Math.PI + 360 + phaseShift) % 360;
        theta = theta * tSize / 360;
        x1 = Math.floor(theta);
        y1 = Math.floor(radius);
        let i = (y1 * xSize + x1) * 4;
        const r = srcPixels[i + 0];
        const g = srcPixels[i + 1];
        const b = srcPixels[i + 2];
        const a = srcPixels[i + 3];
        i = (y * xSize + x) * 4;
        dstPixels[i + 0] = r;
        dstPixels[i + 1] = g;
        dstPixels[i + 2] = b;
        dstPixels[i + 3] = a;
    }
};
const $6c6b8bc9d19c96ee$export$e731e8a0fd067155 = function(imageData) {
    const xSize = imageData.width, ySize = imageData.height;
    let x, y, xoff, i, r, g, b, a, srcPos, dstPos;
    let power = Math.round(this.kaleidoscopePower());
    const angle = Math.round(this.kaleidoscopeAngle());
    const offset = Math.floor(xSize * (angle % 360) / 360);
    if (power < 1) return;
    const tempCanvas = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).createCanvasElement();
    tempCanvas.width = xSize;
    tempCanvas.height = ySize;
    const scratchData = tempCanvas.getContext('2d').getImageData(0, 0, xSize, ySize);
    (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).releaseCanvas(tempCanvas);
    $6c6b8bc9d19c96ee$var$ToPolar(imageData, scratchData, {
        polarCenterX: xSize / 2,
        polarCenterY: ySize / 2
    });
    let minSectionSize = xSize / Math.pow(2, power);
    while(minSectionSize <= 8){
        minSectionSize = minSectionSize * 2;
        power -= 1;
    }
    minSectionSize = Math.ceil(minSectionSize);
    let sectionSize = minSectionSize;
    let xStart = 0, xEnd = sectionSize, xDelta = 1;
    if (offset + minSectionSize > xSize) {
        xStart = sectionSize;
        xEnd = 0;
        xDelta = -1;
    }
    for(y = 0; y < ySize; y += 1)for(x = xStart; x !== xEnd; x += xDelta){
        xoff = Math.round(x + offset) % xSize;
        srcPos = (xSize * y + xoff) * 4;
        r = scratchData.data[srcPos + 0];
        g = scratchData.data[srcPos + 1];
        b = scratchData.data[srcPos + 2];
        a = scratchData.data[srcPos + 3];
        dstPos = (xSize * y + x) * 4;
        scratchData.data[dstPos + 0] = r;
        scratchData.data[dstPos + 1] = g;
        scratchData.data[dstPos + 2] = b;
        scratchData.data[dstPos + 3] = a;
    }
    for(y = 0; y < ySize; y += 1){
        sectionSize = Math.floor(minSectionSize);
        for(i = 0; i < power; i += 1){
            for(x = 0; x < sectionSize + 1; x += 1){
                srcPos = (xSize * y + x) * 4;
                r = scratchData.data[srcPos + 0];
                g = scratchData.data[srcPos + 1];
                b = scratchData.data[srcPos + 2];
                a = scratchData.data[srcPos + 3];
                dstPos = (xSize * y + sectionSize * 2 - x - 1) * 4;
                scratchData.data[dstPos + 0] = r;
                scratchData.data[dstPos + 1] = g;
                scratchData.data[dstPos + 2] = b;
                scratchData.data[dstPos + 3] = a;
            }
            sectionSize *= 2;
        }
    }
    $6c6b8bc9d19c96ee$var$FromPolar(scratchData, imageData, {
        polarRotation: 0
    });
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'kaleidoscopePower', 2, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'kaleidoscopeAngle', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);





function $c84c7cb96b5317be$var$pixelAt(idata, x, y) {
    let idx = (y * idata.width + x) * 4;
    const d = [];
    d.push(idata.data[idx++], idata.data[idx++], idata.data[idx++], idata.data[idx++]);
    return d;
}
function $c84c7cb96b5317be$var$rgbDistance(p1, p2) {
    return Math.sqrt(Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2) + Math.pow(p1[2] - p2[2], 2));
}
function $c84c7cb96b5317be$var$rgbMean(pTab) {
    const m = [
        0,
        0,
        0
    ];
    for(let i = 0; i < pTab.length; i++){
        m[0] += pTab[i][0];
        m[1] += pTab[i][1];
        m[2] += pTab[i][2];
    }
    m[0] /= pTab.length;
    m[1] /= pTab.length;
    m[2] /= pTab.length;
    return m;
}
function $c84c7cb96b5317be$var$backgroundMask(idata, threshold) {
    const rgbv_no = $c84c7cb96b5317be$var$pixelAt(idata, 0, 0);
    const rgbv_ne = $c84c7cb96b5317be$var$pixelAt(idata, idata.width - 1, 0);
    const rgbv_so = $c84c7cb96b5317be$var$pixelAt(idata, 0, idata.height - 1);
    const rgbv_se = $c84c7cb96b5317be$var$pixelAt(idata, idata.width - 1, idata.height - 1);
    const thres = threshold || 10;
    if ($c84c7cb96b5317be$var$rgbDistance(rgbv_no, rgbv_ne) < thres && $c84c7cb96b5317be$var$rgbDistance(rgbv_ne, rgbv_se) < thres && $c84c7cb96b5317be$var$rgbDistance(rgbv_se, rgbv_so) < thres && $c84c7cb96b5317be$var$rgbDistance(rgbv_so, rgbv_no) < thres) {
        const mean = $c84c7cb96b5317be$var$rgbMean([
            rgbv_ne,
            rgbv_no,
            rgbv_se,
            rgbv_so
        ]);
        const mask = [];
        for(let i = 0; i < idata.width * idata.height; i++){
            const d = $c84c7cb96b5317be$var$rgbDistance(mean, [
                idata.data[i * 4],
                idata.data[i * 4 + 1],
                idata.data[i * 4 + 2]
            ]);
            mask[i] = d < thres ? 0 : 255;
        }
        return mask;
    }
}
function $c84c7cb96b5317be$var$applyMask(idata, mask) {
    for(let i = 0; i < idata.width * idata.height; i++)idata.data[4 * i + 3] = mask[i];
}
function $c84c7cb96b5317be$var$erodeMask(mask, sw, sh) {
    const weights = [
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1
    ];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for(let y = 0; y < sh; y++)for(let x = 0; x < sw; x++){
        const so = y * sw + x;
        let a = 0;
        for(let cy = 0; cy < side; cy++)for(let cx = 0; cx < side; cx++){
            const scy = y + cy - halfSide;
            const scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                const srcOff = scy * sw + scx;
                const wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a === 2040 ? 255 : 0;
    }
    return maskResult;
}
function $c84c7cb96b5317be$var$dilateMask(mask, sw, sh) {
    const weights = [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for(let y = 0; y < sh; y++)for(let x = 0; x < sw; x++){
        const so = y * sw + x;
        let a = 0;
        for(let cy = 0; cy < side; cy++)for(let cx = 0; cx < side; cx++){
            const scy = y + cy - halfSide;
            const scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                const srcOff = scy * sw + scx;
                const wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a >= 1020 ? 255 : 0;
    }
    return maskResult;
}
function $c84c7cb96b5317be$var$smoothEdgeMask(mask, sw, sh) {
    const weights = [
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9
    ];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for(let y = 0; y < sh; y++)for(let x = 0; x < sw; x++){
        const so = y * sw + x;
        let a = 0;
        for(let cy = 0; cy < side; cy++)for(let cx = 0; cx < side; cx++){
            const scy = y + cy - halfSide;
            const scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                const srcOff = scy * sw + scx;
                const wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a;
    }
    return maskResult;
}
const $c84c7cb96b5317be$export$991dcf7284de63d = function(imageData) {
    const threshold = this.threshold();
    let mask = $c84c7cb96b5317be$var$backgroundMask(imageData, threshold);
    if (mask) {
        mask = $c84c7cb96b5317be$var$erodeMask(mask, imageData.width, imageData.height);
        mask = $c84c7cb96b5317be$var$dilateMask(mask, imageData.width, imageData.height);
        mask = $c84c7cb96b5317be$var$smoothEdgeMask(mask, imageData.width, imageData.height);
        $c84c7cb96b5317be$var$applyMask(imageData, mask);
    }
    return imageData;
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'threshold', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);





const $879e3ceba3e3a13f$export$484d33a0500a4ce1 = function(imageData) {
    const amount = this.noise() * 255, data = imageData.data, nPixels = data.length, half = amount / 2;
    for(let i = 0; i < nPixels; i += 4){
        data[i + 0] += half - 2 * half * Math.random();
        data[i + 1] += half - 2 * half * Math.random();
        data[i + 2] += half - 2 * half * Math.random();
    }
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'noise', 0.2, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);






const $f27cf23dfb100d82$export$63396595bf5aeaa7 = function(imageData) {
    let pixelSize = Math.ceil(this.pixelSize()), width = imageData.width, height = imageData.height, nBinsX = Math.ceil(width / pixelSize), nBinsY = Math.ceil(height / pixelSize), data = imageData.data;
    if (pixelSize <= 0) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('pixelSize value can not be <= 0');
        return;
    }
    for(let xBin = 0; xBin < nBinsX; xBin += 1)for(let yBin = 0; yBin < nBinsY; yBin += 1){
        let red = 0;
        let green = 0;
        let blue = 0;
        let alpha = 0;
        const xBinStart = xBin * pixelSize;
        const xBinEnd = xBinStart + pixelSize;
        const yBinStart = yBin * pixelSize;
        const yBinEnd = yBinStart + pixelSize;
        let pixelsInBin = 0;
        for(let x = xBinStart; x < xBinEnd; x += 1){
            if (x >= width) continue;
            for(let y = yBinStart; y < yBinEnd; y += 1){
                if (y >= height) continue;
                const i = (width * y + x) * 4;
                red += data[i + 0];
                green += data[i + 1];
                blue += data[i + 2];
                alpha += data[i + 3];
                pixelsInBin += 1;
            }
        }
        red = red / pixelsInBin;
        green = green / pixelsInBin;
        blue = blue / pixelsInBin;
        alpha = alpha / pixelsInBin;
        for(let x = xBinStart; x < xBinEnd; x += 1){
            if (x >= width) continue;
            for(let y = yBinStart; y < yBinEnd; y += 1){
                if (y >= height) continue;
                const i = (width * y + x) * 4;
                data[i + 0] = red;
                data[i + 1] = green;
                data[i + 2] = blue;
                data[i + 3] = alpha;
            }
        }
    }
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'pixelSize', 8, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);





const $25e4ed057d22ebcc$export$ccda2563bc5d1354 = function(imageData) {
    const levels = Math.round(this.levels() * 254) + 1, data = imageData.data, len = data.length, scale = 255 / levels;
    for(let i = 0; i < len; i += 1)data[i] = Math.floor(data[i] / scale) * scale;
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'levels', 0.5, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);





const $c44c727575bf2327$export$8f9ece5a47764b93 = function(imageData) {
    const data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue();
    for(let i = 0; i < nPixels; i += 4){
        const brightness = (0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2]) / 255;
        data[i] = brightness * red;
        data[i + 1] = brightness * green;
        data[i + 2] = brightness * blue;
        data[i + 3] = data[i + 3];
    }
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'red', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'green', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'blue', 0, (0, $d7c0e5ae0fe3f9a6$export$af51e4581c640b27), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);





const $c9fcfd0e8f0cfc11$export$f50470518fe8f14a = function(imageData) {
    const data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), alpha = this.alpha();
    for(let i = 0; i < nPixels; i += 4){
        const ia = 1 - alpha;
        data[i] = red * alpha + data[i] * ia;
        data[i + 1] = green * alpha + data[i + 1] * ia;
        data[i + 2] = blue * alpha + data[i + 2] * ia;
    }
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'red', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'green', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'blue', 0, (0, $d7c0e5ae0fe3f9a6$export$af51e4581c640b27), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'alpha', 1, function(val) {
    this._filterUpToDate = false;
    if (val > 1) return 1;
    else if (val < 0) return 0;
    else return val;
});


const $5272dd5841a82d90$export$1eeb4741c69006fa = function(imageData) {
    const data = imageData.data, nPixels = data.length;
    for(let i = 0; i < nPixels; i += 4){
        const r = data[i + 0];
        const g = data[i + 1];
        const b = data[i + 2];
        data[i + 0] = Math.min(255, r * 0.393 + g * 0.769 + b * 0.189);
        data[i + 1] = Math.min(255, r * 0.349 + g * 0.686 + b * 0.168);
        data[i + 2] = Math.min(255, r * 0.272 + g * 0.534 + b * 0.131);
    }
};


const $e65c0d23ae0ff66e$export$d60d51c3865bca60 = function(imageData) {
    const threshold = 128;
    const d = imageData.data;
    for(let i = 0; i < d.length; i += 4){
        const r = d[i], g = d[i + 1], b = d[i + 2];
        const L = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        if (L >= threshold) {
            d[i] = 255 - r;
            d[i + 1] = 255 - g;
            d[i + 2] = 255 - b;
        }
    }
    return imageData;
};





const $de70fa3e5ae3f655$export$14f770b2ce0bb8ad = function(imageData) {
    const level = this.threshold() * 255, data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 1)data[i] = data[i] < level ? 0 : 255;
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'threshold', 0.5, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);


const $7bf9b2e06b49f79d$export$b9f99057a3c7692 = (0, $184c4f87393bf8b7$export$b9f99057a3c7692).Util._assign((0, $184c4f87393bf8b7$export$b9f99057a3c7692), {
    Arc: $7e6edc1d7eb9aa8d$export$6ef80ffb606dd232,
    Arrow: $ed4c5015d754ac7a$export$21b07c8f274aebd5,
    Circle: $cfc8e10222484598$export$c89a927ffc67e6fa,
    Ellipse: $a1df33efdd3b5d94$export$80b0269ab108fa11,
    Image: $f0156a163f3b5062$export$3e431a229df88919,
    Label: $68b4427dcf69bf6a$export$b04be29aa201d4f5,
    Tag: $68b4427dcf69bf6a$export$3288d34c523a1192,
    Line: $5329876ec3db1142$export$17d680238e50603e,
    Path: $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9,
    Rect: $f22346c22f20789a$export$c79fc6492f3af13d,
    RegularPolygon: $a02eac566278789b$export$e2ee866164812ecd,
    Ring: $e1deb4ed1ad79a18$export$a6e3577650b6d6d7,
    Sprite: $5a6b0dd32a4eac33$export$3075603db8e6204c,
    Star: $4d356f0361a4a7f0$export$1644ba17714857f1,
    Text: $8540f0f5ac9d4ade$export$5f1af8db9871e1d6,
    TextPath: $df8ddbf07e58c785$export$f7e34a95cc06fac7,
    Transformer: $801345eab32c3d30$export$f993aef960936087,
    Wedge: $38218507e674999c$export$28718c7785907330,
    Filters: {
        Blur: $115c1355c0a3c8a8$export$975a268f2c733e4,
        Brightness: $d2cbac3f9294abf4$export$98835ff3df8927e5,
        Brighten: $ced669b61682093f$export$a2d0d82739cac11f,
        Contrast: $915438a9a02e65de$export$656ae42051d0ca86,
        Emboss: $2b42f6c4d038b489$export$3c8699b389eb838,
        Enhance: $2ad1b73e774f59bb$export$5cb8e8388f951d6f,
        Grayscale: $d01fff91fba4df8f$export$e2b0a794e83ca071,
        HSL: $4b70970df87d7d14$export$46d8b0f9bc8f87a2,
        HSV: $a9eed7ce687c1218$export$d2edaecd208aed43,
        Invert: $15eda2f50977af8f$export$1073348d81b17440,
        Kaleidoscope: $6c6b8bc9d19c96ee$export$e731e8a0fd067155,
        Mask: $c84c7cb96b5317be$export$991dcf7284de63d,
        Noise: $879e3ceba3e3a13f$export$484d33a0500a4ce1,
        Pixelate: $f27cf23dfb100d82$export$63396595bf5aeaa7,
        Posterize: $25e4ed057d22ebcc$export$ccda2563bc5d1354,
        RGB: $c44c727575bf2327$export$8f9ece5a47764b93,
        RGBA: $c9fcfd0e8f0cfc11$export$f50470518fe8f14a,
        Sepia: $5272dd5841a82d90$export$1eeb4741c69006fa,
        Solarize: $e65c0d23ae0ff66e$export$d60d51c3865bca60,
        Threshold: $de70fa3e5ae3f655$export$14f770b2ce0bb8ad
    }
});


var $544e715f9e3fd6b8$export$2e2bcd8739ae039 = (0, $7bf9b2e06b49f79d$export$b9f99057a3c7692);


// All coordinates are stored as ratios (0-1) relative to canvas dimensions
// This ensures diagrams display correctly across different screen sizes
class $7027e40d5f370fb1$export$3097e7fcde2a46f0 {
    socket = null;
    diagramId;
    clientId = null;
    messageHandlers = new Map();
    reconnectAttempts = 0;
    maxReconnectAttempts = 5;
    reconnectDelay = 1000;
    isConnected = false;
    pendingMessages = [];
    constructor(diagramId){
        this.diagramId = diagramId;
    }
    connect() {
        return new Promise((resolve)=>{
            const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
            const wsUrl = `${protocol}//${window.location.host}/ws/d/${this.diagramId}`;
            console.log('Connecting to:', wsUrl);
            this.socket = new WebSocket(wsUrl);
            this.socket.onopen = ()=>{
                console.log('WebSocket connected');
                this.isConnected = true;
                this.reconnectAttempts = 0;
                // Send any pending messages
                this.pendingMessages.forEach((msg)=>this.socket?.send(msg));
                this.pendingMessages = [];
            };
            this.socket.onmessage = (event)=>{
                try {
                    const message = JSON.parse(event.data);
                    // Handle initial sync
                    if (message.type === 'sync') {
                        this.clientId = message.clientId;
                        resolve(message.state);
                        return;
                    }
                    // Dispatch to handlers
                    const handlers = this.messageHandlers.get(message.type) || [];
                    handlers.forEach((handler)=>handler(message));
                } catch (error) {
                    console.error('Failed to parse message:', error);
                }
            };
            this.socket.onclose = ()=>{
                console.log('WebSocket closed');
                this.isConnected = false;
                this.attemptReconnect();
            };
            this.socket.onerror = (error)=>{
                console.error('WebSocket error:', error);
                resolve(null);
            };
            // Timeout for initial connection
            setTimeout(()=>{
                if (!this.isConnected) resolve(null);
            }, 5000);
        });
    }
    attemptReconnect() {
        if (this.reconnectAttempts >= this.maxReconnectAttempts) {
            console.log('Max reconnect attempts reached');
            return;
        }
        this.reconnectAttempts++;
        const delay = this.reconnectDelay * Math.pow(2, this.reconnectAttempts - 1);
        console.log(`Reconnecting in ${delay}ms (attempt ${this.reconnectAttempts})`);
        setTimeout(()=>{
            this.connect();
        }, delay);
    }
    on(messageType, handler) {
        const handlers = this.messageHandlers.get(messageType) || [];
        handlers.push(handler);
        this.messageHandlers.set(messageType, handlers);
    }
    off(messageType, handler) {
        const handlers = this.messageHandlers.get(messageType) || [];
        const index = handlers.indexOf(handler);
        if (index !== -1) {
            handlers.splice(index, 1);
            this.messageHandlers.set(messageType, handlers);
        }
    }
    send(message) {
        const data = JSON.stringify({
            ...message,
            from: this.clientId
        });
        if (this.isConnected && this.socket?.readyState === WebSocket.OPEN) this.socket.send(data);
        else // Queue message for when connection is established
        this.pendingMessages.push(data);
    }
    // Diagram-specific methods
    sendSlideUpdate(slideIndex, canvasState) {
        this.send({
            type: 'slide-update',
            slideIndex: slideIndex,
            canvasState: canvasState
        });
    }
    sendSlideAdd(slide, insertAfterIndex) {
        this.send({
            type: 'slide-add',
            slide: slide,
            insertAfterIndex: insertAfterIndex
        });
    }
    sendSlideDelete(slideIndex) {
        this.send({
            type: 'slide-delete',
            slideIndex: slideIndex
        });
    }
    sendSlideNavigate(slideIndex) {
        this.send({
            type: 'slide-navigate',
            slideIndex: slideIndex
        });
    }
    sendDescriptionUpdate(description) {
        this.send({
            type: 'description-update',
            description: description
        });
    }
    sendFullSync(state) {
        this.send({
            type: 'full-sync',
            state: state
        });
    }
    sendAudioSegmentAdd(segment) {
        this.send({
            type: 'audio-segment-add',
            segment: segment
        });
    }
    sendAudioSegmentDelete(segmentId) {
        this.send({
            type: 'audio-segment-delete',
            segmentId: segmentId
        });
    }
    disconnect() {
        if (this.socket) {
            this.socket.close();
            this.socket = null;
        }
        this.isConnected = false;
        this.messageHandlers.clear();
    }
    get connected() {
        return this.isConnected;
    }
    get id() {
        return this.clientId;
    }
}


class $89e91b042708b34e$export$de95611a92ae0566 {
    mediaRecorder = null;
    audioChunks = [];
    stream = null;
    state = 'idle';
    startTime = 0;
    timerInterval = null;
    diagramId;
    // Callbacks
    onStateChange;
    onTimeUpdate;
    onSegmentReady;
    onError;
    constructor(options){
        this.diagramId = options.diagramId;
        this.onStateChange = options.onStateChange;
        this.onTimeUpdate = options.onTimeUpdate;
        this.onSegmentReady = options.onSegmentReady;
        this.onError = options.onError;
    }
    async startRecording() {
        if (this.state !== 'idle') return false;
        try {
            // Request microphone access
            this.stream = await navigator.mediaDevices.getUserMedia({
                audio: {
                    echoCancellation: true,
                    noiseSuppression: true,
                    sampleRate: 44100
                }
            });
            // Create MediaRecorder with webm format (best browser support)
            const mimeType = MediaRecorder.isTypeSupported('audio/webm;codecs=opus') ? 'audio/webm;codecs=opus' : 'audio/webm';
            this.mediaRecorder = new MediaRecorder(this.stream, {
                mimeType: mimeType,
                audioBitsPerSecond: 128000
            });
            this.audioChunks = [];
            this.mediaRecorder.ondataavailable = (event)=>{
                if (event.data.size > 0) this.audioChunks.push(event.data);
            };
            this.mediaRecorder.onstop = ()=>{
                this.handleRecordingComplete();
            };
            this.mediaRecorder.onerror = (event)=>{
                console.error('MediaRecorder error:', event);
                this.onError?.('Recording failed');
                this.cleanup();
            };
            // Start recording
            this.mediaRecorder.start(1000); // Capture in 1-second chunks
            this.state = 'recording';
            this.startTime = Date.now();
            this.onStateChange?.('recording');
            // Start timer
            this.timerInterval = window.setInterval(()=>{
                const elapsed = Math.floor((Date.now() - this.startTime) / 1000);
                this.onTimeUpdate?.(elapsed);
            }, 100);
            return true;
        } catch (error) {
            console.error('Failed to start recording:', error);
            if (error instanceof DOMException && error.name === 'NotAllowedError') this.onError?.('Microphone access denied');
            else this.onError?.('Failed to access microphone');
            return false;
        }
    }
    stopRecording() {
        if (this.state !== 'recording' || !this.mediaRecorder) return;
        // Stop the timer
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
        // Stop recording (triggers onstop handler)
        this.mediaRecorder.stop();
    }
    async handleRecordingComplete() {
        const duration = Math.floor((Date.now() - this.startTime) / 1000);
        this.state = 'uploading';
        this.onStateChange?.('uploading');
        // Stop all tracks
        if (this.stream) {
            this.stream.getTracks().forEach((track)=>track.stop());
            this.stream = null;
        }
        // Create blob from chunks
        const audioBlob = new Blob(this.audioChunks, {
            type: 'audio/webm'
        });
        if (audioBlob.size === 0) {
            this.onError?.('No audio recorded');
            this.cleanup();
            return;
        }
        // Generate segment ID
        const segmentId = `seg_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        // Upload to server
        try {
            const response = await fetch(`/api/audio/${this.diagramId}/${segmentId}`, {
                method: 'POST',
                body: audioBlob,
                headers: {
                    'Content-Type': 'audio/webm'
                }
            });
            if (!response.ok) throw new Error(`Upload failed: ${response.status}`);
            const result = await response.json();
            const segment = {
                id: segmentId,
                url: result.url,
                duration: duration,
                createdAt: Date.now()
            };
            this.onSegmentReady?.(segment);
        } catch (error) {
            console.error('Upload error:', error);
            this.onError?.('Failed to save recording');
        }
        this.cleanup();
    }
    cleanup() {
        this.state = 'idle';
        this.onStateChange?.('idle');
        this.mediaRecorder = null;
        this.audioChunks = [];
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
    }
    cancelRecording() {
        if (this.state !== 'recording') return;
        // Stop timer
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
        // Stop media recorder without triggering upload
        if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
            this.mediaRecorder.onstop = null; // Prevent upload
            this.mediaRecorder.stop();
        }
        // Stop all tracks
        if (this.stream) {
            this.stream.getTracks().forEach((track)=>track.stop());
            this.stream = null;
        }
        this.cleanup();
    }
    getState() {
        return this.state;
    }
    isRecording() {
        return this.state === 'recording';
    }
    // Static method to delete audio segment from server
    static async deleteSegment(diagramId, segmentId) {
        try {
            const response = await fetch(`/api/audio/${diagramId}/${segmentId}`, {
                method: 'DELETE'
            });
            return response.ok;
        } catch (error) {
            console.error('Failed to delete audio segment:', error);
            return false;
        }
    }
}
class $89e91b042708b34e$export$95a4ce47d946bbbb {
    audio = null;
    segments = [];
    currentIndex = 0;
    isPlaying = false;
    onPlayStateChange;
    onTimeUpdate;
    onSegmentChange;
    onEnded;
    constructor(options){
        this.onPlayStateChange = options?.onPlayStateChange;
        this.onTimeUpdate = options?.onTimeUpdate;
        this.onSegmentChange = options?.onSegmentChange;
        this.onEnded = options?.onEnded;
    }
    setSegments(segments) {
        this.segments = segments;
        this.currentIndex = 0;
        if (this.audio) this.audio.pause();
        this.isPlaying = false;
    }
    loadSegment(index) {
        if (index < 0 || index >= this.segments.length) return;
        const segment = this.segments[index];
        this.currentIndex = index;
        if (this.audio) {
            this.audio.pause();
            this.audio.src = '';
        }
        this.audio = new Audio(segment.url);
        this.audio.addEventListener('ended', ()=>{
            // Move to next segment
            if (this.currentIndex < this.segments.length - 1) {
                this.loadSegment(this.currentIndex + 1);
                this.audio?.play();
                this.onSegmentChange?.(this.currentIndex);
            } else {
                // All segments complete
                this.isPlaying = false;
                this.currentIndex = 0;
                this.onPlayStateChange?.(false);
                this.onEnded?.();
            }
        });
        this.audio.addEventListener('timeupdate', ()=>{
            if (this.audio) {
                const elapsed = this.getElapsedTime() + this.audio.currentTime;
                this.onTimeUpdate?.(elapsed, this.getTotalDuration(), this.currentIndex);
            }
        });
    }
    play() {
        if (this.segments.length === 0) return;
        if (!this.audio) this.loadSegment(0);
        this.audio?.play();
        this.isPlaying = true;
        this.onPlayStateChange?.(true);
    }
    pause() {
        this.audio?.pause();
        this.isPlaying = false;
        this.onPlayStateChange?.(false);
    }
    toggle() {
        if (this.isPlaying) this.pause();
        else this.play();
    }
    stop() {
        if (this.audio) {
            this.audio.pause();
            this.audio.currentTime = 0;
        }
        this.isPlaying = false;
        this.currentIndex = 0;
        this.onPlayStateChange?.(false);
    }
    seekToSegment(index) {
        if (index < 0 || index >= this.segments.length) return;
        const wasPlaying = this.isPlaying;
        this.loadSegment(index);
        this.onSegmentChange?.(index);
        if (wasPlaying) this.audio?.play();
    }
    getIsPlaying() {
        return this.isPlaying;
    }
    getTotalDuration() {
        return this.segments.reduce((sum, s)=>sum + s.duration, 0);
    }
    getElapsedTime() {
        let elapsed = 0;
        for(let i = 0; i < this.currentIndex; i++)elapsed += this.segments[i].duration;
        return elapsed;
    }
    getCurrentSegmentIndex() {
        return this.currentIndex;
    }
    destroy() {
        if (this.audio) {
            this.audio.pause();
            this.audio.src = '';
            this.audio = null;
        }
        this.segments = [];
        this.isPlaying = false;
    }
}


// Base canvas dimensions (will be scaled)
const $c6f8878b4b43a5af$var$BASE_WIDTH = 400;
const $c6f8878b4b43a5af$var$BASE_HEIGHT = 500;
// Official ITF tennis court dimensions (feet)
const $c6f8878b4b43a5af$var$COURT = {
    length: 78,
    singlesWidth: 27,
    doublesWidth: 36,
    serviceLineFromNet: 21,
    halfCourt: 39,
    netHeightCenter: 3,
    netHeightPost: 3.5,
    serviceBoxWidth: 13.5,
    doublesAlley: 4.5
};
const $c6f8878b4b43a5af$var$PERSPECTIVE_CONFIG = {
    viewerDistance: 40,
    courtMarginTop: 0.36,
    courtMarginBottom: 0.36,
    nearWidthRatio: 0.80
};
// Helper functions to convert between pixels and ratios
function $c6f8878b4b43a5af$var$pixelToRatio(px, base) {
    return px / base;
}
function $c6f8878b4b43a5af$var$ratioToPixel(ratio, current) {
    return ratio * current;
}
class $c6f8878b4b43a5af$export$12ec5b3a122d4623 {
    element;
    router;
    diagramId;
    // Canvas state
    CANVAS_WIDTH = $c6f8878b4b43a5af$var$BASE_WIDTH;
    CANVAS_HEIGHT = $c6f8878b4b43a5af$var$BASE_HEIGHT;
    PERSPECTIVE;
    // Konva objects
    stage;
    backgroundLayer;
    courtLayer;
    arrowLayer;
    playerLayer;
    uiLayer;
    // App state
    currentMode = 'select';
    currentArrowStyle = 'curved';
    selectedShape = null;
    isDrawing = false;
    drawStartPos = null;
    tempArrow = null;
    hitCounter = 0;
    // Slide state
    slides = [];
    currentSlideIndex = 0;
    STORAGE_KEY = 'tennis-diagram-state';
    // Undo/Redo
    undoStack = [];
    redoStack = [];
    MAX_UNDO = 50;
    // DOM references
    canvasWrapper;
    undoBtn;
    redoBtn;
    titleInput;
    descriptionInput;
    helpModal;
    deleteSlideBtn;
    prevSlideBtn;
    nextSlideBtn;
    slideIndicator;
    addSlideBtn;
    // Audio segments (diagram-level)
    audioSegments = [];
    audioRecorder = null;
    segmentPlayer = null;
    mediaBar;
    recordBtn;
    playAllBtn;
    segmentTimeline;
    audioTimer;
    isRecording = false;
    isPlaying = false;
    // Event handlers (for cleanup)
    boundHandleResize;
    boundHandleKeydown;
    resizeTimeout;
    // Sync client for real-time collaboration
    syncClient = null;
    syncDebounceTimer;
    constructor(container, router, diagramId){
        this.router = router;
        this.diagramId = diagramId;
        this.PERSPECTIVE = this.getPerspective();
        this.element = document.createElement('div');
        this.element.className = 'diagram-editor';
        this.render();
        container.appendChild(this.element);
        this.boundHandleResize = this.handleResize.bind(this);
        this.boundHandleKeydown = this.handleKeydown.bind(this);
        this.init();
    }
    render() {
        this.element.innerHTML = `
      <div class="canvas-area">
        <div class="description-overlay">
          <div id="description-input" contenteditable="true" data-placeholder="Tap to add description..." spellcheck="false"></div>
        </div>
        <div id="canvas-wrapper"></div>
      </div>

      <input type="text" id="title-input" value="Untitled Diagram" spellcheck="false" hidden />

      <div class="toolbar">
        <div class="tool-section">
          <button id="help-btn" class="tool-btn" title="Help">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </button>
        </div>

        <div class="tool-section">
          <button id="undo-btn" class="tool-btn" title="Undo (Ctrl+Z)">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 10h10a5 5 0 0 1 5 5v2"/>
              <polyline points="3 10 8 5"/>
              <polyline points="3 10 8 15"/>
            </svg>
          </button>
          <button id="redo-btn" class="tool-btn" title="Redo (Ctrl+Shift+Z)">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 10H11a5 5 0 0 0-5 5v2"/>
              <polyline points="21 10 16 5"/>
              <polyline points="21 10 16 15"/>
            </svg>
          </button>
        </div>

        <div class="tool-section pagination">
          <button id="prev-slide" class="tool-btn" title="Previous Slide">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
          </button>
          <span id="slide-indicator" class="slide-indicator">1/1</span>
          <button id="next-slide" class="tool-btn" title="Next Slide">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </button>
          <button id="add-slide" class="tool-btn" title="Add Slide">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
          </button>
          <button id="delete-slide" class="tool-btn" title="Delete Slide">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="3 6 5 6 21 6"/>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
            </svg>
          </button>
        </div>

      </div>

      <!-- Record Button - Centered above media bar -->
      <button id="record-btn" class="record-btn-floating" title="Record Audio">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
          <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
          <line x1="12" y1="19" x2="12" y2="23"/>
          <line x1="8" y1="23" x2="16" y2="23"/>
        </svg>
      </button>

      <!-- Media Bar for audio segments -->
      <div class="media-bar" id="media-bar">
        <button id="play-all-btn" class="tool-btn" title="Play All">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="5 3 19 12 5 21 5 3"/>
          </svg>
        </button>
        <div class="segment-timeline" id="segment-timeline">
          <span class="empty-message">No recordings yet</span>
        </div>
        <span id="audio-timer" class="audio-timer"></span>
      </div>

      <div class="help-modal" id="help-modal">
        <div class="help-content">
          <h2>How to Use</h2>
          <ul>
            <li><strong>Draw shots</strong>Drag on court to draw shot trajectories</li>
            <li><strong>Adjust</strong>Tap arrow to select, drag handles to adjust</li>
            <li><strong>Colors</strong>Top\u{2192}down = red (opponent), bottom\u{2192}up = green (you)</li>
            <li><strong>Delete</strong>Select and tap trash icon or press Delete</li>
            <li><strong>Players</strong>Drag player markers to position</li>
          </ul>
          <button class="help-close" id="help-close">Got it</button>
        </div>
      </div>
    `;
    }
    init() {
        // Get DOM references
        this.canvasWrapper = this.element.querySelector('#canvas-wrapper');
        this.undoBtn = this.element.querySelector('#undo-btn');
        this.redoBtn = this.element.querySelector('#redo-btn');
        this.titleInput = this.element.querySelector('#title-input');
        this.descriptionInput = this.element.querySelector('#description-input');
        this.helpModal = this.element.querySelector('#help-modal');
        this.prevSlideBtn = this.element.querySelector('#prev-slide');
        this.nextSlideBtn = this.element.querySelector('#next-slide');
        this.slideIndicator = this.element.querySelector('#slide-indicator');
        this.addSlideBtn = this.element.querySelector('#add-slide');
        this.deleteSlideBtn = this.element.querySelector('#delete-slide');
        this.mediaBar = this.element.querySelector('#media-bar');
        this.recordBtn = this.element.querySelector('#record-btn');
        this.playAllBtn = this.element.querySelector('#play-all-btn');
        this.segmentTimeline = this.element.querySelector('#segment-timeline');
        this.audioTimer = this.element.querySelector('#audio-timer');
        // Get responsive size
        const size = this.getCanvasSize();
        this.CANVAS_WIDTH = size.width;
        this.CANVAS_HEIGHT = size.height;
        this.PERSPECTIVE = this.getPerspective();
        // Create Konva stage
        this.stage = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Stage({
            container: this.canvasWrapper,
            width: this.CANVAS_WIDTH,
            height: this.CANVAS_HEIGHT
        });
        // Create layers
        this.backgroundLayer = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Layer();
        this.courtLayer = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Layer();
        this.arrowLayer = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Layer();
        this.playerLayer = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Layer();
        this.uiLayer = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Layer();
        this.stage.add(this.backgroundLayer);
        this.stage.add(this.courtLayer);
        this.stage.add(this.arrowLayer);
        this.stage.add(this.playerLayer);
        this.stage.add(this.uiLayer);
        // Draw initial state
        this.drawBackground();
        this.drawCourt();
        this.createDefaultPlayers();
        // Bind events
        this.bindEvents();
        // Initialize slides (loads from localStorage or creates first slide)
        this.initializeSlides();
        // Save initial state
        this.saveState();
        this.updateUndoRedoButtons();
    }
    getCanvasSize() {
        const container = this.element.querySelector('.canvas-area');
        if (!container) return {
            width: $c6f8878b4b43a5af$var$BASE_WIDTH,
            height: $c6f8878b4b43a5af$var$BASE_HEIGHT
        };
        const width = container.clientWidth;
        const height = container.clientHeight;
        return {
            width: Math.floor(width),
            height: Math.floor(height)
        };
    }
    calculatePerspectiveScale(depthFraction) {
        const d = $c6f8878b4b43a5af$var$PERSPECTIVE_CONFIG.viewerDistance;
        const courtDepth = $c6f8878b4b43a5af$var$COURT.length;
        return d / (d + depthFraction * courtDepth);
    }
    calculateScreenPosition(depthFraction) {
        const steps = 100;
        let integral = 0;
        let totalIntegral = 0;
        for(let i = 0; i < steps; i++){
            const t = i / steps;
            const scale = this.calculatePerspectiveScale(t);
            const contribution = scale;
            totalIntegral += contribution;
            if (t < depthFraction) integral += contribution;
        }
        return integral / totalIntegral;
    }
    getPerspective() {
        const cfg = $c6f8878b4b43a5af$var$PERSPECTIVE_CONFIG;
        const farScale = this.calculatePerspectiveScale(1.0);
        const nearScale = this.calculatePerspectiveScale(0.0);
        const scaleRatio = farScale / nearScale;
        const nearY = this.CANVAS_HEIGHT * (1 - cfg.courtMarginBottom);
        const farY = this.CANVAS_HEIGHT * cfg.courtMarginTop;
        const courtScreenHeight = nearY - farY;
        const nearHalfWidth = cfg.nearWidthRatio * this.CANVAS_WIDTH / 2;
        const farHalfWidth = nearHalfWidth * scaleRatio;
        const centerX = this.CANVAS_WIDTH / 2;
        const netDepthFraction = 0.5;
        const netScreenFraction = this.calculateScreenPosition(netDepthFraction);
        const netY = nearY - courtScreenHeight * netScreenFraction;
        return {
            nearLeft: centerX - nearHalfWidth,
            nearRight: centerX + nearHalfWidth,
            nearY: nearY,
            farLeft: centerX - farHalfWidth,
            farRight: centerX + farHalfWidth,
            farY: farY,
            netY: netY,
            scaleRatio: scaleRatio
        };
    }
    getPerspectiveX(x, y) {
        const P = this.PERSPECTIVE;
        const t = (y - P.nearY) / (P.farY - P.nearY);
        const leftX = P.nearLeft + t * (P.farLeft - P.nearLeft);
        const rightX = P.nearRight + t * (P.farRight - P.nearRight);
        return leftX + x * (rightX - leftX);
    }
    getCourtWidth(y) {
        const P = this.PERSPECTIVE;
        const t = (y - P.nearY) / (P.farY - P.nearY);
        const leftX = P.nearLeft + t * (P.farLeft - P.nearLeft);
        const rightX = P.nearRight + t * (P.farRight - P.nearRight);
        return rightX - leftX;
    }
    getCourtLeft(y) {
        const P = this.PERSPECTIVE;
        const t = (y - P.nearY) / (P.farY - P.nearY);
        return P.nearLeft + t * (P.farLeft - P.nearLeft);
    }
    getScaleFactor(y) {
        const P = this.PERSPECTIVE;
        const t = (y - P.nearY) / (P.farY - P.nearY);
        return 1 - t * 0.5;
    }
    drawBackground() {
        const bg = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Rect({
            x: 0,
            y: 0,
            width: this.CANVAS_WIDTH,
            height: this.CANVAS_HEIGHT,
            fill: '#1a3a4a'
        });
        this.backgroundLayer.add(bg);
    // No title bar - using HTML overlay for description
    }
    drawCourt() {
        const P = this.PERSPECTIVE;
        const singlesInset = 0.09;
        // Dark navy surround
        const surroundPadding = 0.15;
        const surroundNearLeft = P.nearLeft - (P.nearRight - P.nearLeft) * surroundPadding;
        const surroundNearRight = P.nearRight + (P.nearRight - P.nearLeft) * surroundPadding;
        const surroundFarLeft = P.farLeft - (P.farRight - P.farLeft) * surroundPadding;
        const surroundFarRight = P.farRight + (P.farRight - P.farLeft) * surroundPadding;
        const surroundNearY = P.nearY + 30;
        const surroundFarY = P.farY - 15;
        const surround = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Line({
            points: [
                surroundNearLeft,
                surroundNearY,
                surroundNearRight,
                surroundNearY,
                surroundFarRight,
                surroundFarY,
                surroundFarLeft,
                surroundFarY
            ],
            fill: '#1a2a4a',
            closed: true
        });
        this.courtLayer.add(surround);
        // Court surface
        const surface = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Line({
            points: [
                P.nearLeft,
                P.nearY,
                P.nearRight,
                P.nearY,
                P.farRight,
                P.farY,
                P.farLeft,
                P.farY
            ],
            fill: '#5B9BD5',
            closed: true
        });
        this.courtLayer.add(surface);
        // Outer boundary
        const boundary = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Line({
            points: [
                P.nearLeft,
                P.nearY,
                P.nearRight,
                P.nearY,
                P.farRight,
                P.farY,
                P.farLeft,
                P.farY
            ],
            stroke: 'white',
            strokeWidth: 3,
            closed: true
        });
        this.courtLayer.add(boundary);
        // Singles sidelines
        const leftSingles = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Line({
            points: [
                this.getPerspectiveX(singlesInset, P.nearY),
                P.nearY,
                this.getPerspectiveX(singlesInset, P.farY),
                P.farY
            ],
            stroke: 'white',
            strokeWidth: 2
        });
        this.courtLayer.add(leftSingles);
        const rightSingles = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Line({
            points: [
                this.getPerspectiveX(1 - singlesInset, P.nearY),
                P.nearY,
                this.getPerspectiveX(1 - singlesInset, P.farY),
                P.farY
            ],
            stroke: 'white',
            strokeWidth: 2
        });
        this.courtLayer.add(rightSingles);
        // Net
        const netLeft = this.getCourtLeft(P.netY);
        const netWidth = this.getCourtWidth(P.netY);
        const netRight = netLeft + netWidth;
        const netCenter = netLeft + netWidth / 2;
        const postHeight = 18;
        const centerHeight = 10;
        const postWidth = 4;
        const netMesh = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Shape({
            sceneFunc: (ctx, shape)=>{
                ctx.beginPath();
                ctx.moveTo(netLeft, P.netY);
                ctx.lineTo(netRight, P.netY);
                ctx.lineTo(netRight, P.netY - postHeight);
                ctx.quadraticCurveTo(netCenter, P.netY - centerHeight, netLeft, P.netY - postHeight);
                ctx.closePath();
                ctx.fillStrokeShape(shape);
            },
            fill: 'rgba(255, 255, 255, 0.35)',
            stroke: 'rgba(255, 255, 255, 0.6)',
            strokeWidth: 1
        });
        this.courtLayer.add(netMesh);
        const netTopBand = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Shape({
            sceneFunc: (ctx, shape)=>{
                ctx.beginPath();
                ctx.moveTo(netLeft, P.netY - postHeight);
                ctx.quadraticCurveTo(netCenter, P.netY - centerHeight, netRight, P.netY - postHeight);
                ctx.strokeShape(shape);
            },
            stroke: 'white',
            strokeWidth: 2
        });
        this.courtLayer.add(netTopBand);
        // Posts
        const leftPost = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Rect({
            x: netLeft - postWidth / 2,
            y: P.netY - postHeight,
            width: postWidth,
            height: postHeight,
            fill: 'white'
        });
        this.courtLayer.add(leftPost);
        const rightPost = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Rect({
            x: netRight - postWidth / 2,
            y: P.netY - postHeight,
            width: postWidth,
            height: postHeight,
            fill: 'white'
        });
        this.courtLayer.add(rightPost);
        // Service lines
        const nearServiceDepth = ($c6f8878b4b43a5af$var$COURT.halfCourt - $c6f8878b4b43a5af$var$COURT.serviceLineFromNet) / $c6f8878b4b43a5af$var$COURT.length;
        const farServiceDepth = ($c6f8878b4b43a5af$var$COURT.halfCourt + $c6f8878b4b43a5af$var$COURT.serviceLineFromNet) / $c6f8878b4b43a5af$var$COURT.length;
        const nearServiceScreenPos = this.calculateScreenPosition(nearServiceDepth);
        const farServiceScreenPos = this.calculateScreenPosition(farServiceDepth);
        const courtScreenHeight = P.nearY - P.farY;
        const serviceLineNearY = P.nearY - courtScreenHeight * nearServiceScreenPos;
        const serviceLineFarY = P.nearY - courtScreenHeight * farServiceScreenPos;
        // Near service line
        const nearServiceLeft = this.getPerspectiveX(singlesInset, serviceLineNearY);
        const nearServiceRight = this.getPerspectiveX(1 - singlesInset, serviceLineNearY);
        const nearServiceLine = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Line({
            points: [
                nearServiceLeft,
                serviceLineNearY,
                nearServiceRight,
                serviceLineNearY
            ],
            stroke: 'white',
            strokeWidth: 2
        });
        this.courtLayer.add(nearServiceLine);
        // Far service line
        const farServiceLeft = this.getPerspectiveX(singlesInset, serviceLineFarY);
        const farServiceRight = this.getPerspectiveX(1 - singlesInset, serviceLineFarY);
        const farServiceLine = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Line({
            points: [
                farServiceLeft,
                serviceLineFarY,
                farServiceRight,
                serviceLineFarY
            ],
            stroke: 'white',
            strokeWidth: 2
        });
        this.courtLayer.add(farServiceLine);
        // Center service lines
        const centerServiceNear = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Line({
            points: [
                this.getPerspectiveX(0.5, serviceLineNearY),
                serviceLineNearY,
                this.getPerspectiveX(0.5, P.netY),
                P.netY
            ],
            stroke: 'white',
            strokeWidth: 2
        });
        this.courtLayer.add(centerServiceNear);
        const centerServiceFar = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Line({
            points: [
                this.getPerspectiveX(0.5, P.netY),
                P.netY,
                this.getPerspectiveX(0.5, serviceLineFarY),
                serviceLineFarY
            ],
            stroke: 'white',
            strokeWidth: 2
        });
        this.courtLayer.add(centerServiceFar);
        // Center marks
        const nearCenterMark = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Line({
            points: [
                this.getPerspectiveX(0.5, P.nearY),
                P.nearY,
                this.getPerspectiveX(0.5, P.nearY - 15),
                P.nearY - 15
            ],
            stroke: 'white',
            strokeWidth: 3
        });
        this.courtLayer.add(nearCenterMark);
        const farCenterMark = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Line({
            points: [
                this.getPerspectiveX(0.5, P.farY),
                P.farY,
                this.getPerspectiveX(0.5, P.farY + 8),
                P.farY + 8
            ],
            stroke: 'white',
            strokeWidth: 2
        });
        this.courtLayer.add(farCenterMark);
    }
    createTitleText() {
        const title = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Text({
            id: 'title-text',
            x: this.CANVAS_WIDTH / 2,
            y: 25,
            text: this.titleInput.value,
            fontSize: 16,
            fontStyle: '500',
            fill: 'white',
            fontFamily: '-apple-system, Helvetica Neue, Arial, sans-serif'
        });
        title.x(this.CANVAS_WIDTH / 2 - title.width() / 2);
        title.on('click tap', ()=>{
            this.editText(title, this.uiLayer, true);
        });
        this.uiLayer.add(title);
    }
    createDefaultPlayers() {
        const P = this.PERSPECTIVE;
        const nearY = P.nearY - this.CANVAS_HEIGHT * 0.04;
        const farY = P.farY + this.CANVAS_HEIGHT * 0.03;
        this.createPlayer(this.getPerspectiveX(0.70, nearY), nearY, '#22C55E', 'You');
        this.createPlayer(this.getPerspectiveX(0.30, farY), farY, '#EF4444', '');
    }
    createPlayer(x, y, color, label) {
        const scale = this.getScaleFactor(y);
        const baseRadiusX = 22;
        const baseRadiusY = 8;
        const group = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Group({
            x: x,
            y: y,
            draggable: true,
            name: 'player'
        });
        const ellipse = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Ellipse({
            radiusX: baseRadiusX * scale,
            radiusY: baseRadiusY * scale,
            fill: color,
            stroke: '#fff',
            strokeWidth: 2 * scale
        });
        group.add(ellipse);
        const fontSize = Math.max(12, 14 * scale);
        // Always place label below the player ellipse
        const labelOffsetY = (baseRadiusY + 8) * scale;
        const text = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Text({
            text: label,
            fontSize: fontSize,
            fill: 'white',
            fontFamily: 'Arial',
            y: labelOffsetY,
            align: 'center',
            name: 'player-label'
        });
        text.x(-text.width() / 2);
        const hitBg = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Rect({
            x: text.x() - 10,
            y: text.y() - 4,
            width: text.width() + 20,
            height: text.height() + 8,
            fill: 'transparent',
            name: 'label-hitarea'
        });
        const editLabel = (e)=>{
            e.cancelBubble = true;
            const absPos = text.getAbsolutePosition();
            this.editPlayerLabel(text, group, absPos);
        };
        text.on('click tap', editLabel);
        hitBg.on('click tap', editLabel);
        group.add(hitBg);
        group.add(text);
        group.on('dragmove', ()=>{
            const newScale = this.getScaleFactor(group.y());
            const e = group.findOne('Ellipse');
            const t = group.findOne('Text');
            const h = group.findOne('.label-hitarea');
            if (e) {
                e.radiusX(baseRadiusX * newScale);
                e.radiusY(baseRadiusY * newScale);
                e.strokeWidth(2 * newScale);
            }
            if (t) {
                const newFontSize = Math.max(12, 14 * newScale);
                t.fontSize(newFontSize);
                // Always place label below
                const labelOffsetY = (baseRadiusY + 8) * newScale;
                t.y(labelOffsetY);
                t.x(-t.width() / 2);
                if (h) {
                    h.x(t.x() - 10);
                    h.y(t.y() - 4);
                    h.width(t.width() + 20);
                    h.height(t.height() + 8);
                }
            }
        });
        // Trash icon (always above the player)
        const trashGroup = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Group({
            x: 0,
            y: -(baseRadiusY + 35),
            visible: false,
            name: 'trash-icon'
        });
        const trashBg = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Circle({
            radius: 12,
            fill: '#EF4444',
            stroke: 'white',
            strokeWidth: 2
        });
        trashGroup.add(trashBg);
        const trashIcon = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Shape({
            sceneFunc: (ctx, shape)=>{
                ctx.beginPath();
                ctx.moveTo(-5, -5);
                ctx.lineTo(5, -5);
                ctx.moveTo(-4, -3);
                ctx.lineTo(-3, 5);
                ctx.lineTo(3, 5);
                ctx.lineTo(4, -3);
                ctx.moveTo(-2, -5);
                ctx.lineTo(-2, -7);
                ctx.lineTo(2, -7);
                ctx.lineTo(2, -5);
                ctx.strokeShape(shape);
            },
            stroke: 'white',
            strokeWidth: 1.5,
            lineCap: 'round',
            lineJoin: 'round'
        });
        trashGroup.add(trashIcon);
        trashGroup.on('click tap', (e)=>{
            e.cancelBubble = true;
            group.destroy();
            this.selectedShape = null;
            this.playerLayer.draw();
            this.saveState();
        });
        group.add(trashGroup);
        group.on('click tap', (e)=>{
            if (this.currentMode === 'select') {
                this.selectShape(group);
                e.cancelBubble = true;
            }
        });
        group.on('dragstart', ()=>{
            this.selectShape(group);
        });
        group.on('dragend', ()=>{
            this.saveState();
        });
        this.playerLayer.add(group);
        this.playerLayer.draw();
        return group;
    }
    createArrow(initStartX, initStartY, initEndX, initEndY, color, style = 'curved', customCtrl = null, initBounce = null, hitNumber = null) {
        let startX = initStartX;
        let startY = initStartY;
        let endX = initEndX;
        let endY = initEndY;
        const group = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Group({
            name: 'arrow'
        });
        // Calculate bounce point and arc heights
        const calcBounceParams = ()=>{
            let bounceX, bounceY;
            if (initBounce) {
                bounceX = initBounce.x;
                bounceY = initBounce.y;
            } else {
                const dx = endX - startX;
                const dy = endY - startY;
                const bounceRatio = 0.65;
                bounceX = startX + dx * bounceRatio;
                bounceY = startY + dy * bounceRatio;
            }
            const dx1 = bounceX - startX;
            const dy1 = bounceY - startY;
            const distance1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
            const dx2 = endX - bounceX;
            const dy2 = endY - bounceY;
            const distance2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
            const arc1Height = distance1 * 0.22;
            const arc2Height = distance2 * 0.3;
            const perpX = distance1 > 0 ? -dy1 / distance1 : 0;
            const perpY = distance1 > 0 ? dx1 / distance1 : 0;
            let arcDirection;
            if (Math.abs(perpY) > 0.1) arcDirection = perpY < 0 ? 1 : -1;
            else {
                const midX = (startX + bounceX) / 2;
                const courtCenterX = this.CANVAS_WIDTH / 2;
                arcDirection = midX < courtCenterX ? -1 : 1;
            }
            const mid1X = (startX + bounceX) / 2;
            const mid1Y = (startY + bounceY) / 2;
            const ctrl1X = mid1X + perpX * arc1Height * arcDirection;
            const ctrl1Y = mid1Y + perpY * arc1Height * arcDirection;
            const perp2X = distance2 > 0 ? -dy2 / distance2 : 0;
            const perp2Y = distance2 > 0 ? dx2 / distance2 : 0;
            const mid2X = (bounceX + endX) / 2;
            const mid2Y = (bounceY + endY) / 2;
            const ctrl2X = mid2X + perp2X * arc2Height * arcDirection;
            const ctrl2Y = mid2Y + perp2Y * arc2Height * arcDirection;
            return {
                bounceX: bounceX,
                bounceY: bounceY,
                ctrl1X: ctrl1X,
                ctrl1Y: ctrl1Y,
                ctrl2X: ctrl2X,
                ctrl2Y: ctrl2Y,
                arcDirection: arcDirection
            };
        };
        let bounceParams = calcBounceParams();
        let arc1Apex = {
            t: 0.5,
            offset: null
        };
        if (customCtrl) {
            bounceParams.ctrl1X = customCtrl.x;
            bounceParams.ctrl1Y = customCtrl.y;
        }
        const computeApex = (baseStartX, baseStartY, baseEndX, baseEndY, t, offset, defaultOffsetRatio)=>{
            const dx = baseEndX - baseStartX;
            const dy = baseEndY - baseStartY;
            const len = Math.sqrt(dx * dx + dy * dy);
            if (len < 1) return {
                x: (baseStartX + baseEndX) / 2,
                y: (baseStartY + baseEndY) / 2
            };
            const baseX = baseStartX + dx * t;
            const baseY = baseStartY + dy * t;
            const perpX = -dy / len;
            const perpY = dx / len;
            let actualOffset;
            if (offset !== null) actualOffset = offset;
            else {
                const midX = (baseStartX + baseEndX) / 2;
                const courtCenterX = this.CANVAS_WIDTH / 2;
                const sign = midX < courtCenterX ? -1 : 1;
                actualOffset = len * defaultOffsetRatio * sign;
            }
            return {
                x: baseX + perpX * actualOffset,
                y: baseY + perpY * actualOffset
            };
        };
        const extractApexRelative = (baseStartX, baseStartY, baseEndX, baseEndY, apexX, apexY)=>{
            const dx = baseEndX - baseStartX;
            const dy = baseEndY - baseStartY;
            const len = Math.sqrt(dx * dx + dy * dy);
            if (len < 1) return {
                t: 0.5,
                offset: 0
            };
            const toApexX = apexX - baseStartX;
            const toApexY = apexY - baseStartY;
            const t = Math.max(0, Math.min(1, (toApexX * dx + toApexY * dy) / (len * len)));
            const baseX = baseStartX + dx * t;
            const baseY = baseStartY + dy * t;
            const perpX = -dy / len;
            const perpY = dx / len;
            const toApexFromBaseX = apexX - baseX;
            const toApexFromBaseY = apexY - baseY;
            const offset = toApexFromBaseX * perpX + toApexFromBaseY * perpY;
            return {
                t: t,
                offset: offset
            };
        };
        const recomputeArrow = ()=>{
            const bp = bounceParams;
            const dx1 = bp.bounceX - startX;
            const dy1 = bp.bounceY - startY;
            const len1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
            if (len1 < 1) return;
            const apex1 = computeApex(startX, startY, bp.bounceX, bp.bounceY, arc1Apex.t, arc1Apex.offset, 0.22);
            bp.ctrl1X = apex1.x;
            bp.ctrl1Y = apex1.y;
            const perp1X = -dy1 / len1;
            const perp1Y = dx1 / len1;
            const mid1X = (startX + bp.bounceX) / 2;
            const mid1Y = (startY + bp.bounceY) / 2;
            const ctrl1OffsetX = bp.ctrl1X - mid1X;
            const ctrl1OffsetY = bp.ctrl1Y - mid1Y;
            const arc1Side = ctrl1OffsetX * perp1X + ctrl1OffsetY * perp1Y >= 0 ? 1 : -1;
            const secondArcLen = len1 * 0.25;
            endX = bp.bounceX + dx1 / len1 * secondArcLen;
            endY = bp.bounceY + dy1 / len1 * secondArcLen;
            const dx2 = endX - bp.bounceX;
            const dy2 = endY - bp.bounceY;
            const len2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
            if (len2 < 1) return;
            const perp2X = -dy2 / len2;
            const perp2Y = dx2 / len2;
            const mid2X = (bp.bounceX + endX) / 2;
            const mid2Y = (bp.bounceY + endY) / 2;
            const offset2 = len2 * 0.3 * arc1Side;
            bp.ctrl2X = mid2X + perp2X * offset2;
            bp.ctrl2Y = mid2Y + perp2Y * offset2;
        };
        const generateBezierPoints = (sx, sy, ex, ey, cx, cy)=>{
            const pts = [];
            for(let t = 0; t <= 1; t += 0.05){
                const x = (1 - t) * (1 - t) * sx + 2 * (1 - t) * t * cx + t * t * ex;
                const y = (1 - t) * (1 - t) * sy + 2 * (1 - t) * t * cy + t * t * ey;
                pts.push(x, y);
            }
            return pts;
        };
        const generateBounceTrajectory = ()=>{
            const bp = bounceParams;
            const arc1 = generateBezierPoints(startX, startY, bp.bounceX, bp.bounceY, bp.ctrl1X, bp.ctrl1Y);
            const arc2 = generateBezierPoints(bp.bounceX, bp.bounceY, endX, endY, bp.ctrl2X, bp.ctrl2Y);
            return [
                ...arc1,
                ...arc2
            ];
        };
        const updateArrowHead = (pts)=>{
            const lastIdx = pts.length;
            const arrowEndX = pts[lastIdx - 2];
            const arrowEndY = pts[lastIdx - 1];
            const prevX = pts[lastIdx - 4] || startX;
            const prevY = pts[lastIdx - 3] || startY;
            const angle = Math.atan2(arrowEndY - prevY, arrowEndX - prevX);
            const headLength = 15;
            const headAngle = Math.PI / 6;
            return [
                arrowEndX - headLength * Math.cos(angle - headAngle),
                arrowEndY - headLength * Math.sin(angle - headAngle),
                arrowEndX,
                arrowEndY,
                arrowEndX - headLength * Math.cos(angle + headAngle),
                arrowEndY - headLength * Math.sin(angle + headAngle)
            ];
        };
        let points = style === 'curved' ? generateBounceTrajectory() : [
            startX,
            startY,
            endX,
            endY
        ];
        const line = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Line({
            points: points,
            stroke: color,
            strokeWidth: 4,
            hitStrokeWidth: 20,
            lineCap: 'round',
            lineJoin: 'round',
            name: 'arrow-line'
        });
        group.add(line);
        const arrowHead = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Line({
            points: updateArrowHead(points),
            stroke: color,
            strokeWidth: 4,
            lineCap: 'round',
            lineJoin: 'round',
            name: 'arrow-head'
        });
        group.add(arrowHead);
        // Hit number label
        if (hitNumber !== null) {
            const hitLabel = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Label({
                x: startX - 20,
                y: startY - 20,
                name: 'hit-label'
            });
            hitLabel.add(new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Tag({
                fill: color,
                cornerRadius: 10
            }));
            hitLabel.add(new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Text({
                text: String(hitNumber),
                fontSize: 14,
                fontFamily: 'system-ui, -apple-system, sans-serif',
                fontStyle: 'bold',
                fill: 'white',
                padding: 4,
                align: 'center'
            }));
            group.add(hitLabel);
        }
        const redrawArrow = ()=>{
            recomputeArrow();
            const newPoints = style === 'curved' ? generateBounceTrajectory() : [
                startX,
                startY,
                endX,
                endY
            ];
            line.points(newPoints);
            arrowHead.points(updateArrowHead(newPoints));
            const bHandle = group.findOne('.bounce-handle');
            if (bHandle) {
                bHandle.x(bounceParams.bounceX);
                bHandle.y(bounceParams.bounceY);
            }
            const hHandle = group.findOne('.height-handle');
            if (hHandle) {
                hHandle.x(bounceParams.ctrl1X);
                hHandle.y(bounceParams.ctrl1Y);
            }
            const trash = group.findOne('.trash-icon');
            if (trash) {
                trash.x(startX);
                trash.y(startY - 45);
            }
            const label = group.findOne('.hit-label');
            if (label) {
                label.x(startX - 20);
                label.y(startY - 20);
            }
            group.setAttrs({
                arrowData: {
                    startX: startX,
                    startY: startY,
                    endX: endX,
                    endY: endY,
                    color: color,
                    style: style,
                    bounce: {
                        x: bounceParams.bounceX,
                        y: bounceParams.bounceY
                    }
                }
            });
            this.arrowLayer.batchDraw();
        };
        // Start handle
        const startHandle = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Circle({
            x: startX,
            y: startY,
            radius: 8,
            fill: 'white',
            stroke: color,
            strokeWidth: 2,
            draggable: true,
            visible: false,
            name: 'start-handle'
        });
        startHandle.on('dragmove', ()=>{
            startX = startHandle.x();
            startY = startHandle.y();
            redrawArrow();
        });
        startHandle.on('dragend', ()=>{
            this.arrowLayer.draw();
            this.saveState();
        });
        group.add(startHandle);
        // Bounce handle
        const bounceHandle = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Circle({
            x: bounceParams.bounceX,
            y: bounceParams.bounceY,
            radius: 8,
            fill: 'white',
            stroke: color,
            strokeWidth: 2,
            draggable: true,
            visible: false,
            name: 'bounce-handle'
        });
        bounceHandle.on('dragmove', ()=>{
            const bp = bounceParams;
            bp.bounceX = bounceHandle.x();
            bp.bounceY = bounceHandle.y();
            recomputeArrow();
            const hHandle = group.findOne('.height-handle');
            if (hHandle) {
                hHandle.x(bp.ctrl1X);
                hHandle.y(bp.ctrl1Y);
            }
            const newPoints = generateBounceTrajectory();
            line.points(newPoints);
            arrowHead.points(updateArrowHead(newPoints));
            this.arrowLayer.batchDraw();
        });
        bounceHandle.on('dragend', ()=>{
            this.arrowLayer.draw();
            this.saveState();
        });
        group.add(bounceHandle);
        // Height handle
        const heightHandle = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Circle({
            x: bounceParams.ctrl1X,
            y: bounceParams.ctrl1Y,
            radius: 8,
            fill: 'white',
            stroke: color,
            strokeWidth: 2,
            draggable: true,
            visible: false,
            name: 'height-handle'
        });
        heightHandle.on('dragmove', ()=>{
            bounceParams.ctrl1X = heightHandle.x();
            bounceParams.ctrl1Y = heightHandle.y();
            const relative = extractApexRelative(startX, startY, bounceParams.bounceX, bounceParams.bounceY, bounceParams.ctrl1X, bounceParams.ctrl1Y);
            arc1Apex.t = relative.t;
            arc1Apex.offset = relative.offset;
            const bp = bounceParams;
            const mid2X = (bp.bounceX + endX) / 2;
            const mid2Y = (bp.bounceY + endY) / 2;
            const mid1X = (startX + bp.bounceX) / 2;
            const mid1Y = (startY + bp.bounceY) / 2;
            const dirX = bp.ctrl1X - mid1X;
            const dirY = bp.ctrl1Y - mid1Y;
            const dirLen = Math.sqrt(dirX * dirX + dirY * dirY);
            if (dirLen > 0) {
                const secondArcLen = Math.sqrt(Math.pow(endX - bp.bounceX, 2) + Math.pow(endY - bp.bounceY, 2));
                const arc2Height = secondArcLen * 0.3;
                bp.ctrl2X = mid2X + dirX / dirLen * arc2Height;
                bp.ctrl2Y = mid2Y + dirY / dirLen * arc2Height;
            }
            const newPoints = generateBounceTrajectory();
            line.points(newPoints);
            arrowHead.points(updateArrowHead(newPoints));
            this.arrowLayer.batchDraw();
        });
        heightHandle.on('dragend', ()=>{
            this.arrowLayer.draw();
            this.saveState();
        });
        group.add(heightHandle);
        // Trash icon
        const trashGroup = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Group({
            x: startX,
            y: startY - 45,
            visible: false,
            name: 'trash-icon'
        });
        const trashBg = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Circle({
            radius: 14,
            fill: '#EF4444',
            stroke: 'white',
            strokeWidth: 2
        });
        trashGroup.add(trashBg);
        const trashIcon = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Shape({
            sceneFunc: (ctx, shape)=>{
                ctx.beginPath();
                ctx.moveTo(-6, -6);
                ctx.lineTo(6, -6);
                ctx.moveTo(-5, -4);
                ctx.lineTo(-4, 6);
                ctx.lineTo(4, 6);
                ctx.lineTo(5, -4);
                ctx.moveTo(-2, -6);
                ctx.lineTo(-2, -8);
                ctx.lineTo(2, -8);
                ctx.lineTo(2, -6);
                ctx.strokeShape(shape);
            },
            stroke: 'white',
            strokeWidth: 1.5,
            lineCap: 'round',
            lineJoin: 'round'
        });
        trashGroup.add(trashIcon);
        trashGroup.on('click tap', (e)=>{
            e.cancelBubble = true;
            group.destroy();
            this.selectedShape = null;
            this.arrowLayer.draw();
            this.saveState();
        });
        group.add(trashGroup);
        group.setAttrs({
            arrowData: {
                startX: startX,
                startY: startY,
                endX: endX,
                endY: endY,
                color: color,
                style: style,
                ctrl: style === 'curved' ? {
                    x: bounceParams.ctrl1X,
                    y: bounceParams.ctrl1Y
                } : null
            }
        });
        group.on('click tap', (e)=>{
            if (this.currentMode === 'select') {
                this.selectShape(group);
                e.cancelBubble = true;
            }
        });
        this.arrowLayer.add(group);
        this.arrowLayer.draw();
        return group;
    }
    createArrowWithBounce(startX, startY, bounceX, bounceY, endX, endY, color, style = 'curved', hitNumber = null) {
        return this.createArrow(startX, startY, endX, endY, color, style, null, {
            x: bounceX,
            y: bounceY
        }, hitNumber);
    }
    selectShape(shape) {
        if (this.selectedShape) {
            const prevEllipse = this.selectedShape.findOne('Ellipse');
            if (prevEllipse) {
                prevEllipse.stroke('#fff');
                const scale = this.getScaleFactor(this.selectedShape.y());
                prevEllipse.strokeWidth(2 * scale);
            }
            const prevTrash = this.selectedShape.findOne('.trash-icon');
            if (prevTrash) prevTrash.visible(false);
            if (this.selectedShape.name() === 'arrow') {
                const prevLine = this.selectedShape.findOne('.arrow-line');
                if (prevLine) prevLine.shadowEnabled(false);
                const handleNames = [
                    '.start-handle',
                    '.bounce-handle',
                    '.height-handle'
                ];
                handleNames.forEach((name)=>{
                    const handle = this.selectedShape.findOne(name);
                    if (handle) handle.visible(false);
                });
            }
        }
        this.selectedShape = shape;
        if (shape) {
            const ellipse = shape.findOne('Ellipse');
            if (ellipse) {
                ellipse.stroke('#e94560');
                const scale = this.getScaleFactor(shape.y());
                ellipse.strokeWidth(4 * scale);
            }
            const trash = shape.findOne('.trash-icon');
            if (trash) trash.visible(true);
            if (shape.name() === 'arrow') {
                const line = shape.findOne('.arrow-line');
                if (line) {
                    line.shadowColor('#e94560');
                    line.shadowBlur(10);
                    line.shadowEnabled(true);
                }
                const handleNames = [
                    '.start-handle',
                    '.bounce-handle',
                    '.height-handle'
                ];
                handleNames.forEach((name)=>{
                    const handle = shape.findOne(name);
                    if (handle) handle.visible(true);
                });
            }
        }
        this.playerLayer.draw();
        this.arrowLayer.draw();
    }
    startDrawing(pos) {
        this.isDrawing = true;
        this.drawStartPos = pos;
    }
    continueDrawing(pos) {
        if (!this.isDrawing || !this.drawStartPos) return;
        const dx = pos.x - this.drawStartPos.x;
        const dy = pos.y - this.drawStartPos.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (distance < 15) return;
        if (this.tempArrow) this.tempArrow.destroy();
        const previewColor = this.drawStartPos.y < pos.y ? '#EF4444' : '#22C55E';
        const bounceX = pos.x;
        const bounceY = pos.y;
        const secondArcLen = distance * 0.25;
        const endX = bounceX + dx / distance * secondArcLen;
        const endY = bounceY + dy / distance * secondArcLen;
        this.tempArrow = this.createArrowWithBounce(this.drawStartPos.x, this.drawStartPos.y, bounceX, bounceY, endX, endY, previewColor, this.currentArrowStyle);
        this.tempArrow.opacity(0.5);
        const handleNames = [
            '.start-handle',
            '.bounce-handle',
            '.height-handle'
        ];
        handleNames.forEach((name)=>{
            const handle = this.tempArrow.findOne(name);
            if (handle) handle.visible(false);
        });
        this.arrowLayer.draw();
    }
    endDrawing(pos) {
        if (!this.isDrawing || !this.drawStartPos) return;
        this.isDrawing = false;
        if (this.tempArrow) {
            this.tempArrow.destroy();
            this.tempArrow = null;
        }
        const dx = pos.x - this.drawStartPos.x;
        const dy = pos.y - this.drawStartPos.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (distance > 20) {
            const arrowColor = this.drawStartPos.y < pos.y ? '#EF4444' : '#22C55E';
            const bounceX = pos.x;
            const bounceY = pos.y;
            const secondArcLen = distance * 0.25;
            const endX = bounceX + dx / distance * secondArcLen;
            const endY = bounceY + dy / distance * secondArcLen;
            this.hitCounter++;
            const newArrow = this.createArrowWithBounce(this.drawStartPos.x, this.drawStartPos.y, bounceX, bounceY, endX, endY, arrowColor, this.currentArrowStyle, this.hitCounter);
            this.selectShape(newArrow);
            this.saveState();
        }
        this.arrowLayer.draw();
    }
    bindEvents() {
        // Stage events
        this.stage.on('mousedown touchstart', (e)=>{
            const target = e.target;
            const parent = target.parent;
            const isOnPlayer = parent && parent.name() === 'player';
            const isOnArrow = parent && parent.name() === 'arrow';
            const isOnHandle = target.name() && (target.name().includes('handle') || target.name().includes('trash'));
            if (!isOnPlayer && !isOnArrow && !isOnHandle && (target === this.stage || parent === this.courtLayer || parent === this.backgroundLayer)) {
                this.selectShape(null);
                const pos = this.stage.getPointerPosition();
                if (pos) this.startDrawing(pos);
            }
        });
        this.stage.on('mousemove touchmove', ()=>{
            if (this.isDrawing) {
                const pos = this.stage.getPointerPosition();
                if (pos) this.continueDrawing(pos);
            }
        });
        this.stage.on('mouseup touchend', ()=>{
            if (this.isDrawing) {
                const pos = this.stage.getPointerPosition();
                if (pos) this.endDrawing(pos);
            }
        });
        // Toolbar buttons
        this.undoBtn.addEventListener('click', ()=>this.undo());
        this.redoBtn.addEventListener('click', ()=>this.redo());
        // Help modal
        this.element.querySelector('#help-btn').addEventListener('click', ()=>{
            this.helpModal.classList.add('visible');
        });
        this.element.querySelector('#help-close').addEventListener('click', ()=>{
            this.helpModal.classList.remove('visible');
        });
        this.helpModal.addEventListener('click', (e)=>{
            if (e.target === this.helpModal) this.helpModal.classList.remove('visible');
        });
        // Pagination
        this.prevSlideBtn.addEventListener('click', ()=>this.goToPrevSlide());
        this.nextSlideBtn.addEventListener('click', ()=>this.goToNextSlide());
        this.addSlideBtn.addEventListener('click', ()=>this.addNewSlide());
        this.deleteSlideBtn.addEventListener('click', ()=>this.deleteCurrentSlide());
        // Audio controls (media bar)
        this.recordBtn.addEventListener('click', ()=>this.toggleRecording());
        this.playAllBtn.addEventListener('click', ()=>this.togglePlayback());
        // Description auto-save (contenteditable)
        this.descriptionInput.addEventListener('input', ()=>{
            // Save description to current slide
            if (this.slides.length > 0) this.slides[this.currentSlideIndex].description = this.descriptionInput.innerText;
            this.saveToLocalStorage();
            this.syncToServer();
        });
        // Handle paste to strip formatting
        this.descriptionInput.addEventListener('paste', (e)=>{
            e.preventDefault();
            const text = e.clipboardData?.getData('text/plain') || '';
            document.execCommand('insertText', false, text);
        });
        // Keyboard
        document.addEventListener('keydown', this.boundHandleKeydown);
        // Resize
        window.addEventListener('resize', this.boundHandleResize);
    }
    handleKeydown(e) {
        const target = e.target;
        if (target.tagName === 'INPUT' || target.isContentEditable) return;
        if ((e.ctrlKey || e.metaKey) && e.key === 'z' && !e.shiftKey) {
            e.preventDefault();
            this.undo();
        }
        if ((e.ctrlKey || e.metaKey) && (e.key === 'z' && e.shiftKey || e.key === 'y')) {
            e.preventDefault();
            this.redo();
        }
        if (e.key === 'Delete' || e.key === 'Backspace') {
            if (this.selectedShape) {
                this.selectedShape.destroy();
                this.selectedShape = null;
                this.playerLayer.draw();
                this.arrowLayer.draw();
                this.saveState();
            }
        }
        if (e.key === 'Escape') {
            this.selectShape(null);
            if (this.isDrawing) {
                this.isDrawing = false;
                if (this.tempArrow) {
                    this.tempArrow.destroy();
                    this.tempArrow = null;
                    this.arrowLayer.draw();
                }
            }
            if (this.helpModal.classList.contains('visible')) this.helpModal.classList.remove('visible');
        }
        // Slide navigation with arrow keys
        if (e.key === 'ArrowLeft' && !e.ctrlKey && !e.metaKey) this.goToPrevSlide();
        if (e.key === 'ArrowRight' && !e.ctrlKey && !e.metaKey) this.goToNextSlide();
    }
    handleResize() {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = window.setTimeout(()=>{
            const players = [];
            const arrows = [];
            this.playerLayer.find('.player').forEach((player)=>{
                const p = player;
                const ellipse = p.findOne('Ellipse');
                const text = p.findOne('Text');
                if (ellipse && text) players.push({
                    xRatio: p.x() / this.CANVAS_WIDTH,
                    yRatio: p.y() / this.CANVAS_HEIGHT,
                    color: ellipse.fill(),
                    label: text.text()
                });
            });
            this.arrowLayer.find('.arrow').forEach((arrow)=>{
                const data = arrow.getAttr('arrowData');
                if (data) arrows.push({
                    startXRatio: data.startX / this.CANVAS_WIDTH,
                    startYRatio: data.startY / this.CANVAS_HEIGHT,
                    endXRatio: data.endX / this.CANVAS_WIDTH,
                    endYRatio: data.endY / this.CANVAS_HEIGHT,
                    color: data.color,
                    style: data.style,
                    ctrlXRatio: data.ctrl ? data.ctrl.x / this.CANVAS_WIDTH : null,
                    ctrlYRatio: data.ctrl ? data.ctrl.y / this.CANVAS_HEIGHT : null
                });
            });
            this.playerLayer.destroyChildren();
            this.arrowLayer.destroyChildren();
            const size = this.getCanvasSize();
            this.CANVAS_WIDTH = size.width;
            this.CANVAS_HEIGHT = size.height;
            this.PERSPECTIVE = this.getPerspective();
            this.stage.width(this.CANVAS_WIDTH);
            this.stage.height(this.CANVAS_HEIGHT);
            this.backgroundLayer.destroyChildren();
            this.courtLayer.destroyChildren();
            this.uiLayer.destroyChildren();
            this.drawBackground();
            this.drawCourt();
            players.forEach((p)=>{
                this.createPlayer(p.xRatio * this.CANVAS_WIDTH, p.yRatio * this.CANVAS_HEIGHT, p.color, p.label);
            });
            arrows.forEach((a)=>{
                const ctrl = a.ctrlXRatio !== null && a.ctrlYRatio !== null ? {
                    x: a.ctrlXRatio * this.CANVAS_WIDTH,
                    y: a.ctrlYRatio * this.CANVAS_HEIGHT
                } : null;
                this.createArrow(a.startXRatio * this.CANVAS_WIDTH, a.startYRatio * this.CANVAS_HEIGHT, a.endXRatio * this.CANVAS_WIDTH, a.endYRatio * this.CANVAS_HEIGHT, a.color, a.style, ctrl);
            });
            this.stage.draw();
        }, 150);
    }
    editText(textNode, layer, centerAfterEdit = false) {
        const textPosition = textNode.absolutePosition();
        const stageBox = this.stage.container().getBoundingClientRect();
        const input = document.createElement('input');
        input.type = 'text';
        input.value = textNode.text();
        input.style.position = 'fixed';
        input.style.left = `${stageBox.left + textPosition.x}px`;
        input.style.top = `${stageBox.top + textPosition.y - 4}px`;
        input.style.width = `${Math.max(textNode.width() + 40, 100)}px`;
        input.style.fontSize = `${textNode.fontSize()}px`;
        input.style.fontFamily = textNode.fontFamily();
        input.style.padding = '4px 8px';
        input.style.border = '2px solid #FF6B00';
        input.style.borderRadius = '2px';
        input.style.background = 'rgba(13, 40, 51, 0.95)';
        input.style.color = 'white';
        input.style.outline = 'none';
        input.style.zIndex = '1000';
        input.style.textAlign = centerAfterEdit ? 'center' : 'left';
        document.body.appendChild(input);
        input.focus();
        input.select();
        textNode.visible(false);
        layer.draw();
        const finishEdit = ()=>{
            const newText = input.value.trim() || textNode.text();
            textNode.text(newText);
            textNode.visible(true);
            if (centerAfterEdit) textNode.x(this.CANVAS_WIDTH / 2 - textNode.width() / 2);
            if (textNode.id() === 'title-text') this.titleInput.value = newText;
            layer.draw();
            input.remove();
        };
        input.addEventListener('blur', finishEdit);
        input.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter') input.blur();
            if (e.key === 'Escape') {
                input.value = textNode.text();
                input.blur();
            }
        });
    }
    editPlayerLabel(textNode, group, absPos) {
        const stageBox = this.stage.container().getBoundingClientRect();
        const scale = this.getScaleFactor(group.y());
        const fontSize = 11 * scale;
        const input = document.createElement('input');
        input.type = 'text';
        input.value = textNode.text();
        input.style.position = 'fixed';
        input.style.left = `${stageBox.left + absPos.x - 40}px`;
        input.style.top = `${stageBox.top + absPos.y - 4}px`;
        input.style.width = '80px';
        input.style.fontSize = `${Math.max(fontSize, 11)}px`;
        input.style.fontFamily = 'Arial, sans-serif';
        input.style.padding = '4px 8px';
        input.style.border = '2px solid #FF6B00';
        input.style.borderRadius = '2px';
        input.style.background = 'rgba(13, 40, 51, 0.95)';
        input.style.color = 'white';
        input.style.outline = 'none';
        input.style.zIndex = '1000';
        input.style.textAlign = 'center';
        document.body.appendChild(input);
        input.focus();
        input.select();
        textNode.visible(false);
        this.playerLayer.draw();
        const finishEdit = ()=>{
            const newText = input.value.trim() || textNode.text();
            textNode.text(newText);
            textNode.visible(true);
            textNode.x(-textNode.width() / 2);
            const hitBg = group.findOne('.label-hitarea');
            if (hitBg) {
                hitBg.x(textNode.x() - 10);
                hitBg.width(textNode.width() + 20);
            }
            this.playerLayer.draw();
            input.remove();
        };
        input.addEventListener('blur', finishEdit);
        input.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter') input.blur();
            if (e.key === 'Escape') {
                input.value = textNode.text();
                input.blur();
            }
        });
    }
    // State management
    saveState() {
        const state = {
            players: [],
            arrows: []
        };
        this.playerLayer.find('.player').forEach((p)=>{
            const player = p;
            const ellipse = player.findOne('Ellipse');
            const text = player.findOne('Text');
            if (ellipse && text) state.players.push({
                x: player.x(),
                y: player.y(),
                color: ellipse.fill(),
                label: text.text()
            });
        });
        this.arrowLayer.find('.arrow').forEach((a)=>{
            const data = a.getAttr('arrowData');
            if (data) state.arrows.push({
                ...data
            });
        });
        this.undoStack.push(JSON.stringify(state));
        if (this.undoStack.length > this.MAX_UNDO) this.undoStack.shift();
        this.redoStack.length = 0;
        this.updateUndoRedoButtons();
        // Also persist to localStorage and sync to server
        this.saveToLocalStorage();
        this.syncToServer();
    }
    restoreState(stateJson) {
        const state = JSON.parse(stateJson);
        this.playerLayer.find('.player').forEach((p)=>p.destroy());
        this.arrowLayer.find('.arrow').forEach((a)=>a.destroy());
        this.selectedShape = null;
        state.players.forEach((p)=>{
            this.createPlayer(p.x, p.y, p.color, p.label);
        });
        state.arrows.forEach((a)=>{
            this.createArrow(a.startX, a.startY, a.endX, a.endY, a.color, a.style, a.ctrl || null);
        });
        this.playerLayer.draw();
        this.arrowLayer.draw();
    }
    undo() {
        if (this.undoStack.length < 2) return;
        const currentState = this.undoStack.pop();
        this.redoStack.push(currentState);
        const previousState = this.undoStack[this.undoStack.length - 1];
        this.restoreState(previousState);
        this.updateUndoRedoButtons();
    }
    redo() {
        if (this.redoStack.length === 0) return;
        const nextState = this.redoStack.pop();
        this.undoStack.push(nextState);
        this.restoreState(nextState);
        this.updateUndoRedoButtons();
    }
    updateUndoRedoButtons() {
        this.undoBtn.style.opacity = this.undoStack.length > 1 ? '1' : '0.3';
        this.redoBtn.style.opacity = this.redoStack.length > 0 ? '1' : '0.3';
    }
    // Slide Management
    generateSlideId() {
        return `slide_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    }
    getCurrentCanvasState() {
        const state = {
            players: [],
            arrows: []
        };
        // Save players as ratios (0-1) for cross-device compatibility
        this.playerLayer.find('.player').forEach((p)=>{
            const player = p;
            const ellipse = player.findOne('Ellipse');
            const text = player.findOne('Text');
            if (ellipse && text) state.players.push({
                x: $c6f8878b4b43a5af$var$pixelToRatio(player.x(), this.CANVAS_WIDTH),
                y: $c6f8878b4b43a5af$var$pixelToRatio(player.y(), this.CANVAS_HEIGHT),
                color: ellipse.fill(),
                label: text.text()
            });
        });
        // Save arrows as ratios (0-1) for cross-device compatibility
        // Note: arrowData is stored in pixels, so convert to ratios here
        this.arrowLayer.find('.arrow').forEach((a)=>{
            const data = a.getAttr('arrowData');
            if (data) state.arrows.push({
                startX: $c6f8878b4b43a5af$var$pixelToRatio(data.startX, this.CANVAS_WIDTH),
                startY: $c6f8878b4b43a5af$var$pixelToRatio(data.startY, this.CANVAS_HEIGHT),
                endX: $c6f8878b4b43a5af$var$pixelToRatio(data.endX, this.CANVAS_WIDTH),
                endY: $c6f8878b4b43a5af$var$pixelToRatio(data.endY, this.CANVAS_HEIGHT),
                color: data.color,
                style: data.style,
                ctrl: data.ctrl ? {
                    x: $c6f8878b4b43a5af$var$pixelToRatio(data.ctrl.x, this.CANVAS_WIDTH),
                    y: $c6f8878b4b43a5af$var$pixelToRatio(data.ctrl.y, this.CANVAS_HEIGHT)
                } : null,
                bounce: data.bounce ? {
                    x: $c6f8878b4b43a5af$var$pixelToRatio(data.bounce.x, this.CANVAS_WIDTH),
                    y: $c6f8878b4b43a5af$var$pixelToRatio(data.bounce.y, this.CANVAS_HEIGHT)
                } : undefined
            });
        });
        return state;
    }
    saveCurrentSlideToMemory() {
        if (this.slides.length === 0) return;
        const currentSlide = this.slides[this.currentSlideIndex];
        currentSlide.canvasState = this.getCurrentCanvasState();
    }
    loadSlideByIndex(index) {
        if (index < 0 || index >= this.slides.length) return;
        // Save current slide before switching
        this.saveCurrentSlideToMemory();
        this.saveSlideDescription();
        this.currentSlideIndex = index;
        const slide = this.slides[index];
        // Load description for this slide
        this.descriptionInput.innerText = slide.description || '';
        // Clear canvas
        this.playerLayer.find('.player').forEach((p)=>p.destroy());
        this.arrowLayer.find('.arrow').forEach((a)=>a.destroy());
        this.selectedShape = null;
        this.hitCounter = 0;
        // Restore slide state - convert ratios to current canvas pixels
        slide.canvasState.players.forEach((p)=>{
            const x = $c6f8878b4b43a5af$var$ratioToPixel(p.x, this.CANVAS_WIDTH);
            const y = $c6f8878b4b43a5af$var$ratioToPixel(p.y, this.CANVAS_HEIGHT);
            this.createPlayer(x, y, p.color, p.label);
        });
        slide.canvasState.arrows.forEach((a)=>{
            this.hitCounter++;
            const startX = $c6f8878b4b43a5af$var$ratioToPixel(a.startX, this.CANVAS_WIDTH);
            const startY = $c6f8878b4b43a5af$var$ratioToPixel(a.startY, this.CANVAS_HEIGHT);
            const endX = $c6f8878b4b43a5af$var$ratioToPixel(a.endX, this.CANVAS_WIDTH);
            const endY = $c6f8878b4b43a5af$var$ratioToPixel(a.endY, this.CANVAS_HEIGHT);
            const ctrl = a.ctrl ? {
                x: $c6f8878b4b43a5af$var$ratioToPixel(a.ctrl.x, this.CANVAS_WIDTH),
                y: $c6f8878b4b43a5af$var$ratioToPixel(a.ctrl.y, this.CANVAS_HEIGHT)
            } : null;
            const bounce = a.bounce ? {
                x: $c6f8878b4b43a5af$var$ratioToPixel(a.bounce.x, this.CANVAS_WIDTH),
                y: $c6f8878b4b43a5af$var$ratioToPixel(a.bounce.y, this.CANVAS_HEIGHT)
            } : null;
            this.createArrow(startX, startY, endX, endY, a.color, a.style, ctrl, bounce, this.hitCounter);
        });
        // Reset undo/redo for this slide
        this.undoStack = [
            JSON.stringify(slide.canvasState)
        ];
        this.redoStack = [];
        this.updateUndoRedoButtons();
        this.playerLayer.draw();
        this.arrowLayer.draw();
        this.updateSlideIndicator();
        this.updatePaginationButtons();
        this.updateAudioUI();
        this.saveToLocalStorage();
    }
    addNewSlide() {
        // Save current slide first
        this.saveCurrentSlideToMemory();
        this.saveSlideDescription();
        // Create new blank slide with default players
        const newSlide = {
            id: this.generateSlideId(),
            description: '',
            canvasState: {
                players: this.getDefaultPlayersState(),
                arrows: []
            }
        };
        const insertAfterIndex = this.currentSlideIndex;
        // Insert after current slide
        this.slides.splice(insertAfterIndex + 1, 0, newSlide);
        // Sync to server
        this.syncClient?.sendSlideAdd(newSlide, insertAfterIndex);
        // Navigate to new slide
        this.loadSlideByIndex(insertAfterIndex + 1);
        // Clear description for new slide
        this.descriptionInput.innerText = '';
    }
    getDefaultPlayersState() {
        // Returns players as ratios (0-1) for storage
        const P = this.PERSPECTIVE;
        const nearY = P.nearY - this.CANVAS_HEIGHT * 0.04;
        const farY = P.farY + this.CANVAS_HEIGHT * 0.03;
        const playerNearX = this.getPerspectiveX(0.70, nearY);
        const playerFarX = this.getPerspectiveX(0.30, farY);
        return [
            {
                x: $c6f8878b4b43a5af$var$pixelToRatio(playerNearX, this.CANVAS_WIDTH),
                y: $c6f8878b4b43a5af$var$pixelToRatio(nearY, this.CANVAS_HEIGHT),
                color: '#22C55E',
                label: 'You'
            },
            {
                x: $c6f8878b4b43a5af$var$pixelToRatio(playerFarX, this.CANVAS_WIDTH),
                y: $c6f8878b4b43a5af$var$pixelToRatio(farY, this.CANVAS_HEIGHT),
                color: '#EF4444',
                label: ''
            }
        ];
    }
    updateSlideIndicator() {
        this.slideIndicator.textContent = `${this.currentSlideIndex + 1}/${this.slides.length}`;
    }
    updatePaginationButtons() {
        this.prevSlideBtn.style.opacity = this.currentSlideIndex > 0 ? '1' : '0.3';
        this.nextSlideBtn.style.opacity = this.currentSlideIndex < this.slides.length - 1 ? '1' : '0.3';
    }
    goToPrevSlide() {
        if (this.currentSlideIndex > 0) this.loadSlideByIndex(this.currentSlideIndex - 1);
    }
    goToNextSlide() {
        if (this.currentSlideIndex < this.slides.length - 1) this.loadSlideByIndex(this.currentSlideIndex + 1);
    }
    deleteCurrentSlide() {
        // Can't delete the last slide
        if (this.slides.length <= 1) return;
        const indexToDelete = this.currentSlideIndex;
        // Sync to server first
        this.syncClient?.sendSlideDelete(indexToDelete);
        // Remove the slide
        this.slides.splice(indexToDelete, 1);
        // Adjust current index
        if (this.currentSlideIndex >= this.slides.length) this.currentSlideIndex = this.slides.length - 1;
        // Load the new current slide
        this.reloadCurrentSlide();
        this.loadSlideDescription();
        this.updateSlideIndicator();
        this.updatePaginationButtons();
        this.saveToLocalStorage();
    }
    loadSlideDescription() {
        const slide = this.slides[this.currentSlideIndex];
        if (slide) this.descriptionInput.innerText = slide.description || '';
    }
    // Audio segment methods
    initAudioRecorder() {
        if (!this.diagramId) return;
        this.audioRecorder = new (0, $89e91b042708b34e$export$de95611a92ae0566)({
            diagramId: this.diagramId,
            onStateChange: (state)=>{
                this.isRecording = state === 'recording';
                this.updateRecordButton();
                if (state === 'uploading') this.audioTimer.textContent = 'Saving...';
            },
            onTimeUpdate: (seconds)=>{
                this.audioTimer.textContent = this.formatTime(seconds);
            },
            onSegmentReady: (segment)=>{
                // Add segment to array
                this.audioSegments.push(segment);
                this.saveToLocalStorage();
                this.syncAudioSegmentAdd(segment);
                this.renderSegmentTimeline();
                this.audioTimer.textContent = '';
            },
            onError: (error)=>{
                console.error('Audio error:', error);
                this.audioTimer.textContent = '';
                alert(error);
            }
        });
        this.segmentPlayer = new (0, $89e91b042708b34e$export$95a4ce47d946bbbb)({
            onPlayStateChange: (playing)=>{
                this.isPlaying = playing;
                this.updatePlayButton();
            },
            onTimeUpdate: (currentTime, totalDuration, segmentIndex)=>{
                this.audioTimer.textContent = `${this.formatTime(Math.floor(currentTime))} / ${this.formatTime(Math.floor(totalDuration))}`;
                this.highlightPlayingSegment(segmentIndex);
            },
            onSegmentChange: (index)=>{
                this.highlightPlayingSegment(index);
            },
            onEnded: ()=>{
                this.audioTimer.textContent = this.formatTime(this.getTotalDuration());
                this.highlightPlayingSegment(-1);
            }
        });
    }
    toggleRecording() {
        if (!this.diagramId) {
            alert('Please save the diagram first to enable recording');
            return;
        }
        if (!this.audioRecorder) this.initAudioRecorder();
        if (this.isRecording) this.audioRecorder?.stopRecording();
        else {
            // Stop any playing audio first
            if (this.isPlaying) this.segmentPlayer?.pause();
            this.audioRecorder?.startRecording();
        }
    }
    togglePlayback() {
        if (this.audioSegments.length === 0) return;
        if (!this.segmentPlayer) this.initAudioRecorder();
        if (this.isPlaying) this.segmentPlayer?.pause();
        else {
            this.segmentPlayer?.setSegments(this.audioSegments);
            this.segmentPlayer?.play();
        }
    }
    updateRecordButton() {
        if (this.isRecording) {
            this.recordBtn.classList.add('recording');
            this.recordBtn.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="none">
          <rect x="6" y="6" width="12" height="12" rx="2"/>
        </svg>
      `;
            this.recordBtn.title = 'Stop Recording';
        } else {
            this.recordBtn.classList.remove('recording');
            this.recordBtn.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
          <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
          <line x1="12" y1="19" x2="12" y2="23"/>
          <line x1="8" y1="23" x2="16" y2="23"/>
        </svg>
      `;
            this.recordBtn.title = 'Record Audio';
        }
    }
    updatePlayButton() {
        if (this.isPlaying) {
            this.playAllBtn.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="6" y="4" width="4" height="16"/>
          <rect x="14" y="4" width="4" height="16"/>
        </svg>
      `;
            this.playAllBtn.title = 'Pause';
        } else {
            this.playAllBtn.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polygon points="5 3 19 12 5 21 5 3"/>
        </svg>
      `;
            this.playAllBtn.title = 'Play All';
        }
    }
    renderSegmentTimeline() {
        if (this.audioSegments.length === 0) {
            this.segmentTimeline.innerHTML = '<span class="empty-message">No recordings yet</span>';
            this.audioTimer.textContent = '';
            return;
        }
        const totalDuration = this.getTotalDuration();
        this.segmentTimeline.innerHTML = this.audioSegments.map((seg, index)=>`
      <div class="segment-item" data-segment-id="${seg.id}" data-index="${index}">
        <span class="segment-duration">${this.formatTime(seg.duration)}</span>
        <button class="segment-delete" data-segment-id="${seg.id}" title="Delete segment">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
    `).join('');
        this.audioTimer.textContent = this.formatTime(totalDuration);
        // Bind click events for segments
        this.segmentTimeline.querySelectorAll('.segment-item').forEach((el)=>{
            el.addEventListener('click', (e)=>{
                const target = e.target;
                // Don't trigger if clicking delete button
                if (target.closest('.segment-delete')) return;
                const index = parseInt(el.getAttribute('data-index') || '0');
                this.playFromSegment(index);
            });
        });
        // Bind delete events
        this.segmentTimeline.querySelectorAll('.segment-delete').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                e.stopPropagation();
                const segmentId = btn.getAttribute('data-segment-id');
                if (segmentId) this.deleteSegment(segmentId);
            });
        });
    }
    playFromSegment(index) {
        if (!this.segmentPlayer) this.initAudioRecorder();
        this.segmentPlayer?.setSegments(this.audioSegments);
        this.segmentPlayer?.seekToSegment(index);
        this.segmentPlayer?.play();
    }
    highlightPlayingSegment(index) {
        this.segmentTimeline.querySelectorAll('.segment-item').forEach((el, i)=>{
            if (i === index) el.classList.add('playing');
            else el.classList.remove('playing');
        });
    }
    deleteSegment(segmentId) {
        // Stop playback if playing
        if (this.isPlaying) this.segmentPlayer?.stop();
        // Delete from server
        if (this.diagramId) (0, $89e91b042708b34e$export$de95611a92ae0566).deleteSegment(this.diagramId, segmentId);
        // Remove from local array
        this.audioSegments = this.audioSegments.filter((s)=>s.id !== segmentId);
        // Update UI
        this.renderSegmentTimeline();
        this.saveToLocalStorage();
        this.syncAudioSegmentDelete(segmentId);
    }
    getTotalDuration() {
        return this.audioSegments.reduce((sum, s)=>sum + s.duration, 0);
    }
    syncAudioSegmentAdd(segment) {
        this.syncClient?.sendAudioSegmentAdd(segment);
    }
    syncAudioSegmentDelete(segmentId) {
        this.syncClient?.sendAudioSegmentDelete(segmentId);
    }
    formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    }
    saveSlideDescription() {
        if (this.slides.length > 0) this.slides[this.currentSlideIndex].description = this.descriptionInput.innerText;
    }
    saveToLocalStorage() {
        // Save current slide state first
        this.saveCurrentSlideToMemory();
        const diagramState = {
            description: this.descriptionInput.value,
            slides: this.slides,
            currentSlideIndex: this.currentSlideIndex,
            audioSegments: this.audioSegments
        };
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(diagramState));
    }
    loadFromLocalStorage() {
        const saved = localStorage.getItem(this.STORAGE_KEY);
        if (!saved) return false;
        try {
            const diagramState = JSON.parse(saved);
            this.slides = diagramState.slides;
            this.currentSlideIndex = diagramState.currentSlideIndex;
            this.audioSegments = diagramState.audioSegments || [];
            if (this.slides.length === 0) return false;
            // Load current slide's description and state
            const slide = this.slides[this.currentSlideIndex];
            this.descriptionInput.innerText = slide?.description || '';
            // Clear default players
            this.playerLayer.find('.player').forEach((p)=>p.destroy());
            // Restore slide state - convert ratios to current canvas pixels
            slide.canvasState.players.forEach((p)=>{
                const x = $c6f8878b4b43a5af$var$ratioToPixel(p.x, this.CANVAS_WIDTH);
                const y = $c6f8878b4b43a5af$var$ratioToPixel(p.y, this.CANVAS_HEIGHT);
                this.createPlayer(x, y, p.color, p.label);
            });
            slide.canvasState.arrows.forEach((a)=>{
                this.hitCounter++;
                const startX = $c6f8878b4b43a5af$var$ratioToPixel(a.startX, this.CANVAS_WIDTH);
                const startY = $c6f8878b4b43a5af$var$ratioToPixel(a.startY, this.CANVAS_HEIGHT);
                const endX = $c6f8878b4b43a5af$var$ratioToPixel(a.endX, this.CANVAS_WIDTH);
                const endY = $c6f8878b4b43a5af$var$ratioToPixel(a.endY, this.CANVAS_HEIGHT);
                const ctrl = a.ctrl ? {
                    x: $c6f8878b4b43a5af$var$ratioToPixel(a.ctrl.x, this.CANVAS_WIDTH),
                    y: $c6f8878b4b43a5af$var$ratioToPixel(a.ctrl.y, this.CANVAS_HEIGHT)
                } : null;
                const bounce = a.bounce ? {
                    x: $c6f8878b4b43a5af$var$ratioToPixel(a.bounce.x, this.CANVAS_WIDTH),
                    y: $c6f8878b4b43a5af$var$ratioToPixel(a.bounce.y, this.CANVAS_HEIGHT)
                } : null;
                this.createArrow(startX, startY, endX, endY, a.color, a.style, ctrl, bounce, this.hitCounter);
            });
            this.updateSlideIndicator();
            this.updatePaginationButtons();
            this.renderSegmentTimeline();
            return true;
        } catch  {
            return false;
        }
    }
    initializeSlides() {
        // If we have a diagramId, connect to WebSocket for sync
        if (this.diagramId) {
            this.connectToSync();
            return;
        }
        // Otherwise, try to load from localStorage
        if (this.loadFromLocalStorage()) return;
        // Create first slide with default state
        const firstSlide = {
            id: this.generateSlideId(),
            description: '',
            canvasState: this.getCurrentCanvasState()
        };
        this.slides = [
            firstSlide
        ];
        this.currentSlideIndex = 0;
        this.descriptionInput.innerText = '';
        this.updateSlideIndicator();
        this.updatePaginationButtons();
    }
    async connectToSync() {
        if (!this.diagramId) return;
        this.syncClient = new (0, $7027e40d5f370fb1$export$3097e7fcde2a46f0)(this.diagramId);
        // Set up message handlers before connecting
        this.setupSyncHandlers();
        // Connect and get initial state
        const state = await this.syncClient.connect();
        if (state) {
            // Load state from server
            this.slides = state.slides;
            this.currentSlideIndex = state.currentSlideIndex;
            this.audioSegments = state.audioSegments || [];
            if (this.slides.length > 0) {
                // Clear default players and load from server state
                this.playerLayer.find('.player').forEach((p)=>p.destroy());
                const slide = this.slides[this.currentSlideIndex];
                // Load slide description
                this.descriptionInput.innerText = slide.description || '';
                // Restore state - convert ratios to current canvas pixels
                slide.canvasState.players.forEach((p)=>{
                    const x = $c6f8878b4b43a5af$var$ratioToPixel(p.x, this.CANVAS_WIDTH);
                    const y = $c6f8878b4b43a5af$var$ratioToPixel(p.y, this.CANVAS_HEIGHT);
                    this.createPlayer(x, y, p.color, p.label);
                });
                slide.canvasState.arrows.forEach((a)=>{
                    this.hitCounter++;
                    const startX = $c6f8878b4b43a5af$var$ratioToPixel(a.startX, this.CANVAS_WIDTH);
                    const startY = $c6f8878b4b43a5af$var$ratioToPixel(a.startY, this.CANVAS_HEIGHT);
                    const endX = $c6f8878b4b43a5af$var$ratioToPixel(a.endX, this.CANVAS_WIDTH);
                    const endY = $c6f8878b4b43a5af$var$ratioToPixel(a.endY, this.CANVAS_HEIGHT);
                    const ctrl = a.ctrl ? {
                        x: $c6f8878b4b43a5af$var$ratioToPixel(a.ctrl.x, this.CANVAS_WIDTH),
                        y: $c6f8878b4b43a5af$var$ratioToPixel(a.ctrl.y, this.CANVAS_HEIGHT)
                    } : null;
                    const bounce = a.bounce ? {
                        x: $c6f8878b4b43a5af$var$ratioToPixel(a.bounce.x, this.CANVAS_WIDTH),
                        y: $c6f8878b4b43a5af$var$ratioToPixel(a.bounce.y, this.CANVAS_HEIGHT)
                    } : null;
                    this.createArrow(startX, startY, endX, endY, a.color, a.style, ctrl, bounce, this.hitCounter);
                });
            }
            this.updateSlideIndicator();
            this.updatePaginationButtons();
            this.renderSegmentTimeline();
        } else {
            // Connection failed, fall back to localStorage
            console.warn('WebSocket connection failed, using localStorage');
            if (!this.loadFromLocalStorage()) {
                const firstSlide = {
                    id: this.generateSlideId(),
                    description: '',
                    canvasState: this.getCurrentCanvasState()
                };
                this.slides = [
                    firstSlide
                ];
                this.currentSlideIndex = 0;
                this.descriptionInput.innerText = '';
                this.updateSlideIndicator();
                this.updatePaginationButtons();
            }
        }
    }
    setupSyncHandlers() {
        if (!this.syncClient) return;
        // Handle slide updates from other clients
        this.syncClient.on('slide-update', (msg)=>{
            const message = msg;
            if (message.slideIndex === this.currentSlideIndex) {
                // Update current slide - reload canvas
                this.slides[message.slideIndex].canvasState = message.canvasState;
                this.reloadCurrentSlide();
            } else // Update other slide in memory
            this.slides[message.slideIndex].canvasState = message.canvasState;
        });
        // Handle slide additions from other clients
        this.syncClient.on('slide-add', (msg)=>{
            const message = msg;
            this.slides.splice(message.insertAfterIndex + 1, 0, message.slide);
            this.updateSlideIndicator();
            this.updatePaginationButtons();
        });
        // Handle slide deletions from other clients
        this.syncClient.on('slide-delete', (msg)=>{
            const message = msg;
            if (this.slides.length > 1) {
                this.slides.splice(message.slideIndex, 1);
                if (this.currentSlideIndex >= this.slides.length) {
                    this.currentSlideIndex = this.slides.length - 1;
                    this.reloadCurrentSlide();
                } else if (this.currentSlideIndex === message.slideIndex) this.reloadCurrentSlide();
                this.updateSlideIndicator();
                this.updatePaginationButtons();
            }
        });
        // Handle description updates from other clients
        this.syncClient.on('description-update', (msg)=>{
            const message = msg;
            this.descriptionInput.value = message.description;
        });
        // Handle full sync from other clients
        this.syncClient.on('full-sync', (msg)=>{
            const message = msg;
            this.descriptionInput.value = message.state.description;
            this.slides = message.state.slides;
            this.currentSlideIndex = message.state.currentSlideIndex;
            this.audioSegments = message.state.audioSegments || [];
            this.reloadCurrentSlide();
            this.updateSlideIndicator();
            this.updatePaginationButtons();
            this.renderSegmentTimeline();
        });
        // Handle audio segment additions from other clients
        this.syncClient.on('audio-segment-add', (msg)=>{
            const message = msg;
            this.audioSegments.push(message.segment);
            this.renderSegmentTimeline();
        });
        // Handle audio segment deletions from other clients
        this.syncClient.on('audio-segment-delete', (msg)=>{
            const message = msg;
            this.audioSegments = this.audioSegments.filter((s)=>s.id !== message.segmentId);
            this.renderSegmentTimeline();
        });
    }
    reloadCurrentSlide() {
        // Clear canvas
        this.playerLayer.find('.player').forEach((p)=>p.destroy());
        this.arrowLayer.find('.arrow').forEach((a)=>a.destroy());
        this.selectedShape = null;
        this.hitCounter = 0;
        // Reload current slide - convert ratios to current canvas pixels
        const slide = this.slides[this.currentSlideIndex];
        if (slide) {
            // Load description
            this.descriptionInput.innerText = slide.description || '';
            slide.canvasState.players.forEach((p)=>{
                const x = $c6f8878b4b43a5af$var$ratioToPixel(p.x, this.CANVAS_WIDTH);
                const y = $c6f8878b4b43a5af$var$ratioToPixel(p.y, this.CANVAS_HEIGHT);
                this.createPlayer(x, y, p.color, p.label);
            });
            slide.canvasState.arrows.forEach((a)=>{
                this.hitCounter++;
                const startX = $c6f8878b4b43a5af$var$ratioToPixel(a.startX, this.CANVAS_WIDTH);
                const startY = $c6f8878b4b43a5af$var$ratioToPixel(a.startY, this.CANVAS_HEIGHT);
                const endX = $c6f8878b4b43a5af$var$ratioToPixel(a.endX, this.CANVAS_WIDTH);
                const endY = $c6f8878b4b43a5af$var$ratioToPixel(a.endY, this.CANVAS_HEIGHT);
                const ctrl = a.ctrl ? {
                    x: $c6f8878b4b43a5af$var$ratioToPixel(a.ctrl.x, this.CANVAS_WIDTH),
                    y: $c6f8878b4b43a5af$var$ratioToPixel(a.ctrl.y, this.CANVAS_HEIGHT)
                } : null;
                const bounce = a.bounce ? {
                    x: $c6f8878b4b43a5af$var$ratioToPixel(a.bounce.x, this.CANVAS_WIDTH),
                    y: $c6f8878b4b43a5af$var$ratioToPixel(a.bounce.y, this.CANVAS_HEIGHT)
                } : null;
                this.createArrow(startX, startY, endX, endY, a.color, a.style, ctrl, bounce, this.hitCounter);
            });
        }
        this.playerLayer.draw();
        this.arrowLayer.draw();
    }
    syncToServer() {
        if (!this.syncClient) return;
        // Debounce sync to avoid flooding server
        clearTimeout(this.syncDebounceTimer);
        this.syncDebounceTimer = window.setTimeout(()=>{
            this.saveCurrentSlideToMemory();
            this.syncClient?.sendSlideUpdate(this.currentSlideIndex, this.slides[this.currentSlideIndex].canvasState);
        }, 300);
    }
    destroy() {
        document.removeEventListener('keydown', this.boundHandleKeydown);
        window.removeEventListener('resize', this.boundHandleResize);
        clearTimeout(this.resizeTimeout);
        clearTimeout(this.syncDebounceTimer);
        this.syncClient?.disconnect();
        this.audioRecorder?.cancelRecording();
        this.segmentPlayer?.destroy();
        this.stage.destroy();
        this.element.remove();
    }
}


const $b4e14b6b8da86996$var$container = document.getElementById('app');
const $b4e14b6b8da86996$var$router = new (0, $5f00034adfeb2fe9$export$55185c17a0fcbe46)($b4e14b6b8da86996$var$container);
let $b4e14b6b8da86996$var$currentPage = null;
$b4e14b6b8da86996$var$router.route('/', ()=>{
    if ($b4e14b6b8da86996$var$currentPage) $b4e14b6b8da86996$var$currentPage.destroy();
    $b4e14b6b8da86996$var$currentPage = new (0, $46b6101c9a6cf325$export$355f3d6a1f8b250c)($b4e14b6b8da86996$var$container, $b4e14b6b8da86996$var$router);
    $b4e14b6b8da86996$var$router.setCleanup(()=>$b4e14b6b8da86996$var$currentPage?.destroy());
}).route('/new', ()=>{
    // For now, just render the editor directly
    // Phase 2: This will create a new diagram and redirect to /d/:id
    if ($b4e14b6b8da86996$var$currentPage) $b4e14b6b8da86996$var$currentPage.destroy();
    $b4e14b6b8da86996$var$currentPage = new (0, $c6f8878b4b43a5af$export$12ec5b3a122d4623)($b4e14b6b8da86996$var$container, $b4e14b6b8da86996$var$router);
    $b4e14b6b8da86996$var$router.setCleanup(()=>$b4e14b6b8da86996$var$currentPage?.destroy());
}).route('/d/:id', (params)=>{
    // Phase 2: Load diagram by ID from backend
    if ($b4e14b6b8da86996$var$currentPage) $b4e14b6b8da86996$var$currentPage.destroy();
    $b4e14b6b8da86996$var$currentPage = new (0, $c6f8878b4b43a5af$export$12ec5b3a122d4623)($b4e14b6b8da86996$var$container, $b4e14b6b8da86996$var$router, params.id);
    $b4e14b6b8da86996$var$router.setCleanup(()=>$b4e14b6b8da86996$var$currentPage?.destroy());
}).start();


//# sourceMappingURL=tennis-tactics-app.215572d6.js.map
